webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blazy__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_blazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_blazy__);





var CONFIG = {
  date: {
    iso: 'YYYY-MM-DD HH:mm:ss'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    apiBaseUrl: function apiBaseUrl() {
      return this.$store.state.apiBaseUrl;
    },
    config: function config() {
      return this.$store.state.config;
    },
    token: function token() {
      return this.$store.state.token;
    },
    user: function user() {
      return this.parseJwt(this.token);
    }
  },

  methods: {
    isVideo: function isVideo(url) {
      var videoExtensions = this.videoExtensions.some(function (ext) {
        return url.toLowerCase().endsWith(ext);
      });
      return videoExtensions;
    },
    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
      if (!string) return '';
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    parseTextintoTitle: function parseTextintoTitle(string) {
      var _this = this;

      if (!string) return '';
      string = string.replace('_', ' ');

      var result = [];
      var letters = string.split(' ');
      letters.forEach(function (value) {
        result.push(_this.capitalizeFirstLetter(value));
      });

      return result.join(' ');
    },
    toSlug: function toSlug(string) {
      if (!string) return '';
      return string.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-');
    },
    digitGrouping: function digitGrouping(string) {
      if (!string) return '';
      return __WEBPACK_IMPORTED_MODULE_2_numeral___default()(string).format('0,0');
    },
    parseJwt: function parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace('-', '+').replace('_', '/');
      return JSON.parse(window.atob(base64));
    },
    validateBearer: function validateBearer() {
      var _this2 = this;

      var localToken = window.localStorage.getItem('token');
      var storeToken = this.$store.state.token;
      var axiosBearer = this.axios.defaults.headers.common.Authorization;
      var axiosToken = axiosBearer.split('Bearer ').pop().trim();

      if (axiosToken.length < 12) {
        if (!localToken) {
          if (window.localStorage.getItem('reload') === 1) {
            this.$swal({
              title: 'Auth Required',
              text: 'Authorization missing, please relogin.',
              type: 'warning',
              timer: 8000,
              onClose: function onClose() {
                _this2.$store.commit('REMOVE_TOKEN');
                _this2.$store.commit('REMOVE_USER');

                if (window.localStorage) {
                  window.localStorage.removeItem('token');
                }

                _this2.$router.push('/login');
              }
            });
          }

          window.localStorage.setItem('reload', 1);
          location.reload();
          return;
        }

        if (storeToken !== localToken) {
          this.$store.commit('SET_TOKEN', localToken);
        }

        this.axios.defaults.headers.common.Authorization = 'Bearer ' + storeToken;
        window.localStorage.removeItem('reload');
      }
    },
    stringify: function stringify(data) {
      if (!data) return '';
      return __WEBPACK_IMPORTED_MODULE_0_qs___default.a.stringify(data);
    },
    parseTime: function parseTime(date, format) {
      if (!date) return '';

      var formatTo = format || CONFIG.date.iso;
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format(formatTo);
    },
    parseImage: function parseImage(url, size) {
      if (!url) return '';

      var imageSize = size || '_thumb';
      return url.substring(0, url.lastIndexOf('.')) + imageSize + url.substring(url.lastIndexOf('.'));
    },
    getSize: function getSize(url, size) {
      if (!url) return '';
      var imageSize = size ? '_' + size : '';
      return url.replace(/(\.[\w\d_-]+)$/i, imageSize + '$1');
    },
    numberFormat: function numberFormat(number) {
      var reverse = number.toString().split('').reverse().join('');

      var result = reverse.match(/\d{1,3}/g);
      result = result.join('.').split('').reverse().join('');

      return result;
    },
    initLazyLoad: function initLazyLoad() {
      // eslint-disable-next-line no-new, no-unused-vars
      belazy = new __WEBPACK_IMPORTED_MODULE_3_blazy___default.a({
        selector: '.thumbnail'
      });
    },
    revalidateLazyload: function revalidateLazyload() {
      if (typeof belazy !== 'undefined') {
        belazy.revalidate();
      }
    }
  },

  mounted: function mounted() {
    this.validateBearer();
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e0c240_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(425);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e0c240_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd24978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(439);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fd24978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd24978_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_KEY */
/* unused harmony export API_GATEWAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return WEB_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return X_API_KEY; });
/* unused harmony export X_SECRET_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXTRANET_WEB_URL; });
/* unused harmony export EXTRANET_API_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXTRANET_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXTRANET_APP_SECRET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_BASEURL_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return X_API_KEY_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return X_SECRET_KEY_V2; });
var API_BASEURL = 'https://jasmine-api.misteraladin.com/activities';
var API_KEY = 'H7cuh2C7Ym8RJr1VgvcP4822jypnML';
var API_GATEWAY = 'https://jasmine-api.misteraladin.com/payment-gateways/';
var WEB_URL = 'https://www.misteraladin.com/aladinxplore';
var X_API_KEY = 'LNm#t*WSRB6#dPDTo~m8';
var X_SECRET_KEY = 'Fl!ZSQRH$uAU(fq%-Np9##ClEAAeYaxIqt&zy%ecE~UTa$xvP0';
var EXTRANET_WEB_URL = 'https://production-partner-explore.misterb2b.com';
var EXTRANET_API_URL = 'https://production-api-partner-explore.misteraladin.com/api/v1';
var EXTRANET_APP_ID = '100016';
var EXTRANET_APP_SECRET = 'f3a89165a9661683b2748b6ec80ee155';

var X_API_KEY_V2 = 'ZcrvZBN8VdYtK435J37j';
var API_BASEURL_V2 = 'https://pg-api.misteraladin.com/payment-gateways/v2';
var X_SECRET_KEY_V2 = 'ZbY7scgYJX7zf3aQWh9FBpUwqMUKUJQzrHK';



/* harmony default export */ __webpack_exports__["i"] = (API_BASEURL);

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileGallery_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56398aba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileGallery_vue__ = __webpack_require__(431);
function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56398aba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileGallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56398aba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileGallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* eslint-disable no-shadow */
var state = {
  token: null,
  apiBaseUrl: __WEBPACK_IMPORTED_MODULE_3__config__["i" /* default */],
  modal: {
    show: false,
    type: null
  },
  config: {
    date: {
      iso: 'YYYY-MM-DD',
      simple: 'DD MMM YYYY'
    }
  },
  user: {
    name: null,
    role: null,
    email: null,
    id: null,
    privilege: null
  }
};

function getPrivilagesSlug(data) {
  var privilege = [];
  data.forEach(function (dt) {
    return privilege.push(dt.slug);
  });
  return privilege;
}

var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  REMOVE_TOKEN: function REMOVE_TOKEN(state) {
    state.token = null;
  },
  SET_MODAL: function SET_MODAL(state, type) {
    state.modal.show = !state.modal.show;
    state.modal.type = type || null;
  },
  SET_USER: function SET_USER(state, payload) {
    state.user.name = payload.name;
    state.user.role = payload.role;
    state.user.email = payload.email;
    state.user.id = payload.sub;
    state.user.privilege = payload.privilege ? getPrivilagesSlug(payload.privilege) : [];
  },
  SET_USER_NAME: function SET_USER_NAME(state, name) {
    state.user.name = name;
  },
  REMOVE_USER: function REMOVE_USER(state) {
    state.user.name = null;
    state.user.role = null;
    state.user.email = null;
    state.user.id = null;
    state.user.privilege = null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  strict: debug,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    key: 'ma-activity-backoffice'
  })]
}));

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Box_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141b1bbd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Box_vue__ = __webpack_require__(619);
function injectStyle (ssrContext) {
  __webpack_require__(618)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-141b1bbd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Box_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141b1bbd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Box_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__ = __webpack_require__(6);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BadgesIndex',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Common__["a" /* default */]],
  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      params: {
        name: null,
        page: null,
        type: null,
        status: null
      },
      start_date: null,
      end_date: null,
      badges: [],
      isLoading: false,
      error: null,
      pagination: {},
      statuses: [{
        title: 'All Badges Status',
        value: null
      }, {
        title: 'Active',
        value: 'active'
      }, {
        title: 'Inactive',
        value: 'inactive'
      }],
      types: [{
        title: 'All Badges Type',
        value: null
      }, {
        title: 'Default Badges',
        value: 'default_badge'
      }, {
        title: 'Top Hover Badges',
        value: 'top_badge'
      }, {
        title: 'Bottom Hover Badges',
        value: 'bottom_badge'
      }]
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setQuery();

              case 2:
                _context.next = 4;
                return _this.fetch();

              case 4:
                _this.isInitial = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setQuery: function setQuery() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.params.name = _this2.$route.query.name || null;
        _this2.params.page = _this2.$route.query.page || null;
        _this2.params.type = _this2.$route.query.type || null;
        resolve();
      });
    },
    fetch: function fetch() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.isLoading = true;
      if (page) this.params.page = page || null;

      this.axios.get('/badges', { params: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.params, { start_date: this.startDate, end_date: this.endDate }) }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        var isEmpty = !data && meta.pagination.current_page > meta.pagination.total_pages;
        _this3.badges = !isEmpty ? data : [];
        _this3.pagination = !isEmpty ? meta.pagination : {};
        _this3.setPushState();
      }).catch(function (error) {
        console.log('Fetch error', error);

        if (error.response) {
          _this3.error = error.response.data.errors;
        }

        if (error) {
          _this3.$swal({
            title: 'Failed!',
            text: 'Failed to fetch Data',
            type: 'warning',
            timer: 3000
          });
        }
      }).finally(function () {
        _this3.isLoading = false;
      });
    },
    pushState: function pushState() {
      this.fetch();
    },
    setPushState: function setPushState() {
      var title = 'Badges page ' + this.params.page;
      var paramUrl = '/badges';
      var parameters = this.generateQuery(this.params);
      var startParam = this.startDate ? '&start_date=' + this.startDate : '';
      var endParam = this.endDate ? '&end_date=' + this.endDate : '';
      window.history.pushState(title, null, '' + paramUrl + parameters + startParam + endParam);
    },
    generateQuery: function generateQuery(params) {
      var _this4 = this;

      if (!params) return null;

      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
        return params[key];
      }).map(function (key) {
        return key + '=' + _this4.params[key];
      });

      return query ? '?' + query.join('&') : null;
    },


    onInput: __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'badges-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'badges-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(badge) {
      var _this5 = this;

      this.axios.delete('/badges/' + badge.id).then(function () {
        _this5.fetch();

        _this5.$swal({
          title: 'Deleted',
          text: badge.name + ' has been deleted.',
          type: 'success',
          timer: 3000
        });
      }).catch(function (error) {
        if (error.response) {
          _this5.$swal({
            title: 'Failed',
            text: 'Oppss! You can\'t delete "' + badge.name + '" because this category still used by the product',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    remove: function remove(badge) {
      var _this6 = this;

      this.$swal({
        title: 'Deleting Badge',
        text: 'Are you sure you want to delete ' + badge.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this6.delete(badge);
        } else {
          _this6.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this6.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }
      });
    }
  },
  computed: {
    startDate: function startDate() {
      if (this.start_date) {
        return this.parseTime(this.start_date, 'YYYY-MM-DD');
      }
      return null;
    },
    endDate: function endDate() {
      if (this.end_date) {
        return this.parseTime(this.end_date, 'YYYY-MM-DD');
      }
      return null;
    },
    badgeType: function badgeType() {
      return function (v) {
        if (v === 'default_badge') {
          return 'Default Badges';
        }
        if (v === 'top_badge') {
          return 'Top Hover Badges';
        }
        if (v === 'bottom_badge') {
          return 'Bottom Hover Badges';
        }
        return null;
      };
    },
    disabledStartDate: function disabledStartDate() {
      return {
        to: this.start_date ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.start_date).subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(1, 'days').toDate()
      };
    },
    disabledEndDate: function disabledEndDate() {
      return {
        to: this.start_date ? __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_5_moment___default()().toDate()
      };
    }
  }
});

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      pages: [],
      show: false
    };
  },


  props: {
    label: {
      type: String,
      required: false,
      default: 'Pagination'
    },

    pagination: {
      type: Object,
      required: true
    }
  },

  watch: {
    pagination: function pagination() {
      this.createPages();
    }
  },

  methods: {
    goTo: function goTo(page) {
      this.$emit('goto-page', page);
    },
    createPages: function createPages() {
      this.show = false;
      var current = this.pagination.current_page;
      var step = 4;
      var min = 1;
      var max = this.pagination.total_pages;

      var start = void 0;
      var end = void 0;
      var pageRange = void 0;

      if (current === 1) {
        pageRange = max <= 8 ? max : 8;
        start = 1;
        end = current + pageRange;
      } else if (current === max) {
        pageRange = max <= 8 ? max : 8;
        start = current - pageRange + 1;
        end = current + 1;
      } else {
        start = current - (step - 1) > min ? current - (step - 1) : min;
        end = current + step < max ? current + step : max + 1;
      }

      this.pages = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["range"])(start, end);
      this.show = true;
    }
  }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__riophae_vue_treeselect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__riophae_vue_treeselect__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BadgesForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Common__["a" /* default */]],
  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a,
    FileGallery: __WEBPACK_IMPORTED_MODULE_6__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Modal__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_10__riophae_vue_treeselect__["Treeselect"]
  },
  watch: {
    /* eslint-disable */
    'form.start_date': function formStart_date() {
      if (this.form.start_date > this.form.end_date) {
        this.form.end_date = null;
      }
    }
  },
  computed: {
    disabledEndDate: function disabledEndDate() {
      return {
        to: this.form.start_date ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').toDate()
      };
    }
  },
  data: function data() {
    return {
      disabledStartDate: { to: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').toDate() },
      title: 'Add New Badges',
      error: null,
      form: {
        start_date: null,
        end_date: null,
        days: [],
        name: null,
        image: {
          id: null,
          url: null
        },
        destinations: [],
        categories: [],
        vendors: [],
        merchants: [],
        products: [],
        medias: [],
        status: 'active',
        type: 'default_badge',
        badge_title: '',
        preset_color_id: null,
        badge_description: ''
      },
      badgeColor: [],
      show: {
        gallery: false
      },
      days: [{
        label: 'Mon',
        value: 1
      }, {
        label: 'Tue',
        value: 2
      }, {
        label: 'Wed',
        value: 3
      }, {
        label: 'Thu',
        value: 4
      }, {
        label: 'Fri',
        value: 5
      }, {
        label: 'Sat',
        value: 6
      }, {
        label: 'Sun',
        value: 7
      }],
      list: {
        products: [],
        destinations: [],
        flatDestinations: [],
        categories: [],
        vendors: [],
        merchants: []
      },
      params: {
        page: 1,
        perpage: 500
      },
      medias: [{
        label: 'Desktop',
        value: 'desktop'
      }, {
        label: 'Apps',
        value: 'apps'
      }]
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    handleClearDate: function handleClearDate() {
      this.disabledStartDate = { to: __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').toDate() };
    },
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.isCreate) {
                  _this.title = 'Edit Badges';
                  _this.fetch();
                }

                _this.getBadgeColor();
                _context.next = 4;
                return _this.fetchItem('categories');

              case 4:
                _context.next = 6;
                return _this.fetchItem('vendors');

              case 6:
                _context.next = 8;
                return _this.fetchItem('merchants');

              case 8:
                _context.next = 10;
                return _this.fetchItem('products');

              case 10:
                _context.next = 12;
                return _this.getAvailableDestination();

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetch: function fetch() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.axios.get('/badges/' + _this2.$route.params.id).then(function (response) {
                  var data = response.data.data;

                  _this2.setFieldValue(data);
                }).catch(function (error) {
                  if (error.response) {
                    _this2.error = error.response.data.errors;
                  }
                });

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getBadgeColor: function getBadgeColor() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.axios.get('/badge-color').then(function (response) {
                  _this3.badgeColor = response.data.data;
                }).catch(function (error) {
                  console.log(error);
                });

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    setFieldValue: function setFieldValue(data) {
      this.form.start_date = data.start_date;
      this.form.end_date = data.end_date;
      this.form.days = data.days.split(',').map(Number);
      this.form.name = data.name;
      this.form.image.id = data.image_id;
      this.form.image.url = data.image;
      this.form.badge_title = data.title;
      this.form.badge_description = data.description;
      this.form.preset_color_id = data.preset_color_id;
      this.form.type = data.type;
      if (data.destinations) {
        var valueDestinations = data.destinations.filter(function (l) {
          return !data.destinations.find(function (val) {
            return l.id === val.parent_id;
          });
        }).map(function (l) {
          return l.id;
        });
        this.form.destinations = valueDestinations;
      }
      this.form.categories = data.categories ? this.getLabelValueItem(data.categories) : [];
      this.form.vendors = data.vendors ? this.getLabelValueItem(data.vendors) : [];
      this.form.merchants = data.merchants ? this.getLabelValueItem(data.merchants) : [];
      if (data.products) {
        this.form.products = this.getLabelValueItem(data.products.filter(function (product) {
          return product.is_insert_manual;
        }));
      }
      this.form.status = data.status;
      this.form.medias = data.medias.split(',');
    },
    getLabelValueItem: function getLabelValueItem(dataArray) {
      if (!dataArray) return [];

      var dataList = [];
      dataArray.map(function (data) {
        return dataList.push({
          value: data.id,
          label: data.name
        });
      });
      return dataList;
    },
    getAvailableDestination: function getAvailableDestination() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.fetchItem('destinations');

              case 2:
                destinations = _context4.sent;
                _context4.next = 5;
                return _this4.generate(destinations);

              case 5:
                _this4.list.destinations = _context4.sent;
                _context4.next = 8;
                return _this4.flattenDestination(destinations);

              case 8:
                _this4.list.flatDestinations = _context4.sent;

              case 9:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    fetchItem: function fetchItem(type) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var enpoint = type;
        if (type === 'products') {
          enpoint = 'products-only';
        }
        _this5.axios.get('/' + enpoint, { params: _this5.params }).then(function (response) {
          var data = response.data.data;

          var results = data.map(function (item) {
            return { label: item.name, value: item.id };
          });
          _this5.list[type] = results;
          resolve(data);
        }).catch(function (error) {
          console.log('Fetch ' + type + ' error', error);

          if (error.response) {
            _this5.error = error.response.data.errors;
          }

          if (error) {
            _this5.$swal({
              title: 'Failed',
              text: 'Failed to fetch available ' + type,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this5.fetchItem(type);
              }
            });
          }
        });
      });
    },
    generate: function generate(data) {
      if (!data) return [];

      return data.map(function (local) {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map(function (parent) {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  isDefaultExpanded: true,
                  children: parent.child.map(function (child) {
                    if (child.child) {
                      return {
                        id: child.id,
                        label: child.name,
                        children: child.child.map(function (grandchild) {
                          return {
                            id: grandchild.id,
                            label: grandchild.name
                          };
                        })
                      };
                    }
                    return {
                      id: child.id,
                      label: child.name
                    };
                  })
                };
              }

              return {
                id: parent.id,
                label: parent.name
              };
            })
          };
        }

        return {
          id: local.id,
          label: local.name
        };
      });
    },
    flattenDestination: function flattenDestination(data) {
      var result = [];

      data.forEach(function (parent) {
        result.push({
          id: parent.id,
          label: parent.name
        });

        if (parent.child !== null) {
          parent.child.forEach(function (child) {
            result.push({
              id: child.id,
              label: child.name
            });

            if (child.child) {
              child.child.forEach(function (grandchild) {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name
                });
              });
            }
          });
        }
      });

      return __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default()(result);
    },
    loadOptions: function loadOptions(_ref) {
      var _this6 = this;

      var action = _ref.action;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(action === __WEBPACK_IMPORTED_MODULE_10__riophae_vue_treeselect__["LOAD_ROOT_OPTIONS"])) {
                  _context5.next = 5;
                  break;
                }

                if (!_this6.destinationListUpdated) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 4;
                return _this6.getAvailableDestination();

              case 4:
                _this6.destinationListUpdated = false;

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    toggleAllDays: function toggleAllDays() {
      if (this.form.days.length < 1) {
        this.form.days = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.form.days = [];
      }
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage: function setImage(payload) {
      this.form.image = payload.images;
    },
    validate: function validate() {
      if (!this.form.start_date) {
        this.$swal('Start Date required', 'Please select start date to continue', 'warning');
        return false;
      }

      if (!this.form.end_date) {
        this.$swal('End Date required', 'Please select end date to continue', 'warning');
        return false;
      }

      if (this.form.days.length < 1) {
        this.$swal('Days required', 'Please select days to continue', 'warning');
        return false;
      }

      if (!this.form.name) {
        this.$swal('Badge Name required', 'Please fill badge name to continue', 'warning');
        return false;
      }

      if (this.form.type === 'bottom_badge') {
        if (!this.form.badge_description) {
          this.$swal('Badge Description required', 'Please fill badge description to continue', 'warning');
          return false;
        }
      }

      if (this.form.type === 'top_badge') {
        if (!this.form.preset_color_id) {
          this.$swal('Badge Preset Color is required', 'Please fill badge preset color to continue', 'warning');
          return false;
        }
        if (!this.form.badge_description) {
          this.$swal('Badge Description required', 'Please fill badge description to continue', 'warning');
          return false;
        }
        if (!this.form.badge_title) {
          this.$swal('Badge Title required', 'Please fill badge title to continue', 'warning');
          return false;
        }
      }

      if (this.form.type !== 'top_badge') {
        if (!this.form.image.id || !this.form.image.url) {
          this.$swal('Image required', 'Please select image to continue', 'warning');
          return false;
        }
      }

      if (this.form.medias.length < 1) {
        this.$swal('Media required', 'Please select media to continue', 'warning');
        return false;
      }

      if (!this.form.status) {
        this.$swal('Status required', 'Please select status to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    generatePostData: function generatePostData() {
      var destinationsData = this.form.destinations != null ? this.form.destinations.map(function (item) {
        return +item;
      }) : +item;
      var categoriesData = this.form.categories != null ? this.form.categories.map(function (item) {
        return item.value;
      }) : null;
      var vendorsData = this.form.vendors != null ? this.form.vendors.map(function (item) {
        return item.value;
      }) : null;
      var merchantsData = this.form.merchants != null ? this.form.merchants.map(function (item) {
        return item.value;
      }) : null;
      var productsData = this.form.products != null ? this.form.products.map(function (item) {
        return item.value;
      }) : null;
      if (this.form.type === 'default_badge') {
        var data = {
          start_date: this.parseTime(this.form.start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form.end_date, 'YYYY-MM-DD'),
          days: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form.days),
          name: this.form.name,
          image: this.form.image.id,
          destinations: destinationsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(destinationsData) : destinationsData,
          categories: categoriesData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(categoriesData) : categoriesData,
          vendors: vendorsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vendorsData) : vendorsData,
          merchants: merchantsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(merchantsData) : merchantsData,
          products: productsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(productsData) : productsData,
          medias: this.form.medias.toString(),
          status: this.form.status,
          position: 'right',
          type: this.form.type
        };
        return data;
      }
      if (this.form.type === 'bottom_badge') {
        var _data = {
          start_date: this.parseTime(this.form.start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form.end_date, 'YYYY-MM-DD'),
          days: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form.days),
          name: this.form.name,
          image: this.form.image.id,
          destinations: destinationsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(destinationsData) : destinationsData,
          categories: categoriesData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(categoriesData) : categoriesData,
          vendors: vendorsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vendorsData) : vendorsData,
          merchants: merchantsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(merchantsData) : merchantsData,
          products: productsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(productsData) : productsData,
          medias: this.form.medias.toString(),
          status: this.form.status,
          position: 'right',
          type: this.form.type,
          description: this.form.badge_description
        };
        return _data;
      }
      if (this.form.type === 'top_badge') {
        var _data2 = {
          start_date: this.parseTime(this.form.start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form.end_date, 'YYYY-MM-DD'),
          days: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form.days),
          name: this.form.name,
          image: this.form.image.id,
          destinations: destinationsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(destinationsData) : destinationsData,
          categories: categoriesData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(categoriesData) : categoriesData,
          vendors: vendorsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vendorsData) : vendorsData,
          merchants: merchantsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(merchantsData) : merchantsData,
          products: productsData != null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(productsData) : productsData,
          medias: this.form.medias.toString(),
          status: this.form.status,
          position: 'right',
          type: this.form.type,
          description: this.form.badge_description,
          title: this.form.badge_title,
          preset_color_id: this.form.preset_color_id
        };
        return _data2;
      }
      return null;
    },
    create: function create() {
      var _this7 = this;

      var data = this.generatePostData();

      return this.axios.post('/badges', this.stringify(data)).then(function (response) {
        _this7.badgeByBadge(response.data.data.id);
        _this7.$swal({
          title: 'Created',
          text: _this7.form.name + ' has been created.',
          type: 'success',
          timer: 3000
        });

        _this7.$router.go(-1);
      }).catch(function (error) {
        console.log('error', error.response);

        if (error.response) {
          _this7.error = error.response.data.Message;
        }

        if (error) {
          var message = 'Failed to create new Badges';

          if (_this7.error) {
            message = _this7.error;
          }

          if (message.indexOf('Duplicate entry') >= 0) {
            message = 'Badges name alreay exist';
          }

          _this7.$swal({
            title: 'Create Failed!',
            text: message,
            type: 'warning',
            timer: 5000,
            onClose: function onClose() {
              _this7.error = null;
            }
          });
        }
      });
    },
    update: function update() {
      var _this8 = this;

      var data = this.generatePostData();

      return this.axios.put('/badges/' + this.$route.params.id, this.stringify(data)).then(function () {
        _this8.$swal({
          title: 'Updated',
          text: _this8.form.name + ' has been updated.',
          type: 'success',
          timer: 3000
        });
        _this8.badgeByBadge(_this8.$route.params.id);
        _this8.$router.go(-1);
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this8.error = error.response.data.errors;
        }

        if (error) {
          var message = 'Failed to update new Badges';

          if (_this8.error) {
            message = _this8.error;
          }

          _this8.$swal({
            title: 'Update Failed!',
            text: message,
            type: 'warning',
            timer: 5000,
            onClose: function onClose() {
              _this8.error = null;
            }
          });
        }
      });
    },
    badgeByBadge: function badgeByBadge(badgeId) {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6(resolve, reject) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.prev = 0;
                  _context6.next = 3;
                  return _this9.axios.put('/badge-product/by-badge/' + badgeId);

                case 3:
                  resolve();
                  _context6.next = 9;
                  break;

                case 6:
                  _context6.prev = 6;
                  _context6.t0 = _context6['catch'](0);

                  reject(_context6.t0);

                case 9:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this9, [[0, 6]]);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blazy__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var belazy = void 0;
var lazyLoadInterval = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileGallery',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      images: [],
      checked: [],
      limit: 60,
      isAll: false,
      meta: null,

      showDropzone: false,
      videoExtensions: ['.mp4', '.webm'],
      configs: {
        dropzone: {
          url: this.$store.state.apiBaseUrl + '/galleries',
          method: 'post',
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token,
            'Cache-Control': '',
            'X-Requested-With': ''
          }
        },
        dropzoneReview: {
          url: this.$store.state.apiBaseUrl + '/galleries/review',
          method: 'post',
          acceptedFiles: 'image/*',
          maxFilesize: 10,
          addRemoveLinks: true,
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token,
            'Cache-Control': '',
            'X-Requested-With': '',
            'X-Ma-Client': 'backend'
          }
        }
      }
    };
  },


  props: {
    selected: {
      required: false,
      default: function _default() {
        return [];
      }
    },

    type: {
      type: String,
      required: true
    },

    isReview: {
      type: Boolean,
      required: false,
      default: false
    },

    isMultiple: {
      type: Boolean,
      required: false,
      default: false
    },

    inline: {
      type: Boolean,
      required: false,
      default: false
    },
    allowVideo: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    limited: function limited() {
      var _this = this;

      var output = this.images;
      if (this.images.length > 0) {
        output = this.images.slice(0, this.limit);
      }

      if (!this.allowVideo) {
        return output.filter(function (image) {
          return !_this.isVideo(image.url);
        });
      }

      return output;
    },
    gelleryDropzoneConfig: function gelleryDropzoneConfig() {
      var configs = this.configs;
      var videoItem = this.videoExtensions.map(function (ext) {
        return ext;
      }).join(',');
      if (this.allowVideo) {
        configs.dropzone.acceptedFiles = 'image/*,' + videoItem;
      }
      return configs;
    }
  },

  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a
  },

  watch: {
    limited: function limited() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.revalidateLazyload();
      });
    }
  },

  methods: {
    fetch: function fetch() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.axios.get('/galleries?perpage=' + _this3.limit).then(function (response) {
          var _response$data = response.data,
              data = _response$data.data,
              meta = _response$data.meta;


          _this3.meta = meta.pagination;

          if (_this3.isMultiple) {
            var temp = [];

            data.forEach(function (image) {
              _this3.checked.forEach(function (checked) {
                if (image.id === checked.id) {
                  image.selected = true;
                }
              });
              temp.push(image);
            });

            _this3.images = temp;
          } else {
            _this3.images = data.map(function (item) {
              item.selected = _this3.checked.id === item.id;
              _this3.revalidateLazyload();
              return item;
            });
          }

          if (_this3.limit >= _this3.meta.total) {
            _this3.isAll = true;
          }

          _this3.$nextTick(function () {
            _this3.revalidateLazyload();
          });

          resolve();
        }).catch(function (e) {
          reject();
          console.log(e);
        });
      });
    },
    errorUpload: function errorUpload() {
      this.$swal('Max Size Reached', 'Maximum Photo file size is 10mb', 'warning');
    },
    parseImage: function parseImage(url, size) {
      if (!url) return '';
      var imageUrl = url.includes('https://') ? url : 'https://' + url;
      var imageSize = size || '_thumb';
      return imageUrl.substring(0, url.lastIndexOf('.')) + imageSize + imageUrl.substring(url.lastIndexOf('.'));
    },
    imageClass: function imageClass(image) {
      if (this.isMultiple) {
        return image.selected ? 'checked' : '';
      }

      return image.id === this.checked.id ? 'checked' : '';
    },
    selectImage: function selectImage(image) {
      if (this.isMultiple) {
        this.images = this.images.map(function (item) {
          if (item.id === image.id) {
            item.selected = !item.selected;
          }
          return item;
        });

        if (this.isReview && this.checked.length >= 5) {
          this.checked = this.images.filter(function (item) {
            return !!item.selected;
          });
          this.checked[0].selected = !this.checked[0].selected;
          this.checked = this.checked.slice(-5);
        } else {
          this.checked = this.images.filter(function (item) {
            return !!item.selected;
          });
        }
      } else {
        this.checked = image;
      }

      if (this.inline) {
        this.$emit('update-images', {
          target: this.type,
          images: this.checked
        });
      }
    },
    toggleDropzone: function toggleDropzone() {
      this.$refs.imageUpload.setOption({
        paramName: 'file',
        uploadMultiple: false,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.token
        }
      });
      this.showDropzone = !this.showDropzone;
    },
    update: function update() {
      this.$emit('update-images', {
        target: this.type,
        images: this.checked
      });
      this.$store.commit('SET_MODAL');
      __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('close-modal');
    },
    showMore: function showMore() {
      if (this.meta.total >= this.limit) {
        this.limit += this.limit;
        this.fetch();
      }

      if (this.limit >= this.meta.total) {
        this.isAll = true;
      }
    },
    lazyLoad: function lazyLoad() {
      var _this4 = this;

      // eslint-disable-next-line no-new, no-unused-vars
      belazy = new __WEBPACK_IMPORTED_MODULE_1_blazy___default.a({
        selector: '.thumbnail'
      });

      lazyLoadInterval = setInterval(function () {
        _this4.revalidateLazyload();
      }, 2 * 1000);
    },
    revalidateLazyload: function revalidateLazyload() {
      if (typeof belazy !== 'undefined') {
        belazy.revalidate();
      }
    }
  },

  created: function created() {
    if (this.selected) {
      this.checked = this.selected;
    }

    this.fetch();
  },
  mounted: function mounted() {
    this.lazyLoad();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(lazyLoadInterval);
  }
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_bus__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: false
    }
  },

  computed: {
    show: function show() {
      return this.$store.state.modal.show;
    }
  },

  methods: {
    close: function close() {
      this.$store.commit('SET_MODAL');
      __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$emit('close-modal');
    }
  }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_common_FileGallery__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CategoryForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Add New Category',

      form: {
        id: null,
        name: null,
        name_en: null,
        slug: null,
        image: {
          id: null,
          url: null
        }
      },

      show: {
        gallery: false
      },

      error: null
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_5__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.axios.get('/categories/' + _this.$route.params.id).then(function (response) {
                  var data = response.data.data;


                  _this.form.id = data.id;
                  _this.form.name = data.name;
                  _this.form.name_en = data.name_en;
                  _this.form.slug = data.slug;
                  _this.form.image.id = data.image_id;
                  _this.form.image.url = data.image_url;
                }).catch(function (error) {
                  if (error.response) {
                    _this.error = error.response.data.errors;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage: function setImage(payload) {
      this.form.image = payload.images;
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.name_en) {
        this.$swal('Name En required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.image.id || !this.form.image.url) {
        this.$swal('Image required', 'Please select image to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this2 = this;

      var data = {
        name: this.form.name,
        name_en: this.form.name_en,
        slug: this.form.slug,
        image: this.form.image.id
      };

      this.axios.post('/categories', this.stringify(data)).then(function () {
        _this2.$router.push({
          name: 'category-index'
        });
      }).catch(function (error) {
        if (error.response) {
          _this2.$swal({
            title: 'Failed',
            text: 'Oppss! Name already used',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    update: function update() {
      var _this3 = this;

      var data = {
        name: this.form.name,
        name_en: this.form.name_en,
        slug: this.form.slug,
        image: this.form.image.id
      };

      this.axios.put('/categories/' + this.form.id, this.stringify(data)).then(function () {
        _this3.$router.push({
          name: 'category-index'
        });
      }).catch(function (error) {
        if (error.response) {
          _this3.$swal({
            title: 'Failed',
            text: 'Oppss! Name already used',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Category';
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this4.show.gallery = false;
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CategoryIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      categories: [],
      pagination: {},
      error: null,

      params: {
        name: null
      }
    };
  },


  methods: {
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/categories', {
        params: this.params,
        responseType: this.type
      }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          _this.categories = null;
          _this.pagination = {};
          return;
        }

        _this.categories = data;
        _this.pagination = meta.pagination;
      });

      if (page) {
        window.history.pushState('Categories page: ' + page, null, '/categories?page=' + page);
      }
    },


    onInput: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'category-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'category-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(category) {
      var _this2 = this;

      this.axios.delete('/categories/' + category.id).then(function () {
        _this2.fetch();

        _this2.$swal({
          title: 'Deleted',
          text: category.name + ' has been deleted.',
          type: 'success',
          timer: 3000
        });
      }).catch(function (error) {
        if (error.response) {
          _this2.$swal({
            title: 'Failed',
            text: 'Oppss! You can\'t delete "' + category.name + '" because this category still used by the product',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    remove: function remove(category) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting Category',
        text: 'Are you sure you want to delete ' + category.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this3.delete(category);
        } else {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }
      });
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__partials_Sidebar__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__partials_Header__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_Footer__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__partials_ControlSidebar__ = __webpack_require__(454);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  components: {
    'app-sidebar': __WEBPACK_IMPORTED_MODULE_0__partials_Sidebar__["a" /* default */],
    'app-header': __WEBPACK_IMPORTED_MODULE_1__partials_Header__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_2__partials_Footer__["a" /* default */],
    'control-sidebar': __WEBPACK_IMPORTED_MODULE_3__partials_ControlSidebar__["a" /* default */]
  }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardSidebar',

  data: function data() {
    return {
      datarole: [],
      privilege: null,
      token: null
    };
  },


  methods: {
    toggle: function toggle(e) {
      var parent = $(e.currentTarget).closest('li');
      var children = parent.find('ul.sidebar-menu');

      if (children.css('display') === 'none') {
        children.css('display', 'block');
      } else {
        children.css('display', 'none');
      }
    },
    generateMenuData: function generateMenuData(privilege) {
      var menu = [];
      if (privilege.includes('dashboard')) {
        menu.push({
          to: '/dashboard',
          class: 'fa fa-dashboard',
          title: 'Dashboard'
        });
      }

      if (privilege.includes('highlights')) {
        menu.push({
          to: { name: 'highlights-edit' },
          class: 'fa fa-star',
          title: 'Highlights'
        });
      }

      if (privilege.includes('badges')) {
        menu.push({
          to: { name: 'badges-index' },
          class: 'fa fa-certificate',
          title: 'Badges'
        });
      }

      if (privilege.includes('categories')) {
        menu.push({
          to: { name: 'category-index' },
          class: 'fa fa-th-list',
          title: 'Categories'
        });
      }

      if (privilege.includes('destinations')) {
        menu.push({
          to: { name: 'destination-index', query: { type: 'domestic' } },
          class: 'fa fa-compass',
          title: 'Destinations'
        });
      }

      if (privilege.includes('destinations')) {
        menu.push({
          to: { name: 'review-index' },
          class: 'fa fa-star',
          title: 'Explore Review'
        });
      }

      if (privilege.includes('tags')) {
        menu.push({
          to: { name: 'tag-index' },
          class: 'fa fa-tags',
          title: 'Tags'
        });
      }

      if (privilege.includes('sources')) {
        menu.push({
          to: { name: 'source-index' },
          class: 'fa fa-vcard',
          title: 'Sources'
        });
      }

      if (privilege.includes('merchants')) {
        menu.push({
          to: { name: 'merchant-index' },
          class: 'fa fa-vcard',
          title: 'Merchants'
        });
      }

      if (privilege.includes('inventory-ticket')) {
        menu.push({
          to: { name: 'inventory-index' },
          class: 'fa fa-tags',
          title: 'Inventory Ticket'
        });
      }

      if (privilege.includes('products')) {
        menu.push({
          to: { name: 'product-index' },
          class: 'fa fa-plane',
          title: 'Products'
        });
      }

      if (privilege.includes('klook')) {
        menu.push({
          to: { name: 'klook-index' },
          class: 'fa fa-ticket',
          title: 'Klook'
        });
      }

      if (privilege.includes('promotions')) {
        var submenu = [];

        if (privilege.includes('payments')) {
          submenu.push({
            to: '/promo/config',
            class: 'fa fa-credit-card',
            title: 'Payments'
          });
        }

        if (privilege.includes('code')) {
          submenu.push({
            to: '/promo/code',
            class: 'fa fa-ticket',
            title: 'Code'
          });
        }

        if (privilege.includes('bin')) {
          submenu.push({
            to: '/promo/bin',
            class: 'fa fa-bank',
            title: 'BIN'
          });
        }

        menu.push({
          class: 'fa fa-gift',
          title: 'Promotions',
          children: submenu
        });
      }

      if (privilege.includes('orders')) {
        var _submenu = [];

        if (privilege.includes('order-summary')) {
          _submenu.push({
            to: '/orders',
            class: 'fa fa-file-text-o',
            title: 'Orders Summary'
          });
        }

        if (privilege.includes('payment-to-merchant')) {
          _submenu.push({
            to: '/order-payment',
            class: 'fa fa-money',
            title: 'Payment to Merchant'
          });
        }

        menu.push({
          class: 'fa fa-shopping-cart',
          title: 'Orders',
          children: _submenu
        });
      }

      if (privilege.includes('ticketing')) {
        var _submenu2 = [];

        if (privilege.includes('ticketing-redeem')) {
          _submenu2.push({
            to: '/ticketing/redeem',
            class: 'fa fa-star',
            title: 'Redeem'
          });
        }

        if (privilege.includes('ticketing-check-in')) {
          _submenu2.push({
            to: '/ticketing/check-in',
            class: 'fa fa-tags',
            title: 'Check In'
          });
        }

        menu.push({
          class: 'fa fa-database',
          title: 'Ticketing',
          children: _submenu2
        });
      }

      if (privilege.includes('user-setup')) {
        var _submenu3 = [];

        if (privilege.includes('role-setup')) {
          _submenu3.push({
            to: __WEBPACK_IMPORTED_MODULE_0__config__["d" /* EXTRANET_WEB_URL */] + '/user-setup/role/?appId=' + __WEBPACK_IMPORTED_MODULE_0__config__["b" /* EXTRANET_APP_ID */] + '&appSecret=' + __WEBPACK_IMPORTED_MODULE_0__config__["c" /* EXTRANET_APP_SECRET */] + '&token=' + this.token,
            class: 'fa fa-key',
            title: 'Role Setup'
          });
        }

        if (privilege.includes('internal-user-setup')) {
          _submenu3.push({
            to: '/user-setup',
            class: 'fa fa-user-circle',
            title: 'Internal User Setup'
          });
        }

        if (privilege.includes('merchant-user-setup')) {
          _submenu3.push({
            to: __WEBPACK_IMPORTED_MODULE_0__config__["d" /* EXTRANET_WEB_URL */] + '/user-setup/merchant-user/?appId=' + __WEBPACK_IMPORTED_MODULE_0__config__["b" /* EXTRANET_APP_ID */] + '&appSecret=' + __WEBPACK_IMPORTED_MODULE_0__config__["c" /* EXTRANET_APP_SECRET */] + '&token=' + this.token,
            class: 'fa fa-user-o',
            title: 'Merchant User Setup'
          });
        }

        menu.push({
          class: 'fa fa-cogs',
          title: 'User Management',
          children: _submenu3
        });
      }

      return menu;
    }
  },

  created: function created() {
    this.privilege = this.$store.state.user.role;
    this.token = this.$store.state.token;
    this.datarole = this.generateMenuData(this.$store.state.user.privilege);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Common__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardHeader',

  data: function data() {
    return {
      isLoading: false,
      klook: {
        balance: 0,
        currency: null
      }
    };
  },


  computed: {
    user: function user() {
      return this.$store.state.user;
    }
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Common__["a" /* default */]],

  methods: {
    getBalance: function getBalance() {
      var _this = this;

      if (this.isLoading) return;

      this.isLoading = true;

      this.axios.get('/klook/balance').then(function (response) {
        var _response$data = response.data,
            balance = _response$data.balance,
            currency = _response$data.currency;


        _this.klook = {
          balance: _this.digitGrouping(balance),
          currency: currency
        };

        _this.isLoading = false;
      }).catch(function (error) {
        console.log('Failed fetching balance', error);
      });
    },
    collapse: function collapse() {
      $('body').toggleClass('sidebar-collapse');

      var width = $(window).width();
      if (width < 480) {
        $('body').toggleClass('sidebar-open');
      }
    },
    logout: function logout() {
      this.$store.commit('REMOVE_TOKEN');
      this.$store.commit('REMOVE_USER');

      if (window.localStorage) {
        window.localStorage.removeItem('token');
      }

      this.$router.push('/login');
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {
      _this2.getBalance();
    }, 1500);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardFooter',

  data: function data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ControlSidebar'
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DashboardIndex'
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_common_FileGallery__ = __webpack_require__(16);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__webpack_require__(461);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DestinationForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Add New Destination',
      modalVisible: false,
      checkError: {
        name: null,
        name_en: null,
        image: null,
        destinationType: null,
        parent: null
      },
      checkErrorModal: {
        name: null,
        name_en: null,
        image: null,
        destinationType: null,
        parent: null
      },
      form: {
        id: null,
        type: 'domestic',
        name: null,
        name_en: null,
        description: null,
        description_en: null,
        slug: null,
        destinationType: null,
        parent: null,
        image: {
          id: null,
          url: null
        }
      },

      isCreateModal: false,
      isEditModal: false,

      formModal: {
        id: null,
        type: 'domestic',
        name: null,
        name_en: null,
        description: null,
        description_en: null,
        slug: null,
        destinationType: null,
        parent: null,
        image: {
          id: null,
          url: null
        }
      },

      show: {
        gallery: false
      },

      destinationData: {},

      error: null,

      destinations: null,
      destinationType: [{ label: 'City', value: 'city' }, { label: 'Province', value: 'province' }, { label: 'Country', value: 'country' }],
      flatDestinations: []
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    },
    isEdit: {
      type: Boolean,
      required: false
    },
    isView: {
      type: Boolean,
      required: false
    }
  },

  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["Treeselect"],
    FileGallery: __WEBPACK_IMPORTED_MODULE_7__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Modal__["a" /* default */]
  },
  watch: {
    'form.type': function formType() {
      this.$router.push('?types=' + this.form.type);
    },
    'form.destinationType': function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.form.parent = null;
                _context.next = 3;
                return this.getDestinationByType();

              case 3:
                destinations = _context.sent;
                _context.next = 6;
                return this.generate(destinations);

              case 6:
                this.destinations = _context.sent;

                if (this.form.destinationType === 'country') {
                  this.form.parent = this.destinations[0];
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function formDestinationType() {
        return _ref.apply(this, arguments);
      }

      return formDestinationType;
    }()
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.axios.get('destinations', { params: { perpage: 200, type: _this.$route.query.types } }).then(function (response) {
          resolve(response.data.data);
        }).catch(function (error) {
          console.log('Fetch error', error);
          if (error) {
            _this.errors = error.response.data.errors;
          }
        });
      });
    },
    getDestinationByType: function getDestinationByType() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.axios.get('destinations/parent?type=' + _this2.form.type + '&region_type=' + _this2.form.destinationType).then(function (response) {
          resolve(response.data.data);
        }).catch(function (error) {
          console.log('Fetch error', error);
        });
      });
    },
    get: function get() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.axios.get('/destinations/' + _this3.$route.params.id).then(function (response) {
          var data = response.data.data;


          _this3.destinationData = data || [];
          _this3.form.id = data.id || null;
          _this3.form.type = data.type || 'domestic';
          _this3.form.name = data.name || '';
          _this3.form.name_en = data.name_en || '';
          _this3.form.description = data.description || '';
          _this3.form.description_en = data.description_en || '';
          _this3.form.slug = data.slug || '';
          _this3.form.image.id = data.image_id || '';
          _this3.form.destinationType = data.region_type || null;
          _this3.form.image.url = data.image_url || '';

          if (data.parent_id) {
            _this3.set(data.parent_id);
          }

          resolve();
        }).catch(function (error) {
          if (error.response) {
            _this3.errors = error.response.data.errors;
          }
        });
      });
    },
    flat: function flat() {
      var result = [];

      this.destinations.forEach(function (local) {
        result.push({
          id: local.id,
          label: local.label,
          level: 1
        });

        if (local.children) {
          local.children.forEach(function (parent) {
            result.push({
              id: parent.id,
              label: parent.label,
              level: 2
            });

            if (parent.children) {
              parent.children.forEach(function (child) {
                result.push({
                  id: child.id,
                  label: child.label,
                  level: 3
                });

                if (child.children) {
                  child.children.forEach(function (grandchild) {
                    result.push({
                      id: grandchild.id,
                      label: grandchild.label,
                      level: 4
                    });
                  });
                }
              });
            }
          });
        }
      });

      return result;
    },
    set: function set(parent) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.flat();

              case 2:
                _this4.flatDestinations = _context2.sent;


                _this4.flatDestinations.forEach(function (item) {
                  if (parent === item.id) {
                    _this4.form.parent = item;
                  }
                });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    generate: function generate(data) {
      if (!data) return [];

      return data.map(function (local) {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            level: 1,
            isDefaultExpanded: true,
            children: local.child.map(function (parent) {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  level: 2,
                  children: parent.child.map(function (parent2) {
                    if (parent2.child) {
                      return {
                        id: parent2.id,
                        label: parent2.name,
                        level: 3,
                        children: parent2.child.map(function (child) {
                          return {
                            id: child.id,
                            label: child.name,
                            level: 4
                          };
                        })
                      };
                    }

                    return {
                      id: parent2.id,
                      label: parent2.name,
                      level: 3
                    };
                  })
                };
              }

              return {
                id: parent.id,
                label: parent.name,
                level: 2
              };
            })
          };
        }

        return {
          id: local.id,
          label: local.name,
          level: 1
        };
      });
    },
    init: function init() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this5.isCreate) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 3;
                return _this5.getDestinationByType();

              case 3:
                destinations = _context3.sent;
                _context3.next = 6;
                return _this5.generate(destinations);

              case 6:
                _this5.destinations = _context3.sent;
                _context3.next = 9;
                return _this5.get();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    loadOptions: function loadOptions(_ref2) {
      var _this6 = this;

      var action = _ref2.action;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(action === __WEBPACK_IMPORTED_MODULE_3__riophae_vue_treeselect__["LOAD_ROOT_OPTIONS"])) {
                  _context4.next = 7;
                  break;
                }

                _context4.next = 3;
                return _this6.getDestinationByType();

              case 3:
                destinations = _context4.sent;
                _context4.next = 6;
                return _this6.generate(destinations);

              case 6:
                _this6.destinations = _context4.sent;

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    setValue: function setValue(value) {
      this.form.parent = value;
    },
    setImage: function setImage(payload) {
      this.form.image = payload.images;
    },
    setImageModal: function setImageModal(payload) {
      this.formModal.image = payload.images;
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    popUpCall: function popUpCall(type) {
      if (type === 'succeed') {
        this.$swal('Succeed', 'Create new destination succeed.', 'success', 2000);
      }
      if (type === 'edited') {
        this.$swal('Succeed', 'Edit destination succeed.', 'success', 1000);
      }
      if (type === 'error') {
        this.$swal({
          title: 'Failed',
          text: 'Destination Name already used.',
          type: 'error',
          timer: 8000
        });
      }
    },
    addModal: function addModal(value) {
      this.isCreateModal = true;
      this.isEditModal = false;
      this.modalVisible = true;
      this.formModal.type = value.type || 'domestic';
      this.formModal.destinationType = 'city' || null;
      this.formModal.parent = {
        id: value.id,
        label: value.name
      };
    },
    add: function add() {
      this.$router.push({
        name: 'destination-create'
      });
    },
    setDefaultModal: function setDefaultModal() {
      if (this.modalVisible) {
        this.modalVisible = false;
      } else {
        this.modalVisible = true;
      }
      this.formModal.id = null;
      this.formModal.type = 'domestic';
      this.formModal.name = '';
      this.formModal.name_en = '';
      this.formModal.description = '';
      this.formModal.description_en = '';
      this.formModal.slug = '';
      this.formModal.image.id = null;
      this.formModal.destinationType = '';
      this.formModal.image.url = '';
      this.formModal.parent = {
        id: null,
        label: null
      };
    },
    editModal: function editModal(value, parent) {
      this.isEditModal = true;
      this.isCreateModal = false;
      this.modalVisible = true;
      this.formModal.id = value.id || null;
      this.formModal.type = value.type || 'domestic';
      this.formModal.name = value.name || '';
      this.formModal.name_en = value.name_en || '';
      this.formModal.description = value.description || '';
      this.formModal.description_en = value.description_en || '';
      this.formModal.slug = value.slug || '';
      this.formModal.image.id = value.image_id || '';
      this.formModal.destinationType = value.region_type || 'city';
      this.formModal.image.url = value.image_url || '';
      this.formModal.parent = {
        id: value.parent_id,
        label: parent
      };
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'destination-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(destination) {
      var _this7 = this;

      this.axios.delete('/destinations/' + destination.id).then(function () {
        _this7.get();

        _this7.$swal('Deleted!', destination.name + ' has been deleted.', 'success');
      }).catch(function (error) {
        if (error.response) {
          _this7.$swal({
            title: 'Failed',
            text: 'Oppss! You can\'t delete "' + destination.name + '" because this destination still used by the product',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    remove: function remove(destination) {
      var _this8 = this;

      this.$swal({
        title: 'Deleting Destination',
        text: 'Are you sure you want to delete ' + destination.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this8.delete(destination);
        } else {
          _this8.$swal('Cancelled', null, 'info');
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this8.$swal('Cancelled', null, 'info');
        }
      });
    },
    checkForm: function checkForm(type) {
      if (type === 'modal') {
        if (!this.formModal.name) {
          this.checkErrorModal.name = 'Please Input Name';
        } else {
          this.checkErrorModal.name = null;
        }
        if (!this.formModal.name_en) {
          this.checkErrorModal.name_en = 'Please Input Name En';
        } else {
          this.checkErrorModal.name_en = null;
        }
        if (!this.formModal.image.id || !this.formModal.image.url) {
          this.checkErrorModal.image = 'Please Add image';
        } else {
          this.checkErrorModal.image = null;
        }
        if (!this.formModal.destinationType) {
          this.checkErrorModal.destinationType = 'Please Select destinationType';
        } else {
          this.checkErrorModal.destinationType = null;
        }
        if (!this.formModal.parent) {
          this.checkErrorModal.parent = 'Please Select parent';
        } else {
          this.checkErrorModal.parent = null;
        }
      } else {
        if (!this.form.name) {
          this.checkError.name = 'Please Input Name';
        } else {
          this.checkError.name = null;
        }
        if (!this.form.name_en) {
          this.checkError.name_en = 'Please Input Name En';
        } else {
          this.checkError.name_en = null;
        }
        if (!this.form.image.id || !this.form.image.url) {
          this.checkError.image = 'Please Add image';
        } else {
          this.checkError.image = null;
        }
        if (!this.form.destinationType) {
          this.checkError.destinationType = 'Please Select destinationType';
        } else {
          this.checkError.destinationType = null;
        }
        if (!this.form.parent) {
          this.checkError.parent = 'Please Select parent';
        } else {
          this.checkError.parent = null;
        }
      }
    },
    validate: function validate() {
      if (!this.form.name || !this.form.name_en || !this.form.parent || !this.form.destinationType || this.form.parent.level > 3 || !this.form.image.id || !this.form.image.url) {
        this.$swal('Mandatory field required', 'Please fill all mandatory field', 'warning');
        return false;
      }

      return true;
    },
    validateModal: function validateModal() {
      if (!this.formModal.name || !this.formModal.name_en || !this.formModal.parent || !this.formModal.destinationType || this.formModal.parent.level > 3 || !this.formModal.image.id || !this.formModal.image.url) {
        this.$swal('Mandatory field required', 'Please fill all mandatory field', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit(type) {
      if (type === 'modal') {
        var result = this.validateModal();
        if (!result) return;

        if (this.isCreateModal) {
          this.create(type);
        } else {
          this.update(type);
        }
      } else {
        var _result = this.validate();
        if (!_result) return;

        if (this.isCreate) {
          this.create();
        } else {
          this.update();
        }
      }
    },
    generateData: function generateData(type) {
      /* eslint no-else-return: "error" */
      if (type === 'modal') {
        var dataModal = {
          type: this.formModal.type,
          name: this.formModal.name,
          name_en: this.formModal.name_en,
          description: this.formModal.description,
          description_en: this.formModal.description_en,
          slug: this.formModal.slug,
          region_type: this.formModal.destinationType,
          parent_id: parseInt(this.formModal.parent.id, 10),
          image: parseInt(this.formModal.image.id, 10)
        };

        return dataModal;
      }
      var data = {
        type: this.form.type,
        name: this.form.name,
        name_en: this.form.name_en,
        description: this.form.description,
        description_en: this.form.description_en,
        slug: this.form.slug,
        region_type: this.form.destinationType,
        parent_id: parseInt(this.form.parent.id, 10),
        image: parseInt(this.form.image.id, 10)
      };

      return data;
    },
    create: function create(type) {
      var _this9 = this;

      if (type === 'modal') {
        var data = this.generateData(type);

        this.axios.post('/destinations', this.stringify(data)).then(function () {
          _this9.get();
          _this9.setDefaultModal();
          _this9.$swal('Succeed', 'Create new destination succeed.', 'success', 1000);
        }).catch(function (error) {
          if (error.response) {
            _this9.$swal({
              title: 'Failed',
              text: 'Destination Name already used.',
              type: 'error',
              timer: 8000
            });
          }
        });
      } else {
        var _data = this.generateData();

        this.axios.post('/destinations', this.stringify(_data)).then(function (res) {
          _this9.get();
          var id = res.data.data.id;
          var newDestination = res.data.data;
          if (newDestination.region_type === 'province' || newDestination.region_type === 'country' && newDestination.type === 'international') {
            _this9.$swal({
              title: 'Succeed',
              text: '' + (newDestination.region_type === 'province' ? 'Create new destination succeed. Do you want to add new city in this province?' : 'Create new destination succeed. Do you want to add new city in this country?'),
              type: 'success',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
            }).then(function (result) {
              if (result.value) {
                _this9.$router.push({
                  name: 'destination-edit',
                  params: {
                    id: id
                  },
                  query: {
                    isConfirm: true,
                    type: newDestination.type,
                    parent_id: newDestination.id,
                    parent_name: newDestination.name
                  }
                });
              } else {
                _this9.popUpCall('succeed');
                _this9.$router.push({
                  name: 'destination-index',
                  query: {
                    type: newDestination.type
                  }
                });
              }

              if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
                _this9.popUpCall('succeed');
                _this9.$router.push({
                  name: 'destination-index',
                  query: {
                    type: newType
                  }
                });
              }
            });
          } else {
            _this9.popUpCall('succeed');
            _this9.$router.push({
              name: 'destination-index',
              query: {
                type: newDestination.type
              }
            });
          }
        }).catch(function (error) {
          if (error.response) {
            _this9.popUpCall('error');
          }
        });
      }
    },
    update: function update(type) {
      var _this10 = this;

      if (type === 'modal') {
        var data = this.generateData(type);

        this.axios.put('/destinations/' + this.formModal.id, this.stringify(data)).then(function () {
          _this10.get();
          _this10.setDefaultModal();
          _this10.popUpCall('edited');
        }).catch(function (error) {
          if (error.response) {
            _this10.popUpCall('error');
          }
        });
      } else {
        var _data2 = this.generateData();

        this.axios.put('/destinations/' + this.$route.params.id, this.stringify(_data2)).then(function (res) {
          var newDestination = res.data.data;
          _this10.popUpCall('edited');
          _this10.$router.push({
            name: 'destination-index',
            query: {
              type: newDestination.type
            }
          });
        }).catch(function (error) {
          if (error.response) {
            _this10.popUpCall('error');
          }
        });
      }
    },
    cancel: function cancel() {
      this.$router.push({
        name: 'destination-index',
        query: {
          type: this.$route.query.types
        }
      });
      // this.$router.go(-1);
    }
  },

  created: function created() {
    if (this.isEdit) {
      this.title = 'Edit Destination';
    }
    if (this.isView) {
      this.title = 'View Destination';
    }

    this.init();
  },
  mounted: function mounted() {
    var _this11 = this;

    if (this.$route.query.isConfirm) {
      var queries = this.$route.query;
      this.modalVisible = true;
      this.isCreateModal = true;
      this.formModal.type = queries.type || 'domestic';
      this.formModal.destinationType = 'city' || null;
      this.formModal.parent = {
        id: queries.parent_id,
        label: queries.parent_name
      };
    }
    if (this.$route.query.types) {
      this.form.type = this.$route.query.types || 'domestic';
    }
    if (this.$route.query.types === 'international') {
      this.destinationType = [{ label: 'City', value: 'city' }, { label: 'Country', value: 'country' }];
    }
    __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this11.show.gallery = false;
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DestinationIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      destinations: [],
      error: null,

      params: {
        type: this.$route.query.type,
        province: null,
        city: null,
        country: null
      },
      list: {
        provinces: [],
        cities: [],
        countries: []
      }
    };
  },


  methods: {
    fetch: function fetch() {
      var _this = this;

      this.axios.get('/destinations?perpage=500', {
        params: this.params
      }).then(function (response) {
        _this.destinations = response.data.data;
      });
    },
    search: function search() {
      var _this2 = this;

      if (this.params.city) {
        this.axios.get('/destinations?type=' + this.$route.query.type + '&name=' + this.params.city.label).then(function (response) {
          _this2.destinations = response.data.data;
        });
      } else if (this.params.type === 'domestic' && this.params.province && !this.params.city) {
        this.axios.get('/destinations?type=domestic&name=' + this.params.province.label).then(function (response) {
          _this2.destinations = response.data.data;
        });
      } else if (this.params.type === 'international' && this.params.country && !this.params.city) {
        this.axios.get('/destinations?type=international&name=' + this.params.country.label).then(function (response) {
          _this2.destinations = response.data.data;
        });
      } else {
        this.fetch();
      }
    },
    fetchProvince: function fetchProvince() {
      var _this3 = this;

      if (this.params.type === 'domestic') {
        this.axios.get('/destinations?perpage=50&type=domestic&region_type=province').then(function (response) {
          var provinceData = response.data.data[0].child[0].child;
          _this3.list.provinces = provinceData ? provinceData.map(function (item) {
            return { label: item.name, value: item.id };
          }) : [];
        });
      } else {
        this.axios.get('/destinations?perpage=50&type=international&region_type=country').then(function (response) {
          var countryData = response.data.data[0].child;
          _this3.list.countries = countryData ? countryData.map(function (item) {
            return { label: item.name, value: item.id };
          }) : [];
        });
      }
    },
    fetchCity: function fetchCity() {
      var _this4 = this;

      if (this.params.type === 'domestic') {
        if (this.params.province !== null) {
          this.axios.get('/destinations/' + this.params.province.value).then(function (response) {
            var cityData = response.data.data.child;
            console.log(cityData);
            _this4.list.cities = cityData ? cityData.map(function (item) {
              return {
                label: item.name, value: item.id };
            }) : [];
          });
        } else {
          this.axios.get('/destinations?type=domestic&region_type=country').then(function (response) {
            var cityData = response.data.data[0].child[0].child;
            var cityAll = cityData.flatMap(function (item) {
              return item.child;
            }).filter(function (item) {
              return item !== null;
            });
            _this4.list.cities = cityAll ? cityAll.map(function (item) {
              return item !== null ? {
                label: item.name, value: item.id } : {};
            }) : [];
          });
        }
      }
      if (this.params.type === 'international') {
        if (this.params.country !== null) {
          this.axios.get('/destinations/' + this.params.country.value).then(function (response) {
            var cityData = response.data.data.child;
            _this4.list.cities = cityData ? cityData.map(function (item) {
              return {
                label: item.name, value: item.id };
            }) : [];
          });
        } else {
          this.axios.get('/destinations?type=international&region_type=country').then(function (response) {
            var cityAll = response.data.data[0].child;
            var cityData = cityAll.flatMap(function (item) {
              return item.child;
            }).filter(function (item) {
              return item !== null;
            });
            console.log(cityData);
            _this4.list.cities = cityData ? cityData.map(function (item) {
              return item !== null ? {
                label: item.name, value: item.id } : {};
            }) : [];
          });
        }
      }
    },
    setParamsToDefault: function setParamsToDefault() {
      this.params.city = null;
      this.params.province = null;
      this.params.country = null;
    },
    onSelect: function onSelect() {
      this.params.city = null;
      if (!this.params.province) {
        this.params.city = null;
        this.fetch();
      } else {
        this.fetchCity();
      }
      if (this.params.province === null) {
        this.fetchCity();
      }
    },
    onSelectCountry: function onSelectCountry() {
      this.params.city = null;
      if (!this.params.country) {
        this.params.city = null;
        this.fetch();
      } else {
        this.fetchCity();
      }
      if (this.params.country === null) {
        this.fetchCity();
      }
    },

    onInput: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    showDeleteButton: function showDeleteButton(slug) {
      if (slug === 'internasional' || slug === 'international' || slug === 'domestik' || slug === 'domestic') {
        return false;
      }

      return true;
    },
    changeFlag: function changeFlag() {
      if (this.params.type === 'domestic') {
        this.params.type = 'international';
      } else {
        this.params.type = 'domestic';
      }
      this.$router.push('?type=' + this.params.type);
      this.setParamsToDefault();
      this.fetchProvince();
      this.fetch();
      this.fetchCity();
    },
    add: function add() {
      this.$router.push({
        name: 'destination-create',
        query: {
          types: this.$route.query.type
        }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'destination-edit',
        params: {
          id: id
        },
        query: {
          types: this.$route.query.type
        }
      });
    },
    view: function view(id) {
      this.$router.push({
        name: 'destination-view',
        params: {
          id: id
        },
        query: {
          types: this.$route.query.type
        }
      });
    },
    delete: function _delete(destination) {
      var _this5 = this;

      this.axios.delete('/destinations/' + destination.id).then(function () {
        _this5.fetch();

        _this5.$swal('Deleted!', destination.name + ' has been deleted.', 'success');
      }).catch(function (error) {
        if (error.response) {
          _this5.$swal({
            title: 'Failed',
            text: 'Oppss! You can\'t delete "' + destination.name + '" because this destination still used by the product',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    remove: function remove(destination) {
      var _this6 = this;

      this.$swal({
        title: 'Deleting Destination',
        text: 'Are you sure you want to delete ' + destination.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this6.delete(destination);
        } else {
          _this6.$swal('Cancelled', null, 'info');
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this6.$swal('Cancelled', null, 'info');
        }
      });
    }
  },

  created: function created() {
    this.fetch();
    this.fetchProvince();
    this.fetchCity();
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(14);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import FileUpload from '@/components/modules/common/FileUpload';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InventoryForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: '',

      params: {
        flaging: null
      },

      form: {
        id: null,
        name: null,
        file: null,
        delimiter: null,
        image: {
          id: null,
          url: null
        }
      },

      tickets: [],

      list: {
        delimiter: [{
          label: ';',
          value: ';'
        }, {
          label: ',',
          value: ','
        }]
      },

      inventory: {
        id: null,
        name: null,
        file: null
      },
      show: {
        gallery: false
      },
      configs: {
        ckeditor: {
          toolbar: [['Styles', 'Format', '-', 'Bold', 'Italic', 'Strike', '-', 'NumberedList', 'BulletedList', '-', 'Source']],
          height: 300,
          extraPlugins: 'uploadimage',
          uploadUrl: '/static/temp/'
        },
        dropzone: {
          url: this.$store.state.apiBaseUrl + '/ticketItems/upload',
          method: 'put',
          acceptedFiles: 'text/csv, text/comma-separated-values, application/csv, application/x-csv, text/x-comma-separated-values, text/tab-separated-values',
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token,
            'Cache-Control': '',
            'X-Requested-With': ''
          }
        }
      },
      error: null
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_8__components_modules_common_FileGallery__["a" /* default */],
    Dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    // FileUpload,
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.axios.get('/tickets/' + _this.$route.params.id).then(function (response) {
                  var data = response.data.data;


                  _this.form.id = data.id;
                  _this.form.name = data.name;
                  _this.form.file = data.file;
                  _this.form.delimiter.value = data.delimiter;
                  // this.form.image.url = data.image_url;
                }).catch(function (error) {
                  if (error.response) {
                    _this.error = error.response.data.errors;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchAllTickets: function fetchAllTickets() {
      var _this2 = this;

      this.axios.get('/tickets', {
        params: {
          perpage: 1000
        }
      }).then(function (response) {
        var data = response.data.data;

        _this2.tickets = data;
      });
    },
    processFile: function processFile(event) {
      this.someData = event.target.files[0];
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },


    // setImage(payload) {
    //   this.form.image = payload.images;
    // },

    setFile: function setFile(e) {
      if (!e.target) {
        // alert('No file selected');
        return;
      }
      var files = e.target.files;

      this.form.file = files[0];
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.delimiter) {
        this.$swal('Delimiter required', 'Please select a delimiter to continue', 'warning');
        return false;
      }

      if (!this.form.file) {
        this.$swal('Upload required', 'Please upload file to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    redirect: function redirect() {
      this.$router.push({ name: 'inventory-index' });
    },
    showError: function showError(type) {
      if (type === 'ticket-exists') {
        this.$swal('Ticket Exist', 'The ticket already exists, please use the edit feature to update', 'warning');
      }

      if (type === 'ticket-failed') {
        this.$swal('Create Ticket Failed', 'Create ticket and upload stock failed', 'warning');
      }
    },
    setErrorMessage: function setErrorMessage(message) {
      var _this3 = this;

      this.error = message;

      setTimeout(function () {
        _this3.error = false;
      }, 10000);
    },
    handleSubmitError: function handleSubmitError(error) {
      console.log('error', error);

      if (error === 'ticket-exists') {
        this.showError('ticket-exists');
      }

      if (error === 'ticket-failed') {
        this.showError('ticket-failed');
      }

      if (error.type === 'stock-failed') {
        this.showError('stock-failed');
      }

      if (this.isCreate) {
        this.deleteTicket(this.form.id);
      }

      this.setErrorMessage(error.message);
    },
    validateTicketExist: function validateTicketExist() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var isExist = false;

        if (_this4.tickets.length > 0) {
          var ticketNames = _this4.tickets.map(function (ticket) {
            return ticket.name;
          });
          isExist = ticketNames.includes(_this4.form.name);

          if (isExist) {
            reject('ticket-exists');
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    prepareFormTicket: function prepareFormTicket() {
      var formData = new FormData();

      formData.append('name', this.form.name);
      formData.append('type_product', this.params.flaging);

      return formData;
    },
    submitTicket: function submitTicket(type, dataTicket) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (type === 'create') {
          _this5.axios.post('/tickets', dataTicket).then(function (response) {
            return resolve(response.data.data.id);
          }).catch(function () {
            return reject('ticket-failed');
          });
        }

        if (type === 'update') {
          _this5.axios.put('/tickets/' + _this5.form.id, dataTicket).then(function (response) {
            return resolve(response.data.data.id);
          }).catch(function () {
            return reject('ticket-failed');
          });
        }
      });
    },
    setFormId: function setFormId(formId) {
      this.form.id = formId;
    },
    prepareFormStock: function prepareFormStock() {
      var _form = this.form,
          id = _form.id,
          file = _form.file,
          delimiter = _form.delimiter;

      var formData = new FormData();

      formData.append('ticket_id', id);
      formData.append('file', file);
      formData.append('delimiter', delimiter.value);

      return formData;
    },
    submitStock: function submitStock(data) {
      var _this6 = this;

      var config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.axios.post('/ticketItems/upload', data, config).then(function () {
          return resolve();
        }).catch(function (error) {
          reject({
            type: 'stock-failed',
            message: error.response ? error.response.data.errors : 'Error'
          });
        });
      });
    },
    deleteTicket: function deleteTicket(id) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.axios.delete('tickets/' + id).then(function () {
          return resolve();
        }).catch(function (error) {
          return reject(error);
        });
      });
    },
    create: function create() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var dataTicket, formId, dataStock;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                dataTicket = _this8.prepareFormTicket();
                _context2.next = 4;
                return _this8.submitTicket('create', dataTicket);

              case 4:
                formId = _context2.sent;

                _this8.setFormId(formId);
                dataStock = _this8.prepareFormStock();
                _context2.next = 9;
                return _this8.submitStock(dataStock);

              case 9:
                _this8.redirect();
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](0);

                _this8.handleSubmitError(_context2.t0);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[0, 12]]);
      }))();
    },
    update: function update() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var dataTicket, dataStock;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                dataTicket = _this9.prepareFormTicket();
                _context3.next = 4;
                return _this9.submitTicket('update', dataTicket);

              case 4:
                if (!_this9.form.file) {
                  _context3.next = 8;
                  break;
                }

                dataStock = _this9.prepareFormStock();
                _context3.next = 8;
                return _this9.submitStock(dataStock);

              case 8:

                _this9.redirect();
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](0);

                _this9.handleSubmitError(_context3.t0);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this9, [[0, 11]]);
      }))();
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    downloadTemplate: function downloadTemplate() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = __WEBPACK_IMPORTED_MODULE_9__config__["i" /* default */] + '/ticketItems/export';

                _this10.axios.get(url, { responseType: 'blob' }).then(function (response) {
                  var href = URL.createObjectURL(response.data);
                  var link = document.createElement('a');
                  link.href = href;
                  link.setAttribute('download', 'Inventory Ticket.csv');
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  URL.revokeObjectURL(href);
                }).catch(function (error) {
                  console.error('[downloadTemplate]', error);
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    setTitle: function setTitle() {
      if (!this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Edit Explore Inventory';
      } else if (!this.isCreate && this.params.flaging === 'tour') {
        this.title = 'Edit Tour Inventory';
      } else if (this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Add New Explore Inventory';
      } else {
        this.title = 'Add New Tour Inventory';
      }
    },
    init: function init() {
      this.params.flaging = this.$route.query.flaging || null;
      this.setTitle();
      if (!this.isCreate) {
        this.fetch();
      }
    }
  },

  created: function created() {
    this.init();
  },
  mounted: function mounted() {
    var _this11 = this;

    __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this11.show.gallery = false;
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Pagination__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InventoryIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      isLoading: true,
      isInitial: true,
      items: [],
      pagination: {},
      params: {
        flaging: null,
        name: null,
        page: null
      }
    };
  },


  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setQuery();

              case 2:
                _context.next = 4;
                return _this.fetch();

              case 4:
                if (!_this.params.flaging) {
                  _this.params.flaging = 'explore';
                }
                _this.isInitial = false;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetch: function fetch() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.isLoading = true;
      if (page) this.params.page = page || null;

      var getParams = {
        type_product: this.params.flaging,
        name: this.params.name,
        page: this.params.page
      };

      this.axios.get('/tickets', { params: getParams }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        var isEmpty = !data && meta.pagination.current_page > meta.pagination.total_pages;
        _this2.items = !isEmpty ? data : [];
        _this2.pagination = !isEmpty ? meta.pagination : {};
        _this2.isLoading = false;
        _this2.setPushState();
      });
    },


    onInput: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    setQuery: function setQuery() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.params.flaging = _this3.$route.query.flaging || null;
        _this3.params.name = _this3.$route.query.name || null;
        _this3.params.page = _this3.$route.query.page || null;

        resolve();
      });
    },
    generateQuery: function generateQuery(params) {
      var _this4 = this;

      if (!params) return null;

      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
        return params[key];
      }).map(function (key) {
        return key + '=' + _this4.params[key];
      });

      return query ? '?' + query.join('&') : null;
    },
    setPushState: function setPushState() {
      var title = 'Inventory page ' + this.params.page;
      var paramUrl = '/inventory';
      var parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, '' + paramUrl + parameters);
    },
    changeFlag: function changeFlag() {
      if (this.params.flaging === 'explore') {
        this.params.flaging = 'tour';
      } else {
        this.params.flaging = 'explore';
      }
      this.params.name = null;
      this.params.page = null;
      this.fetch();
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'inventory-create',
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'inventory-edit',
        params: { id: id },
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      });
    },
    view: function view(id) {
      this.$router.push({
        name: 'inventory-view',
        params: { id: id },
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      });
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InventoryView',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      title: 'Loading Ticket..',
      params: {
        flaging: null
      },
      inventorys: [],
      pagination: {},

      inventory: {
        id: null,
        name: null,
        unique_code: null,
        validity_date_from: null,
        validity_date_to: null,
        is_booked: null,
        booked_atTime: null,
        booked_atValid: null,
        is_sold: null,
        sold_atTime: null,
        sold_atValid: null
      }
    };
  },


  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = page || this.$route.query.page;

      var params = {
        page: pageQuery
      };

      this.axios.get('/ticketItems/' + this.$route.params.id, { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          return;
        }

        _this.inventorys = data;
        _this.pagination = meta.pagination;
      });

      if (pageQuery) {
        window.history.pushState('Inventorys page: ' + pageQuery, null, '/inventory/' + this.$route.params.id + '?flaging=' + this.params.flaging + '?page=' + pageQuery);
      }
    },
    fetchTicket: function fetchTicket() {
      var _this2 = this;

      this.axios.get('/tickets/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;

        _this2.title = data.name;
      });
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'inventory-create'
      });
    },
    view: function view(id) {
      this.$router.push({
        name: 'inventory-view',
        params: { id: id }
      });
    }
  },

  created: function created() {
    this.params.flaging = this.$route.query.flaging || null;
    this.fetchTicket();
    this.fetch();
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      credentials: {
        email: null,
        password: null
      },
      errorMessage: null
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.axios.post('/auth/login', __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(this.credentials)).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
          var token, claims;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  token = response.data.token;
                  claims = _this.parseJwt(token);


                  _this.$store.commit('SET_TOKEN', token);
                  _this.$store.commit('SET_USER', claims);

                  // Save to local storage as well
                  if (window.localStorage) {
                    window.localStorage.setItem('token', token);
                  }
                  _this.$router.push('/dashboard');

                case 6:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (error) {
        if (error.response) {
          _this.errorMessage = error.response.data.errors;
        }
      });
    }
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      credentials: {
        email: null
      },
      errorMessage: null
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.axios.post('/auth/password/email', qs.stringify(this.credentials)).then(function (response) {
        console.log('Success', response.data);
        _this.credentials.email = null;
        _this.$swal('Success', 'Reset link has been sent to your email.', 'success');
      }).catch(function (error) {
        console.log('Error', error.response.data.errors);
        _this.$swal('Error', error.response.data.errors, 'error');
      });
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      password: null,
      errorMessage: null,
      isInvalid: false,
      inputType: 'password',
      showPassword: false
    };
  },

  methods: {
    check: function check() {
      var _this = this;

      this.axios.get('/auth/password/reset?email=' + this.$route.query.email + '&token=' + this.$route.query.token).then(function (response) {
        console.log(response);
      }).catch(function (error) {
        console.log(error.response.data.errors);
        // console.log(error.response.status);

        _this.isInvalid = true;
        _this.errorMessage = error.response.data.errors;
        setTimeout(function () {
          _this.$router.push('/login');
        }, 5000);
      });
    },
    reset: function reset() {
      var _this2 = this;

      var credentials = {
        email: this.$route.query.email,
        token: this.$route.query.token,
        password: this.password
      };

      this.axios.post('/auth/password/reset', qs.stringify(credentials)).then(function (response) {
        _this2.$swal({
          title: 'Success',
          text: 'Your password sucessfully changed.',
          type: 'success',
          onClose: function onClose() {
            _this2.$router.push('/login');
          }
        });

        console.log(response);
      }).catch(function (error) {
        _this2.$swal('Error', error.response.data.errors, 'error');
        console.log(error.response.data.errors);
      });
    },
    togglePassword: function togglePassword() {
      console.log('Klik password');
      this.showPassword = !this.showPassword;
      this.inputType = this.inputType === 'password' ? 'text' : 'password';
      console.log(this.inputType);
      this.$refs.password.setAttribute('type', this.inputType);
    }
  },
  created: function created() {
    this.check();
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_common_FileGallery__ = __webpack_require__(16);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MoodForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Add new Mood',

      form: {
        id: null,
        name: null,
        slug: null,
        image: {
          id: null,
          url: null
        }
      },

      show: {
        gallery: false
      },

      error: null
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_5__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.axios.get('/moods/' + _this.$route.params.id).then(function (response) {
                  var data = response.data.data;


                  _this.form.id = data.id;
                  _this.form.name = data.name;
                  _this.form.slug = data.slug;
                  _this.form.image.id = data.image_id;
                  _this.form.image.url = data.image_url;
                }).catch(function (error) {
                  if (error.response) {
                    _this.error = error.response.data.errors;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.slug) {
        this.$swal('Slug required', 'Please fill slug to continue', 'warning');
        return false;
      }

      if (!this.form.image.id || !this.form.image.url) {
        this.$swal('Image required', 'Please select image to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this2 = this;

      var data = {
        name: this.form.name,
        slug: this.form.slug,
        image: this.form.image.id
      };

      this.axios.post('/moods', this.stringify(data)).then(function () {
        _this2.$router.push({ name: 'mood-index' });
      }).catch(function (error) {
        if (error.response) {
          _this2.error = error.response.data.errors;
        }

        if (error) {
          _this2.$swal({
            title: 'Create Failed!',
            text: 'Failed to create new Mood',
            type: 'warning',
            timer: 3000
          });
        }
      });
    },
    update: function update() {
      var _this3 = this;

      var data = {
        id: this.form.id,
        name: this.form.name,
        slug: this.form.slug,
        image: this.form.image.id
      };

      this.axios.put('/moods/' + this.form.id, this.stringify(data)).then(function () {
        _this3.$router.push({ name: 'mood-index' });
      }).catch(function (error) {
        if (error.response) {
          _this3.error = error.response.data.errors;
        }

        if (error) {
          _this3.$swal({
            title: 'Update Failed!',
            text: 'Failed to update ' + _this3.form.name,
            type: 'warning',
            timer: 3000
          });
        }
      });
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage: function setImage(payload) {
      this.form.image = payload.images;
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Mood';
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_2__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this4.show.gallery = false;
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_2__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MoodIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      moods: [],
      pagination: {}
    };
  },


  methods: {
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;

      var params = {
        page: page || pageQuery
      };

      this.axios.get('/moods', { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          return;
        }

        _this.moods = data;
        _this.pagination = meta.pagination;
      });

      if (page) {
        window.history.pushState('Categories page: ' + page, null, '/categories?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'mood-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'mood-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(mood) {
      var _this2 = this;

      this.axios.delete('/moods/' + mood.id).then(function () {
        _this2.fetch();

        _this2.$swal({
          title: 'Deleted',
          text: mood.name + ' has been deleted.',
          type: 'success',
          timer: 3000
        });
      });
    },
    remove: function remove(mood) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting Mood',
        text: 'Are you sure you want to delete ' + mood.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this3.delete(mood);
        } else {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }
      });
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotFound'
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_spinner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__riophae_vue_treeselect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__riophae_vue_treeselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modules_common_Ckeditor__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modules_common_ContentHeader__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modules_common_Box__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__partials_Quickjump__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__partials_LanguageTabs__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__partials_LanguageTab__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__partials_ModalTags__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__partials_ModalMoods__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__partials_ModalCategories__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__partials_ModalDestinations__ = __webpack_require__(634);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








 // eslint-disable-line no-unused-vars















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create Product',
      videoExtensions: ['.mp4', '.webm'],
      breadcrumbs: [{
        name: 'Products',
        link: 'product-index'
      }],

      params: {
        flaging: null
      },

      status_product: null,
      vselect_disabled: false,
      isLoading: true,
      isSubmitting: false,
      isHidden: false,
      error: null,
      klookLoading: false,

      form: {
        id: null,
        name: null,
        name_en: null,
        slug: null,

        vendor: null,
        merchant: null,
        product_code: null,

        categories: null,
        destinations: null,
        type: {
          label: 'Domestic',
          value: 'domestic'
        },

        condition: {
          label: 'No need specific condition',
          value: 0
        },
        with_adult_is_must: 0,
        print_voucher: 0,

        has_criteria: true,
        open_date: 1,
        fixed_date: 0,
        valid_from: null,
        valid_to: null,

        has_booking_duration: false,
        booking_duration: 0,
        booking_duration_unit: 'days',

        has_travel_duration: false,
        travel_duration: 0,
        travel_duration_unit: {
          label: 'day',
          value: 'day'
        },

        tags: null,

        gallery: null,
        image: {
          id: null,
          url: null
        },
        image_apps: {
          id: null,
          url: null
        },

        booking: {
          buff_period: null,
          is_open_trip: false,
          start_time: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          end_time: {
            HH: '23',
            mm: '59',
            ss: '59'
          },
          bookingDate: [{
            from: null,
            to: null
          }],
          travelDate: [{
            from: null,
            to: null
          }],
          packages: [{
            id: null,
            sku_id: null,
            sku_title: null,
            name_en: null,
            name: null,
            multiply: 1,
            description: null,
            description_en: null,
            age_max: 0,
            ticket: null,
            min_person: null,
            max_person: null,
            type: null,
            travel_date: [{
              from: null,
              to: null
            }],
            prices: [{
              id: null,
              base_cost: null,
              block_cost: {
                type: 0,
                value: null
              },
              min_qty: 1,
              start_from: 1,
              source_price: null,
              exchange_rate: null,
              currency: null,
              price_per_type: 'pax',
              price_per_type_en: 'pax',
              gimmick_price: null
            }]
          }]
        },

        booking_tour: {
          bookingOption: '0',
          bookingDuration: null,
          bookingDate: [{
            from: null,
            to: null
          }],
          travelDate: [{
            from: null,
            to: null
          }],
          start_time: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          end_time: {
            HH: '23',
            mm: '59',
            ss: '59'
          }
        },

        sequence: null,
        badges: null,

        tabs: [{
          title: 'Informasi',
          title_en: 'Information',
          description: null,
          description_en: null
        }, {
          title: 'Harga Termasuk',
          title_en: 'Price Includes',
          description: null,
          description_en: null
        }, {
          title: 'Harga Tidak Termasuk',
          title_en: 'Price Excludes',
          description: null,
          description_en: null
        }, {
          title: 'Syarat dan Ketentuan',
          title_en: 'Term and Conditions',
          description: null,
          description_en: null
        }],

        vouchers: [],
        visibility: true,
        is_publish: true,
        hide_breadcrumbs: false,
        hide_searchbar: false,
        hide_recommendation: false,
        ticket_image: {
          id: null,
          url: null
        }
      },

      exchange: {
        rate: null,
        currency: null
      },

      optionForm: {
        categories: {
          name: null,
          name_en: null,
          slug: null,
          image: {
            id: null,
            url: null
          }
        },

        destinations: {
          name: null,
          slug: null,
          parent: null,
          image: {
            id: null,
            url: null
          }
        }
      },

      list: {
        flatDestinations: [],
        destinations: [],
        categories: [],
        tags: [],
        vendors: [],
        merchants: [],
        tickets: [],
        region: [{
          label: 'Domestic',
          value: 'domestic'
        }, {
          label: 'International',
          value: 'international'
        }],
        type: [{
          label: 'Anak-anak',
          value: 'children'
        }, {
          label: 'Dewasa',
          value: 'adult'
        }, {
          label: 'Senior',
          value: 'senior'
        }],
        condition: [{
          label: 'No need specific condition',
          value: 0
        }, {
          label: 'With adult is a must',
          value: 1
        }],

        travel_duration_unit: [{
          label: 'day',
          value: 'day'
        }, {
          label: 'week',
          value: 'week'
        }, {
          label: 'month',
          value: 'month'
        }]
      },

      destinationListUpdated: false,
      hasStartFrom: 0,

      show: {
        gallery: false,
        featured: false,
        featured_apps: false,
        categories: false,
        destinations: false,
        tags: false,
        ticket_image: false
      },

      configs: {
        datepicker: {
          disabled: {
            to: __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'd').toDate()
          }
        },

        ckeditor: {
          toolbar: [{
            name: 'basicstyles',
            items: ['Styles', 'Format', '-', 'Bold', 'Italic', 'Strike', '-', 'NumberedList', 'BulletedList', '-', 'Source']
          }, {
            name: 'links',
            items: ['Link', 'Unlink', 'Anchor']
          }],
          height: 200,
          extraPlugins: 'uploadimage',
          uploadUrl: '/static/temp/'
        }
      },

      passRoute: {
        name: 'product-index-page',
        params: { page: 1 },
        query: null
      }
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    isKlook: function isKlook() {
      return this.form.vendor && this.form.vendor.label === 'Klook';
    }
  },

  components: {
    Box: __WEBPACK_IMPORTED_MODULE_20__components_modules_common_Box__["a" /* default */],
    Ckeditor: __WEBPACK_IMPORTED_MODULE_17__components_modules_common_Ckeditor__["a" /* default */],
    ContentHeader: __WEBPACK_IMPORTED_MODULE_19__components_modules_common_ContentHeader__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker___default.a,
    FileGallery: __WEBPACK_IMPORTED_MODULE_18__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_16__components_modules_common_Modal__["a" /* default */],
    ModalCategories: __WEBPACK_IMPORTED_MODULE_26__partials_ModalCategories__["a" /* default */],
    ModalDestinations: __WEBPACK_IMPORTED_MODULE_27__partials_ModalDestinations__["a" /* default */],
    ModalMoods: __WEBPACK_IMPORTED_MODULE_25__partials_ModalMoods__["a" /* default */],
    ModalTags: __WEBPACK_IMPORTED_MODULE_24__partials_ModalTags__["a" /* default */],
    ProgressLoader: __WEBPACK_IMPORTED_MODULE_9_vue_loading_spinner__["a" /* Circle */],
    Quickjump: __WEBPACK_IMPORTED_MODULE_21__partials_Quickjump__["a" /* default */],
    Tab: __WEBPACK_IMPORTED_MODULE_23__partials_LanguageTab__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_22__partials_LanguageTabs__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_12__riophae_vue_treeselect__["Treeselect"],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker___default.a
  },

  filters: {
    pluralDays: function pluralDays(number) {
      var num = parseInt(number, 10);
      if (!num) return 'Day';
      if (num > 1) return 'Days';
      return 'Day';
    }
  },
  watch: {
    'form.type': function formType() {
      this.fetchDestination();
    }
  },
  methods: {
    fetchItem: function fetchItem(type) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        var itemParams = {
          perpage: 5000,
          type_product: null
        };
        if (type === 'tickets') {
          itemParams.type_product = _this.params.flaging;
        }

        var enpoint = type;
        if (type === 'tickets') {
          enpoint = 'tickets-only';
        }

        _this.axios.get('/' + enpoint, { params: itemParams }).then(function (response) {
          var data = response.data.data;

          if (!data) data = [];
          var results = data.map(function (item) {
            return { label: item.name, value: item.id };
          });
          _this.list[type] = results;
          resolve(data);
        }).catch(function (error) {
          console.log('Fetch ' + type + ' error', error);

          if (error.response) {
            _this.error = error.response.data.errors;
          }

          if (error) {
            _this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available ' + type,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this.fetchItem(type);
              }
            });
          }
        });
      });
    },
    flattenDestinations: function flattenDestinations(data) {
      var result = [];
      var dataChild = [];
      if (this.form.type.value === 'domestic') {
        dataChild = data[0].child;
      } else {
        dataChild = data[1].child;
      }
      if (!data) return result;

      dataChild.forEach(function (parent) {
        result.push({
          id: parent.id,
          label: parent.name
        });
        if (parent.child) {
          parent.child.forEach(function (child) {
            result.push({
              id: child.id,
              label: child.name
            });
            if (child.child) {
              child.child.forEach(function (grandchild) {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name
                });
              });
            }
          });
        }
      });

      return __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default()(result);
    },
    levelDestinations: function levelDestinations(data) {
      if (!data) return [];
      var dataChild = [];
      if (this.form.type.value === 'domestic') {
        dataChild = data[0].child;
      } else {
        dataChild = data[1].child;
      }
      return dataChild.map(function (local) {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map(function (parent) {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  children: parent.child.map(function (child) {
                    return {
                      id: child.id,
                      label: child.name
                    };
                  })
                };
              }

              return {
                id: parent.id,
                label: parent.name
              };
            })
          };
        }

        return {
          id: local.id,
          label: local.name
        };
      });
    },
    fetchDestination: function fetchDestination() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.fetchItem('destinations');

              case 2:
                destinations = _context.sent;
                _context.next = 5;
                return _this2.levelDestinations(destinations);

              case 5:
                _this2.list.destinations = _context.sent;
                _context.next = 8;
                return _this2.flattenDestinations(destinations);

              case 8:
                _this2.list.flatDestinations = _context.sent;

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    isArray: function isArray(array) {
      return Array.isArray(array);
    },
    setContentTabs: function setContentTabs(tabs) {
      if (!tabs) {
        return [{
          title: null,
          title_en: null,
          description: null,
          description_en: null
        }];
      }

      return tabs;
    },
    setContentPackages: function setContentPackages(packages) {
      var _this3 = this;

      if (!packages) {
        var emptyDate = [{
          from: null,
          to: null
        }];

        return [{
          sku_id: null,
          name: null,
          name_en: null,
          multiply: 1,
          description: null,
          description_en: null,
          age_max: 0,
          min_person: null,
          max_person: null,
          ticket: null,
          type: null,
          travel_date: !this.isKlook ? null : emptyDate,
          prices: [{
            base_cost: null,
            block_cost: {
              type: 0,
              value: null
            },
            min_qty: 1,
            start_from: 1,
            source_price: null,
            exchange_rate: null,
            currency: null,
            price_per_type: 'pax',
            price_per_type_en: 'pax'
          }]
        }];
      }

      packages.forEach(function (item) {
        item.ticket = _this3.mapValue(item.ticket.id, 'tickets');
        item.type = _this3.mapValue(item.type, 'type');

        // Fallback for Klook product with empty travel dates
        if (!item.travel_date) {
          item.travel_date = [{
            from: null,
            to: null
          }];
        }

        // Fallback for empty unit title
        if (item.prices) {
          item.prices.forEach(function (price) {
            if (price.block_cost_percentage === 0) {
              price.block_cost = {
                type: 1,
                value: price.block_cost
              };
            } else {
              price.block_cost = {
                type: 0,
                value: price.block_cost_percentage
              };
            }

            if (!price.price_per_type) {
              price.price_per_type = 'pax';
            }

            if (!price.price_per_type_en) {
              price.price_per_type_en = 'pax';
            }
          });
        }
      });

      return packages;
    },
    parseDate: function parseDate(data) {
      if (!data || data === 'null') {
        return [{
          from: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format(this.config.date.iso),
          to: __WEBPACK_IMPORTED_MODULE_6_moment___default()().format(this.config.date.iso)
        }];
      }

      return JSON.parse(data);
    },
    compareMultiple: function compareMultiple(data, options, returnAsArray, selector) {
      var _this4 = this;

      var array = [];

      if (!Array.isArray(data)) {
        return array;
      }

      data.forEach(function (selected) {
        _this4.list[options].forEach(function (item) {
          if (item[selector] === selected.id) {
            array.push(item);
          }
        });
      });

      return array;
    },
    compareSingle: function compareSingle(data, options, returnAsArray, selector) {
      var value = returnAsArray ? [] : null;

      this.list[options].forEach(function (item) {
        if (item[selector] === data) {
          value = item;
        }
      });

      return value;
    },
    fullStartTime: function fullStartTime(startTime) {
      return startTime.HH + ':' + startTime.mm + ':' + startTime.ss;
    },
    fullEndTime: function fullEndTime(endTime) {
      return endTime.HH + ':' + endTime.mm + ':' + endTime.ss;
    },


    /**
     * [mapValue description]
     * @param  {[Object, Array]}   data          [description]
     * @param  {Array}             options       [description]
     * @param  {Boolean}           returnAsArray [description]
     * @param  {String}            selector      [description]
     * @return {[Object, Array]}
     */
    mapValue: function mapValue(data, options) {
      var returnAsArray = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var selector = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'value';

      if (this.isArray(data)) {
        return this.compareMultiple(data, options, returnAsArray, selector);
      }

      return this.compareSingle(data, options, returnAsArray, selector);
    },
    setTime: function setTime(dataTime, dataIfNull) {
      var time = dataTime || dataIfNull;
      var timeSplit = time.split(':');

      var timeFull = {
        HH: timeSplit[0],
        mm: timeSplit[1],
        ss: timeSplit[2]
      };

      return timeFull;
    },
    getLabelValueItem: function getLabelValueItem(dataArray) {
      if (!dataArray) return [];

      var dataList = [];
      dataArray.map(function (data) {
        return dataList.push({
          value: data.badge_id,
          label: data.badge_name
        });
      });
      return dataList.filter(function (data) {
        return !!data.label;
      });
    },
    setFormValue: function setFormValue(data) {
      this.form.id = data.id;
      this.form.slug = data.slug;
      this.form.is_publish = data.is_publish;

      // Title
      this.form.name = data.name;
      this.form.name_en = data.name_en;

      // Details
      this.form.type = this.mapValue(data.type, 'region');
      var valueDestinations = data.destinations.filter(function (l) {
        return !data.destinations.find(function (val) {
          return l.id === val.parent_id;
        });
      }).map(function (l) {
        return l.id;
      });
      this.form.destinations = valueDestinations;
      this.form.categories = this.mapValue(data.categories, 'categories');
      this.form.tags = this.mapValue(data.tags, 'tags', true);

      // Tags
      this.form.tags.can_be_canceled = data.can_be_canceled ? 0 : 1;
      this.form.tags.changed_voucher = data.changed_voucher ? 1 : 0;
      this.form.tags.duration_1_day = data.duration_1_day ? 1 : 0;
      this.form.tags.duration_2_day = data.duration_2_day ? 1 : 0;
      this.form.tags.require_confirmation = data.require_confirmation ? 1 : 0;
      // this.form.tags.is_fixed_date = data.is_fixed_date ? 1 : 0;
      // this.form.tags.is_open_date = data.is_open_date ? 1 : 0;
      // this.form.tags.calendar_display = data.calendar_display;

      // Conditions
      this.form.condition = this.mapValue(data.with_adult_is_must, 'condition');
      this.form.with_adult_is_must = data.with_adult_is_must;
      this.form.print_voucher = data.print_voucher ? 1 : 0;

      // Source
      this.form.merchant = this.mapValue(data.merchant_id, 'merchants');
      this.form.vendor = this.mapValue(data.vendor_id, 'vendors');
      this.form.product_code = data.product_code;

      // Bookings
      if (this.params.flaging === 'explore') {
        this.form.has_criteria = data.open_date === 1;
        this.form.open_date = data.open_date;
        this.form.fixed_date = data.fixed_date;
        this.form.valid_from = data.valid_from ? new Date(data.valid_from) : new Date();
        this.form.valid_to = data.valid_to ? new Date(data.valid_to) : new Date();
        this.form.booking.bookingDate = this.parseDate(data.booking_date);
        this.form.booking.travelDate = this.parseDate(data.travel_date);
        this.form.has_booking_duration = data.is_booking_duration === 1;
        this.form.has_travel_duration = data.is_travel_duration === 1;
        this.form.travel_duration = data.travel_duration;
        this.form.booking_duration = data.booking_duration;
        this.form.travel_duration_unit = this.mapValue(data.travel_duration_unit, 'travel_duration_unit');
        this.form.booking.start_time = this.setTime(data.start_time, '00:00:00');
        this.form.booking.end_time = this.setTime(data.end_time, '23:59:59');
        // this.form.require_confirmation = data.require_confirmation;
      } else {
        this.form.booking_tour.bookingOption = data.is_open_trip;
        this.form.booking_tour.bookingDuration = data.booking_duration.toString();
        this.form.booking_tour.bookingDate = this.parseDate(data.booking_date);
        this.form.booking_tour.travelDate = this.parseDate(data.travel_date);
        this.form.booking_tour.start_time = this.setTime(data.start_time, '00:00:00');
        this.form.booking_tour.end_time = this.setTime(data.end_time, '23:59:59');
      }

      // Package Section
      this.form.booking.packages = this.setContentPackages(data.prices);

      // Sequence and Badge
      this.form.sequence = data.sequence;
      this.form.badges = this.getLabelValueItem(data.badges);

      // Contents
      this.form.tabs = this.setContentTabs(data.tabs);

      // Content on E-Voucher
      if (this.params.flaging === 'explore') {
        this.form.vouchers[0].title = 'Instruksi Tiket';
        this.form.vouchers[0].title_en = 'Ticket Instruction';

        this.form.vouchers[1].title = 'Syarat dan Ketentuan';
        this.form.vouchers[1].title_en = 'Term and Conditions';
      } else {
        this.form.vouchers[0].title = 'Jadwal Perjalanan';
        this.form.vouchers[0].title_en = 'Itinerary';

        this.form.vouchers[1].title = 'Syarat dan Ketentuan';
        this.form.vouchers[1].title_en = 'Term and Conditions';
      }
      this.form.vouchers[0].description = data.how_to_use;
      this.form.vouchers[0].description_en = data.how_to_use_en;

      this.form.vouchers[1].description = data.terms_condition;
      this.form.vouchers[1].description_en = data.terms_condition_en;

      // Image & Gallery
      this.form.image.id = data.image_id;
      this.form.image.url = data.image_url;
      this.form.image_apps.id = data.image_apps_id;
      this.form.image_apps.url = data.image_apps_url;
      this.form.ticket_image.id = data.ticket_image_id;
      this.form.ticket_image.url = data.ticket_image_url;
      this.form.gallery = data.galleries;
      this.form.hide_breadcrumbs = data.hide_breadcrumbs;
      this.form.hide_searchbar = data.hide_searchbar;
      this.form.hide_recommendation = data.hide_recommendation;
    },
    fetchProduct: function fetchProduct() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        var route = _this5.getApiRoute();
        _this5.axios.get(route + '/' + _this5.$route.params.id).then(function (response) {
          var data = response.data.data;

          // Data

          _this5.setFormValue(data);
          _this5.status_product = data.status_product;

          // State
          _this5.isLoading = false;
          _this5.checkStartFrom();

          if (_this5.status_product === 'Need Revision') {
            _this5.disableAllInput();
          }

          resolve();
        }).catch(function (error) {
          console.log('Fetch product error', error);

          if (error.response) {
            _this5.error = error.response.data.errors;
          }

          if (error) {
            _this5.$swal({
              title: 'Failed',
              text: 'Failed to fetch product data',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this5.fetchProduct();
              }
            });
          }
        });
      });
    },
    disableAllInput: function disableAllInput() {
      var _this6 = this;

      setTimeout(function () {
        _this6.vselect_disabled = true;
        var form = document.getElementById('product_id');
        var tags = ['input', 'button', 'select', 'textarea'];
        tags.forEach(function (tag) {
          var inputs = form.getElementsByTagName(tag);

          for (var i = 0; i < inputs.length; i += 1) {
            inputs[i].disabled = true;
          }
        });
      });
    },
    fetchAll: function fetchAll() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this7.fetchDestination();

              case 2:
                _context2.next = 4;
                return _this7.fetchItem('categories');

              case 4:
                _context2.next = 6;
                return _this7.fetchItem('tags');

              case 6:
                _context2.next = 8;
                return _this7.fetchItem('vendors');

              case 8:
                _context2.next = 10;
                return _this7.fetchItem('merchants');

              case 10:
                _context2.next = 12;
                return _this7.fetchItem('tags');

              case 12:
                _context2.next = 14;
                return _this7.fetchItem('tickets');

              case 14:
                if (_this7.isCreate) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return _this7.fetchProduct();

              case 17:
                _context2.next = 20;
                break;

              case 19:
                _this7.isLoading = false;

              case 20:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    getKlookPackageDate: function getKlookPackageDate(index) {
      var date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(1, 'd').format('YYYY-MM-DD');

      var travelDate = this.form.booking.packages[index].travel_date;
      var firstTravelDate = travelDate[0];
      var lastTravelDate = travelDate[travelDate.length - 1];

      if (travelDate.length > 1 && lastTravelDate.to) {
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(lastTravelDate.to).format('YYYY-MM-DD');
      } else if (firstTravelDate.to) {
        date = __WEBPACK_IMPORTED_MODULE_6_moment___default()(firstTravelDate.to).format('YYYY-MM-DD');
      }

      return date;
    },
    fetchKlookPrice: function fetchKlookPrice(skuId, index) {
      var _this8 = this;

      if (!skuId) return;

      this.klookLoading = true;

      var date = this.getKlookPackageDate(index);

      this.axios.get('/klook/price?product_id=' + this.form.product_code + '&sku_id=' + skuId + '&date=' + date).then(function (response) {
        var _response$data = response.data,
            price = _response$data.price,
            title = _response$data.title,
            rate = _response$data.rate,
            currency = _response$data.currency;


        _this8.form.booking.packages[index].sku_title = title;

        _this8.form.booking.packages[index].prices.forEach(function (item) {
          item.source_price = price;
          item.exchange_rate = rate;
          item.currency = currency;

          var total = rate * price;
          item.base_cost = Math.ceil(total.toFixed(2));
        });

        _this8.klookLoading = false;
      }).catch(function (error) {
        console.log('Fetch Klook price error', error);
        _this8.klookLoading = false;
      });
    },
    resetFormOptions: function resetFormOptions() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this9.optionForm.categories.name = null;
        _this9.optionForm.categories.name_en = null;
        _this9.optionForm.categories.slug = null;
        _this9.optionForm.categories.image = {
          id: null,
          url: null
        };

        _this9.optionForm.destinations.name = null;
        _this9.optionForm.destinations.slug = null;
        _this9.optionForm.destinations.parent = null;
        _this9.optionForm.destinations.image = {
          id: null,
          url: null
        };

        resolve();
      });
    },
    addOption: function addOption(type) {
      var _this10 = this;

      var data = void 0;

      if (type === 'categories') {
        data = {
          name: this.optionForm.categories.name,
          name_en: this.optionForm.categories.name_en,
          slug: this.optionForm.categories.slug,
          image: parseInt(this.optionForm.categories.image.id, 10)
        };
      }

      if (type === 'destinations') {
        data = {
          name: this.optionForm.destinations.name,
          slug: this.optionForm.destinations.slug,
          parent_id: parseInt(this.optionForm.destinations.parent.id, 10),
          image: parseInt(this.optionForm.destinations.image.id, 10)
        };
      }

      this.axios.post('/' + type, this.stringify(data)).then(function () {
        if (type === 'destinations') {
          _this10.list.destinations = null;

          _this10.$nextTick(function () {
            _this10.fetchDestination();
            _this10.resetFormOptions();
            _this10.closeModals();
          });
        } else {
          _this10.fetchItem(type);
          _this10.resetFormOptions();
          _this10.closeModals();
        }
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this10.error = error.response.data.errors;
        }

        if (error) {
          _this10.$swal({
            title: 'Create Failed!',
            text: 'Failed to create new ' + type,
            type: 'warning',
            timer: 3000
          });
        }
      });
    },
    setPriceStartFrom: function setPriceStartFrom(index, priceIndex) {
      var _this11 = this;

      this.form.booking.packages.map(function (vpackage, ipackage) {
        _this11.form.booking.packages[ipackage].prices.map(function (price) {
          price.start_from = 0;
          return true;
        });
        return true;
      });
      this.form.booking.packages[index].prices[priceIndex].start_from = 1;
    },
    addItem: function addItem(type, index) {
      if (type === 'package') {
        this.form.booking.packages.push({
          sku_id: null,
          sku_title: null,
          name: null,
          name_en: null,
          multiply: 1,
          description: null,
          description_en: null,
          age_max: 0,
          ticket: null,
          max_person: null,
          min_person: null,
          type: null,
          travel_date: [{
            from: null,
            to: null
          }],
          prices: [{
            base_cost: null,
            block_cost: {
              type: 0,
              value: null
            },
            min_qty: 1,
            start_from: 0,
            source_price: null,
            exchange_rate: null,
            currency: null,
            price_per_type: 'pax',
            price_per_type_en: 'pax',
            gimmick_price: null
          }]
        });
      }

      if (type === 'price') {
        this.form.booking.packages[index].prices.push({
          base_cost: null,
          block_cost: {
            type: 0,
            value: null
          },
          min_qty: 1,
          start_from: 0,
          source_price: null,
          exchange_rate: null,
          currency: null,
          price_per_type: 'pax',
          price_per_type_en: 'pax',
          gimmick_price: null
        });
        if (this.isKlook) {
          this.fetchKlookPrice(this.form.booking.packages[index].sku_id, index);
        }
      }

      var booking = null;
      if (this.params.flaging === 'explore') {
        booking = this.form.booking;
      } else {
        booking = this.form.booking_tour;
      }

      if (type === 'booking') {
        booking.bookingDate.push({
          from: null,
          to: null
        });
      }

      if (type === 'travel') {
        booking.travelDate.push({
          from: null,
          to: null
        });
      }

      if (type === 'klook-travel') {
        booking.packages[index].travel_date.push({
          from: null,
          to: null
        });
      }
    },
    removeItem: function removeItem(item, object, itemIndex) {
      var _this12 = this;

      this.$swal({
        title: 'Delete Item',
        text: 'Are you sure to delete this item?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result.value) {
          if (object === 'packages') {
            var index = _this12.form.booking.packages.indexOf(item);
            _this12.form.booking.packages.splice(index, 1);
          } else if (object === 'price') {
            var _index = _this12.form.booking.packages.indexOf(item);
            _this12.form.booking.packages[_index].prices.splice(itemIndex, 1);
          } else if (object === 'booking') {
            var booking = null;
            if (_this12.params.flaging === 'explore') {
              booking = _this12.form.booking;
            } else {
              booking = _this12.form.booking_tour;
            }
            var _index2 = booking.bookingDate.indexOf(item);
            booking.bookingDate.splice(_index2, 1);
          } else if (object === 'travel') {
            var _booking = null;
            if (_this12.params.flaging === 'explore') {
              _booking = _this12.form.booking;
            } else {
              _booking = _this12.form.booking_tour;
            }
            var _index3 = _booking.travelDate.indexOf(item);
            _booking.travelDate.splice(_index3, 1);
          } else if (object === 'klook-travel') {
            var _index4 = _this12.form.booking.packages.indexOf(item);
            _this12.form.booking.packages[_index4].travel_date.splice(itemIndex, 1);
          } else {
            var _index5 = _this12.form[object].indexOf(item);
            _this12.form[object].splice(_index5, 1);
          }
        }
      });
    },
    publishRate: function publishRate(index, priceIndex) {
      var baseCost = this.form.booking.packages[index].prices[priceIndex].base_cost;
      var blockCost = this.form.booking.packages[index].prices[priceIndex].block_cost;
      if (!baseCost || !blockCost.value) return null;

      var price = 0;
      var baseCostInt = parseInt(baseCost, 10);
      var blockCostInt = parseInt(blockCost.value, 10);
      if (blockCost.type === 0) {
        price = baseCostInt + baseCostInt / 100 * blockCostInt;
      } else {
        price = baseCostInt + blockCostInt;
      }
      return __WEBPACK_IMPORTED_MODULE_7_numeral___default()(price).format('0,0');
    },
    setImage: function setImage(payload) {
      if (payload.target === 'featured') {
        this.form.image = payload.images;
      }

      if (payload.target === 'featured_apps') {
        this.form.image_apps = payload.images;
      }

      if (payload.target === 'gallery') {
        this.form.gallery = payload.images;
      }

      if (payload.target === 'category') {
        this.optionForm.categories.image = payload.images;
      }

      if (payload.target === 'destinations') {
        this.optionForm.destinations.image = payload.images;
      }

      if (payload.target === 'ticket_image') {
        this.form.ticket_image = payload.images;
      }

      // if (payload.target === 'logo') {
      //   this.form.logo = payload.images;
      // }

      // if (payload.target === 'moods') {
      //   this.optionForm.moods.image = payload.images;
      // }
    },
    getDisabledDate: function getDisabledDate(index, type) {
      var today = __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'd').toDate();
      var to = null;

      if (this.booking[type][index].to) {
        to = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.booking[type][index].to).toDate();
      }

      return {
        to: this.booking[type][index].to ? to : today
      };
    },
    loadOptions: function loadOptions(_ref) {
      var _this13 = this;

      var action = _ref.action;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(action === __WEBPACK_IMPORTED_MODULE_12__riophae_vue_treeselect__["LOAD_ROOT_OPTIONS"])) {
                  _context3.next = 5;
                  break;
                }

                if (!_this13.destinationListUpdated) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return _this13.fetchDestination();

              case 4:
                _this13.destinationListUpdated = false;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this13);
      }))();
    },
    checkUrl: function checkUrl(url) {
      if (!url) return '';
      var absoluteUrl = url.includes('https://') ? url : 'https://' + url;
      return absoluteUrl;
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    closeModals: function closeModals() {
      var _this14 = this;

      document.body.classList.remove('locked');
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.show).forEach(function (modal) {
        _this14.show[modal] = false;
      });
    },
    isBefore: function isBefore(dateBefore, dateAfter) {
      var fromBefore = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateBefore);
      var fromAfter = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateAfter);
      return fromBefore.isAfter(fromAfter, 'day');
    },
    validateForm: function validateForm() {
      /* eslint-disable camelcase */
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill product Name', 'warning');
        return false;
      }

      if (!this.form.name_en) {
        this.$swal('Name En required', 'Please fill product Name En', 'warning');
        return false;
      }

      // Detail Section
      if (!this.form.type) {
        this.$swal('Travel type required', 'Please select travel type', 'warning');
        return false;
      }

      if (!this.form.destinations || this.form.destinations.length < 1) {
        this.$swal('Destination required', 'Please select at least one destination', 'warning');
        return false;
      }
      if (this.form.destinations && this.form.destinations.length > 3) {
        this.$swal('Please update destinations', 'You can only choose one city as destinations', 'warning');
        return false;
      }

      if (!this.form.categories || this.form.categories.length < 1) {
        this.$swal('Categories required', 'Please select at least one category', 'warning');
        return false;
      }

      if (!this.form.tags || this.form.tags.length < 1) {
        this.$swal('Tags required', 'Please select at least one tag', 'warning');
        return false;
      }

      // Source Section
      if (!this.isKlook) {
        if (!this.form.merchant) {
          this.$swal('Merchant required', 'Please select merchant', 'warning');
          return false;
        }
      }

      if (!this.form.vendor) {
        this.$swal('Source required', 'Please select source', 'warning');
        return false;
      }

      if (this.isKlook) {
        if (!this.form.product_code) {
          this.$swal('Product code required', 'Please fill Klook product code', 'warning');
          return false;
        }
      }

      // Booking Section
      if (this.params.flaging === 'explore') {
        if (this.form.has_criteria) {
          var dateBetweenValidation = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.valid_to).isAfter(this.form.valid_from, 'day');
          if (!this.form.valid_from) {
            this.$swal('Booking Criteria required', 'Please fill Booking Criteria from', 'warning');
            return false;
          }
          if (!this.form.valid_to) {
            this.$swal('Booking Criteria required', 'Please fill Booking Criteria to', 'warning');
            return false;
          }
          if (!dateBetweenValidation) {
            this.$swal('Booking Criteria Invalid', '"Booking Criteria to" is before "Booking Criteria from"', 'warning');
            return false;
          }
        }

        if (this.form.is_booking_duration === 0) {
          for (var bI = 0; bI < this.form.booking.bookingDate.length; bI += 1) {
            var _form$booking$booking = this.form.booking.bookingDate[bI],
                from = _form$booking$booking.from,
                to = _form$booking$booking.to;

            var _dateBetweenValidation = __WEBPACK_IMPORTED_MODULE_6_moment___default()(to).isAfter(from, 'day');

            if (!from) {
              this.$swal('Booking Date required', 'Please fill Booking Date from', 'warning');
              return false;
            }

            if (!to) {
              this.$swal('Booking Date required', 'Please fill Booking Date to', 'warning');
              return false;
            }

            if (!_dateBetweenValidation) {
              this.$swal('Booking Date Invalid', '"Booking date to" is before "Booking date from"', 'warning');
              return false;
            }
          }
        }

        if (!this.isKlook) {
          for (var bD = 0; bD < this.form.booking.bookingDate.length; bD += 1) {
            var _form$booking$booking2 = this.form.booking.bookingDate[bD],
                _from = _form$booking$booking2.from,
                _to = _form$booking$booking2.to;

            var _dateBetweenValidation2 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_to).isSameOrAfter(_from, 'day');

            if (!_from) {
              this.$swal('Booking Date required', 'Please fill Booking Date from', 'warning');
              return false;
            }

            if (!_to) {
              this.$swal('Booking Date required', 'Please fill Booking Date to', 'warning');
              return false;
            }

            if (!_dateBetweenValidation2) {
              this.$swal('Booking Date Invalid', '"Booking date to" is before "Booking date from"', 'warning');
              return false;
            }
          }

          for (var _bI = 0; _bI < this.form.booking.travelDate.length; _bI += 1) {
            var _form$booking$travelD = this.form.booking.travelDate[_bI],
                _from2 = _form$booking$travelD.from,
                _to2 = _form$booking$travelD.to;

            var _dateBetweenValidation3 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_to2).isSameOrAfter(_from2, 'day');

            if (!_from2) {
              this.$swal('Travel Date required', 'Please fill Travel Date from', 'warning');
              return false;
            }

            if (!_to2) {
              this.$swal('Travel Date required', 'Please fill Travel Date to', 'warning');
              return false;
            }

            if (!_dateBetweenValidation3) {
              this.$swal('Travel Date Invalid', '"Travel date to" is before "Travel date from"', 'warning');
              return false;
            }
          }
        }

        if (this.form.has_travel_duration === true && this.form.travel_duration <= 0) {
          this.$swal('Travel duration must greater than 0');
          return false;
        }

        if (!this.isKlook) {
          for (var ii = 0; ii < this.form.booking.bookingDate.length; ii += 1) {
            if (this.form.booking.bookingDate.length - 1 !== ii) {
              var fromBefore = this.form.booking.bookingDate[ii].to;
              var fromAfter = this.form.booking.bookingDate[ii + 1].from;
              var isNotValid = this.isBefore(fromBefore, fromAfter);

              if (isNotValid) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust booking dates. Booking date before is larger than booking date after'
                });

                return false;
              }
            }
          }

          for (var it = 0; it < this.form.booking.travelDate.length; it += 1) {
            if (this.form.booking.travelDate.length - 1 !== it) {
              var _fromBefore = this.form.booking.travelDate[it].to;
              var _fromAfter = this.form.booking.travelDate[it + 1].from;
              var _isNotValid = this.isBefore(_fromBefore, _fromAfter);

              if (_isNotValid) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust travel dates. Travel date before is larger than travel date after'
                });

                return false;
              }
            }
          }
        }

        var startTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.fullStartTime(this.form.booking.start_time), 'HH:mm:ss');
        var endTime = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.fullEndTime(this.form.booking.end_time), 'HH:mm:ss');

        if (endTime.isBefore(startTime)) {
          this.$swal('Booking time invalid', 'Please choose correct end time to continue', 'warning');
          return false;
        }
      } else {
        if (!this.form.booking_tour.bookingDuration) {
          this.$swal('Booking Duration required', 'Please fill Booking Duration', 'warning');
          return false;
        }

        for (var _bD = 0; _bD < this.form.booking_tour.bookingDate.length; _bD += 1) {
          var _form$booking_tour$bo = this.form.booking_tour.bookingDate[_bD],
              _from3 = _form$booking_tour$bo.from,
              _to3 = _form$booking_tour$bo.to;

          var _dateBetweenValidation4 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_to3).isSameOrAfter(_from3, 'day');

          if (!_from3) {
            this.$swal('Booking Date required', 'Please fill Booking Date from', 'warning');
            return false;
          }

          if (!_to3) {
            this.$swal('Booking Date required', 'Please fill Booking Date to', 'warning');
            return false;
          }

          if (!_dateBetweenValidation4) {
            this.$swal('Booking Date Invalid', '"Booking date to" is before "Booking date from"', 'warning');
            return false;
          }
        }

        for (var _bI2 = 0; _bI2 < this.form.booking_tour.travelDate.length; _bI2 += 1) {
          var _form$booking_tour$tr = this.form.booking_tour.travelDate[_bI2],
              _from4 = _form$booking_tour$tr.from,
              _to4 = _form$booking_tour$tr.to;

          var _dateBetweenValidation5 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_to4).isSameOrAfter(_from4, 'day');

          if (!_from4) {
            this.$swal('Travel Date required', 'Please fill Travel Date from', 'warning');
            return false;
          }

          if (!_to4) {
            this.$swal('Travel Date required', 'Please fill Travel Date to', 'warning');
            return false;
          }

          if (!_dateBetweenValidation5) {
            this.$swal('Travel Date Invalid', '"Travel date to" is before "Travel date from"', 'warning');
            return false;
          }
        }
      }
      // Package Section
      for (var paI = 0; paI < this.form.booking.packages.length; paI += 1) {
        var _form$booking$package = this.form.booking.packages[paI],
            name = _form$booking$package.name,
            name_en = _form$booking$package.name_en,
            description = _form$booking$package.description,
            description_en = _form$booking$package.description_en,
            multiply = _form$booking$package.multiply,
            type = _form$booking$package.type,
            min_person = _form$booking$package.min_person,
            max_person = _form$booking$package.max_person,
            sku_id = _form$booking$package.sku_id,
            ticket = _form$booking$package.ticket,
            travel_date = _form$booking$package.travel_date;


        if (!name) {
          this.$swal('Package name required', 'Please fill package name', 'warning');
          return false;
        }

        if (!name_en) {
          this.$swal('Package name required', 'Please fill english package name', 'warning');
          return false;
        }

        if (!description) {
          this.$swal('Package description required', 'Please fill package description', 'warning');
          return false;
        }

        if (!description_en) {
          this.$swal('Package description required', 'Please fill english package description', 'warning');
          return false;
        }

        if (!multiply || multiply < 0) {
          this.$swal('Package multiplier required', 'Please set package multiplier', 'warning');
          return false;
        }

        if (!type) {
          this.$swal('Package type required', 'Please select package type', 'warning');
          return false;
        }

        if (!min_person || min_person < 0) {
          this.$swal('Package min person required', 'Please fill package min person', 'warning');
          return false;
        }

        if (!max_person || max_person < 0) {
          this.$swal('Package max person required', 'Please fill package max person', 'warning');
          return false;
        }

        if (parseInt(min_person, 10) > parseInt(max_person, 10)) {
          this.$swal('Package person Invalid', 'Min person is greater than max person', 'warning');
          return false;
        }

        if (!ticket && !this.isKlook) {
          this.$swal('Ticket inventory required', 'Please select ticket inventory', 'warning');
          return false;
        }

        if (this.isKlook) {
          if (!sku_id) {
            this.$swal('Package SKU ID required', 'Please fill package SKU ID', 'warning');
            return false;
          }

          for (var _bI3 = 0; _bI3 < travel_date.length; _bI3 += 1) {
            var _travel_date$_bI = travel_date[_bI3],
                _from5 = _travel_date$_bI.from,
                _to5 = _travel_date$_bI.to;

            var _dateBetweenValidation6 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_to5).isSameOrAfter(_from5, 'day');

            if (!_from5) {
              this.$swal('Travel Date required', 'Please fill Travel Date from', 'warning');
              return false;
            }

            if (!_to5) {
              this.$swal('Travel Date required', 'Please fill Travel Date to', 'warning');
              return false;
            }

            if (!_dateBetweenValidation6) {
              this.$swal('Travel Date Invalid', '"Travel date to" is before "Travel date from"', 'warning');
              return false;
            }
          }

          if (travel_date.length === this.form.booking.bookingDate.length) {
            for (var _bI4 = 0; _bI4 < travel_date.length; _bI4 += 1) {
              var bookingDateTo = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.booking.bookingDate[_bI4].to).format('YYYY-MM-DD');
              var bookingDateFrom = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.booking.bookingDate[_bI4].from).format('YYYY-MM-DD');
              var travelDateTo = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.booking.packages[paI].travel_date[_bI4].to).format('YYYY-MM-DD');
              var travelDateFrom = __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.booking.packages[paI].travel_date[_bI4].from).format('YYYY-MM-DD');
              var isSameTo = __WEBPACK_IMPORTED_MODULE_6_moment___default()(bookingDateTo).isSame(travelDateTo);
              var isSameFrom = __WEBPACK_IMPORTED_MODULE_6_moment___default()(bookingDateFrom).isSame(travelDateFrom);
              var isNotValidTo = this.isBefore(bookingDateTo, travelDateTo);
              var isNotValidFrom = this.isBefore(bookingDateFrom, travelDateFrom);

              if (isNotValidTo) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust booking dates. Travel date to is larger than booking date to'
                });

                return false;
              }

              if (isNotValidFrom) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust booking dates. Travel date from is larger than booking date from'
                });

                return false;
              }

              if (isSameFrom) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust travel dates. Travel date from cannot is same booking date from'
                });

                return false;
              }

              if (isSameTo) {
                this.$swal({
                  type: 'error',
                  title: 'Date Not Valid',
                  text: 'Please readjust travel dates. Travel date to cannot is same booking date to'
                });

                return false;
              }
            }
          }
        }

        for (var piI = 0; piI < this.form.booking.packages[paI].prices.length; piI += 1) {
          var _form$booking$package2 = this.form.booking.packages[paI].prices[piI],
              base_cost = _form$booking$package2.base_cost,
              block_cost = _form$booking$package2.block_cost,
              min_qty = _form$booking$package2.min_qty,
              source_price = _form$booking$package2.source_price,
              currency = _form$booking$package2.currency,
              exchange_rate = _form$booking$package2.exchange_rate;


          if (!base_cost || base_cost === '0' || parseInt(base_cost, 10) < 1) {
            this.$swal('Package nett price required', 'Please set package nett price. Minimum nett price is 1', 'warning');
            return false;
          }

          if (!block_cost.value && parseInt(block_cost.value, 10) < 0 || block_cost.value === '') {
            this.$swal('Package commission required', 'Please set package commission price. Minimum comission is 0', 'warning');
            return false;
          }

          if (!min_qty) {
            this.$swal('Package Quantity required', 'Please set package minimum quantity', 'warning');
            return false;
          }

          if (!base_cost && !min_qty) {
            this.$swal('Package detail required', 'Please fill package contents', 'warning');
            return false;
          }

          if (this.isKlook) {
            if (!source_price) {
              this.$swal('Package source price required', 'Please fill package source price', 'warning');
              return false;
            }

            if (!currency) {
              this.$swal('Package currency required', 'Please fill package currency', 'warning');
              return false;
            }

            if (!exchange_rate) {
              this.$swal('Package exchange rate required', 'Please fill package exchange rate', 'warning');
              return false;
            }
          }
        }
      }

      this.checkStartFrom();
      if (!this.hasStartFrom) {
        this.$swal('Start from is required', 'Please select a \'start from\' from the price list', 'warning');
        return false;
      }

      // Sequence and Badge
      if (!this.form.sequence) {
        this.$swal('Sequence is required', 'Please fill the sequence', 'warning');
        return false;
      }

      // Content Tabs Section
      for (var i = 0; i < this.form.tabs.length; i += 1) {
        var _form$tabs$i = this.form.tabs[i],
            title = _form$tabs$i.title,
            _description = _form$tabs$i.description,
            title_en = _form$tabs$i.title_en,
            _description_en = _form$tabs$i.description_en;


        if (!title) {
          this.$swal('Tab required', 'Please fill tab indonesia title', 'warning');
          return false;
        }

        if (!_description) {
          this.$swal('Tab required', 'Please fill tab indonesia description', 'warning');
          return false;
        }

        if (!title_en) {
          this.$swal('Tab required', 'Please fill tab englsih title', 'warning');
          return false;
        }

        if (!_description_en) {
          this.$swal('Tab required', 'Please fill tab englsih description', 'warning');
          return false;
        }

        if (!title && !_description && !title_en && !_description_en) {
          this.$swal('Tab required', 'Please fill uncomplete content', 'warning');
          return false;
        }
      }

      // E-vouchers Section
      for (var _i = 0; _i < this.form.vouchers.length; _i += 1) {
        var _form$vouchers$_i = this.form.vouchers[_i],
            _title = _form$vouchers$_i.title,
            _description2 = _form$vouchers$_i.description,
            _title_en = _form$vouchers$_i.title_en,
            _description_en2 = _form$vouchers$_i.description_en;


        if (!_title) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher indonesia title', 'warning');
          return false;
        }

        if (!_description2) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher indonesia description', 'warning');
          return false;
        }

        if (!_title_en) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher englsih title', 'warning');
          return false;
        }

        if (!_description_en2) {
          this.$swal('Content on E-Voucher required', 'Please fill Content on E-Voucher englsih description', 'warning');
          return false;
        }

        if (!_title && !_description2 && !_title_en && !_description_en2) {
          this.$swal('Content on E-Voucher required', 'Please fill uncomplete content', 'warning');
          return false;
        }
      }

      // Image Section
      // if (!(this.form.image.id.toString())) {
      //   this.$swal('Thumbnail required', 'Please choose product image', 'warning');
      //   return false;
      // }

      // if (!this.form.image_apps.id.toString()) {
      //   this.$swal('Thumbnail apps required', 'Please choose product image apps', 'warning');
      //   return false;
      // }

      if (!this.form.gallery || this.form.gallery.length < 1) {
        this.$swal('Image Gallery Required', 'Please select at least one Image Gallery', 'warning');
        return false;
      }

      /* eslint-enable camelcase */
      return true;
    },
    setErrors: function setErrors(error, mode) {
      var _this15 = this;

      console.error(mode + ' error', error);

      this.isSubmitting = false;

      if (error.response) {
        this.error = error.response.data.errors;
      }

      if (error) {
        var message = 'Failed to ' + mode + ' Product';

        if (this.error) {
          message = this.error;
        }

        this.$swal({
          title: mode + ' Failed!',
          text: message,
          type: 'error',
          timer: 5000,
          onClose: function onClose() {
            _this15.error = null;
          }
        });
      }
    },
    showErrorModal: function showErrorModal(errors) {
      var string = '';

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errors).length > 0) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errors).forEach(function (key, value) {
          string += key + ' ' + value + ', ';
        });
      }

      this.$swal('Data required', string, 'warning');
    },
    checkStartFrom: function checkStartFrom() {
      var _this16 = this;

      this.form.booking.packages.map(function (vpackage, ipackage) {
        if (_this16.form.booking.packages[ipackage].prices) {
          _this16.form.booking.packages[ipackage].prices.map(function (price) {
            _this16.hasStartFrom += price.start_from;
            return true;
          });
        }
        return true;
      });
    },
    generateDisabledDate: function generateDisabledDate(target) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var indexPackage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var date = null;
      var to = null;

      /**
       * Only for booking criteria
       */
      if (target === 'valid_to') {
        return {
          to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.valid_from).add(1, 'days').toDate()
        };
      }

      /**
       * Only for Klook Travel Date
       */
      if (target === 'klook') {
        to = __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate();

        if (index < 1 && type === 'to') {
          date = this.form.booking.packages[indexPackage].travel_date[index].from;
          to = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).toDate();
        }

        if (index > 0 && type === 'from') {
          date = this.form.booking.packages[indexPackage].travel_date[index - 1].to || null;

          if (!date) {
            date = this.form.booking.packages[indexPackage].travel_date[index - 1].from || null;
          }

          if (!date) {
            date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate();
          }

          to = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(1, 'd').toDate();
        }

        if (type === 'to') {
          date = this.form.booking.packages[indexPackage].travel_date[index].from || null;

          // Fallback if last fromDate also not yet filled
          if (!date) {
            date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate();
          }

          to = __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(1, 'days').toDate();
        }

        return {
          to: to
        };
      }

      /**
       * Set default: from today
       */

      var booking = null;
      if (this.params.flaging === 'explore') {
        booking = this.form.booking;
      } else {
        booking = this.form.booking_tour;
      }

      if (index < 1 && type === 'from') {
        return {
          to: __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'd').toDate()
        };
      }

      /**
       * Get first fromDate
       */
      if (index < 1 && type === 'to') {
        date = booking[target][index].from;

        return {
          to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).toDate()
        };
      }

      /**
       * Get toDate from the previous array
       */
      if (index > 0 && type === 'from') {
        date = booking[target][index - 1].to || null;

        // Fallback if last toDate not yet filled
        if (!date) {
          date = booking[target][index - 1].from || null;
        }

        // Fallback if last fromDate also not yet filled
        if (!date) {
          date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate();
        }

        return {
          to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).add(1, 'd').toDate()
        };
      }

      /**
       * Get fromDate from the previous array
       */
      if (type === 'to') {
        date = booking[target][index].from || null;

        // Fallback if last fromDate also not yet filled
        if (!date) {
          date = __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate();
        }

        return {
          to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).toDate()
        };
      }

      /**
       * Return default disabled date
       */
      return this.configs.datepicker.disabled;
    },
    openDateFromMinDate: function openDateFromMinDate(target, index, type) {
      var date = null;

      var booking = null;
      if (this.params.flaging === 'explore') {
        booking = this.form.booking;
      } else {
        booking = this.form.booking_tour;
      }

      if (index > 0) {
        if (type === 'from') {
          date = booking[target][index - 1].to || null;
        }

        if (type === 'to') {
          date = booking[target][index].from || null;
        }
      }

      return date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate();
    },
    generatePreview: function generatePreview(slug, id) {
      if (!slug) return '';
      var basePreviewPath = __WEBPACK_IMPORTED_MODULE_13__config__["e" /* WEB_URL */] || 'https://www.misteraladin.com/aladintravel/aladinxplore';
      return basePreviewPath + '/product/' + slug + '-' + id + '?preview=true';
    },
    generateDates: function generateDates(array) {
      var _this17 = this;

      var returnAsString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!array) return null;

      var data = [];

      if (!subtract) {
        array.forEach(function (item) {
          data.push({
            from: __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.from).format(_this17.config.date.iso),
            to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.to).format(_this17.config.date.iso)
          });
        });
      } else {
        array.forEach(function (item) {
          data.push({
            from: __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.from).format(_this17.config.date.iso),
            to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(item.to).format(_this17.config.date.iso)
          });
        });
      }

      if (!returnAsString) {
        return data;
      }

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
    },
    generatePackages: function generatePackages(data) {
      var _this18 = this;

      var packages = [];

      data.forEach(function (item) {
        var prices = [];

        item.prices.forEach(function (itemPrice) {
          prices.push({
            base_cost: parseInt(itemPrice.base_cost, 10),
            block_cost: _this18.calculateBlockCost(itemPrice.base_cost, itemPrice.block_cost),
            block_cost_percentage: itemPrice.block_cost.type === 0 ? parseInt(itemPrice.block_cost.value, 10) : null,
            gimmick_price: parseInt(itemPrice.gimmick_price, 10),
            min_qty: parseInt(itemPrice.min_qty, 10),
            start_from: parseInt(itemPrice.start_from, 10),
            source_price: parseFloat(itemPrice.source_price),
            exchange_rate: parseFloat(itemPrice.exchange_rate),
            currency: itemPrice.currency,
            price_per_type: itemPrice.price_per_type,
            price_per_type_en: itemPrice.price_per_type_en
          });
        });

        packages.push({
          sku_id: item.sku_id,
          name: item.name,
          name_en: item.name_en,
          description: item.description,
          description_en: item.description_en,
          multiply: parseInt(item.multiply, 10),
          min_person: parseInt(item.min_person, 10),
          max_person: parseInt(item.max_person, 10),
          ticket_id: !_this18.isKlook ? item.ticket.value : 0,
          travel_date: _this18.isKlook ? _this18.generateDates(item.travel_date, false) : null,
          type: item.type.value,
          prices: prices
        });
      });

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(packages);
    },
    calculateBlockCost: function calculateBlockCost(baseCost, blockCost) {
      var baseCostInt = parseInt(baseCost, 10);
      var blockCostInt = parseInt(blockCost.value, 10);
      var blockCostReturn = 0;
      if (blockCost.type === 0) {
        blockCostReturn = baseCostInt / 100 * blockCostInt;
      } else {
        blockCostReturn = blockCostInt;
      }
      return Math.ceil(blockCostReturn);
    },
    generateTabs: function generateTabs(tabs) {
      var data = tabs.map(function (tab, index) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, tab, {
          seq: index
        });
      });

      return data;
    },
    generateData: function generateData() {
      /* eslint-disable camelcase, no-unused-vars, object-shorthand, max-len */
      var _form = this.form,
          booking = _form.booking,
          badges = _form.badges,
          booking_duration = _form.booking_duration,
          categories = _form.categories,
          condition = _form.condition,
          destinations = _form.destinations,
          fixed_date = _form.fixed_date,
          gallery = _form.gallery,
          has_booking_duration = _form.has_booking_duration,
          has_travel_duration = _form.has_travel_duration,
          id = _form.id,
          image = _form.image,
          image_apps = _form.image_apps,
          is_publish = _form.is_publish,
          merchant = _form.merchant,
          name = _form.name,
          name_en = _form.name_en,
          open_date = _form.open_date,
          product_code = _form.product_code,
          print_voucher = _form.print_voucher,
          slug = _form.slug,
          tabs = _form.tabs,
          tags = _form.tags,
          type = _form.type,
          travel_duration = _form.travel_duration,
          travel_duration_unit = _form.travel_duration_unit,
          has_criteria = _form.has_criteria,
          valid_from = _form.valid_from,
          valid_to = _form.valid_to,
          vendor = _form.vendor,
          visibility = _form.visibility,
          with_adult_is_must = _form.with_adult_is_must,
          ticket_image = _form.ticket_image,
          booking_tour = _form.booking_tour,
          sequence = _form.sequence,
          vouchers = _form.vouchers,
          hide_breadcrumbs = _form.hide_breadcrumbs,
          hide_searchbar = _form.hide_searchbar,
          hide_recommendation = _form.hide_recommendation;


      var data = {};

      // Data
      data.slug = !slug ? this.toSlug(name) : slug;
      data.is_publish = is_publish ? 1 : 0;
      data.visibility = visibility ? 1 : 0;
      data.type_product = this.params.flaging;
      data.hide_breadcrumbs = hide_breadcrumbs;
      data.hide_searchbar = hide_searchbar;
      data.hide_recommendation = hide_recommendation;

      // Title
      data.name = name;
      data.name_en = name_en;

      // Details
      data.type = type.value;
      data.destinations = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(destinations.map(Number));
      data.categories = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(categories.map(function (item) {
        return item.value;
      }));
      data.tags = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tags.map(function (item) {
        return item.value;
      }));

      // Tags
      data.require_confirmation = tags.require_confirmation ? 1 : 0;
      data.can_be_canceled = tags.can_be_canceled ? 0 : 1;
      data.duration_1_day = tags.duration_1_day ? 1 : 0;
      data.duration_2_day = tags.duration_2_day ? 1 : 0;
      data.changed_voucher = tags.changed_voucher ? 1 : 0;

      /**
       * Condition Start - Da fuck is these shit!!!!????
       * @type {integer}
       */
      data.with_adult_is_must = condition.value === 1 ? 1 : 0;
      data.no_need_specific_condition = condition.value === 1 ? 0 : 1;
      /**
       * Condition End - Da fuck is these shit!!!!????
       */

      data.print_voucher = print_voucher ? 1 : 0;

      // Source
      data.vendor = vendor ? vendor.value : null;
      data.merchant_id = merchant ? merchant.value : null;

      // Klook
      data.product_code = product_code;

      if (this.params.flaging === 'explore') {
        // Booking Open Date
        data.open_date = has_criteria ? 1 : 0;
        data.fixed_date = has_criteria ? 0 : 1;
        data.valid_from = open_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(valid_from).format(this.config.date.iso) : null;
        data.valid_to = open_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(valid_to).format(this.config.date.iso) : null;

        /**
         * Booking duration Start - Da fuck is these shit!!!!????
         * @type {integer}
         */
        data.is_booking_duration = has_booking_duration ? 1 : 0;
        data.no_is_booking_duration = has_booking_duration ? 0 : 1;
        /**
         * Booking duration End - Da fuck is these shit!!!!????
         */

        data.booking_duration = has_booking_duration ? booking_duration : 0;
        data.booking_duration_unit = 'day';

        /**
         * Travel duration Start - Da fuck is these shit!!!!????
         * @type {integer}
         */
        data.is_travel_duration = has_travel_duration ? 1 : 0;
        data.no_is_travel_duration = has_travel_duration ? 0 : 1;
        /**
         * Travel duration End - Da fuck is these shit!!!!????
         */

        data.travel_duration = has_travel_duration ? travel_duration : 0;
        data.travel_duration_unit = has_travel_duration ? travel_duration_unit.value : null;

        // Bookings
        data.booking_date = this.generateDates(booking.bookingDate);
        data.travel_date = this.generateDates(booking.travelDate);
        data.start_time = this.fullStartTime(booking.start_time);
        data.end_time = this.fullEndTime(booking.end_time);
      } else {
        // Booking Tour
        data.is_open_trip = booking_tour.bookingOption;
        data.booking_duration = booking_tour.bookingDuration;
        data.booking_duration_unit = 'day';
        data.booking_date = this.generateDates(booking_tour.bookingDate);
        data.travel_date = this.generateDates(booking_tour.travelDate);
        data.start_time = this.fullStartTime(booking_tour.start_time);
        data.end_time = this.fullStartTime(booking_tour.end_time);
      }

      // Packages/Prices/Persons
      data.persons = this.generatePackages(booking.packages);

      // Sequence and Badges
      data.sequence = parseInt(sequence, 10);
      if (!this.isCreate) {
        data.badges = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(badges.map(function (item) {
          return item.value;
        }));
      }

      // Tabs
      data.tabs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.generateTabs(tabs));

      // E-Vouchers
      data.how_to_use_title = vouchers[0].title;
      data.how_to_use_title_en = vouchers[0].title_en;
      data.how_to_use = vouchers[0].description;
      data.how_to_use_en = vouchers[0].description_en;

      data.terms_condition_title = vouchers[1].title;
      data.terms_condition_title_en = vouchers[1].title_en;
      data.terms_condition = vouchers[1].description;
      data.terms_condition_en = vouchers[1].description_en;

      // Image & Gallery
      data.image = image ? image.id : null;
      data.image_apps = image_apps ? image_apps.id : null;
      data.ticket_image = ticket_image ? ticket_image.id : null;
      data.galleries = gallery ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(gallery.map(function (item) {
        return item.id;
      })) : null;
      // logo: logoData,

      // Product status
      if (this.isCreate) {
        data.status_product = 'Approved';
      }

      return this.stringify(data);
      /* eslint-enable camelcase, no-unused-vars, object-shorthand, max-len */
    },
    submit: function submit(action) {
      if (!this.validateForm()) return;
      this.isSubmitting = true;

      var data = this.generateData();

      if (this.isCreate) {
        this.create(data);
      } else {
        if (this.status_product === 'Need Approval') {
          this.confirmStatusChange(action, data);
        }
        if (this.status_product === 'Approved') {
          this.update(data);
        }
      }
    },
    getApiRoute: function getApiRoute() {
      var route = '';
      if (this.params.flaging === 'tour') {
        route = '/products-tour';
      } else {
        route = '/products';
      }
      return route;
    },
    create: function create(data) {
      var _this19 = this;

      var route = this.getApiRoute();
      return this.axios.post(route, data).then(function (response) {
        var productId = response.data.data.id;
        if (_this19.form.is_publish) {
          _this19.badgeByProduct(productId);
        }
        _this19.$swal({
          title: 'Created',
          text: _this19.form.name + ' has been created.',
          type: 'success',
          timer: 3000
        });
        _this19.redirect();
      }).catch(function (error) {
        return _this19.setErrors(error, 'Create');
      });
    },
    update: function update(data) {
      var _this20 = this;

      var route = this.getApiRoute();
      return this.axios.put(route + '/' + this.form.id, data).then(function () {
        if (_this20.form.is_publish) {
          _this20.badgeByProduct(_this20.form.id);
        }
        _this20.$swal({
          title: 'Updated',
          text: _this20.form.name + ' has been updated.',
          type: 'success',
          timer: 3000
        });
        _this20.redirect();
      }).catch(function (error) {
        return _this20.setErrors(error, 'Update');
      });
    },
    badgeByProduct: function badgeByProduct(productId) {
      var _this21 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.prev = 0;
                  _context4.next = 3;
                  return _this21.axios.put('/badge-product/by-product/' + productId);

                case 3:
                  resolve();
                  _context4.next = 9;
                  break;

                case 6:
                  _context4.prev = 6;
                  _context4.t0 = _context4['catch'](0);

                  reject(_context4.t0);

                case 9:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this21, [[0, 6]]);
        }));

        return function (_x8, _x9) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    confirmStatusChange: function confirmStatusChange(action, data) {
      var _this22 = this;

      var swalConf = null;

      if (action === 'approved') {
        swalConf = {
          title: 'Confirmation',
          text: 'Are you sure want to Approved this products?',
          showCancelButton: true,
          confirmButtonColor: '#83A777',
          confirmButtonText: 'Approved',
          cancelButtonText: 'Cancel'
        };
      } else {
        swalConf = {
          title: 'Confirmation',
          text: 'Are you sure want to change this status to Need Revision?',
          showCancelButton: true,
          confirmButtonColor: '#FF6B6B',
          confirmButtonText: 'Need Revision',
          cancelButtonText: 'Cancel'
        };
      }

      this.$swal(swalConf).then(function (result) {
        if (result.value) {
          if (action === 'approved') {
            _this22.updateProductStatus('Approved', data);
          } else {
            _this22.updateProductStatus('Need Revision', data);
          }
        } else {
          _this22.isSubmitting = false;
        }
      });

      return false;
    },
    updateProductStatus: function updateProductStatus(status, data) {
      var _this23 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var formdata;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                formdata = new FormData();

                formdata.append('status_product', status);
                _context5.next = 5;
                return _this23.axios.put('/products/status/' + _this23.$route.params.id, formdata);

              case 5:
                _this23.update(data);
                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](0);

                _this23.setErrors(_context5.t0, 'Update');

              case 11:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this23, [[0, 8]]);
      }))();
    },
    redirect: function redirect() {
      __WEBPACK_IMPORTED_MODULE_14__utils_bus__["a" /* default */].$emit('destroy-editor');
      this.isSubmitting = false;
      return window.history.length !== 1 ? this.$router.go(-1) : this.$router.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.passRoute, {
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      }));
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_14__utils_bus__["a" /* default */].$emit('destroy-editor');
      return window.history.length !== 1 ? this.$router.go(-1) : this.$router.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.passRoute, {
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      }));
    },
    handleBookingOptions: function handleBookingOptions(checkboxType) {
      var _this24 = this;

      setTimeout(function () {
        if (_this24.form.has_criteria && _this24.form.has_booking_duration && _this24.form.has_travel_duration) {
          _this24.invalidBookingOption(checkboxType);
        }

        if (_this24.form.has_criteria && _this24.form.has_travel_duration) {
          _this24.invalidBookingOption(checkboxType);
        }
      }, 500);
    },
    invalidBookingOption: function invalidBookingOption(checkboxType) {
      this.form.has_criteria = false;
      this.form.has_booking_duration = false;
      this.form.has_travel_duration = false;
      if (checkboxType === 'open date') {
        this.form.has_criteria = true;
      } else if (checkboxType === 'booking duration') {
        this.form.has_booking_duration = true;
      } else {
        this.form.has_travel_duration = true;
      }
      this.$swal('Invalid Booking Option', 'Please select valid booking option', 'warning');
    },
    resetField: function resetField(payload) {
      this.handleBookingOptions(payload);
    },
    setTitle: function setTitle() {
      if (!this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Edit Explore Product';
      } else if (!this.isCreate && this.params.flaging === 'tour') {
        this.title = 'Edit Tour Product';
      } else if (this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Add New Explore Product';
      } else {
        this.title = 'Add New Tour Product';
      }
    },
    setFlagingField: function setFlagingField() {
      this.setTabTourOnCreate();
      this.setVoucherOnCreated();
      this.form.print_voucher = 0;
    },
    setTabTourOnCreate: function setTabTourOnCreate() {
      if (this.params.flaging === 'tour') {
        this.form.tabs[0].title = 'Informasi Tur';
        this.form.tabs[0].title_en = 'Tour Information';
        this.form.tabs.splice(1, 0, {
          title: 'Jadwal Perjalanan',
          title_en: 'Itinerary',
          description: null,
          description_en: null
        });
      }
    },
    setVoucherOnCreated: function setVoucherOnCreated() {
      if (this.params.flaging === 'explore') {
        this.form.vouchers.push({
          title: 'Instruksi Tiket',
          title_en: 'Ticket Instruction',
          description: null,
          description_en: null
        }, {
          title: 'Syarat dan Ketentuan',
          title_en: 'Term and Conditions',
          description: null,
          description_en: null
        });
      } else {
        this.form.vouchers.push({
          title: 'Jadwal Perjalanan',
          title_en: 'Itinerary',
          description: null,
          description_en: null
        }, {
          title: 'Syarat dan Ketentuan',
          title_en: 'Term and Conditions',
          description: null,
          description_en: null
        });
      }
    }
  },

  created: function created() {
    this.params.flaging = this.$route.query.flaging || null;
    this.setFlagingField();
    this.setTitle();
    this.fetchAll();
  },
  mounted: function mounted() {
    var _this25 = this;

    __WEBPACK_IMPORTED_MODULE_14__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this25.closeModals();
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_14__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    color: {
      default: '#35495e'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        border: this.stroke + ' solid ' + this.background,
        borderTopColor: this.color
      };
    }
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    dotSize: {
      default: function _default() {
        var size = parseInt(this.size);
        return size / 3 + 1;
      }
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      var halfSize = size / 3;
      return {
        width: this.size,
        height: this.size,
        border: '0px solid ' + this.background,
        boxShadow: '0 -' + halfSize + 'px 0 ' + this.dotSize + 'px ' + this.background + ' inset'
      };
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 44 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 120 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 100 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    diamondStyle: function diamondStyle() {
      var size = parseInt(this.size);
      return {
        width: size / 4 + 'px',
        height: size / 4 + 'px'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 4 + 'px'
      };
    }
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '2.0s'
    }
  },
  computed: {
    bounceStyle: function bounceStyle() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: size / 2 + 'px'
      };
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 164 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 64 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size) / 2;
      return {
        transform: 'scale(' + size / 75 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 31 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 60 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: 'auto',
        fill: this.color
      };
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 250 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size,
        transform: 'scale(' + size / 70 + ')'
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: size + 'px',
        height: this.size
      };
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        backgroundColor: this.background,
        width: this.size,
        height: this.size,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 80 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.0s'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    innerStyles: function innerStyles() {
      var size = parseInt(this.size);
      return {
        transform: 'scale(' + size / 220 + ')'
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    lineStyles: function lineStyles() {
      return {
        width: this.size,
        height: this.stroke,
        background: this.color,
        borderRadius: this.stroke
      };
    },
    styles: function styles() {
      var size = parseInt(this.size);
      return {
        width: this.size,
        height: this.size,
        transform: 'scale(' + size / 75 + ')'
      };
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.3s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.2s'
    }
  },
  computed: {
    rectStyles: function rectStyles() {
      return {
        backgroundColor: this.background,
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    color: {
      default: '#41b883'
    }
  },
  computed: {
    blobStyles: function blobStyles() {
      return {
        borderColor: this.color
      };
    },
    moveBlobStyles: function moveBlobStyles() {
      return {
        borderColor: this.color,
        background: this.color
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    duration: {
      default: '1.8s'
    }
  },
  computed: {
    cubeStyles: function cubeStyles() {
      return {
        backgroundColor: this.background,
        animationName: 'sk-cubemove',
        animationDuration: this.duration
      };
    },
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      default: '40px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(15);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(18);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONFIG = {
  HOUR_TOKENS: ['HH', 'H', 'hh', 'h', 'kk', 'k'],
  MINUTE_TOKENS: ['mm', 'm'],
  SECOND_TOKENS: ['ss', 's'],
  APM_TOKENS: ['A', 'a']
};

exports.default = {
  name: 'VueTimepicker',

  props: {
    value: { type: Object },
    hideClearButton: { type: Boolean },
    format: { type: String },
    minuteInterval: { type: Number },
    secondInterval: { type: Number },
    id: { type: String }
  },

  data: function data() {
    return {
      hours: [],
      minutes: [],
      seconds: [],
      apms: [],
      showDropdown: false,
      muteWatch: false,
      hourType: 'HH',
      minuteType: 'mm',
      secondType: '',
      apmType: '',
      hour: '',
      minute: '',
      second: '',
      apm: '',
      fullValues: undefined
    };
  },


  computed: {
    displayTime: function displayTime() {
      var formatString = String(this.format || 'HH:mm');
      if (this.hour) {
        formatString = formatString.replace(new RegExp(this.hourType, 'g'), this.hour);
      }
      if (this.minute) {
        formatString = formatString.replace(new RegExp(this.minuteType, 'g'), this.minute);
      }
      if (this.second && this.secondType) {
        formatString = formatString.replace(new RegExp(this.secondType, 'g'), this.second);
      }
      if (this.apm && this.apmType) {
        formatString = formatString.replace(new RegExp(this.apmType, 'g'), this.apm);
      }
      return formatString;
    },
    showClearBtn: function showClearBtn() {
      if (this.hour && this.hour !== '' || this.minute && this.minute !== '') {
        return true;
      }
      return false;
    }
  },

  watch: {
    'format': 'renderFormat',
    minuteInterval: function minuteInterval(newInteval) {
      this.renderList('minute', newInteval);
    },
    secondInterval: function secondInterval(newInteval) {
      this.renderList('second', newInteval);
    },

    'value': 'readValues',
    'displayTime': 'fillValues'
  },

  methods: {
    formatValue: function formatValue(type, i) {
      switch (type) {
        case 'H':
        case 'm':
        case 's':
          return String(i);
        case 'HH':
        case 'mm':
        case 'ss':
          return i < 10 ? '0' + i : String(i);
        case 'h':
        case 'k':
          return String(i + 1);
        case 'hh':
        case 'kk':
          return i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
        default:
          return '';
      }
    },
    checkAcceptingType: function checkAcceptingType(validValues, formatString, fallbackValue) {
      if (!validValues || !formatString || !formatString.length) {
        return '';
      }
      for (var i = 0; i < validValues.length; i++) {
        if (formatString.indexOf(validValues[i]) > -1) {
          return validValues[i];
        }
      }
      return fallbackValue || '';
    },
    renderFormat: function renderFormat(newFormat) {
      newFormat = newFormat || this.format;
      if (!newFormat || !newFormat.length) {
        newFormat = 'HH:mm';
      }

      this.hourType = this.checkAcceptingType(CONFIG.HOUR_TOKENS, newFormat, 'HH');
      this.minuteType = this.checkAcceptingType(CONFIG.MINUTE_TOKENS, newFormat, 'mm');
      this.secondType = this.checkAcceptingType(CONFIG.SECOND_TOKENS, newFormat);
      this.apmType = this.checkAcceptingType(CONFIG.APM_TOKENS, newFormat);

      this.renderHoursList();
      this.renderList('minute');

      if (this.secondType) {
        this.renderList('second');
      }

      if (this.apmType) {
        this.renderApmList();
      }

      var self = this;
      this.$nextTick(function () {
        self.readValues();
      });
    },
    renderHoursList: function renderHoursList() {
      var hoursCount = this.hourType === 'h' || this.hourType === 'hh' ? 12 : 24;
      this.hours = [];
      for (var i = 0; i < hoursCount; i++) {
        this.hours.push(this.formatValue(this.hourType, i));
      }
    },
    renderList: function renderList(listType, interval) {
      if (listType === 'second') {
        interval = interval || this.secondInterval;
      } else if (listType === 'minute') {
        interval = interval || this.minuteInterval;
      } else {
        return;
      }

      if (interval === 0) {
        interval = 60;
      } else if (interval > 60) {
        window.console.warn('`' + listType + '-interval` should be less than 60. Current value is', interval);
        interval = 1;
      } else if (interval < 1) {
        window.console.warn('`' + listType + '-interval` should be NO less than 1. Current value is', interval);
        interval = 1;
      } else if (!interval) {
        interval = 1;
      }

      if (listType === 'minute') {
        this.minutes = [];
      } else {
        this.seconds = [];
      }

      for (var i = 0; i < 60; i += interval) {
        if (listType === 'minute') {
          this.minutes.push(this.formatValue(this.minuteType, i));
        } else {
          this.seconds.push(this.formatValue(this.secondType, i));
        }
      }
    },
    renderApmList: function renderApmList() {
      this.apms = [];
      if (!this.apmType) {
        return;
      }
      this.apms = this.apmType === 'A' ? ['AM', 'PM'] : ['am', 'pm'];
    },
    readValues: function readValues() {
      if (!this.value || this.muteWatch) {
        return;
      }

      var timeValue = JSON.parse((0, _stringify2.default)(this.value || {}));

      var values = (0, _keys2.default)(timeValue);
      if (values.length === 0) {
        return;
      }

      if (values.indexOf(this.hourType) > -1) {
        this.hour = timeValue[this.hourType];
      }

      if (values.indexOf(this.minuteType) > -1) {
        this.minute = timeValue[this.minuteType];
      }

      if (values.indexOf(this.secondType) > -1) {
        this.second = timeValue[this.secondType];
      } else {
        this.second = 0;
      }

      if (values.indexOf(this.apmType) > -1) {
        this.apm = timeValue[this.apmType];
      }

      this.fillValues();
    },
    fillValues: function fillValues() {
      var fullValues = {};

      var baseHour = this.hour;
      var baseHourType = this.hourType;

      var hourValue = baseHour || baseHour === 0 ? Number(baseHour) : '';
      var baseOnTwelveHours = this.isTwelveHours(baseHourType);
      var apmValue = baseOnTwelveHours && this.apm ? String(this.apm).toLowerCase() : false;

      CONFIG.HOUR_TOKENS.forEach(function (token) {
        if (token === baseHourType) {
          fullValues[token] = baseHour;
          return;
        }

        var value = void 0;
        var apm = void 0;
        switch (token) {
          case 'H':
          case 'HH':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue % 12;
              }
            } else {
              value = hourValue % 24;
            }
            fullValues[token] = token === 'HH' && value < 10 ? '0' + value : String(value);
            break;
          case 'k':
          case 'kk':
            if (!String(hourValue).length) {
              fullValues[token] = '';
              return;
            } else if (baseOnTwelveHours) {
              if (apmValue === 'pm') {
                value = hourValue < 12 ? hourValue + 12 : hourValue;
              } else {
                value = hourValue === 12 ? 24 : hourValue;
              }
            } else {
              value = hourValue === 0 ? 24 : hourValue;
            }
            fullValues[token] = token === 'kk' && value < 10 ? '0' + value : String(value);
            break;
          case 'h':
          case 'hh':
            if (apmValue) {
              value = hourValue;
              apm = apmValue || 'am';
            } else {
              if (!String(hourValue).length) {
                fullValues[token] = '';
                fullValues.a = '';
                fullValues.A = '';
                return;
              } else if (hourValue > 11) {
                apm = 'pm';
                value = hourValue === 12 ? 12 : hourValue % 12;
              } else {
                if (baseOnTwelveHours) {
                  apm = '';
                } else {
                  apm = 'am';
                }
                value = hourValue % 12 === 0 ? 12 : hourValue;
              }
            }
            fullValues[token] = token === 'hh' && value < 10 ? '0' + value : String(value);
            fullValues.a = apm;
            fullValues.A = apm.toUpperCase();
            break;
        }
      });

      if (this.minute || this.minute === 0) {
        var minuteValue = Number(this.minute);
        fullValues.m = String(minuteValue);
        fullValues.mm = minuteValue < 10 ? '0' + minuteValue : String(minuteValue);
      } else {
        fullValues.m = '';
        fullValues.mm = '';
      }

      if (this.second || this.second === 0) {
        var secondValue = Number(this.second);
        fullValues.s = String(secondValue);
        fullValues.ss = secondValue < 10 ? '0' + secondValue : String(secondValue);
      } else {
        fullValues.s = '';
        fullValues.ss = '';
      }

      this.fullValues = fullValues;
      this.updateTimeValue(fullValues);
      this.$emit('change', { data: fullValues });
    },
    updateTimeValue: function updateTimeValue(fullValues) {
      this.muteWatch = true;

      var self = this;

      var baseTimeValue = JSON.parse((0, _stringify2.default)(this.value || {}));
      var timeValue = {};

      (0, _keys2.default)(baseTimeValue).forEach(function (key) {
        timeValue[key] = fullValues[key];
      });

      this.$emit('input', timeValue);

      this.$nextTick(function () {
        self.muteWatch = false;
      });
    },
    isTwelveHours: function isTwelveHours(token) {
      return token === 'h' || token === 'hh';
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    select: function select(type, value) {
      if (type === 'hour') {
        this.hour = value;
      } else if (type === 'minute') {
        this.minute = value;
      } else if (type === 'second') {
        this.second = value;
      } else if (type === 'apm') {
        this.apm = value;
      }
    },
    clearTime: function clearTime() {
      this.hour = '';
      this.minute = '';
      this.second = '';
      this.apm = '';
    }
  },

  mounted: function mounted() {
    this.renderFormat();
  }
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ckeditor_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102c9b1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ckeditor_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(614)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ckeditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_102c9b1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ckeditor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_bus__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//



var inc = new Date().getTime();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vue-ckeditor',
  props: {
    name: {
      type: String,
      default: function _default() {
        return 'editor-' + (inc + 1);
      }
    },
    value: {
      type: String
    },
    id: {
      type: String,
      default: function _default() {
        return 'editor-' + inc;
      }
    },
    types: {
      type: String,
      default: function _default() {
        return 'classic';
      }
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      destroyed: false
    };
  },


  computed: {
    instance: function instance() {
      return CKEDITOR.instances[this.id];
    }
  },

  watch: {
    value: function value(val) {
      try {
        if (this.instance) {
          this.update(val);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.create();

    __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$on('destroy-editor', function () {
      _this.destroy();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_0__utils_bus__["a" /* default */].$off('destroy-editor');
  },


  methods: {
    create: function create() {
      var _this2 = this;

      if (typeof CKEDITOR === 'undefined') {
        console.log('CKEDITOR is missing (http://ckeditor.com/)');
      } else {
        if (this.types === 'inline') {
          CKEDITOR.inline(this.id, this.config);
        } else {
          CKEDITOR.replace(this.id, this.config);
        }

        this.instance.setData(this.value);
        this.instance.on('instanceReady', function () {
          _this2.instance.setData(_this2.value);
        });
        this.instance.on('change', this.onChange);
        this.instance.on('blur', this.onBlur);
        this.instance.on('focus', this.onFocus);
      }
    },
    update: function update(val) {
      var html = this.instance.getData();
      if (html !== val) {
        this.instance.setData(val, { internal: false });
      }
    },
    destroy: function destroy() {
      if (!this.destroyed) {
        try {
          this.instance.focusManager.blur(true);
          this.instance.removeAllListeners();
          this.instance.destroy();
          this.destroyed = true;
        } catch (e) {
          console.error(e);
        }
      }
    },
    onChange: function onChange() {
      var html = this.instance.getData();
      if (html !== this.value) {
        this.$emit('input', html);
      }
    },
    onBlur: function onBlur() {
      this.$emit('blur', this.instance);
    },
    onFocus: function onFocus() {
      this.$emit('focus', this.instance);
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      required: true
    },

    breadcrumbs: {
      type: Array,
      required: false
    },

    isCreate: {
      type: Boolean,
      required: false
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      collapse: false
    };
  },


  props: {
    title: {
      type: String,
      required: true
    },

    border: {
      type: Boolean,
      required: false,
      default: true
    },

    borderType: {
      type: String,
      required: false
    },

    action: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  methods: {
    toggle: function toggle() {
      if (!this.action) return;
      this.collapse = !this.collapse;
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    showKlook: {
      type: Boolean,
      required: false,
      default: false
    }
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tabs: []
    };
  },


  methods: {
    selectTab: function selectTab(selectedTab) {
      this.tabs.forEach(function (tab) {
        tab.isActive = tab.href === selectedTab.href;
      });
    }
  },

  created: function created() {
    this.tabs = this.$children;
  }
});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    name: {
      type: String,
      required: true
    },

    selected: {
      type: Boolean,
      required: false,
      default: false
    },

    tabClass: {
      type: String,
      required: false
    }
  },

  computed: {
    href: function href() {
      return '#' + this.toLowercase(this.name);
    }
  },

  methods: {
    toLowercase: function toLowercase(str) {
      return str.toLowerCase().replace(/ /g, '-');
    }
  },

  mounted: function mounted() {
    this.isActive = this.selected;
  }
});

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_common_Modal__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    optionForm: {
      type: Object,
      required: true
    },

    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_0__components_modules_common_Modal__["a" /* default */]
  }
});

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Modal__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    optionForm: {
      type: Object,
      required: true
    },

    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_0__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    setImage: function setImage(payload) {
      this.$emit('setImage', payload);
    }
  }
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Modal__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    optionForm: {
      type: Object,
      required: true
    },

    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_0__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    setImage: function setImage(payload) {
      this.$emit('setImage', payload);
    }
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    optionForm: {
      type: Object,
      required: true
    },

    list: {
      type: Object,
      required: true
    },

    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__["a" /* default */],
    Treeselect: __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["Treeselect"]
  },

  methods: {
    loadOptions: function loadOptions(_ref) {
      var _this = this;

      var action = _ref.action;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(action === __WEBPACK_IMPORTED_MODULE_4__riophae_vue_treeselect__["LOAD_ROOT_OPTIONS"])) {
                  _context.next = 5;
                  break;
                }

                if (!_this.destinationListUpdated) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.fetchDestination();

              case 4:
                _this.destinationListUpdated = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setImage: function setImage(payload) {
      this.$emit('setImage', payload);
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_common_Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(14);






var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProductIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_8__components_modules_common_Pagination__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Modal__["a" /* default */]
  },

  data: function data() {
    return {
      products: [],
      pagination: {},

      isLoading: false,
      modalError: false,

      params: {
        flaging: null,
        name: null,
        mood: null,
        category: null,
        merchant_id: null,
        destination: null,
        sequence: null,
        status: null,
        status_product: null,
        page: null,
        vendor: null,
        export_csv: 0,
        sort_field: null,
        sort_order: null
      },

      need_approve_explore: false,
      need_approve_tour: false,

      list: {
        vendors: null,
        merchants: null
      },

      sort: {
        field: '',
        status: false
      }
    };
  },


  watch: {
    'params.page': {
      handler: function handler(val) {
        _this.fetch(val);
      },
      deep: false
    },

    sort: function sort(newVal) {
      this.params = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.params, {
        sort_field: newVal.field,
        sort_order: newVal.status ? 'asc' : 'desc'
      });
      this.fetch();
    }
  },

  computed: {
    redirectEdit: function redirectEdit() {
      return {
        name: 'product-edit',
        params: {},
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      };
    }
  },

  methods: {
    getApiRoute: function getApiRoute() {
      var route = '';
      if (this.params.flaging === 'tour') {
        route = '/products-tour?b2b_type=internal';
      } else {
        route = '/products?b2b_type=internal';
      }
      return route;
    },
    fetch: function fetch() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (page && (typeof page === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(page)) !== 'object') this.params.page = page;

      var route = this.getApiRoute();
      this.setProductsEmpty();
      this.fetchNeeedApproval();

      this.isLoading = true;

      this.axios.get(route, {
        params: this.params,
        responseType: this.type
      }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          _this2.setProductsEmpty();
          return;
        }

        _this2.products = data.filter(function (dt) {
          return !!dt.id;
        });
        _this2.pagination = meta.pagination;
      }).finally(function () {
        _this2.setParamsAndQueries();
        _this2.isLoading = false;
      });
    },
    checkBookingDateType: function checkBookingDateType(bookingDate) {
      return typeof bookingDate !== 'string';
    },


    onInput: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    onSelect: function onSelect() {
      this.params.page = null;
      this.fetch();
    },
    onExportCsv: function onExportCsv() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, totalRow, queryParams, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = '';

                _this3.params.export_csv = 1;

                totalRow = _this3.pagination.total;
                queryParams = _this3.params;


                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(queryParams).forEach(function (key) {
                  params += key + '=' + (queryParams[key] || '') + '&';
                });

                params = params.slice(0, -1);
                if (_this3.params.status) {
                  url = '';

                  url = __WEBPACK_IMPORTED_MODULE_10__config__["i" /* default */] + '/products?' + params + '&perpage=' + (totalRow || '');

                  window.location = url;
                  _this3.params.export_csv = 0;
                } else {
                  _this3.modalError = true;
                  _this3.params.export_csv = 0;
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    setProductsEmpty: function setProductsEmpty() {
      this.products = [];
      this.pagination = {};
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    parseBookingDate: function parseBookingDate(booking, target) {
      var bookingDate = JSON.parse(booking);
      var bookingLength = bookingDate.length;

      if (bookingLength < 1) return null;

      if (target === 'from') {
        var fromDate = bookingDate[0].from;
        return this.parseTime(fromDate, 'DD MMM YYYY');
      }

      var toDate = bookingDate[bookingLength - 1].to;
      return this.parseTime(toDate, 'DD MMM YYYY');
    },
    add: function add() {
      this.$router.push({
        name: 'product-create',
        query: { flaging: this.params.flaging === 'explore' ? 'explore' : 'tour' }
      });
    },
    edit: function edit(id) {
      this.$router.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.redirectEdit, { params: { id: id } }));
    },
    delete: function _delete(product) {
      var _this4 = this;

      this.axios.delete('/products/' + product.id).then(function () {
        _this4.fetch();
        _this4.$swal('Deleted!', product.name + ' has been deleted.', 'success');
      });
    },
    remove: function remove(product) {
      var _this5 = this;

      this.$swal({
        title: 'Deleting Product',
        text: 'Are you sure you want to delete ' + product.name + '? This action cannot be undone.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this5.delete(product);
        }
      }, function (dismiss) {
        if (dismiss === 'cancel') {
          _this5.$swal('Cancelled', null, 'error');
        }
      });
    },
    sortList: function sortList(target) {
      this.sort = { field: target, status: !this.sort.status };
    },
    parseStatus: function parseStatus(status, booking) {
      var isActive = status === 1;
      var statusText = isActive ? 'Published' : 'Unpublished';
      var bookingDate = JSON.parse(booking);
      var bookingLength = bookingDate.length;
      if (bookingLength < 1) return statusText;

      var toDate = bookingDate[bookingLength - 1].to;
      if (!toDate) return statusText;

      var isEnd = __WEBPACK_IMPORTED_MODULE_6_moment___default()().isAfter(toDate, 'days');
      if (isActive && isEnd) return 'Unpublished';

      return isActive ? 'Published' : 'Unpublished';
    },
    parseParams: function parseParams() {
      this.params.flaging = this.$route.query.flaging || null;
      this.params.name = this.$route.query.name || null;
      this.params.mood = this.$route.query.mood || null;
      this.params.category = this.$route.query.category || null;
      this.params.destination = this.$route.query.destination || null;
      this.params.sequence = this.$route.query.sequence || null;
      this.params.status = this.$route.query.status || null;
      this.params.status_product = this.$route.query.status_product || null;
      this.params.page = this.$route.params.page || null;
      this.params.vendor = this.$route.query.vendor || null;
      this.params.sort_field = this.$route.query.sort_field || null;
      this.params.sort_order = this.$route.query.sort_order || null;
    },
    setParamsAndQueries: function setParamsAndQueries() {
      var _this6 = this;

      var page = this.params.page || 1;

      var queries = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.params).filter(function (item) {
        return _this6.params[item] && item !== 'page';
      }).map(function (item) {
        return item + '=' + _this6.params[item];
      }).join('&');

      window.history.pushState('Products page: ' + this.params.page, null, '/products/page/' + page + '?' + queries);
    },
    fetchNeeedApproval: function fetchNeeedApproval() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this7.axios.get('/products-only/approval');

              case 3:
                response = _context2.sent;
                data = response.data;

                _this7.need_approve_explore = data.is_need_approval_explore;
                _this7.need_approve_tour = data.is_need_approval_tour;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                _this7.$swal({
                  title: 'Failed',
                  text: 'Failed to fetch data Need approval',
                  type: 'error',
                  timer: 3000
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[0, 9]]);
      }))();
    },
    fetchVendors: function fetchVendors() {
      var _this8 = this;

      return this.axios.get('/vendors').then(function (response) {
        var vendorData = response.data.data;
        _this8.list.vendors = vendorData.map(function (item) {
          return { label: item.name, value: item.id };
        });
      }).catch(function (error) {
        console.log('Fetch vendors error', error);
      });
    },
    fetchMerchants: function fetchMerchants() {
      var _this9 = this;

      return this.axios.get('/merchants', { params: { perpage: 5000 } }).then(function (response) {
        var merchantsData = response.data.data;
        _this9.list.merchants = merchantsData.map(function (item) {
          return { label: item.name, value: item.id };
        });
      }).catch(function (error) {
        console.log('Fetch vendors error', error);
      });
    },
    setParamstoDefault: function setParamstoDefault() {
      this.params.name = null;
      this.params.mood = null;
      this.params.category = null;
      this.params.destination = null;
      this.params.sequence = null;
      this.params.status = null;
      this.params.status_product = null;
      this.params.page = null;
      this.params.vendor = null;
      this.params.export_csv = 0;
      this.params.sort_field = null;
      this.params.sort_order = null;
    },
    changeFlag: function changeFlag() {
      if (this.params.flaging === 'explore') {
        this.params.flaging = 'tour';
      } else {
        this.params.flaging = 'explore';
      }
      this.setParamstoDefault();
      this.fetch();
    }
  },

  mounted: function mounted() {
    this.parseParams();
    if (!this.params.flaging) {
      this.params.flaging = 'explore';
    }
    this.fetch();
    this.fetchVendors();
    this.fetchMerchants();
  }
});

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_nav_tabs__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_nav_tabs_themes_vue_tabs_css__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HighlightsForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_9__mixins_Common__["a" /* default */]],
  data: function data() {
    return {
      title: 'Highlights',

      dragging: true,

      error: {
        destination: null,
        trending: null,
        tour: null,
        campaign1: null,
        campaign2: null,
        favorite: null,
        category: null,
        product: null
      },

      isLoading: true,
      show: {
        gallery: false
      },
      form: {
        trending: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: []
          }],
          destination_items: [{
            destination_id: null,
            items: []
          }]
        },

        tour: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: []
          }],
          destination_items: [{
            destination_id: null,
            items: []
          }]
        },

        campaign1: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: []
          }],
          destination_items: [{
            destination_id: null,
            items: []
          }]
        },

        campaign2: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: []
          }],
          destination_items: [{
            destination_id: null,
            items: []
          }]
        },

        destination: {
          title: null,
          title_en: null,
          image: {
            id: null,
            url: null
          },
          description: null,
          description_en: null,
          country_domestic: [{
            label: 'Indonesia',
            value: 115
          }],
          city_domestic: [],
          international: [{
            country_international: [],
            city_international: []
          }],
          items: []
        },

        favorite: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null
          },
          sectionStyle: 0,
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          item_type: null,
          items: [],
          category_items: [{
            category_id: null,
            items: []
          }],
          destination_items: [{
            destination_id: null,
            items: []
          }]
        },

        category: {
          start_date: null,
          end_date: null,
          status: 1,
          // sequence: null,
          image: {
            id: null,
            url: null
          },
          title: null,
          title_en: null,
          description: null,
          description_en: null,
          items: []
        }
      },

      lists: {
        cities: [],
        destinations: [],
        internationalDestinations: [],
        products: [],
        categories: [],
        productsTour: [],
        categoriesProducts: [],
        domesticProducts: [],
        internationalProducts: [],
        sequenceList: []
      },

      tabDestination: 0
    };
  },


  components: {
    VueTabs: __WEBPACK_IMPORTED_MODULE_13_vue_nav_tabs__["VueTabs"],
    VTab: __WEBPACK_IMPORTED_MODULE_13_vue_nav_tabs__["VTab"],
    Datepicker: __WEBPACK_IMPORTED_MODULE_10_vuejs_datepicker___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_11__components_modules_common_Modal__["a" /* default */],
    FileGallery: __WEBPACK_IMPORTED_MODULE_8__components_modules_common_FileGallery__["a" /* default */],
    draggable: __WEBPACK_IMPORTED_MODULE_12_vuedraggable___default.a
  },
  computed: {
    disabledStartDateCampaign1: function disabledStartDateCampaign1() {
      return {
        to: this.form.campaign1.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.campaign1.end_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.campaign1.end_date).toDate() : null
      };
    },
    disabledEndDateCampaign1: function disabledEndDateCampaign1() {
      return {
        to: this.form.campaign1.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.campaign1.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate()
      };
    },
    disabledStartDateCampaign2: function disabledStartDateCampaign2() {
      return {
        to: this.form.campaign2.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.campaign2.end_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.campaign2.end_date).toDate() : null
      };
    },
    disabledEndDateCampaign2: function disabledEndDateCampaign2() {
      return {
        to: this.form.campaign2.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.campaign2.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate()
      };
    },
    disabledStartDatefavorite: function disabledStartDatefavorite() {
      return {
        to: this.form.favorite.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.favorite.end_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.favorite.end_date).toDate() : null
      };
    },
    disabledEndDatefavorite: function disabledEndDatefavorite() {
      return {
        to: this.form.favorite.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.favorite.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate()
      };
    },
    disabledStartDatetour: function disabledStartDatetour() {
      return {
        to: this.form.tour.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.tour.end_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.tour.end_date).toDate() : null
      };
    },
    disabledEndDatetour: function disabledEndDatetour() {
      return {
        to: this.form.tour.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.tour.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate()
      };
    },
    disabledStartDatecategory: function disabledStartDatecategory() {
      return {
        to: this.form.category.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.category.end_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.category.end_date).toDate() : null
      };
    },
    disabledEndDatecategory: function disabledEndDatecategory() {
      return {
        to: this.form.category.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.category.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate()
      };
    },
    disabledStartDatetrending: function disabledStartDatetrending() {
      return {
        to: this.form.trending.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.trending.end_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.trending.end_date).toDate() : null
      };
    },
    disabledEndDatetrending: function disabledEndDatetrending() {
      return {
        to: this.form.trending.start_date ? __WEBPACK_IMPORTED_MODULE_6_moment___default()(this.form.trending.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_6_moment___default()().toDate()
      };
    },
    draggingInfo: function draggingInfo() {
      return this.dragging ? 'under drag' : '';
    }
  },
  methods: {
    limiter: function limiter(e) {
      if (e.length > 8) {
        e.pop();
        this.$swal('Limited Input City', 'Max of items selected is 8', 'warning');
      }
    },
    limiterCategory: function limiterCategory(e) {
      if (e.length > 8) {
        e.pop();
        this.$swal('Limited Input Category', 'Max of items selected is 8', 'warning');
      }
    },
    setSelected: function setSelected(val) {
      this.onSelectCountry(val, true);
    },
    setSelectedCategory: function setSelectedCategory(val, type) {
      this.onSelectCategories(val, type, true);
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage: function setImage(payload) {
      this.form[payload.target].image = payload.images;
    },
    fetchHighlight: function fetchHighlight(type) {
      var _this = this;

      this.error[type] = null;

      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (type === 'campaign1' || type === 'campaign2') {
          _this.axios.get('/highlights/campaign/' + type).then(function (response) {
            var data = response.data.data;

            _this.form[type].start_date = data.start_date;
            _this.form[type].end_date = data.end_date;
            _this.form[type].status = data.status;
            // this.form[type].sequence = data.sequence;
            _this.form[type].item_type = data.item_type;
            _this.form[type].image.url = data.image || '';
            _this.form[type].sectionStyle = data.style;
            _this.form[type].title = data.title;
            _this.form[type].title_en = data.title_en;
            _this.form[type].description = data.description;
            _this.form[type].description_en = data.description_en;
            if (data.destination_items !== null && data.destination_items.length > 0) {
              _this.form[type].destination_items = data.destination_items.map(function (item) {
                return {
                  destination_id: {
                    value: item.id,
                    label: item.name
                  },
                  items: item.items.map(function (val) {
                    return {
                      value: val.id,
                      label: val.name
                    };
                  })
                };
              });
            }
            if (data.category_items !== null && data.category_items.length > 0) {
              _this.form[type].category_items = data.category_items.map(function (item) {
                return {
                  category_id: {
                    value: item.id,
                    label: item.name
                  },
                  items: item.items.map(function (val) {
                    return {
                      value: val.id,
                      label: val.name
                    };
                  })
                };
              });
            }
            if (data.items !== null && data.items.length > 0) {
              _this.form[type].items = data.items.map(function (item) {
                return {
                  value: item.id,
                  label: item.name
                };
              });
            }
            resolve();
          }).catch(function (error) {
            console.log(type + ' error', error);

            if (error.response) {
              _this.error = error.response.data.errors;
              reject();
            }
          });
        } else {
          _this.axios.get('/highlights/' + type).then(function (response) {
            var data = response.data.data;

            _this.form[type].start_date = data.start_date;
            _this.form[type].end_date = data.end_date;
            _this.form[type].status = data.status;
            // this.form[type].sequence = data.sequence;
            _this.form[type].sectionStyle = data.style;
            _this.form[type].image.url = data.image || '';
            _this.form[type].title = data.title;
            _this.form[type].title_en = data.title_en;
            _this.form[type].description = data.description;
            _this.form[type].description_en = data.description_en;
            _this.form[type].item_type = data.item_type;

            if (data.items !== null && data.items.length > 0) {
              if (type === 'destination') {
                var domesticCity = data.items.filter(function (item) {
                  return item.type === 'domestic';
                });
                _this.form[type].city_domestic = domesticCity.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
                var internationalCity = data.items.filter(function (item) {
                  return item.type === 'international';
                });
                // if (internationalCity && internationalCity.length > 1) {
                // this.form.destination.international.splice(0, 1);
                // }
                var newCountry = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_map___default.a();
                if (internationalCity && internationalCity.length) {
                  for (var i = 0; i < internationalCity.length; i += 1) {
                    var newCity = newCountry.get(internationalCity[i].parent_id) ? newCountry.get(internationalCity[i].parent_id).city_international : [];
                    newCountry.set(internationalCity[i].parent_id, {
                      country_international: [{
                        value: internationalCity[i].parent_id,
                        label: internationalCity[i].parent_name
                      }],
                      city_international: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(newCity), [{
                        value: internationalCity[i].id,
                        label: internationalCity[i].name
                      }])
                    });
                  }
                  var newDestination = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(newCountry)).flat().filter(function (item) {
                    return !(typeof item === 'number');
                  });
                  _this.form[type].international = newDestination;
                }
              } else {
                _this.form[type].items = data.items.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              }
            }
            if (type !== 'category' && type !== 'destination') {
              if (data.destination_items !== null && data.destination_items.length > 0) {
                _this.form[type].destination_items = data.destination_items.map(function (item) {
                  return {
                    destination_id: {
                      value: item.id,
                      label: item.name
                    },
                    items: item.items.map(function (val) {
                      return {
                        value: val.id,
                        label: val.name
                      };
                    })
                  };
                });
              }
              if (data.category_items !== null && data.category_items.length > 0 && data.category_items[0].items !== null) {
                _this.form[type].category_items = data.category_items.map(function (item) {
                  return {
                    category_id: {
                      value: item.id,
                      label: item.name
                    },
                    items: item.items.map(function (val) {
                      return {
                        value: val.id,
                        label: val.name
                      };
                    })
                  };
                });
              }
            }
            resolve();
          }).catch(function (error) {
            console.log(type + ' error', error);

            if (error.response) {
              _this.error = error.response.data.errors;
              reject();
            }
          });
        }
      });
    },
    flattenData: function flattenData(data) {
      var _this2 = this;

      var result = [];

      data.forEach(function (parent) {
        result.push({
          label: parent.name,
          value: parent.id
        });

        if (parent.child && parent.child.length > 0) {
          parent.child.forEach(function (child) {
            result.push({
              label: child.name,
              value: child.id
            });

            if (_this2.tabDestination === 0 && child.child && child.child.length > 0) {
              child.child.forEach(function (grandChild) {
                result.push({
                  label: grandChild.name,
                  value: grandChild.id
                });
              });
            }
          });
        }
      });

      return __WEBPACK_IMPORTED_MODULE_7_lodash_flatten___default()(result);
    },
    onClick: function onClick(tabIndex) {
      this.tabDestination = tabIndex;
      this.fetchlist('destinations');
    },
    onSelectCountry: function onSelectCountry(index, a) {
      var _this3 = this;

      if (a) {
        this.axios.get('/destinations/' + this.form.destination.international[index].country_international[0].value).then(function (response) {
          var cityData = response.data.data.child;
          _this3.lists.cities = cityData ? cityData.map(function (item) {
            return {
              label: item.name, value: item.id };
          }) : [];
        });
      } else {
        this.axios.get('/destinations/' + this.form.destination.international[index].country_international.value).then(function (response) {
          var cityData = response.data.data.child;
          _this3.form.destination.international[index].city_international = null;
          _this3.lists.cities = cityData ? cityData.map(function (item) {
            return {
              label: item.name, value: item.id };
          }) : [];
        });
      }
    },
    onSelectCategories: function onSelectCategories(index, type, a) {
      var _this4 = this;

      this.form[type].item_type = this.form[type].item_type;
      this.form[type].items = [];
      var flaggingType = void 0;
      if (type === 'tour') {
        flaggingType = 'tour';
      } else {
        flaggingType = '';
      }
      this.axios.get('/products?b2b_type=internal&flaging=' + flaggingType + '&category=' + this.form[type].category_items[index].category_id.label).then(function (response) {
        var categoriesProd = response.data.data;
        if (!a) {
          _this4.form[type].category_items[index].items = null;
        }
        _this4.lists.categoriesProducts = categoriesProd ? categoriesProd.map(function (item) {
          return {
            label: item.name, value: item.id };
        }) : [];
      });
    },
    onSelectDomestic: function onSelectDomestic(index, type, a) {
      var _this5 = this;

      this.form[type].item_type = this.form[type].item_type;
      this.form[type].items = [];
      var flaggingType = void 0;
      if (type === 'tour') {
        flaggingType = 'tour';
      } else {
        flaggingType = '';
      }
      this.axios.get('/products?b2b_type=internal&flaging=' + flaggingType + '&destination=' + this.form[type].destination_items[index].destination_id.label).then(function (response) {
        var domesticProd = response.data.data;
        if (!a) {
          _this5.form[type].destination_items[index].items = null;
        }
        _this5.lists.domesticProducts = domesticProd ? domesticProd.map(function (item) {
          return {
            label: item.name, value: item.id };
        }) : [];
      });
    },
    onSelectperItem: function onSelectperItem(type) {
      this.form[type].item_type = 'item';
    },
    onSelectInternational: function onSelectInternational(index, type, a) {
      var _this6 = this;

      this.form[type].item_type = this.form[type].item_type;
      this.form[type].items = [];
      var flaggingType = void 0;
      if (type === 'tour') {
        flaggingType = 'tour';
      } else {
        flaggingType = '';
      }
      this.axios.get('/products?b2b_type=internal&flaging=' + flaggingType + '&destination=' + this.form[type].destination_items[index].destination_id.label).then(function (response) {
        var internationalProd = response.data.data;
        if (!a) {
          _this6.form[type].destination_items[index].items = null;
        }
        _this6.lists.internationalProducts = internationalProd ? internationalProd.map(function (item) {
          return {
            label: item.name, value: item.id };
        }) : [];
      });
    },
    onSelectDestination: function onSelectDestination(index, type) {
      var _this7 = this;

      if (this.form[type].item_type !== 'category') {
        this.axios.get('/destinations', {
          params: {
            perpage: 1000
          },
          headers: {
            'X-MA-Client': 'backend'
          }
        }).then(function (response) {
          var data = response.data.data;


          if (!data) return;
          if (_this7.form[type].item_type === 'international' || _this7.tabDestination === 1) {
            _this7.tabDestination = 1;
            var dataChild = [];
            dataChild = data[1].child;
            if (type === 'destination') {
              var result = [];
              dataChild.forEach(function (parent) {
                result.push({
                  label: parent.name,
                  value: parent.id
                });
              });
              _this7.lists.destinations = result;
            } else {
              _this7.lists.destinations = _this7.flattenData(dataChild);
            }
          } else {
            _this7.tabDestination = 0;
            var _dataChild = [];
            _dataChild = data[_this7.tabDestination].child;

            _this7.lists.destinations = _this7.flattenData(_dataChild);
          }
        }).catch(function (error) {
          if (error.response) {
            _this7.error = error.response.data.errors;
          }
        });
      }
    },
    changelist: function changelist(type) {
      var _this8 = this;

      console.log(this.form[type].item_type);
      this.form[type].destination_items = [{
        destination_id: null,
        items: []
      }];
      this.form[type].category_items = [{
        category_id: null,
        items: []
      }];
      if (this.form[type].item_type !== 'category') {
        this.axios.get('/destinations', {
          params: {
            perpage: 1000
          },
          headers: {
            'X-MA-Client': 'backend'
          }
        }).then(function (response) {
          var data = response.data.data;


          if (!data) return;
          if (_this8.form[type].item_type === 'international') {
            _this8.tabDestination = 1;
            var dataChild = [];
            dataChild = data[1].child;

            _this8.lists.destinations = _this8.flattenData(dataChild);
          } else {
            _this8.tabDestination = 0;
            var _dataChild2 = [];
            _dataChild2 = data[_this8.tabDestination].child;

            _this8.lists.destinations = _this8.flattenData(_dataChild2);
          }
        }).catch(function (error) {
          if (error.response) {
            _this8.error = error.response.data.errors;
          }
        });
      }
    },
    fetchlist: function fetchlist(type) {
      var _this9 = this;

      this.error[type] = null;
      return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this9.axios.get('/' + type, {
          params: {
            perpage: 1000
          },
          headers: {
            'X-MA-Client': 'backend'
          }
        }).then(function (response) {
          var data = response.data.data;


          if (!data) return;

          if (type === 'destinations') {
            var dataChild = [];
            dataChild = data[_this9.tabDestination].child;

            _this9.lists[type] = _this9.flattenData(dataChild);
            // this.lists.cities = this.flattenData(dataGrandChild);
          } else if (type === 'categories') {
            _this9.lists[type] = data.map(function (item) {
              return {
                value: item.id,
                label: item.name
              };
            });
          }
          resolve();
        }).catch(function (error) {
          if (error.response) {
            _this9.error = error.response.data.errors;
            reject();
          }
        });
      });
    },
    fetchlistProducts: function fetchlistProducts() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, products;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this10.axios.get('/products-only');

              case 3:
                response = _context.sent;
                products = response.data.data;

                if (products !== null) {
                  products.forEach(function (item) {
                    _this10.lists.products.push({
                      label: item.name,
                      value: item.id
                    });
                  });
                }
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](0);

                console.log(_context.t0);
                if (_context.t0.response) {
                  _this10.error.product = _context.t0.response.data.errors;
                }

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this10, [[0, 8]]);
      }))();
    },
    fetchlistProductsTour: function fetchlistProductsTour() {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response, products;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this11.axios.get('/products-only?type_product=tour');

              case 3:
                response = _context2.sent;
                products = response.data.data;

                if (products !== null) {
                  products.forEach(function (item) {
                    _this11.lists.productsTour.push({
                      label: item.name,
                      value: item.id
                    });
                  });
                }
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                if (_context2.t0.response) {
                  _this11.error.product = _context2.t0.response.data.errors;
                }

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this11, [[0, 8]]);
      }))();
    },
    fetchlistHighlightSequence: function fetchlistHighlightSequence() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, dataSequence;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this12.axios.get('/highlights/section');

              case 3:
                response = _context3.sent;
                dataSequence = response.data.data;

                if (dataSequence !== null) {
                  dataSequence.forEach(function (item) {
                    _this12.lists.sequenceList.push({
                      id: item.id,
                      title: item.title
                    });
                  });
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this12, [[0, 8]]);
      }))();
    },
    fetchAll: function fetchAll() {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this13.fetchlistProducts();
                _context4.next = 4;
                return _this13.fetchlistProductsTour();

              case 4:
                _context4.next = 6;
                return _this13.fetchlist('destinations');

              case 6:
                _context4.next = 8;
                return _this13.fetchlist('categories');

              case 8:
                _context4.next = 10;
                return _this13.fetchHighlight('favorite');

              case 10:
                _context4.next = 12;
                return _this13.fetchHighlight('category');

              case 12:
                _context4.next = 14;
                return _this13.fetchHighlight('destination');

              case 14:
                _context4.next = 16;
                return _this13.fetchHighlight('trending');

              case 16:
                _context4.next = 18;
                return _this13.fetchHighlight('tour');

              case 18:
                _context4.next = 20;
                return _this13.fetchHighlight('campaign1');

              case 20:
                _context4.next = 22;
                return _this13.fetchHighlight('campaign2');

              case 22:
                _context4.next = 24;
                return _this13.fetchlistHighlightSequence();

              case 24:
                _context4.next = 29;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](0);

                console.log('Fetch highlights failed', _context4.t0);

              case 29:
                _this13.isLoading = false;

              case 30:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this13, [[0, 26]]);
      }))();
    },
    getTitleType: function getTitleType(type) {
      var tabTitle = '';
      if (type === 'favorite') {
        tabTitle = 'Eksplorasi Terfavorit';
      } else if (type === 'category') {
        tabTitle = 'Category Populer';
      } else if (type === 'destination') {
        tabTitle = 'Destination Populer';
      } else if (type === 'trending') {
        tabTitle = 'Pilihan Bulan Ini';
      } else if (type === 'tour') {
        tabTitle = 'Rekomendasi Tour';
      } else if (type === 'campaign1') {
        tabTitle = 'Campaign 1';
      } else if (type === 'campaign2') {
        tabTitle = 'Campaign 2';
      } else if (type === 'sequence') {
        tabTitle = 'Sequence';
      }

      return tabTitle;
    },
    validateBeforeSubmit: function validateBeforeSubmit(type, items) {
      if (type === 'destination') {
        var cityDestination = this.form.destination.international.map(function (val) {
          return val.city_international === null;
        });
        var countryDestination = this.form.destination.international.map(function (val) {
          return val.country_international === null || val.country_international.length < 1;
        });
        var checkNullCity = cityDestination.every(function (v) {
          return v === false;
        });
        var checkNullCountry = countryDestination.every(function (v) {
          return v === false;
        });

        if (!checkNullCity || !checkNullCountry) {
          this.$swal('Items required', 'Please select at least one City/Province on Domestic and International Destinations', 'warning');
          return false;
        }
      }
      var tabTitle = this.getTitleType(type);
      if (type !== 'destination') {
        if (!this.form[type].start_date) {
          this.$swal('Start Date Required', 'Please select Start Date on ' + tabTitle, 'warning');
          return false;
        }
        if (!this.form[type].end_date) {
          this.$swal('End Date Required', 'Please select End Date on ' + tabTitle, 'warning');
          return false;
        }
        if (this.form[type].status < 0) {
          this.$swal('Status required', 'Please fill Status on ' + tabTitle, 'warning');
          return false;
        }
        if (!this.form[type].description) {
          this.$swal('Deskripsi required', 'Please fill deskripsi on ' + tabTitle, 'warning');
          return false;
        }

        if (!this.form[type].description_en) {
          this.$swal('Description required', 'Please fill description on ' + tabTitle, 'warning');
          return false;
        }
      }
      // if (type !== 'destination') {
      //   if (!this.form[type].sequence) {
      //     this.$swal('Sequence required', `Please fill Sequence on ${tabTitle}`, 'warning');
      //     return false;
      //   }
      // }
      if (type !== 'category' && type !== 'destination') {
        if (!this.form[type].sectionStyle) {
          this.$swal('Section Style required', 'Please fill Section Style on ' + tabTitle, 'warning');
          return false;
        }
      }

      if (!this.form[type].title) {
        this.$swal('Title required', 'Please fill Title on ' + tabTitle, 'warning');
        return false;
      }

      if (!this.form[type].title_en) {
        this.$swal('Title En required', 'Please fill title on ' + tabTitle, 'warning');
        return false;
      }
      if (this.form[type].sectionStyle === 4) {
        if (this.form[type].item_type === 'category') {
          var checkCategory = this.form[type].category_items.map(function (val) {
            return val.category_id === null === true;
          });
          var checkNullCategory = checkCategory.every(function (v) {
            return v === false;
          });
          if (!checkNullCategory) {
            this.$swal('Category required', 'Please select category on ' + tabTitle, 'warning');
            return false;
          }
        }
        if (this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international') {
          var checkDesinations = this.form[type].destination_items.map(function (val) {
            return val.destination_id === null === true;
          });
          var checkNullDestination = checkDesinations.every(function (v) {
            return v === false;
          });
          if (!checkNullDestination) {
            this.$swal('Destination required', 'Please select destination on ' + tabTitle, 'warning');
            return false;
          }
        }
        var checkItems = items.map(function (val) {
          return val.length < 1 === true;
        });
        var checkNullItems = checkItems.every(function (v) {
          return v === false;
        });
        if (this.form[type].item_type === 'category' && !checkNullItems || this.form[type].item_type === 'domestic' && !checkNullItems || this.form[type].sectionStyle === 4 && this.form[type].item_type === 'international' && !checkNullItems) {
          this.$swal('Items required', 'Please select at least one items on ' + tabTitle, 'warning');
          return false;
        }
      }

      if (tabTitle === 'Category Populer' && items.length > 8) {
        this.$swal('Limited Input Category', 'Max of items selected is 8 on ' + tabTitle, 'warning');
        return false;
      }

      if (items.length < 1 && tabTitle !== 'Destination Populer') {
        this.$swal('Items required', 'Please select at least one items on ' + tabTitle, 'warning');
        return false;
      }

      if (items.length < 1 && tabTitle === 'Destination Populer') {
        this.$swal('Items required', 'Please select at least one City/Province on Domestic and International Destinations', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit(type) {
      var _this14 = this;

      if (type === 'destination') {
        var items = this.form[type].city_domestic.map(function (item) {
          return item.value;
        });
        var valid = this.validateBeforeSubmit(type, items);
        if (!valid) return;

        var internationalItem = this.form[type].international.flatMap(function (item) {
          return item.city_international.flatMap(function (val) {
            return val.value;
          });
        });
        var valids = this.validateBeforeSubmit(type, internationalItem);
        if (!valids) return;

        var joinItems = items.concat(internationalItem);
        var data = {
          start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
          end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
          status: this.form[type].status,
          // sequence: 10,
          title: this.form[type].title,
          title_en: this.form[type].title_en,
          description: this.form[type].description,
          description_en: this.form[type].description_en,
          items: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(joinItems)
        };
        this.axios.post('highlights/' + type, this.stringify(data)).then(function () {
          var tabTitle = _this14.getTitleType(type);
          _this14.$swal({
            title: 'Updated!',
            text: tabTitle + ' has been updated.',
            type: 'success',
            timer: 2000
          });
        }).catch(function (error) {
          if (error.response) {
            _this14.error = error.response.data.errors;
          }
        });
      } else if (type === 'sequence') {
        var _data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.lists.sequenceList);
        this.axios.patch('highlights/' + type, _data).then(function () {
          var tabTitle = _this14.getTitleType(type);
          _this14.$swal({
            title: 'Updated!',
            text: tabTitle + ' has been updated.',
            type: 'success',
            timer: 2000
          });
        }).catch(function (error) {
          if (error.response) {
            _this14.error = error.response.data.errors;
          }
        });
      } else {
        var _items = [];
        if (this.form[type].item_type === 'category') {
          _items = [];
          _items = this.form[type].category_items && this.form[type].category_items.length > 0 ? this.form[type].category_items.map(function (item) {
            return {
              category_id: item.category_id ? item.category_id.value : null,
              items: item.items && item.items.length > 0 ? item.items.map(function (val) {
                return val.value;
              }) : []
            };
          }) : [];
          var _valid = this.validateBeforeSubmit(type, _items);
          if (!_valid) return;
        } else if (this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international') {
          _items = [];
          _items = this.form[type].destination_items && this.form[type].destination_items.length > 0 ? this.form[type].destination_items.map(function (item) {
            return {
              destination_id: item.destination_id ? item.destination_id.value : null,
              items: item.items && item.items.length > 0 ? item.items.map(function (val) {
                return val.value;
              }) : []
            };
          }) : [];
          var _valid2 = this.validateBeforeSubmit(type, _items);
          if (!_valid2) return;
        } else if (this.form[type].item_type === 'item') {
          _items = [];
          _items = this.form[type].items.map(function (item) {
            return item.value;
          });
          var _valid3 = this.validateBeforeSubmit(type, _items);
          if (!_valid3) return;
        } else {
          _items = [];
          _items = this.form[type].items.map(function (item) {
            return item.value;
          });
          var _valid4 = this.validateBeforeSubmit(type, _items);
          if (!_valid4) return;
        }

        if (type === 'category') {
          var _data2 = {
            start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
            end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
            status: this.form[type].status,
            // sequence: this.form[type].sequence,
            title: this.form[type].title,
            title_en: this.form[type].title_en,
            description: this.form[type].description,
            description_en: this.form[type].description_en,
            items: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items)
          };
          this.axios.post('highlights/' + type, this.stringify(_data2)).then(function () {
            var tabTitle = _this14.getTitleType(type);
            _this14.$swal({
              title: 'Updated!',
              text: tabTitle + ' has been updated.',
              type: 'success',
              timer: 2000
            });
          }).catch(function (error) {
            if (error.response) {
              _this14.error = error.response.data.errors;
            }
          });
        } else if (type === 'campaign1' || type === 'campaign2') {
          if (this.form[type].sectionStyle < 4) {
            this.form[type].item_type = 'item';
          }
          var _data3 = {
            start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
            end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
            status: this.form[type].status,
            // sequence: this.form[type].sequence,
            style: this.form[type].sectionStyle,
            image: this.form[type].image.id,
            item_type: this.form[type].item_type,
            category_items: this.form[type].item_type === 'category' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items) : [],
            destination_items: this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items) : [],
            type: type,
            title: this.form[type].title,
            title_en: this.form[type].title_en,
            description: this.form[type].description,
            description_en: this.form[type].description_en,
            items: this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international' || this.form[type].item_type === 'category' ? [] : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items)
          };
          this.axios.post('highlights/' + type, this.stringify(_data3)).then(function () {
            var tabTitle = _this14.getTitleType(type);
            _this14.$swal({
              title: 'Updated!',
              text: tabTitle + ' has been updated.',
              type: 'success',
              timer: 2000
            });
          }).catch(function (error) {
            if (error.response) {
              _this14.error = error.response.data.errors;
            }
          });
        } else {
          if (this.form[type].sectionStyle < 4) {
            this.form[type].item_type = 'item';
          }
          var _data4 = {
            start_date: this.parseTime(this.form[type].start_date, 'YYYY-MM-DD'),
            end_date: this.parseTime(this.form[type].end_date, 'YYYY-MM-DD'),
            status: this.form[type].status,
            // sequence: this.form[type].sequence,
            image: this.form[type].image.id,
            style: this.form[type].sectionStyle,
            item_type: this.form[type].item_type,
            category_items: this.form[type].item_type === 'category' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items) : [],
            destination_items: this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items) : [],
            title: this.form[type].title,
            title_en: this.form[type].title_en,
            description: this.form[type].description,
            description_en: this.form[type].description_en,
            items: this.form[type].item_type === 'domestic' || this.form[type].item_type === 'international' || this.form[type].item_type === 'category' ? [] : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_items)
          };
          this.axios.post('highlights/' + type, this.stringify(_data4)).then(function () {
            var tabTitle = _this14.getTitleType(type);
            _this14.$swal({
              title: 'Updated!',
              text: tabTitle + ' has been updated.',
              type: 'success',
              timer: 2000
            });
          }).catch(function (error) {
            if (error.response) {
              _this14.error = error.response.data.errors;
            }
          });
        }
      }
    },
    addItem: function addItem(type, itemType) {
      if (type === 'international') {
        this.form.destination.international.push({
          country_international: [],
          city_international: []
        });
      }
      if (itemType === 'categories') {
        this.form[type].category_items.push({
          category_id: null,
          items: []
        });
      } else if (itemType === 'destination') {
        this.form[type].destination_items.push({
          destination_id: null,
          items: []
        });
      }
    },
    removeItem: function removeItem(item, object, itemIndex) {
      var _this15 = this;

      this.$swal({
        title: 'Delete Item',
        text: 'Are you sure to delete this item?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes'
      }).then(function (result) {
        if (result.value) {
          if (object === 'international') {
            _this15.form.destination.international.splice(itemIndex, 1);
          }
          if (item === 'categories') {
            _this15.form[object].category_items.splice(itemIndex, 1);
          }
          if (item === 'destination') {
            _this15.form[object].destination_items.splice(itemIndex, 1);
          }
        }
      });
    }
  },

  created: function created() {
    this.fetchAll();
  }
});

/***/ }),
/* 323 */,
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Common__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TagForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Add New Tag',

      form: {
        id: null,
        name: null,
        name_en: null,
        slug: null
      },

      error: null
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      this.axios.get('/tags/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;

        _this.form.id = data.id;
        _this.form.name = data.name;
        _this.form.name_en = data.name_en;
        _this.form.slug = data.slug;
      }).catch(function (error) {
        if (error.response) {
          _this.error = error.response.data.errors;
        }
      });
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.name_en) {
        this.$swal('Name EN required', 'Please fill name en to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this2 = this;

      this.axios.post('/tags', this.stringify(this.form)).then(function () {
        _this2.$router.push({
          name: 'tag-index'
        });
      }).catch(function (error) {
        if (error.response) {
          _this2.$swal({
            title: 'Failed',
            text: 'Oppss! Name already used',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    update: function update() {
      var _this3 = this;

      this.axios.put('/tags/' + this.form.id, this.stringify(this.form)).then(function () {
        _this3.$router.push({
          name: 'tag-index'
        });
      }).catch(function (error) {
        if (error.response) {
          _this3.$swal({
            title: 'Failed',
            text: 'Oppss! Name already used',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Tag';
    }
  }
});

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Pagination__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TagIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      params: {
        page: null,
        name: null
      }
    };
  },


  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setQuery();

              case 2:
                _context.next = 4;
                return _this.fetch();

              case 4:
                _this.isInitial = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetch: function fetch(page) {
      var _this2 = this;

      this.isLoading = true;
      this.params.page = page || null;

      this.axios.get('/tags', { params: this.params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        var isEmpty = !data && meta.pagination.current_page > meta.pagination.total_pages;
        _this2.items = !isEmpty ? data : [];
        _this2.pagination = !isEmpty ? meta.pagination : {};
        _this2.isLoading = false;
        _this2.setPushState();
      });
    },


    onInput: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    setQuery: function setQuery() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.params.name = _this3.$route.query.name || null;
        _this3.params.page = _this3.$route.query.page ? _this3.$route.query.page : null;

        resolve();
      });
    },
    setPushState: function setPushState() {
      var title = 'Tags page ' + this.params.page;
      var paramUrl = '/tags';
      var parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, '' + paramUrl + parameters);
    },
    generateQuery: function generateQuery(params) {
      var _this4 = this;

      if (!params) return null;

      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
        return params[key];
      }).map(function (key) {
        return key + '=' + _this4.params[key];
      });

      return query ? '?' + query.join('&') : null;
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'tag-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'tag-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(tag) {
      var _this5 = this;

      this.axios.delete('/tags/' + tag.id).then(function () {
        _this5.fetch();

        _this5.$swal('Deleted!', tag.name + ' has been deleted.', 'success');
      });
    },
    remove: function remove(tag) {
      var _this6 = this;

      this.$swal({
        title: 'Deleting Tag',
        text: 'Are you sure you want to delete ' + tag.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this6.delete(tag);
        } else {
          _this6.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this6.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }
      });
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Ckeditor__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bus__ = __webpack_require__(9);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VendorForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Add New Source',

      vendor: {
        id: null,
        name: null,
        code: null,
        description: null,
        contact_person: null,
        phone: null,
        email: null
      },

      error: null,

      configs: {
        ckeditor: {
          toolbar: [['Styles', 'Format', '-', 'Bold', 'Italic', 'Strike', '-', 'NumberedList', 'BulletedList', '-', 'Source']],
          height: 300,
          extraPlugins: 'uploadimage',
          uploadUrl: '/static/temp/'
        }
      }
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  components: {
    Ckeditor: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Ckeditor__["a" /* default */]
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.axios.get('/vendors/' + _this.$route.params.id).then(function (response) {
                  var data = response.data.data;


                  _this.vendor.id = data.id;
                  _this.vendor.name = data.name;
                  _this.vendor.code = data.code;
                  _this.vendor.description = data.description;
                  _this.vendor.contact_person = data.contact_person;
                  _this.vendor.phone = data.phone;
                  _this.vendor.email = data.email;
                }).catch(function (error) {
                  if (error.response) {
                    _this.errors = error.response.data.errors;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validate: function validate() {
      if (!this.vendor.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.vendor.contact_person) {
        this.$swal('Contact Person required', 'Please fill contact person to continue', 'warning');
        return false;
      }

      if (!this.vendor.code) {
        this.$swal('Source code required', 'Please fill source code to continue', 'warning');
        return false;
      }

      if (!this.vendor.code) {
        this.$swal('Source code required', 'Please fill source code to continue', 'warning');
        return false;
      }

      if (!this.vendor.email) {
        this.$swal('Email required', 'Please fill email to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this2 = this;

      this.axios.post('/vendors', this.stringify(this.vendor)).then(function (response) {
        console.log(response);
        __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('destroy-editor');
        _this2.$router.push({
          name: 'source-index'
        });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this2.errors = error.response.data.errors;
        }

        if (error) {
          var vendor = _this2.vendor.name || 'vendor';
          _this2.$swal({
            title: 'Create Failed!',
            text: 'Failed to create ' + vendor,
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    update: function update() {
      var _this3 = this;

      this.axios.put('/vendors/' + this.vendor.id, this.stringify(this.vendor)).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('destroy-editor');
        _this3.$router.push({
          name: 'source-index'
        });
      }).catch(function (error) {
        if (error.response) {
          _this3.errors = error.response.data.errors;
        }

        if (error) {
          _this3.$swal({
            title: 'Create Failed!',
            text: 'Failed to update ' + _this3.vendor.name,
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('destroy-editor');
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Product';
    }
  }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VendorIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      vendors: [],
      pagination: {},

      params: {
        name: null,
        contact: null
      }
    };
  },


  methods: {
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/vendors', {
        params: this.params,
        responseType: this.type
      }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          _this.vendors = null;
          _this.pagination = {};
          return;
        }

        _this.vendors = data;
        _this.pagination = meta.pagination;
      });

      if (page) {
        window.history.pushState('Vendors page: ' + page, null, '/sources?page=' + page);
      }
    },


    onInput: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'source-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'source-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(vendor) {
      var _this2 = this;

      this.axios.delete('/vendors/' + vendor.id).then(function () {
        _this2.fetch();

        _this2.$swal({
          title: 'Deleted',
          text: vendor.name + ' has been deleted.',
          type: 'success',
          timer: 2000
        });
      });
    },
    remove: function remove(vendor) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting Source',
        text: 'Are you sure you want to delete ' + vendor.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this3.delete(vendor);
        } else {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000
          });
        }
      });
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_common_Modal__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MerchantForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Add New Merchant',

      merchant: {
        id: null,
        name: null,
        address: null,
        city: null,
        province: null,
        country: null,
        zip_code: null,
        phone: null,
        email: null,
        pic_name: null,
        pic_phone: null,
        pic_email: null,
        banks: []
      },
      bank: {
        currency: 'IDR',
        swift_code: null,
        name: null,
        branch: null,
        account_number: null,
        account_owner: null
      },
      list: {
        currency: ['IDR', 'USD', 'EUR', 'SGD']
      },
      show: {
        bank: false
      },
      isEditBank: false,
      editIdx: null,
      error: null
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.axios.get('/merchants/' + _this.$route.params.id).then(function (response) {
                  var data = response.data.data;

                  _this.setFormValue(data);
                }).catch(function (error) {
                  if (error.response) {
                    _this.errors = error.response.data.errors;
                  }
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setBanksValue: function setBanksValue(data) {
      var banks = [];

      if (data.length < 1) return banks;

      data.forEach(function (bank) {
        banks.push({
          id: bank.id || null,
          currency: bank.currency || null,
          swift_code: bank.swift_code || null,
          name: bank.bank_name || null,
          branch: bank.bank_branch || null,
          account_number: bank.account_number || null,
          account_owner: bank.account_owner || null
        });
      });

      return banks;
    },
    setFormValue: function setFormValue(data) {
      this.merchant.id = data.id;
      this.merchant.name = data.name || null;
      this.merchant.address = data.address || null;
      this.merchant.city = data.city || null;
      this.merchant.province = data.province || null;
      this.merchant.country = data.country || null;
      this.merchant.country_en = data.country_en || null;
      this.merchant.zip_code = data.zip_code || null;
      this.merchant.phone = data.phone || null;
      this.merchant.email = data.email || null;
      this.merchant.pic_name = data.pic || null;
      this.merchant.pic_phone = data.contact_person || null;
      this.merchant.pic_email = data.pic_email || null;
      this.merchant.banks = this.setBanksValue(data.banks);
    },
    showAddBank: function showAddBank() {
      this.isEditBank = false;
      this.setBankFieldEmpty();
      this.showModalBank('bank');
    },
    showEditBank: function showEditBank(idx) {
      this.isEditBank = true;
      this.setBankField(idx);
      this.editIdx = idx;
      this.showModalBank('bank');
    },
    showModalBank: function showModalBank(modal) {
      if (!this.isEditBank) {
        this.setBankFieldEmpty();
      }
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$off('close-modal');
      document.body.classList.add('locked');
    },
    addBank: function addBank() {
      if (!this.validateAddBank()) return;
      this.merchant.banks.push({
        currency: this.bank.currency,
        swift_code: this.bank.swift_code,
        name: this.bank.name,
        branch: this.bank.branch,
        account_number: this.bank.account_number,
        account_owner: this.bank.account_owner
      });
      this.show.bank = false;
    },
    editBank: function editBank(idx) {
      if (!this.validateAddBank()) return;
      this.merchant.banks[idx].currency = this.bank.currency;
      this.merchant.banks[idx].swift_code = this.bank.swift_code;
      this.merchant.banks[idx].name = this.bank.name;
      this.merchant.banks[idx].branch = this.bank.branch;
      this.merchant.banks[idx].account_number = this.bank.account_number;
      this.merchant.banks[idx].account_owner = this.bank.account_owner;
      this.show.bank = false;
    },
    removeBank: function removeBank(idx) {
      this.merchant.banks.splice(idx, 1);
    },
    setBankField: function setBankField(idx) {
      this.bank.currency = this.merchant.banks[idx].currency;
      this.bank.swift_code = this.merchant.banks[idx].swift_code;
      this.bank.name = this.merchant.banks[idx].name;
      this.bank.branch = this.merchant.banks[idx].branch;
      this.bank.account_number = this.merchant.banks[idx].account_number;
      this.bank.account_owner = this.merchant.banks[idx].account_owner;
    },
    setBankFieldEmpty: function setBankFieldEmpty() {
      this.bank.currency = 'IDR';
      this.bank.swift_code = null;
      this.bank.name = null;
      this.bank.branch = null;
      this.bank.account_number = null;
      this.bank.account_owner = null;
    },
    validateAddBank: function validateAddBank() {
      if (!this.bank.name) {
        this.$swal('Bank Name required', 'Please fill Bank name to continue', 'warning');
        return false;
      }
      if (!this.bank.account_number) {
        this.$swal('Account Number required', 'Please fill Account Number to continue', 'warning');
        return false;
      }
      if (!this.bank.account_owner) {
        this.$swal('Account Owner required', 'Please fill Account Owner to continue', 'warning');
        return false;
      }

      return true;
    },
    validate: function validate() {
      if (!this.merchant.name) {
        this.$swal('Agent Name required', 'Please fill Agent name to continue', 'warning');
        return false;
      }
      if (!this.merchant.address) {
        this.$swal('Address required', 'Please fill Address to continue', 'warning');
        return false;
      }
      if (!this.merchant.city) {
        this.$swal('City required', 'Please City to continue', 'warning');
        return false;
      }
      if (!this.merchant.province) {
        this.$swal('Province required', 'Please fill Province to continue', 'warning');
        return false;
      }
      if (!this.merchant.country) {
        this.$swal('Country required', 'Please fill Country to continue', 'warning');
        return false;
      }
      if (!this.merchant.zip_code) {
        this.$swal('Zip Code required', 'Please fill Zip Code to continue', 'warning');
        return false;
      }
      if (!this.merchant.phone) {
        this.$swal('Agent Phone Number required', 'Please fill Agent Phone Number to continue', 'warning');
        return false;
      }
      if (!this.merchant.email) {
        this.$swal('Agent Email required', 'Please fill Agent Email to continue', 'warning');
        return false;
      }
      if (!this.merchant.pic_name) {
        this.$swal('PIC Name required', 'Please fill PIC Name to continue', 'warning');
        return false;
      }
      if (!this.merchant.pic_phone) {
        this.$swal('PIC phone number required', 'Please fill PIC phone number to continue', 'warning');
        return false;
      }
      if (!this.merchant.pic_email) {
        this.$swal('PIC Email required', 'Please fill PIC Email to continue', 'warning');
        return false;
      }
      if (this.merchant.banks.length < 1) {
        this.$swal('Bank Account required', 'Please fill Bank Account to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    generateBank: function generateBank(data) {
      var _this2 = this;

      var banks = [];
      data.forEach(function (bank) {
        banks.push({
          id: bank.id || null,
          merchant_id: _this2.$route.params.id || null,
          currency: bank.currency,
          swift_code: bank.swift_code,
          bank_name: bank.name,
          bank_branch: bank.branch,
          account_number: parseInt(bank.account_number, 10),
          account_owner: bank.account_owner
        });
      });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(banks);
    },
    generateData: function generateData() {
      /* eslint-disable */
      var _merchant = this.merchant,
          id = _merchant.id,
          name = _merchant.name,
          address = _merchant.address,
          city = _merchant.city,
          province = _merchant.province,
          country = _merchant.country,
          zip_code = _merchant.zip_code,
          phone = _merchant.phone,
          email = _merchant.email,
          pic_name = _merchant.pic_name,
          pic_phone = _merchant.pic_phone,
          pic_email = _merchant.pic_email,
          banks = _merchant.banks;


      var data = {};

      data.id = id;
      data.name = name;
      data.address = address;
      data.city = city;
      data.province = province;
      data.country = country;
      data.zip_code = zip_code;
      data.phone = phone;
      data.email = email;
      data.pic = pic_name;
      data.contact_person = pic_phone;
      data.pic_email = pic_email;
      data.banks = this.generateBank(banks);

      return this.stringify(data);
    },
    create: function create() {
      var _this3 = this;

      var data = this.generateData();

      this.axios.post('/merchants', data).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('destroy-editor');
        _this3.$swal({
          title: 'Created',
          text: 'Merchant ' + _this3.merchant.name + ' has been created.',
          type: 'success',
          timer: 3000
        });

        _this3.$router.go(-1);
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this3.errors = error.response.data.errors;
        }

        if (error) {
          var merchant = _this3.merchant.name || 'merchant';
          _this3.$swal({
            title: 'Create Failed!',
            text: 'Failed to create ' + merchant,
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    update: function update() {
      var _this4 = this;

      var data = this.generateData();

      this.axios.put('/merchants/' + this.merchant.id, data).then(function () {
        __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('destroy-editor');
        _this4.$swal({
          title: 'Updated',
          text: 'Merchant ' + _this4.merchant.name + ' has been updated.',
          type: 'success',
          timer: 3000
        });

        _this4.$router.go(-1);
      }).catch(function (error) {
        if (error.response) {
          _this4.errors = error.response.data.errors;
        }

        if (error) {
          _this4.$swal({
            title: 'Create Failed!',
            text: 'Failed to update ' + _this4.merchant.name,
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$emit('destroy-editor');
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (!this.isCreate) {
      this.fetch();
      this.title = 'Edit Merchant';
    }
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_common_Pagination__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MerchantIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_5__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      merchants: [],
      pagination: {},
      isLoading: false,
      error: null,

      params: {
        page: null,
        name: null,
        city: null,
        country: null,
        province: null,
        pic: null
      }
    };
  },


  methods: {
    fetch: function fetch() {
      var _this = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.isLoading = true;
      if (page) this.params.page = page || null;

      var params = this.params;

      this.axios.get('/merchants', { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          _this.merchants = null;
          _this.pagination = {};
          return;
        }

        _this.merchants = data;
        _this.pagination = meta.pagination;
      }).catch(function (error) {
        console.log('Fetch product error', error);

        if (error.response) {
          _this.error = error.response.data.errors;
        }

        if (error) {
          _this.$swal({
            title: 'Failed',
            text: 'Failed to fetch Merchants data',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this.fetchProduct();
            }
          });
        }
      }).finally(function () {
        _this.isLoading = false;
      });

      if (page) {
        window.history.pushState('Merchant page: ' + page, null, '/merchant?page=' + page);
      }
    },


    onInput: __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'merchant-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'merchant-edit',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(merchant) {
      var _this2 = this;

      this.axios.delete('/merchants/' + merchant.id).then(function () {
        _this2.fetch();

        _this2.$swal({
          title: 'Deleted',
          text: merchant.name + ' has been deleted.',
          type: 'success',
          timer: 2000
        });
      });
    },
    remove: function remove(merchant) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting Merchant',
        text: 'Are you sure you want to delete ' + merchant.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this3.delete(merchant);
        } else {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 2000
          });
        }
      });
    },
    setQuery: function setQuery() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this4.params.name = _this4.$route.query.name || null;
        _this4.params.page = _this4.$route.query.page || null;
        _this4.params.city = _this4.$route.query.city || null;
        _this4.params.country = _this4.$route.query.country || null;
        _this4.params.province = _this4.$route.query.province || null;
        _this4.params.pic = _this4.$route.query.pic || null;
        resolve();
      });
    }
  },

  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this5.setQuery();

            case 2:
              _this5.fetch();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(14);







var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment';






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReviewIndex',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Common__["a" /* default */]],
  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a
  },
  data: function data() {
    return {
      params: {
        page: null,
        type: null,
        approval_status: null,
        name: null,
        export_csv: 0
      },
      product_name: null,
      listProducts: [],
      start_submit_date: null,
      end_submit_date: null,
      start_approval_date: null,
      end_approval_date: null,
      reviews: [],
      isLoading: false,
      error: null,
      pagination: {},
      statuses: [{
        title: 'All Status',
        value: null
      }, {
        title: 'Waiting for Approval',
        value: 0
      }, {
        title: 'Approved',
        value: 1
      }, {
        title: 'Rejected',
        value: 2
      }],
      types: [{
        title: 'All reviews Type',
        value: null
      }, {
        title: 'Default reviews',
        value: 'default_review'
      }, {
        title: 'Top Hover reviews',
        value: 'top_review'
      }, {
        title: 'Bottom Hover reviews',
        value: 'bottom_review'
      }]
    };
  },
  created: function created() {
    this.init();
  },

  watch: {
    'params.page': {
      handler: function handler(val) {
        _this.fetch(val);
      },
      deep: false
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.setQuery();

              case 2:
                _context.next = 4;
                return _this2.fetch();

              case 4:
                _context.next = 6;
                return _this2.fetchListProducts();

              case 6:
                _this2.isInitial = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    onExportCsv: function onExportCsv() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, paramsDate, paramsName, totalRow, queryParams, url;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = '';

                _this3.params.export_csv = 1;
                paramsDate = {
                  reviewed_at_from: _this3.startSubmitDate || '',
                  reviewed_at_to: _this3.endSubmitDate || '',
                  approval_date_from: _this3.startApprovalDate || '',
                  approval_date_to: _this3.endApprovalDate || ''
                };
                paramsName = {
                  product_name: _this3.productName || ''
                };
                totalRow = _this3.pagination.total;
                queryParams = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this3.params, paramsDate, paramsName);


                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(queryParams).forEach(function (key) {
                  params += key + '=' + (queryParams[key] || '') + '&';
                });

                params = params.slice(0, -1);
                // if (this.params.status) {
                url = '';

                url = __WEBPACK_IMPORTED_MODULE_10__config__["i" /* default */] + '/review/backoffice?' + params + '&perpage=' + (totalRow || '');

                window.location = url;
                _this3.params.export_csv = 0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    setQuery: function setQuery() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this4.params.name = _this4.$route.query.name || null;
        _this4.params.page = _this4.$route.query.page || 1;
        resolve();
      });
    },
    fetch: function fetch() {
      var _this5 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.isLoading = true;
      this.params.page = 0;
      if (page && (typeof page === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(page)) !== 'object') this.params.page = page;
      // if (page) this.params.page = page || null;
      var paramsDate = {
        reviewed_at_from: this.parseTime(this.startSubmitDate, 'YYYY-MM-DD') || '',
        reviewed_at_to: this.parseTime(this.endSubmitDate, 'YYYY-MM-DD') || '',
        approval_date_from: this.parseTime(this.startApprovalDate, 'YYYY-MM-DD') || '',
        approval_date_to: this.parseTime(this.endApprovalDate, 'YYYY-MM-DD') || ''
      };
      var paramsName = {
        product_name: this.productName || ''
      };
      this.axios.get('/review/backoffice', { params: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.params, paramsDate, paramsName) }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        var isEmpty = !data && meta.pagination.current_page > meta.pagination.total_pages;
        _this5.reviews = !isEmpty ? data : [];
        _this5.pagination = !isEmpty ? meta.pagination : {};
        // this.setPushState();
      }).catch(function (error) {
        console.log('Fetch error', error);

        if (error.response) {
          _this5.error = error.response.data.errors;
        }

        if (error) {
          _this5.$swal({
            title: 'Failed!',
            text: 'Failed to fetch Data',
            type: 'warning',
            timer: 3000
          });
        }
      }).finally(function () {
        _this5.isLoading = false;
      });
    },
    fetchListProducts: function fetchListProducts() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, products;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this6.axios.get('/products-only');

              case 3:
                response = _context3.sent;
                products = response.data.data;

                if (products !== null) {
                  products.forEach(function (item) {
                    _this6.listProducts.push({
                      label: item.name,
                      value: item.name
                    });
                  });
                }
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](0);

                console.log(_context3.t0);
                if (_context3.t0.response) {
                  _this6.error.product = _context3.t0.response.data.errors;
                }

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 8]]);
      }))();
    },
    pushState: function pushState() {
      this.fetch();
    },
    resetState: function resetState() {
      this.params.page = null;
      this.params.approval_status = null;
      this.params.name = null;
      this.params.email = null;
      this.product_name = null;
      this.start_submit_date = null;
      this.start_approval_date = null;
      this.end_submit_date = null;
      this.end_approval_date = null;
      this.fetch();
    },
    setPushState: function setPushState() {
      var title = 'reviews page ' + this.params.page;
      var paramUrl = '/reviews';
      var parameters = this.generateQuery(this.params);
      var startSubmitParam = this.startSubmitDate ? '&reviewed_at_from=' + this.startSubmitDate : '';
      var endSubmitParam = this.endSubmitDate ? '&reviewed_at_to=' + this.endSubmitDate : '';
      var startApprovalParam = this.startApprovalDate ? '&approval_date_from=' + this.startApprovalDate : '';
      var endApprovalParam = this.endApprovalDate ? '&approval_date_to=' + this.endApprovalDate : '';
      window.history.pushState(title, null, '' + paramUrl + parameters + startSubmitParam + endSubmitParam + startApprovalParam + endApprovalParam);
    },
    generateQuery: function generateQuery(params) {
      var _this7 = this;

      if (!params) return null;

      var query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
        return params[key];
      }).map(function (key) {
        return key + '=' + _this7.params[key];
      });

      return query ? '?' + query.join('&') : null;
    },


    onInput: __WEBPACK_IMPORTED_MODULE_7_lodash_debounce___default()(function debouncedInput() {
      this.params.page = null;
      this.fetch();
    }, 500),

    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({
        name: 'review-create'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'review-approval',
        params: {
          id: id
        }
      });
    },
    delete: function _delete(review) {
      var _this8 = this;

      this.axios.delete('/reviews/' + review.id).then(function () {
        _this8.fetch();

        _this8.$swal({
          title: 'Deleted',
          text: review.name + ' has been deleted.',
          type: 'success',
          timer: 3000
        });
      }).catch(function (error) {
        if (error.response) {
          _this8.$swal({
            title: 'Failed',
            text: 'Oppss! You can\'t delete "' + review.name + '" because this category still used by the product',
            type: 'error',
            timer: 8000
          });
        }
      });
    },
    remove: function remove(review) {
      var _this9 = this;

      this.$swal({
        title: 'Deleting review',
        text: 'Are you sure you want to delete ' + review.name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this9.delete(review);
        } else {
          _this9.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this9.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }
      });
    }
  },
  computed: {
    startSubmitDate: function startSubmitDate() {
      if (this.start_submit_date) {
        return this.parseTime(this.start_submit_date, 'YYYY-MM-DD hh:mm:ss');
      }
      return null;
    },
    endSubmitDate: function endSubmitDate() {
      if (this.end_submit_date) {
        return this.parseTime(this.end_submit_date, 'YYYY-MM-DD hh:mm:ss');
      }
      return null;
    },
    startApprovalDate: function startApprovalDate() {
      if (this.start_approval_date) {
        return this.parseTime(this.start_approval_date, 'YYYY-MM-DD hh:mm:ss');
      }
      return null;
    },
    endApprovalDate: function endApprovalDate() {
      if (this.end_approval_date) {
        return this.parseTime(this.end_approval_date, 'YYYY-MM-DD hh:mm:ss');
      }
      return null;
    },
    productName: function productName() {
      if (this.product_name) {
        return this.product_name.value;
      }
      return null;
    },
    reviewType: function reviewType() {
      return function (v) {
        if (v === 0) {
          return 'Waiting for Approval';
        }
        if (v === 1) {
          return 'Approved';
        }
        if (v === 2) {
          return 'Rejected';
        }
        return null;
      };
    }
  }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_common_VideoUpload__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Box__ = __webpack_require__(79);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ReviewForm',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Common__["a" /* default */]],

    data: function data() {
        return {
            title: 'Add Review',

            review: {
                product_name: null,
                description: null,
                name: null,
                gallery: null,
                video: []
            },
            error: {
                product: null
            },
            flaging: null,
            list: {
                product: [],
                type: [{
                    label: 'Explore Product',
                    value: 'explore'
                }, {
                    label: 'Tour Product',
                    value: 'tour'
                }]
            },
            show: {
                gallery: false,
                video: false
            }
        };
    },

    components: {
        Box: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Box__["a" /* default */],
        FileGallery: __WEBPACK_IMPORTED_MODULE_7__components_modules_common_FileGallery__["a" /* default */],
        VideoUpload: __WEBPACK_IMPORTED_MODULE_8__components_modules_common_VideoUpload__["a" /* default */],
        Modal: __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Modal__["a" /* default */]
    },

    props: {
        isCreate: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        showModal: function showModal(modal) {
            this.$store.commit('SET_MODAL', modal);
            this.show[modal] = true;
            document.body.classList.add('locked');
        },
        closeModals: function closeModals() {
            var _this = this;

            document.body.classList.remove('locked');
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.show).forEach(function (modal) {
                _this.show[modal] = false;
            });
        },
        setImage: function setImage(payload) {
            if (payload.target === 'gallery') {
                this.review.gallery = payload.images;
            }
        },
        setVideo: function setVideo(payload) {
            var _this2 = this;

            this.review.video = [];
            if (payload.target === 'Video Upload') {
                setTimeout(function () {
                    _this2.review.video = payload.video;
                }, 1000);
            }
        },
        validate: function validate() {
            if (!this.review.product_name) {
                this.$swal('Product Name required', 'Please fill Product name to continue', 'warning');
                return false;
            }
            if (!this.review.name) {
                this.$swal('Account Name required', 'Please fill Account name to continue', 'warning');
                return false;
            }
            if (!this.review.description) {
                this.$swal('Description is required', 'Please fill Description to continue', 'warning');
                return false;
            }
            if (!this.review.gallery) {
                this.$swal('Image is required', 'Please fill image to continue', 'warning');
                return false;
            }
            // if (!this.review.video) {
            //     this.$swal('Video is required', 'Please fill Video to continue', 'warning');
            //     return false;
            // }
            return true;
        },
        create: function create() {
            var _this3 = this;

            var validation = this.validate();
            if (!validation) return;
            this.$swal({
                title: 'Confirmation',
                text: 'Are you sure want to submit this review?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#666',
                confirmButtonText: 'Yes'
            }).then(function (result) {
                if (result.value) {
                    _this3.submit();
                }
            });
        },
        submit: function submit() {
            var _this4 = this;

            var data = this.generateData();

            this.axios.post('review/backoffice', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data)).then(function () {
                __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$emit('destroy-editor');
                _this4.$swal({
                    title: 'Created',
                    text: 'Review has been created',
                    type: 'success',
                    timer: 3000
                });

                _this4.$router.go(-1);
            }).catch(function (error) {
                console.log('error', error);

                if (error.response) {
                    _this4.errors = error.response.data.errors;
                }

                if (error) {
                    _this4.$swal({
                        title: 'Create Failed!',
                        text: 'Failed to create review',
                        type: 'warning',
                        timer: 5000
                    });
                }
            });
        },
        cancel: function cancel() {
            __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$emit('destroy-editor');
            this.$router.go(-1);
        },
        generateData: function generateData() {
            /* eslint-disable */
            var _review = this.review,
                product_name = _review.product_name,
                name = _review.name,
                gallery = _review.gallery,
                video = _review.video,
                description = _review.description;


            var data = {};
            data.product_id = product_name.value;
            data.product_name = product_name.label;
            data.name = name;
            data.photos = gallery ? gallery.map(function (item) {
                return item.url;
            }) : null;
            if (video.length > 0) {
                data.videos = [video];
            }
            data.description = description;

            return data;
        },
        fetchlistProducts: function fetchlistProducts() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var response, products;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this5.review.product_name = null;
                                _this5.list.product = [];
                                _context.prev = 2;
                                _context.next = 5;
                                return _this5.axios.get('/products?b2b_type=internal&perpage=1000&page=1&flaging=' + _this5.flaging.value);

                            case 5:
                                response = _context.sent;
                                products = response.data.data;

                                if (products !== null) {
                                    products.forEach(function (item) {
                                        _this5.list.product.push({
                                            label: item.name,
                                            value: item.id,
                                            image: item.image_url,
                                            merchant: item.merchant.name,
                                            destination: item.destinations
                                        });
                                    });
                                }
                                _context.next = 14;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](2);

                                console.log(_context.t0);
                                if (_context.t0.response) {
                                    _this5.error.product = _context.t0.response.data.errors;
                                }

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5, [[2, 10]]);
            }))();
        }
    },
    // created() {
    //     this.fetchlistProducts();
    // },
    mounted: function mounted() {
        var _this6 = this;

        __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$on('close-modal', function () {
            _this6.closeModals();
        });
    },
    destroyed: function destroyed() {
        __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$off('close-modal');
    }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blazy__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone_dist_vue2Dropzone_min_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone_dist_vue2Dropzone_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_dropzone_dist_vue2Dropzone_min_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var belazy = void 0;
var lazyLoadInterval = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoUpload',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      videos: [],
      checked: [],
      limit: 60,
      isAll: false,
      meta: null,

      presignedData: {},
      showDropzones: true,
      urlConfigs: '',
      isLoading: false,
      isComplete: false,
      isDisabled: true,
      configs: {
        dropzones: {
          url: '#',
          method: 'put',
          addRemoveLinks: true,
          autoProcessQueue: false,
          timeout: null,
          uploadMultiple: false,
          maxFileSize: 1,
          maxFiles: 1,
          acceptedFiles: 'video/*',
          headers: {
            Accept: 'multipart/form-data',
            'Content-Type': 'multipart/form-data'
          }
        }
      }
    };
  },


  props: {
    selected: {
      required: false,
      default: function _default() {
        return [];
      }
    },

    type: {
      type: String,
      required: true
    },

    isReview: {
      type: Boolean,
      required: false,
      default: false
    },

    isMultiple: {
      type: Boolean,
      required: false,
      default: false
    },

    inline: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    limited: function limited() {
      if (this.videos.length > 0) {
        return this.videos.slice(0, this.limit);
      }
      return this.videos;
    }
  },

  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_2_vue2_dropzone___default.a,
    Circle2: __WEBPACK_IMPORTED_MODULE_3_vue_loading_spinner__["b" /* Circle2 */]
  },

  watch: {
    limited: function limited() {
      var _this = this;

      this.$nextTick(function () {
        _this.revalidateLazyload();
      });
    }
  },

  methods: {
    fileAddedEvent: function fileAddedEvent(file) {
      var _this2 = this;

      var fileType = file.type.split('/');
      var type = fileType[1];
      var data = {
        path: 'activity/review/',
        file_type: type === 'quicktime' ? 'mov' : type
      };
      if (file.size > 1e+8) {
        this.$swal('Max Size Reached', 'Maximum video file size is 100mb', 'warning');
      } else {
        this.axios.post('galleries/presigned-url', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
          _this2.presignedData = response.data.data;
          // this.$refs.videoUpload.options.url = response.data.data.presigned_url;
          // this.$refs.videoUpload.dropzone.options.url = response.data.data.presigned_url;
          _this2.urlConfigs = response.data.data.presigned_url;
          _this2.isLoading = true;
          _this2.completeEvent(file);
          // this.$refs.videoUpload.processQueue();
        });
      }
    },
    completeEvent: function completeEvent(file) {
      var _this3 = this;

      var axios = this.axios.create();
      /* eslint-disable */
      delete axios.defaults.headers.common['Authorization'];
      var config = {
        method: 'put',
        url: this.urlConfigs,
        data: file,
        headers: {
          'Content-Type': 'multipart/form-data',
          'Access-Control-Allow-Origin': '*'
        }
      };

      axios(config).then(function (response) {
        console.log('Status Code : ', response.status);
        _this3.isLoading = false;
        _this3.isComplete = true;
        setTimeout(function () {
          _this3.isComplete = false;
          _this3.isDisabled = false;
        }, 2000);
        _this3.axios.defaults.headers.common.Authorization = 'Bearer ' + _this3.$store.state.token;
      }).catch(function (error) {
        _this3.isDisabled = true;
        _this3.axios.defaults.headers.common.Authorization = 'Bearer ' + _this3.$store.state.token;
        console.log(error);
      });
    },
    parseVideo: function parseVideo(url, size) {
      if (!url) return '';
      var videoUrl = url.includes('https://') ? url : 'https://' + url;
      var videoSize = size || '_thumb';
      return videoUrl.substring(0, url.lastIndexOf('.')) + videoSize + videoUrl.substring(url.lastIndexOf('.'));
    },
    update: function update() {
      this.$emit('update-video', {
        target: this.type,
        video: this.presignedData.url
      });
      this.$store.commit('SET_MODAL');
      __WEBPACK_IMPORTED_MODULE_5__utils_bus__["a" /* default */].$emit('close-modal');
    },
    lazyLoad: function lazyLoad() {
      var _this4 = this;

      // eslint-disable-next-line no-new, no-unused-vars
      belazy = new __WEBPACK_IMPORTED_MODULE_1_blazy___default.a({
        selector: '.thumbnail'
      });

      lazyLoadInterval = setInterval(function () {
        _this4.revalidateLazyload();
      }, 2 * 1000);
    },
    revalidateLazyload: function revalidateLazyload() {
      if (typeof belazy !== 'undefined') {
        belazy.revalidate();
      }
    }
  },

  created: function created() {
    if (this.selected) {
      this.checked = this.selected;
    }

    //   this.fetch();
  },
  mounted: function mounted() {
    this.lazyLoad();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(lazyLoadInterval);
  }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Box__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel_dist_vue_slick_carousel_css__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel_dist_vue_slick_carousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slick_carousel_dist_vue_slick_carousel_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_theme_css__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_slick_carousel_dist_vue_slick_carousel_theme_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ReviewForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Review Detail',
      detailReview: null,
      destinationDetail: [],
      c1: undefined,
      c2: undefined,
      settings: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        dots: true,
        focusOnSelect: true
      },
      settings2: {
        infinite: true,
        slidesToShow: 5,
        speed: 500,
        focusOnSelect: true
      },
      show: {
        images: false
      }
    };
  },

  components: {
    Box: __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Box__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Modal__["a" /* default */],
    VueSlickCarousel: __WEBPACK_IMPORTED_MODULE_4_vue_slick_carousel___default.a
  },

  methods: {
    openModal: function openModal() {
      this.c1 = this.$refs.c1;
      this.c2 = this.$refs.c2;
      this.$store.commit('SET_MODAL', 'image-modal');
      this.show.images = true;
      document.body.classList.add('locked');
    },
    getDetail: function getDetail() {
      var _this = this;

      this.axios.get('/review/backoffice/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;

        _this.detailReview = data;
        _this.destinationDetail = data.detail.destination.split(',');
      }).catch(function (error) {
        if (error.response) {
          _this.errors = error.response.data.errors;
        }
      });
    },
    approve: function approve() {
      var _this2 = this;

      this.$swal({
        title: 'Confirmation',
        text: 'Are you sure want to APPROVE this review?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes, Approve'
      }).then(function (result) {
        if (result.value) {
          _this2.axios.patch('review/backoffice/approve/' + _this2.$route.params.id).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('destroy-editor');
            _this2.$swal({
              title: 'Approve Succeed',
              text: 'The review will be appear in Customer Site.\nKlik OK to redirect to review list',
              type: 'success',
              timer: 5000
            }).then(function (results) {
              if (results) {
                _this2.$router.go(-1);
              }
            });
          });
        }
      });
    },
    reject: function reject() {
      var _this3 = this;

      this.$swal({
        title: 'Confirmation',
        text: 'Are you sure want to REJECT this review?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#666',
        confirmButtonText: 'Yes, Reject'
      }).then(function (result) {
        if (result.value) {
          _this3.axios.patch('review/backoffice/reject/' + _this3.$route.params.id).then(function () {
            __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('destroy-editor');
            _this3.$swal({
              title: 'Reject Succeed',
              text: 'The review will not be appear in Customer Site.\nKlik OK to redirect to review list',
              type: 'success',
              timer: 5000
            }).then(function (results) {
              if (results) {
                _this3.$router.go(-1);
              }
            });
          });
        }
      });
    },
    cancel: function cancel() {
      __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$emit('destroy-editor');
      this.$router.go(-1);
    }
  },

  computed: {
    checkVideo: function checkVideo() {
      var dataVideo = this.detailReview.detail.videos;
      if (dataVideo === null) {
        return false;
      } else if (dataVideo.length < 1) {
        return false;
      }
      return true;
    },
    checkImage: function checkImage() {
      var dataImages = this.detailReview.detail.photos;
      if (dataImages === null) {
        return false;
      } else if (dataImages.length < 1) {
        return false;
      }
      return true;
    }
  },
  created: function created() {
    this.getDetail();
  },
  mounted: function mounted() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this4.closeModals();
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BinIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      lists: {
        category: []
      }
    };
  },


  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_1__components_modules_common_Pagination__["a" /* default */]
  },

  methods: {
    getCreditCards: function getCreditCards() {
      var _this = this;

      this.axios.get('/payments/creditcard').then(function (response) {
        var data = response.data.data;

        data.forEach(function (item) {
          _this.lists.category.push({
            label: item.name,
            value: item.id
          });
        });
      }).catch(function (error) {
        console.log(error);
        _this.$swal({
          title: 'Failed',
          text: 'Failed to fetch available cards',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#666',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Try again'
        }).then(function (result) {
          if (result.value) {
            _this.getCreditCards();
          }
        });
      });
    },
    getCreditCardName: function getCreditCardName(cardId) {
      var card = this.lists.category.find(function (item) {
        return item.value === cardId;
      });
      return card.label;
    },
    fetch: function fetch(page) {
      var _this2 = this;

      var pageQuery = this.$route.query.page;

      var params = {
        page: page || pageQuery
      };

      this.isLoading = true;

      this.axios.get('/payments/bin', { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          return;
        }

        _this2.items = data;
        _this2.pagination = meta.pagination;
        _this2.isLoading = false;
      }).catch(function (error) {
        console.log('Failed to fetch BINs', error);
        _this2.$swal({
          title: 'Fetch Failed',
          text: 'Failed to fetch BIN data',
          type: 'warning',
          timer: 3000
        });
      });

      if (page) {
        window.history.pushState('Payment BIN page: ' + page, null, '/operation/bin?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    parseStatus: function parseStatus(status) {
      if (status === 1) return 'Active';
      return 'Inactive';
    },
    add: function add() {
      this.$router.push({ name: 'bin-create' });
    },
    remove: function remove(bin) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting BIN',
        text: 'Are you sure you want to delete ' + bin.bin + ' - ' + bin.bank_name + '?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this3.delete(bin);
        } else {
          _this3.$swal('Cancelled', null, 'info');
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this3.$swal('Cancelled', null, 'info');
        }
      });
    },
    delete: function _delete(bin) {
      var _this4 = this;

      this.axios.delete('/payments/bin/' + bin.id).then(function () {
        _this4.fetch();

        _this4.$swal('Deleted!', bin.name + ' has been deleted.', 'success');
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'bin-edit',
        params: { id: id }
      });
    }
  },

  created: function created() {
    this.getCreditCards();
    this.fetch();
  }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BinForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create BIN',
      form: {
        bin: null,
        bankName: null,
        type: null,
        category: null,
        cardSeries: null,
        isEnabled: {
          label: 'Active',
          value: 1
        }
      },

      lists: {
        category: [],

        type: [{
          label: 'Credit',
          value: 'credit'
        }, {
          label: 'Debit',
          value: 'debit'
        }],

        statuses: [{
          label: 'Active',
          value: 1
        }, {
          label: 'Inactive',
          value: 0
        }]
      }
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    getCreditCards: function getCreditCards() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.axios.get('/payments/creditcard').then(function (response) {
          var data = response.data.data;

          data.forEach(function (item) {
            _this.lists.category.push({
              label: item.name,
              value: item.id
            });
          });
          resolve();
        }).catch(function (error) {
          _this.$swal({
            title: 'Failed',
            text: 'Failed to fetch available cards',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this.getCreditCards();
            }
          });

          reject(new Error(error));
        });
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      this.axios.get('/payments/bin/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;


        var categoryData = {};
        _this2.lists.category.forEach(function (item) {
          if (item.value === data.category) {
            categoryData = item;
          }
        });

        var typeData = {};
        _this2.lists.type.forEach(function (item) {
          if (item.value === data.type) {
            typeData = item;
          }
        });

        var enabled = {};
        _this2.lists.statuses.forEach(function (item) {
          if (item.value === data.is_enabled) {
            enabled = item;
          }
        });

        _this2.form.bin = data.bin;
        _this2.form.bankName = data.bank_name;
        _this2.form.cardSeries = data.card_series;
        _this2.form.category = categoryData;
        _this2.form.type = typeData;
        _this2.form.isEnabled = enabled;
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this2.errors = error.response.data.errors;
        }

        if (error) {
          _this2.$swal({
            title: 'Failed',
            text: 'Failed to fetch BIN detail',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this2.fetch();
            }
          });
        }
      });
    },
    init: function init() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.getCreditCards();

              case 2:
                if (_this3.isCreate) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this3.fetch();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    prepareValues: function prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      var isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      var values = [];
      arr.forEach(function (item) {
        values.push(item.value);
      });

      return values;
    },
    isNumber: function isNumber(event) {
      var charCode = event.which ? event.which : event.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault();
      }

      return true;
    },
    validate: function validate() {
      if (!this.form.bin) {
        this.$swal('BIN required', 'Please fill BIN number to continue', 'warning');
        return false;
      }

      if (!this.form.bankName) {
        this.$swal('Bank name required', 'Please fill bank name to continue', 'warning');
        return false;
      }

      if (!this.form.type || this.form.type.length < 1) {
        this.$swal('BIN type required', 'Please select BIN type to continue', 'warning');
        return false;
      }

      if (!this.form.category || this.form.category.length < 1) {
        this.$swal('BIN category required', 'Please select BIN category to continue', 'warning');
        return false;
      }

      if (!this.form.cardSeries) {
        this.$swal('BIN card series required', 'Please select BIN card series to continue', 'warning');
        return false;
      }

      if (!this.form.isEnabled) {
        this.$swal('BIN status required', 'Please select BIN status to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this4 = this;

      var data = {
        bin: this.form.bin,
        bank_name: this.form.bankName,
        card_series: this.form.cardSeries,
        category: this.form.category.value,
        bin_type: this.form.type.value,
        is_enabled: this.form.isEnabled.value
      };

      return this.axios.post('/payments/bin', this.stringify(data)).then(function () {
        _this4.$swal({
          title: 'Created',
          text: 'Bin has been created.',
          type: 'success',
          timer: 3000
        });

        _this4.$router.push({ name: 'bin-index' });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this4.error = error.response.data.errors;
        }

        if (error) {
          _this4.$swal({
            title: 'Create Failed!',
            text: 'Failed to create new BIN',
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    update: function update() {
      var _this5 = this;

      var data = {
        bin: this.form.bin,
        bank_name: this.form.bankName,
        card_series: this.form.cardSeries,
        category: this.form.category.value,
        bin_type: this.form.type.value,
        is_enabled: this.form.isEnabled.value
      };

      return this.axios.put('/payments/bin/' + this.$route.params.id, this.stringify(data)).then(function () {
        _this5.$swal({
          title: 'Updated',
          text: 'Bin has been updated.',
          type: 'success',
          timer: 3000
        });

        _this5.$router.push({ name: 'bin-index' });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this5.error = error.response.data.errors;
        }

        if (error) {
          _this5.$swal({
            title: 'Update Failed!',
            text: 'Failed to update BIN',
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    this.init();

    if (!this.isCreate) {
      this.title = 'Edit BIN';
    }
  }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Main__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(717);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentMethodsMain',

  data: function data() {
    return {
      component: null
    };
  },


  components: {
    PaymentMethods: __WEBPACK_IMPORTED_MODULE_0__Main__["a" /* default */],
    PaymentMethodsForm: __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
  },

  methods: {
    checkPage: function checkPage(to) {
      if (to.params.page === 'edit' || to.params.page === 'create') {
        this.component = __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */];
      } else {
        this.component = __WEBPACK_IMPORTED_MODULE_0__Main__["a" /* default */];
      }
    }
  },

  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.checkPage(to);
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.checkPage(to);
    });
  }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Pagination__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      paymentMethods: [],
      pagination: {}
    };
  },


  methods: {
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;

      var params = {
        page: page || pageQuery
      };

      this.axios.get('/payments/method', { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          return;
        }

        _this.paymentMethods = data;
        _this.pagination = meta.pagination;
      });

      if (page) {
        window.history.pushState('Payment methods page: ' + page, null, '/payment-methods?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push('/payment-methods/create');
    },
    edit: function edit() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$router.push({
        name: 'payment-methods-edit',
        params: {
          id: value,
          page: 'edit'
        }
      });
    },
    toggleStatus: function toggleStatus(item) {
      var _this2 = this;

      var params = item.is_enabled === 1 ? 'deactivate/' + item.id : 'activate/' + item.id;

      this.axios.patch('/payments/method/' + params).then(function () {
        _this2.fetch();
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.axios.delete('/payments/method/' + id).then(function () {
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject();
        });
      });
    },
    remove: function remove(item) {
      var _this4 = this;

      return this.$swal({
        title: 'Delete Method',
        text: 'Are you sure to delete ' + item.name,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return _this4.delete(item.id);

                  case 3:
                    _context.next = 5;
                    return _this4.fetch();

                  case 5:
                    _this4.$swal({
                      title: 'Deleted!',
                      text: item.name + ' has been deleted.',
                      type: 'success',
                      timer: 2000
                    });
                    _context.next = 11;
                    break;

                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);

                    console.log(_context.t0);

                  case 11:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this4, [[0, 8]]);
          }))();
        }
      });
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Common__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create Payment Method',

      error: null,

      isCreate: false,

      form: {
        id: null,
        name: null,
        key: null,
        status: 1
      }
    };
  },


  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.axios.get('/payments/method/' + _this.$route.params.id).then(function (response) {
                  _this.form = response.data.data;
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.key) {
        this.$swal('Key required', 'Please fill key to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this2 = this;

      var data = {
        name: this.form.name,
        key: this.form.key,
        status: this.form.status
      };

      return this.axios.post('/payments/method', this.stringify(data)).then(function () {
        _this2.$router.push({
          path: '/payment-methods'
        });
      }).catch(function (error) {
        if (error.response) {
          _this2.error = error.response.data.errors;
        }
      });
    },
    update: function update() {
      var _this3 = this;

      var data = {
        id: this.form.id,
        name: this.form.name,
        key: this.form.key,
        status: this.form.status
      };

      return this.axios.put('payments/method/' + this.form.id, this.stringify(data)).then(function () {
        _this3.$router.push({
          path: '/payment-methods'
        });
      }).catch(function (error) {
        if (error.response) {
          _this3.error = error.response.data.errors;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (this.$route.params.page === 'create') {
      this.isCreate = true;
    } else {
      this.title = 'Edit Payment Method';
      this.fetch();
    }
  }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Main__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(724);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentSetupsMain',

  data: function data() {
    return {
      component: null
    };
  },


  components: {
    PaymentSetups: __WEBPACK_IMPORTED_MODULE_0__Main__["a" /* default */],
    PaymentSetupsForm: __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */]
  },

  methods: {
    checkPage: function checkPage(to) {
      if (to.params.page === 'edit' || to.params.page === 'create') {
        this.component = __WEBPACK_IMPORTED_MODULE_1__Form__["a" /* default */];
      } else {
        this.component = __WEBPACK_IMPORTED_MODULE_0__Main__["a" /* default */];
      }
    }
  },

  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.checkPage(to);
    next();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.checkPage(to);
    });
  }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      setups: [],
      pagination: {}
    };
  },


  methods: {
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page || null;

      var params = {
        page: page || pageQuery
      };

      this.axios.get('/payments/setup', { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          return;
        }

        _this.setups = data;
        _this.pagination = meta.pagination;
      });

      if (page) {
        window.history.pushState('Payment Setup page: ' + page, null, '/payment-setups?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    getMethodName: function getMethodName(method) {
      return method ? method[0].name : '-';
    },
    add: function add() {
      this.$router.push('/payment-setups/create');
    },
    edit: function edit() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.$router.push({
        name: 'payment-setups-edit',
        params: {
          id: value,
          page: 'edit'
        }
      });
    },
    parseMedia: function parseMedia(media) {
      if (!media) return '';

      if (media === 'web') {
        return 'fa-desktop';
      }

      if (media === 'ios') {
        return 'fa-apple';
      }

      return 'fa-android';
    },
    parseDate: function parseDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD MMMM YYYY');
    },
    parseDay: function parseDay(day) {
      if (day === 1) return 'Mon';
      if (day === 2) return 'Tue';
      if (day === 3) return 'Wed';
      if (day === 4) return 'Thu';
      if (day === 5) return 'Fri';
      if (day === 6) return 'Sat';
      if (day === 7) return 'Sun';
      return '';
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Common__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create Payment Setup',

      error: null,

      isCreate: false,

      form: {
        created: null,
        id: null,
        payment_method: null,
        days: null,
        description: null,
        is_enabled: 1,
        media: null,

        date: {
          start: null,
          end: null
        },

        time: {
          start: {
            HH: '00',
            mm: '00',
            ss: '00'
          },
          end: {
            HH: '23',
            mm: '59',
            ss: '59'
          }
        }
      },

      lists: {
        payments: [],

        medias: [{
          label: 'Web',
          value: 'web'
        }, {
          label: 'iOS',
          value: 'ios'
        }, {
          label: 'Android',
          value: 'android'
        }],

        statuses: [{
          label: 'Active',
          value: 1
        }, {
          label: 'Inactive',
          value: 0
        }],

        days: [{
          label: 'Mon',
          value: 1
        }, {
          label: 'Tue',
          value: 2
        }, {
          label: 'Wed',
          value: 3
        }, {
          label: 'Thu',
          value: 4
        }, {
          label: 'Fri',
          value: 5
        }, {
          label: 'Sat',
          value: 6
        }, {
          label: 'Sun',
          value: 7
        }]
      }
    };
  },


  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_5_vuejs_datepicker___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_6_vue2_timepicker___default.a
  },

  computed: {
    disabledStartDate: function disabledStartDate() {
      return {
        to: this.form.created ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.created).toDate() : __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').toDate()
      };
    },
    disabledEndDate: function disabledEndDate() {
      return {
        to: this.form.date.start ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.date.start).toDate() : __WEBPACK_IMPORTED_MODULE_4_moment___default()().toDate()
      };
    },
    fullStartTime: function fullStartTime() {
      return this.form.time.start.HH + ':' + this.form.time.start.mm + ':' + this.form.time.start.ss;
    },
    fullEndTime: function fullEndTime() {
      return this.form.time.end.HH + ':' + this.form.time.end.mm + ':' + this.form.time.end.ss;
    }
  },

  methods: {
    initCreate: function initCreate() {
      this.isCreate = true;
      this.fetchMethods();
      this.form.is_enabled = {
        label: 'Active',
        value: 1
      };
    },
    fetch: function fetch() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.axios.get('/payments/setup/' + _this.$route.params.id).then(function (response) {
          var data = response.data.data;

          resolve(data);
        }).catch(function (error) {
          var message = null;

          if (error.response) {
            message = error.response.data.errors;
          }

          reject(new Error('Failed to fetch data', message));
        });
      });
    },
    fetchMethods: function fetchMethods() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.axios.get('/payments/method').then(function (response) {
          var data = response.data.data;

          _this2.lists.payments = data.map(function (item) {
            return { label: item.name, value: item.id };
          });
          resolve();
        }).catch(function (error) {
          var message = null;

          if (error.response) {
            message = error.response.data.errors;
          }

          reject(new Error('Failed to fetch methods', message));
        });
      });
    },
    prepareData: function prepareData(data) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        var days = [];
        var medias = [];
        var payments = [];

        data.payment_method.forEach(function (method) {
          _this3.lists.payments.forEach(function (list) {
            if (method.id === list.value) {
              payments.push(list);
            }
          });
        });

        data.media.forEach(function (media) {
          _this3.lists.medias.forEach(function (list) {
            if (media === list.value) {
              medias.push(list);
            }
          });
        });

        data.days.forEach(function (day) {
          _this3.lists.days.forEach(function (list) {
            if (day === list.value) {
              days.push(list);
            }
          });
        });

        var status = void 0;
        _this3.lists.statuses.forEach(function (item) {
          if (item.value === data.is_enabled) {
            status = item;
          }
        });

        _this3.form.created = data.created_at;
        _this3.form.id = data.id;
        _this3.form.description = data.description;
        _this3.form.is_enabled = status;
        _this3.form.payment_method = payments;
        _this3.form.days = days;
        _this3.form.media = medias;

        _this3.form.date = {
          start: data.start_date ? _this3.parseDate(data.start_date) : null,
          end: data.end_date ? _this3.parseDate(data.end_date) : null
        };

        var timeStart = data.start_end_time ? data.start_end_time[0].start : '00:00:00';
        var timeEnd = data.start_end_time ? data.start_end_time[0].end : '23:59:59';

        var timeStartSplit = timeStart.split(':');
        var timeEndSplit = timeEnd.split(':');

        var timeStartFull = {
          HH: timeStartSplit[0] || '00',
          mm: timeStartSplit[1] || '00',
          ss: timeStartSplit[2] || '00'
        };

        var timeEndFull = {
          HH: timeEndSplit[0] || '23',
          mm: timeEndSplit[1] || '59',
          ss: timeEndSplit[2] || '59'
        };

        _this3.form.time = {
          start: timeStartFull,
          end: timeEndFull
        };

        resolve();
      });
    },
    fetchAll: function fetchAll() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this4.fetchMethods();

              case 3:
                _context.next = 5;
                return _this4.fetch();

              case 5:
                data = _context.sent;
                _context.next = 8;
                return _this4.prepareData(data);

              case 8:
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](0);

                console.log('Failed to fetch payment setup', _context.t0);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 10]]);
      }))();
    },
    parseDate: function parseDate(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format(this.config.date.iso);
    },
    validate: function validate() {
      if (!this.form.payment_method || this.form.payment_method.length < 1) {
        this.$swal('Payment method required', 'Please select payment method to continue', 'warning');
        return false;
      }

      if (!this.form.description) {
        this.$swal('Payment description required', 'Please fill payment description to continue', 'warning');
        return false;
      }

      if (!this.form.media || this.form.media.length < 1) {
        this.$swal('Payment media required', 'Please select payment media to continue', 'warning');
        return false;
      }

      if (!this.form.days || this.form.days.length < 1) {
        this.$swal('Payment active days required', 'Please select payment active days to continue', 'warning');
        return false;
      }

      if (!this.form.date.start || !this.form.date.end) {
        this.$swal('Payment dates required', 'Please select payment dates to continue', 'warning');
        return false;
      }

      if (!this.form.time.start || !this.form.time.end) {
        this.$swal('Payment time required', 'Please select payment time to continue', 'warning');
        return false;
      }

      if (!this.form.is_enabled) {
        this.$swal('Payment status required', 'Please select payment status to continue', 'warning');
        return false;
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.fullStartTime, 'HH:mm:ss');
      var endTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.fullEndTime, 'HH:mm:ss');

      if (endTime.isBefore(startTime, 'second')) {
        this.$swal('Payment time invalid', 'Please choose correct end time to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    update: function update() {
      var _this5 = this;

      var payments = this.form.payment_method.map(function (item) {
        return item.value;
      });
      var medias = this.form.media.map(function (item) {
        return item.value;
      });
      var days = this.form.days.map(function (item) {
        return item.value;
      });
      var startEndTime = [{
        start: this.fullStartTime,
        end: this.fullEndTime
      }];

      var data = {
        id: this.form.id,
        payment_method: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payments),
        description: this.form.description,
        start_date: this.parseDate(this.form.date.start),
        end_date: this.parseDate(this.form.date.end),
        start_end_time: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(startEndTime),
        days: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(days),
        media: medias.join(),
        is_enabled: parseInt(this.form.is_enabled.value, 10)
      };

      return this.axios.put('/payments/setup/' + this.form.id, this.stringify(data)).then(function () {
        _this5.$router.push({
          path: '/payment-setups'
        });
      }).catch(function (error) {
        if (error.response) {
          _this5.error = error.response.data.errors;
        }
      });
    },
    create: function create() {
      var _this6 = this;

      var payments = this.form.payment_method.map(function (item) {
        return item.value;
      });
      var medias = this.form.media.map(function (item) {
        return item.value;
      });
      var days = this.form.days.map(function (item) {
        return item.value;
      });
      var startEndTime = [{
        start: this.fullStartTime,
        end: this.fullEndTime
      }];

      var data = {
        payment_method: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payments),
        description: this.form.description,
        start_date: this.parseDate(this.form.date.start),
        end_date: this.parseDate(this.form.date.end),
        start_end_time: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(startEndTime),
        days: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(days),
        media: medias.join(),
        is_enabled: parseInt(this.form.is_enabled.value, 10)
      };

      return this.axios.post('/payments/setup', this.stringify(data)).then(function () {
        _this6.$router.push({
          path: '/payment-setups'
        });
      }).catch(function (error) {
        if (error.response) {
          _this6.error = error.response.data.errors;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  },

  created: function created() {
    if (this.$route.params.page === 'create') {
      this.initCreate();
    } else {
      this.fetchAll();
      this.title = 'Edit Payment Setup';
    }
  }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoIndex'
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoBinIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_2__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},

      params: {
        promo_payment: null
      }
    };
  },


  methods: {
    onInput: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/promobins', { params: this.params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          _this.items = [];
          _this.pagination = {};
          return;
        }

        _this.items = data;
        _this.pagination = meta.pagination;
        _this.isLoading = false;
      }).catch(function () {
        _this.$swal({
          title: 'Fetch Failed',
          text: 'Failed to fetch Promo BIN data',
          type: 'warning',
          timer: 5000
        });
      });

      if (page) {
        window.history.pushState('Promo BIN page: ' + page, null, '/promo/bin?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({ name: 'promo-bin-create' });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'promo-bin-edit',
        params: { id: id }
      });
    },
    delete: function _delete(item) {
      var _this2 = this;

      this.axios.delete('/promobins/' + item.promo_config_id).then(function () {
        _this2.fetch();

        _this2.$swal({
          title: 'Deleted',
          text: 'Promo BIN has been deleted.',
          type: 'success',
          timer: 3000
        });
      }).catch(function (error) {
        console.log('Error', error);
      });
    },
    remove: function remove(item) {
      var _this3 = this;

      this.$swal({
        title: 'Deleting Promo BIN',
        text: 'Are you sure you want to delete Promo Bin?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(function (result) {
        if (result.value) {
          _this3.delete(item);
        } else {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          _this3.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000
          });
        }
      });
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js_sha256__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto_js_sha256__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoBinForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create Promo BIN',
      form: {
        config: null,
        code: null,
        bin: null,
        isEnabled: null
      },

      promoConfigs: [],
      promoBins: [],
      promoCodes: [],
      statuses: [{
        label: 'Active',
        value: 1
      }, {
        label: 'Inactive',
        value: 0
      }]
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    getPromoConfigs: function getPromoConfigs() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.axios.get('/promoconfigs').then(function (response) {
          var data = response.data.data;

          data.forEach(function (item) {
            _this.promoConfigs.push({
              label: item.name,
              value: item.id
            });
          });
          resolve('getPromoConfigs done');
        }).catch(function (error) {
          _this.$swal({
            title: 'Failed',
            text: 'Failed to fetch available promo configs',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this.getPromoConfigs();
            }
          });
          reject(error);
        });
      });
    },
    getPromoCodes: function getPromoCodes() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.axios.get('/promo-code').then(function (response) {
          var data = response.data.data;

          data.forEach(function (item) {
            _this2.promoCodes.push({
              label: item.code,
              value: item.code
            });
          });
          resolve('getPromoCodes done');
        }).catch(function (error) {
          _this2.$swal({
            title: 'Failed',
            text: 'Failed to fetch available promo codes',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this2.getPromoCodes();
            }
          });
          reject(error);
        });
      });
    },
    getTimestamp: function getTimestamp() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.axios.get('/generals/get-timestamp', {
          baseURL: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_BASEURL_V2 */]
        }).then(function (response) {
          return resolve(response.data.data.timestamp);
        }).catch(function () {
          return resolve(moment().unix());
        });
      });
    },
    createToken: function createToken(timestamp) {
      return {
        time: timestamp,
        token: __WEBPACK_IMPORTED_MODULE_6_crypto_js_sha256___default()(__WEBPACK_IMPORTED_MODULE_4__config__["h" /* X_SECRET_KEY_V2 */] + timestamp).toString()
      };
    },
    getPromoBins: function getPromoBins() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var timestamp, _createToken, time, token;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this4.getTimestamp();

              case 2:
                timestamp = _context.sent;
                _createToken = _this4.createToken(timestamp), time = _createToken.time, token = _createToken.token;
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  var config = {
                    baseURL: __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API_BASEURL_V2 */],
                    headers: {
                      'Accept-Language': 'id',
                      'X-Api-Key': __WEBPACK_IMPORTED_MODULE_4__config__["g" /* X_API_KEY_V2 */],
                      'X-Platform': 'web',
                      'X-Payment-Token': token,
                      'X-Request-Time': time
                    }
                  };

                  _this4.axios.get('/bins-active', config).then(function (response) {
                    var data = response.data.data;

                    data.forEach(function (item) {
                      if (item.is_enabled) {
                        _this4.promoBins.push({
                          label: item.bin + ' - ' + item.bank_name,
                          value: item.bin
                        });
                      }
                    });
                    resolve('getPromoBins done');
                  }).catch(function (error) {
                    _this4.$swal({
                      title: 'Failed',
                      text: 'Failed to fetch available promo bins',
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonColor: '#666',
                      cancelButtonColor: '#3085d6',
                      confirmButtonText: 'Try again'
                    }).then(function (result) {
                      if (result.value) {
                        _this4.getPromoBins();
                      }
                    });
                    reject(error);
                  });
                }));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    fetch: function fetch() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.axios.get('/promobins/' + _this5.$route.params.id).then(function (response) {
          var data = response.data.data;


          var configData = null;
          _this5.promoConfigs.forEach(function (item) {
            if (item.value === data.promo_config_id) {
              configData = item;
            }
          });

          var codeData = [];
          data.code.forEach(function (itemData) {
            _this5.promoCodes.forEach(function (item) {
              if (item.value === itemData) {
                codeData.push(item);
              }
            });
          });

          var binData = [];
          data.bin.forEach(function (itemData) {
            _this5.promoBins.forEach(function (item) {
              if (item.value === itemData) {
                binData.push(item);
              }
            });
          });

          var enabled = null;
          _this5.statuses.forEach(function (item) {
            if (item.value === data.is_enabled) {
              enabled = item;
            }
          });

          _this5.form.config = configData;
          _this5.form.code = codeData;
          _this5.form.bin = binData;
          _this5.form.isEnabled = enabled;

          resolve('Fetch done');
        }).catch(function (error) {
          if (error.response) {
            _this5.errors = error.response.data.errors;
          }

          if (error) {
            _this5.$swal({
              title: 'Failed',
              text: 'Failed to fetch promo code detail',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this5.fetch();
              }
            });
          }

          reject('error', error);
        });
      });
    },
    prepareValues: function prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      var isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      var values = [];
      arr.forEach(function (item) {
        values.push(item.value);
      });

      return values;
    },
    validate: function validate() {
      if (!this.form.config) {
        this.$swal('Promo payment required', 'Please select active promo', 'warning');
        return false;
      }

      if (!this.form.code || this.form.code.length < 1) {
        this.$swal('Promo code required', 'Please select at least 1 active promo code', 'warning');
        return false;
      }

      if (!this.form.bin || this.form.bin.length < 1) {
        this.$swal('Promo BIN required', 'Please select at least 1 active promo BIN', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this6 = this;

      var codeData = this.prepareValues(this.form.code);
      var binData = this.prepareValues(this.form.bin);

      var data = {
        promo_config_id: this.form.config.value.toString(),
        bin: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(binData),
        promo_code: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(codeData),
        is_enabled: parseInt(1, 10)
      };

      return this.axios.post('/promobins', this.stringify(data)).then(function () {
        _this6.$swal({
          title: 'created',
          text: 'Promo Bin has been created.',
          type: 'success',
          timer: 3000
        });

        _this6.$router.push({ name: 'promo-bin-index' });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this6.error = error.response.data.errors;
        }

        if (error) {
          _this6.$swal({
            title: 'Create Failed!',
            text: 'Failed to create new Promo BIN',
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    update: function update() {
      var _this7 = this;

      var codeData = this.prepareValues(this.form.code);
      var binData = this.prepareValues(this.form.bin);

      var data = {
        promo_config_id: this.form.config.value.toString(),
        bin: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(binData),
        promo_code: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(codeData)
      };

      this.axios.post('/promobins', this.stringify(data)).then(function () {
        _this7.$swal({
          title: 'Updated',
          text: 'Promo BIN has been updated.',
          type: 'success',
          timer: 3000
        });

        _this7.$router.push({ name: 'promo-bin-index' });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this7.error = error.response.data.errors;
        }

        if (error) {
          _this7.$swal({
            title: 'Failed',
            text: 'Promo BIN update failed. ' + error,
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    init: function init() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this8.getPromoConfigs();

              case 2:
                _context2.next = 4;
                return _this8.getPromoCodes();

              case 4:
                _context2.next = 6;
                return _this8.getPromoBins();

              case 6:
                if (_this8.isCreate) {
                  _context2.next = 10;
                  break;
                }

                _this8.title = 'Edit Promo BIN';
                _context2.next = 10;
                return _this8.fetch();

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoCodeIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      days: {
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat',
        7: 'Sun'
      },

      params: {
        code: null,
        page: 1
      }
    };
  },


  filters: {
    digitGrouping: function digitGrouping(string) {
      if (!string) return 'IDR 0';
      return 'IDR ' + __WEBPACK_IMPORTED_MODULE_1_numeral___default()(string).format('0,0');
    },
    simpleDate: function simpleDate(string) {
      if (!string) return '';
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(string).format('YYYY-MM-DD');
    }
  },

  methods: {
    onInput: __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/promo-code', { params: this.params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          _this.items = [];
          _this.pagination = {};
          return;
        }

        _this.items = data;

        _this.items.forEach(function (item) {
          item.detail.medias = item.detail.media.split(',');
        });

        _this.pagination = meta.pagination;
        _this.isLoading = false;
      }).catch(function () {
        _this.$swal({
          title: 'Fetch Failed',
          text: 'Failed to fetch promo codes data',
          type: 'warning',
          timer: 5000
        });
      });

      if (page) {
        window.history.pushState('Promo codes page: ' + page, null, '/promo/code?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    add: function add() {
      this.$router.push({ name: 'promo-code-create' });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'promo-code-edit',
        params: { id: id }
      });
    },
    view: function view(id) {
      this.$router.push({
        name: 'promo-code-view',
        params: { id: id }
      });
    },
    toggleStatus: function toggleStatus(item) {
      var _this2 = this;

      var params = item.is_enabled === 1 ? 'deactivate/' + item.id : 'activate/' + item.id;

      this.axios.patch('/promo-code/' + params).then(function () {
        _this2.fetch();
      });
    },
    parseMedia: function parseMedia(media) {
      if (!media) return '';

      if (media === 'web') {
        return 'fa-desktop';
      }

      if (media === 'ios') {
        return 'fa-apple';
      }

      return 'fa-android';
    },
    parseStatus: function parseStatus(status) {
      if (status === 1) return 'Enabled';
      return 'Disabled';
    },
    parseNominal: function parseNominal(string, type) {
      if (!string && !type) return '';
      if (type === 'percentage') {
        return string + '%';
      }
      return 'IDR ' + __WEBPACK_IMPORTED_MODULE_1_numeral___default()(string).format('0,0');
    },
    renderRecurringValue: function renderRecurringValue(type, value) {
      var _this3 = this;

      var recurringValue = '';

      if (type === 'day') {
        var days = value.split(',');

        days.forEach(function (day, index) {
          recurringValue += _this3.days[parseInt(day, 10)];

          if (index + 1 !== days.length) {
            recurringValue += ',';
          }
        });
      }

      if (type === 'date') {
        recurringValue = value;
      }

      return recurringValue.replace(/,/g, ', ');
    },
    checkLockedDomain: function checkLockedDomain(status, string) {
      if (status === 0) {
        return 'None';
      }

      return string;
    }
  },

  created: function created() {
    this.fetch();
  }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__riophae_vue_treeselect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__riophae_vue_treeselect__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoCodeForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create Promo Code',

      error: null,

      form: {
        created: null,
        promo_detail_id: null,
        promo_config_id: null,
        code: null,
        start_date: null,
        end_date: null,
        start_time: {
          HH: '00',
          mm: '00',
          ss: '00'
        },
        end_time: {
          HH: '23',
          mm: '59',
          ss: '59'
        },
        config: null,
        type: null,
        nominal: null,
        maximum_amount: null,
        minimum_pay_amount: null,
        minimum_payment: null,
        quota: null,
        daily_quota: null,
        media: [],
        restriction: 0,
        recurring_type: 'none',
        recurring_date: null,
        recurring_day: [],
        is_enabled: {
          label: 'Active',
          value: 1
        },
        created_by: null,
        hide_installment: false,
        description: null,
        isUnlimitedQuota: false,
        isUnlimitedDailyQuota: false,
        available_to: [],
        product_id: null,
        category_id: null,
        badges_id: null,
        destination_id: null
      },

      list: {
        products: [],
        destinations: [],
        flatDestinations: [],
        categories: [],
        badges: []
      },

      showMinPayment: true,
      nominalMaxLength: 99,
      nominalPrefix: 'IDR',
      nominalValidation: 'required',

      promoconfigs: [],

      nominalTypes: [{
        label: 'Percentage',
        value: 'percentage'
      }, {
        label: 'Amount',
        value: 'amount'
      }],

      statuses: [{
        label: 'Active',
        value: 1
      }, {
        label: 'Inactive',
        value: 0
      }],

      medias: [{
        label: 'Web',
        value: 'web'
      }, {
        label: 'iOS',
        value: 'ios'
      }, {
        label: 'Android',
        value: 'android'
      }],

      days: [{
        label: 'Mon',
        value: 1
      }, {
        label: 'Tue',
        value: 2
      }, {
        label: 'Wed',
        value: 3
      }, {
        label: 'Thu',
        value: 4
      }, {
        label: 'Fri',
        value: 5
      }, {
        label: 'Sat',
        value: 6
      }, {
        label: 'Sun',
        value: 7
      }],

      dates: [],

      restrictions: [{
        label: 'Email',
        value: 'email'
      }, {
        label: 'Phone',
        value: 'phone_number'
      }, {
        label: 'One Credit Card Usage',
        value: 'credit_card'
      }],

      timeOptions: {
        numericOnly: true,
        numeralPositiveOnly: true,
        blocks: [2, 2, 2],
        delimiters: [':', ':'],
        delimiterLazyShow: true
      },

      params: {
        page: 1,
        perpage: 500
      },

      availables: [{
        label: 'All',
        value: 'all',
        disabled: false
      }, {
        label: 'Member',
        value: 'member',
        disabled: false
      }]
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  components: {
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a,
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_7_vue2_timepicker___default.a,
    Treeselect: __WEBPACK_IMPORTED_MODULE_9__riophae_vue_treeselect__["Treeselect"]
  },

  computed: {
    disabledStartDate: function disabledStartDate() {
      return {
        to: this.form.created ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.created).toDate() : __WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(1, 'days').toDate(),
        from: this.form.end_date ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.end_date).toDate() : null
      };
    },
    disabledEndDate: function disabledEndDate() {
      return {
        to: this.form.start_date ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.start_date).toDate() : __WEBPACK_IMPORTED_MODULE_4_moment___default()().toDate()
      };
    },
    fullStartTime: function fullStartTime() {
      return this.form.start_time.HH + ':' + this.form.start_time.mm + ':' + this.form.start_time.ss;
    },
    fullEndTime: function fullEndTime() {
      return this.form.end_time.HH + ':' + this.form.end_time.mm + ':' + this.form.end_time.ss;
    }
  },

  methods: {
    setUserId: function setUserId() {
      this.form.created_by = this.user.sub;
    },
    getAvailablePromoConfigs: function getAvailablePromoConfigs() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.axios.get('/promoconfigs', { params: _this.params }).then(function (response) {
          var data = response.data.data;


          if (!data) {
            resolve();
            return;
          }

          data.forEach(function (item) {
            _this.promoconfigs.push({
              label: item.name,
              value: item.id
            });
          });

          resolve();
        }).catch(function (error) {
          console.log(error);
          _this.$swal({
            title: 'Failed',
            text: 'Failed to fetch available promo configs',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this.getAvailablePromoConfigs();
            }
          });
        });
      });
    },
    setDates: function setDates() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        for (var index = 1; index <= 31; index += 1) {
          _this2.dates.push(index.toString());
        }

        resolve();
      });
    },
    parseDate: function parseDate(date, to) {
      if (!date) return '';
      var formatTo = to || 'YYYY-MM-DD';
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format(formatTo);
    },
    isNumber: function isNumber(event) {
      var charCode = event.which ? event.which : event.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        event.preventDefault();
      }

      return true;
    },
    isStringCommaOnly: function isStringCommaOnly(event) {
      var charCode = event.which ? event.which : event.keyCode;

      if (charCode > 31 && (charCode < 65 || charCode > 90)) {
        if (charCode !== 188 && charCode !== 190) {
          event.preventDefault();
        }
      }

      return true;
    },
    switchType: function switchType(type) {
      if (!type) {
        this.form.type = null;
        this.showMinPayment = true;
        this.nominalMaxLength = 99;
        this.nominalPrefix = 'IDR';
        return;
      }

      if (type.value === 'percentage') {
        this.form.minimum_pay_amount = 0;
        this.showMinPayment = false;
        this.nominalMaxLength = 3;
        this.nominalPrefix = '%';
        this.nominalValidation = 'required|max_value:100';
      } else {
        this.showMinPayment = true;
        this.nominalMaxLength = 99;
        this.nominalPrefix = 'IDR';
        this.nominalValidation = 'required|numeric';
      }

      this.form.type = type;
    },
    onUnlimitedChecked: function onUnlimitedChecked(type) {
      if (type === 'quota') {
        if (this.form.isUnlimitedQuota) {
          this.form.quota = 0;
        } else {
          this.form.quota = null;
        }
      }

      if (type === 'daily_quota') {
        if (this.form.isUnlimitedDailyQuota) {
          this.form.daily_quota = 0;
        } else {
          this.form.daily_quota = null;
        }
      }
    },
    fetch: function fetch() {
      var _this3 = this;

      this.axios.get('/promo-code/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;


        var mediaData = [];
        var mediaAarray = data.detail.media.split(',');
        mediaAarray.forEach(function (selected) {
          _this3.medias.forEach(function (item) {
            if (item.value === selected) {
              mediaData.push(item.value);
            }
          });
        });

        var typeData = {};
        _this3.nominalTypes.forEach(function (item) {
          if (item.value === data.detail.type) {
            typeData = item;
          }
        });

        var restrictionData = [];
        var restriction = data.detail.restriction.split(',');
        restriction.forEach(function (dataItem) {
          _this3.restrictions.forEach(function (item) {
            if (item.value === dataItem) {
              restrictionData.push(item);
            }
          });
        });

        var productsData = [];
        if (data.detail.product_id) {
          var arrayProducts = data.detail.product_id.split(',');
          arrayProducts.forEach(function (selected) {
            _this3.list.products.forEach(function (item) {
              if (item.value === parseInt(selected, 10)) {
                productsData.push(item);
              }
            });
          });
        }

        var categoriesData = [];
        if (data.detail.category_id) {
          var arrayCategory = data.detail.category_id.split(',');
          arrayCategory.forEach(function (selected) {
            _this3.list.categories.forEach(function (item) {
              if (item.value === parseInt(selected, 10)) {
                categoriesData.push(item);
              }
            });
          });
        }
        var arrayBadges = data.detail.badges;

        var arrayDestination = data.detail.destinations;
        // const destinationsData = [];
        // if (data.detail.destination_id) {
        //   destinationsData = data.detail.destination_id.split(',');
        //   destinationsData.forEach((selected) => {
        //     this.list.flatDestinations.forEach((item) => {
        //       if (item === parseInt(selected, 10)) {
        //         destinationsData.push(item);
        //       }
        //     });
        //   });
        // }

        var enabled = {};
        _this3.statuses.forEach(function (item) {
          if (item.value === data.is_enable) {
            enabled = item;
          }
        });

        var promoconfigs = null;
        _this3.promoconfigs.forEach(function (item) {
          if (item.value === data.promo_config_id) {
            promoconfigs = item;
          }
        });

        var timeStart = data.start_time || '00:00:00';
        var timeEnd = data.end_time || '23:59:59';

        var timeStartSplit = timeStart.split(':');
        var timeEndSplit = timeEnd.split(':');

        var timeStartFull = {
          HH: timeStartSplit[0] || '00',
          mm: timeStartSplit[1] || '00',
          ss: timeStartSplit[2] || '00'
        };

        var timeEndFull = {
          HH: timeEndSplit[0] || '23',
          mm: timeEndSplit[1] || '59',
          ss: timeEndSplit[2] || '59'
        };

        if (data.quota === 0) {
          _this3.form.isUnlimitedQuota = true;
        }

        if (data.daily_quota === 0) {
          _this3.form.isUnlimitedDailyQuota = true;
        }

        var recurringValue = data.detail.recurring_value.split(',');

        if (data.detail.recurring_type === 'day') {
          _this3.form.recurring_day = recurringValue;
        }

        if (data.detail.recurring_type === 'date') {
          _this3.form.recurring_date = recurringValue;
        }

        var availableData = [];
        if (data.available_to === 'all') {
          availableData.push('all', 'member');
          _this3.availables[1].disabled = true;
        } else {
          availableData.push('member');
        }

        _this3.form.code = data.code;
        _this3.form.created = data.created_at;
        _this3.form.created_by = data.created_by;
        _this3.form.description = data.detail.description;
        _this3.form.end_date = _this3.parseDate(data.end_date);
        _this3.form.end_time = timeEndFull;
        _this3.form.hide_installment = data.detail.hide_installment;
        _this3.form.is_enabled = enabled;
        _this3.form.maximum_amount = data.detail.maximum_amount;
        _this3.form.media = mediaData;
        _this3.form.minimum_pay_amount = data.detail.minimum_pay_amount;
        _this3.form.minimum_payment = data.detail.minimum_payment;
        _this3.form.config = promoconfigs;
        _this3.form.nominal = data.detail.nominal;
        _this3.form.promo_config_id = data.promo_config_id !== 0 ? data.promo_config_id : null;
        _this3.form.promo_detail_id = data.promo_detail_id;
        _this3.form.quota = data.quota;
        _this3.form.daily_quota = data.daily_quota;
        _this3.form.restriction = restrictionData;
        _this3.form.recurring_type = data.detail.recurring_type;
        _this3.form.is_locked_domain = data.detail.is_locked_domain;
        _this3.form.locked_domains = data.detail.locked_domains;
        _this3.form.start_date = _this3.parseDate(data.start_date);
        _this3.form.start_time = timeStartFull;
        _this3.form.type = typeData;
        _this3.form.product_id = productsData;
        _this3.form.category_id = categoriesData;
        _this3.form.available_to = availableData;
        if (arrayBadges) {
          var valueBadges = arrayBadges.map(function (item) {
            return {
              value: item.id,
              label: item.name
            };
          });
          _this3.form.badges_id = valueBadges;
        } else {
          _this3.form.badges_id = null;
        }
        if (arrayDestination) {
          var valueDestinations = arrayDestination.filter(function (l) {
            return !arrayDestination.find(function (val) {
              return l.id === val.parent_id;
            });
          }).map(function (l) {
            return l.id;
          });
          _this3.form.destination_id = valueDestinations;
        } else {
          _this3.form.destination_id = null;
        }
      }).catch(function (error) {
        if (error.response) {
          _this3.errors = error.response.data.errors;
        }

        if (error) {
          _this3.$swal({
            title: 'Failed',
            text: 'Failed to fetch promo code detail',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this3.fetch();
            }
          });
        }
      });
    },
    prepareValues: function prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      var isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      var values = [];
      arr.forEach(function (item) {
        values.push(item.value);
      });

      return values;
    },
    validate: function validate() {
      if (!this.form.start_date) {
        this.$swal('Promo start date required', 'Please fill promo start date to continue', 'warning');
        return false;
      }

      if (!this.form.end_date) {
        this.$swal('Promo end date required', 'Please fill promo end date to continue', 'warning');
        return false;
      }

      if (!this.form.start_time) {
        this.$swal('Promo start time required', 'Please fill promo start time to continue', 'warning');
        return false;
      }

      if (!this.form.end_time) {
        this.$swal('Promo end time required', 'Please fill promo end time to continue', 'warning');
        return false;
      }

      var startTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.fullStartTime, 'HH:mm:ss');
      var endTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.fullEndTime, 'HH:mm:ss');

      if (endTime.isBefore(startTime)) {
        this.$swal('Payment time invalid', 'Please choose correct end time to continue', 'warning');
        return false;
      }

      if (!this.form.code) {
        this.$swal('Promo code required', 'Please fill promo code to continue', 'warning');
        return false;
      }

      if (!this.form.type) {
        this.$swal('Promo type required', 'Please fill promo type to continue', 'warning');
        return false;
      }

      if (this.form.nominal === null || this.form.nominal === '') {
        this.$swal('Nominal required', 'Please fill nominal to continue', 'warning');
        return false;
      }

      if (this.form.type.value === 'percentage' && this.form.nominal > 100) {
        this.$swal('Nominal Invalid', 'Percentage nominal is greater than 100 percent', 'warning');
        return false;
      }

      if (this.form.type.value === 'amount' && (this.form.minimum_pay_amount === '' || this.form.minimum_pay_amount === null)) {
        this.$swal('Promo minimum pay amount required', 'Please fill minimum pay amount to continue', 'warning');
        return false;
      }

      if (this.form.maximum_amount === null || this.form.maximum_amount === '') {
        this.$swal('Promo Maximum Discount required', 'Please fill maximum promo discount to continue', 'warning');
        return false;
      }

      if (this.form.quota === null || this.form.quota < 0) {
        this.$swal('Quota required', 'Quota cannot be empty or less than 0', 'warning');
        return false;
      }

      if (this.form.daily_quota === null || this.form.daily_quota < 0) {
        this.$swal('Quota required', 'Daily quota cannot be empty or less than 0', 'warning');
        return false;
      }

      if (this.form.quota !== 0 && parseInt(this.form.daily_quota, 10) > parseInt(this.form.quota, 0)) {
        this.$swal('Daily Quota Not Valid', 'Daily Quota Must Be Less Than Quota', 'warning');
        return false;
      }

      if (this.form.minimum_payment === null || this.form.minimum_payment === '') {
        this.$swal('Promo minimum payment required', 'Please fill minimum payment to continue', 'warning');
        return false;
      }

      if (!this.form.media || this.form.media.length < 1) {
        this.$swal('Promo media required', 'Please fill media to continue', 'warning');
        return false;
      }

      if (!this.form.description) {
        this.$swal('Promo description required', 'Please fill description to continue', 'warning');
        return false;
      }

      if (!this.form.is_enabled) {
        this.$swal('Promo code status required', 'Please fill promo code status to continue', 'warning');
        return false;
      }

      if (!this.form.available_to || this.form.available_to.length < 1) {
        this.$swal('Promo available to required', 'Please fill available to, to continue', 'warning');
        return false;
      }

      if (this.form.is_locked_domain > 0 && this.form.locked_domains.length < 1) {
        this.$swal('Lock domain address required', 'Please fill domain address to continue', 'warning');

        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this4 = this;

      if (this.form.nominal > 100 && this.form.type.value === 'percentage') {
        return this.$swal('Nominal Invalid', 'Percentage nominal is greater than 100 percent', 'warning');
      }

      var typeData = this.prepareValues(this.form.type);
      var restrictionData = this.prepareValues(this.form.restriction);
      var productsData = this.form.product_id != null ? this.form.product_id.map(function (item) {
        return item.value;
      }) : null;
      var categoriesData = this.form.category_id != null ? this.form.category_id.map(function (item) {
        return item.value;
      }) : null;
      var badgesData = this.form.badges_id != null ? this.form.badges_id.map(function (item) {
        return item.value;
      }) : null;
      var destinationsData = this.form.destination_id != null ? this.form.destination_id.map(function (item) {
        return +item;
      }) : null;

      var recurringValue = null;
      if (this.form.recurring_type === 'date') {
        recurringValue = this.form.recurring_date.join();
      }
      if (this.form.recurring_type === 'day') {
        recurringValue = this.form.recurring_day.join();
      }

      var data = {
        code: this.form.code,
        created_by: this.form.created_by,
        description: this.form.description,
        end_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.end_date).format(this.config.date.iso),
        end_time: this.fullEndTime,
        hide_installment: this.form.hide_installment,
        is_enabled: this.form.is_enabled.value,
        maximum_amount: this.form.maximum_amount,
        media: this.form.media.toString(),
        minimum_pay_amount: this.form.minimum_pay_amount,
        minimum_payment: this.form.minimum_payment,
        nominal: this.form.nominal,
        promo_config_id: this.form.config ? this.form.config.value : null,
        promo_detail_id: this.form.promo_detail_id,
        quota: this.form.quota,
        daily_quota: this.form.daily_quota,
        restriction: restrictionData.join(),
        recurring_type: this.form.recurring_type,
        recurring_value: recurringValue,
        is_locked_domain: this.form.is_locked_domain,
        locked_domains: this.form.locked_domains,
        start_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.start_date).format(this.config.date.iso),
        start_time: this.fullStartTime,
        type: typeData.toString(),
        product_id: productsData != null ? productsData.join() : productsData,
        category_id: categoriesData != null ? categoriesData.join() : categoriesData,
        badge_id: badgesData != null ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(badgesData) : badgesData,
        destination_id: destinationsData != null ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(destinationsData) : destinationsData,
        available_to: this.form.available_to.includes('all') ? 'all' : 'member'
      };

      return this.axios.post('/promo-code', this.stringify(data)).then(function () {
        _this4.$swal({
          title: 'Created',
          text: _this4.form.code + ' has been created.',
          type: 'success',
          timer: 3000
        });

        _this4.$router.push({ name: 'promo-code-index' });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this4.error = error.response.data.errors;
        }

        if (error) {
          var message = 'Failed to create new Promo Code';

          if (_this4.error) {
            message = _this4.error;
          }

          _this4.$swal({
            title: 'Create Failed!',
            text: message,
            type: 'warning',
            timer: 5000,
            onClose: function onClose() {
              _this4.error = null;
            }
          });
        }
      });
    },
    update: function update() {
      var _this5 = this;

      var typeData = this.prepareValues(this.form.type);
      var productsData = this.form.product_id != null ? this.form.product_id.map(function (item) {
        return item.value;
      }) : null;
      var categoriesData = this.form.category_id != null ? this.form.category_id.map(function (item) {
        return item.value;
      }) : null;
      var badgesData = this.form.badges_id != null ? this.form.badges_id.map(function (item) {
        return item.value;
      }) : null;
      var destinationsData = this.form.destination_id != null ? this.form.destination_id.map(function (item) {
        return +item;
      }) : null;

      var restrictionData = null;
      if (this.form.restriction.length > 0) {
        restrictionData = this.prepareValues(this.form.restriction);
        restrictionData = restrictionData.join();
      }

      var recurringValue = null;
      if (this.form.recurring_type === 'date') {
        recurringValue = this.form.recurring_date.join();
      }
      if (this.form.recurring_type === 'day') {
        recurringValue = this.form.recurring_day.join();
      }
      var data = {
        code: this.form.code,
        created_by: this.form.created_by,
        description: this.form.description,
        end_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.end_date).format(this.config.date.iso),
        end_time: this.fullEndTime,
        hide_installment: this.form.hide_installment,
        is_enabled: this.form.is_enabled.value,
        maximum_amount: this.form.maximum_amount,
        media: this.form.media.toString(),
        minimum_pay_amount: this.form.minimum_pay_amount,
        minimum_payment: this.form.minimum_payment,
        nominal: this.form.nominal,
        promo_config_id: this.form.config ? this.form.config.value : null,
        promo_detail_id: this.form.promo_detail_id,
        quota: this.form.quota,
        daily_quota: this.form.daily_quota,
        restriction: restrictionData,
        recurring_type: this.form.recurring_type,
        recurring_value: recurringValue,
        is_locked_domain: this.form.is_locked_domain,
        locked_domains: this.form.locked_domains,
        start_date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.form.start_date).format(this.config.date.iso),
        start_time: this.fullStartTime,
        type: typeData.toString(),
        product_id: productsData != null ? productsData.join() : productsData,
        category_id: categoriesData != null ? categoriesData.join() : categoriesData,
        badge_id: badgesData != null ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(badgesData) : badgesData,
        destination_id: destinationsData != null ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(destinationsData) : destinationsData,
        available_to: this.form.available_to.includes('all') ? 'all' : 'member'
      };

      return this.axios.put('/promo-code/' + this.$route.params.id, this.stringify(data)).then(function () {
        _this5.$swal({
          title: 'Updated',
          text: _this5.form.code + ' has been updated.',
          type: 'success',
          timer: 3000
        });

        _this5.$router.push({ name: 'promo-code-index' });
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this5.error = error.response.data.errors;
        }

        if (error) {
          _this5.$swal({
            title: 'Failed',
            text: 'Failed to update ' + _this5.form.code.label + '.',
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    toggleAllDays: function toggleAllDays() {
      if (this.form.recurring_day.length < 1) {
        this.form.recurring_day = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.form.recurring_day = [];
      }
    },
    init: function init() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.getAvailablePromoConfigs();

              case 2:
                _context.next = 4;
                return _this6.setDates();

              case 4:
                _context.next = 6;
                return _this6.fetchBadges();

              case 6:
                _context.next = 8;
                return _this6.fetchItem('products');

              case 8:
                _context.next = 10;
                return _this6.fetchItem('categories');

              case 10:
                _context.next = 12;
                return _this6.getAvailableDestination();

              case 12:
                if (_this6.isCreate) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return _this6.fetch();

              case 15:
                _context.next = 18;
                break;

              case 17:
                _this6.setUserId();

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    fetchItem: function fetchItem(type) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        var endpoint = type;
        if (type === 'products') {
          endpoint = 'products-only';
        }
        _this7.axios.get('/' + endpoint, { params: _this7.params }).then(function (response) {
          var data = response.data.data;

          var results = data.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          });
          _this7.list[type] = results;
          resolve(data);
        }).catch(function (error) {
          console.log('Fetch ' + type + ' error', error);

          if (error.response) {
            _this7.error = error.response.data.errors;
          }

          if (error) {
            _this7.$swal({
              title: 'Failed',
              text: 'Failed to fetch available ' + type,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this7.fetchItem(type);
              }
            });
          }
        });
      });
    },
    fetchBadges: function fetchBadges() {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        var endpoint = 'badges/type/top';
        _this8.axios.get('/' + endpoint).then(function (response) {
          var data = response.data.data;

          if (data) {
            var results = data.map(function (item) {
              return {
                label: item.name,
                value: item.id
              };
            });
            _this8.list.badges = results;
          }

          resolve(data);
        }).catch(function (error) {
          console.log('Fetch badges error', error);

          if (error.response) {
            _this8.error = error.response.data.errors;
          }

          if (error) {
            _this8.$swal({
              title: 'Failed',
              text: 'Failed to fetch available badges',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this8.fetchBadges();
              }
            });
          }
        });
      });
    },
    getAvailableDestination: function getAvailableDestination() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this9.fetchItem('destinations');

              case 2:
                destinations = _context2.sent;
                _context2.next = 5;
                return _this9.generate(destinations);

              case 5:
                _this9.list.destinations = _context2.sent;
                _context2.next = 8;
                return _this9.flattenDestination(destinations);

              case 8:
                _this9.list.flatDestinations = _context2.sent;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this9);
      }))();
    },
    flattenDestination: function flattenDestination(data) {
      var result = [];

      data.forEach(function (parent) {
        result.push({
          id: parent.id,
          label: parent.name
        });

        if (parent.child !== null) {
          parent.child.forEach(function (child) {
            result.push({
              id: child.id,
              label: child.name
            });

            if (child.child) {
              child.child.forEach(function (grandchild) {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name
                });
              });
            }
          });
        }
      });

      return __WEBPACK_IMPORTED_MODULE_8_lodash_flatten___default()(result);
    },
    generate: function generate(data) {
      if (!data) return [];

      return data.map(function (local) {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map(function (parent) {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  children: parent.child.map(function (child) {
                    if (child.child) {
                      return {
                        id: child.id,
                        label: child.name,
                        children: child.child.map(function (grandchild) {
                          return {
                            id: grandchild.id,
                            label: grandchild.name
                          };
                        })
                      };
                    }
                    return {
                      id: child.id,
                      label: child.name
                    };
                  })
                };
              }

              return {
                id: parent.id,
                label: parent.name
              };
            })
          };
        }

        return {
          id: local.id,
          label: local.name
        };
      });
    },
    loadOptions: function loadOptions(_ref) {
      var _this10 = this;

      var action = _ref.action;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(action === __WEBPACK_IMPORTED_MODULE_9__riophae_vue_treeselect__["LOAD_ROOT_OPTIONS"])) {
                  _context3.next = 5;
                  break;
                }

                if (!_this10.destinationListUpdated) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 4;
                return _this10.getAvailableDestination();

              case 4:
                _this10.destinationListUpdated = false;

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this10);
      }))();
    },
    availableToChecked: function availableToChecked(checkboxValue) {
      if (checkboxValue === 'all') {
        if (!this.form.available_to.includes('all')) {
          if (!this.form.available_to.includes('member')) {
            this.form.available_to.push('member');
            this.availables[1].disabled = true;
          } else {
            this.availables[1].disabled = true;
          }
        } else {
          this.form.available_to.splice('member');
          this.availables[1].disabled = false;
        }
      }
    }
  },

  created: function created() {
    this.init();

    if (!this.isCreate) {
      this.title = 'Edit Promo Code';
    }
  }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flatten__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoCodeView',

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'View Promo Code',

      form: {
        promo_detail_id: null,
        promo_config_name: null,
        code: null,
        start_date: null,
        end_date: null,
        start_time: '00:00:00',
        end_time: '23:59:59',
        config: null,
        type: null,
        nominal: null,
        maximum_amount: null,
        minimum_pay_amount: null,
        minimum_payment: null,
        quota: null,
        daily_quota: null,
        media: [],
        restriction: [],
        recurring_type: 'none',
        recurring_date: null,
        recurring_day: [],
        is_enabled: {
          label: 'Active',
          value: 1
        },
        isUnlimitedQuota: null,
        isUnlimitedDailyQuota: null,
        available_to: [],
        locked_domains: null,
        created_by: null,
        hide_installment: false,
        product_id: null,
        category_id: null,
        badges: null,
        destination_id: null,
        description: null
      },

      list: {
        products: [],
        destinations: [],
        flatDestinations: [],
        categories: [],
        badges: []
      },

      params: {
        page: 1,
        perpage: 500
      },

      statuses: [{
        label: 'Active',
        value: 1
      }, {
        label: 'Inactive',
        value: 0
      }],
      availables: [{
        label: 'All',
        value: 'all',
        disabled: false
      }, {
        label: 'Member',
        value: 'member',
        disabled: false
      }],

      nominalPrefix: 'IDR'
    };
  },


  components: {
    Treeselect: __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["Treeselect"]
  },

  methods: {
    loadOptions: function loadOptions(_ref) {
      var _this = this;

      var action = _ref.action;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(action === __WEBPACK_IMPORTED_MODULE_6__riophae_vue_treeselect__["LOAD_ROOT_OPTIONS"])) {
                  _context.next = 5;
                  break;
                }

                if (!_this.destinationListUpdated) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return _this.getAvailableDestination();

              case 4:
                _this.destinationListUpdated = false;

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    parseDate: function parseDate(date, to) {
      if (!date) return '';
      var formatTo = to || 'YYYY-MM-DD';
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format(formatTo);
    },
    back: function back() {
      this.$router.go(-1);
    },
    fetch: function fetch() {
      var _this2 = this;

      this.axios.get('/promo-code/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;


        _this2.form.start_date = _this2.parseDate(data.start_date, 'DD MMM YYYY');
        _this2.form.end_date = _this2.parseDate(data.end_date, 'DD MMM YYYY');
        _this2.form.start_time = data.start_time;
        _this2.form.end_time = data.end_time;
        _this2.form.code = data.code;
        _this2.form.promo_config_name = data.promo_config_name;
        _this2.form.type = data.detail.type;
        _this2.form.quota = data.quota;
        _this2.form.daily_quota = data.daily_quota;
        _this2.form.nominal = data.detail.nominal;
        _this2.form.maximum_amount = data.detail.maximum_amount;
        _this2.form.minimum_pay_amount = data.detail.minimum_pay_amount;
        _this2.form.minimum_payment = data.detail.minimum_payment;
        _this2.form.description = data.detail.description;
        _this2.form.is_locked_domain = data.detail.is_locked_domain;
        _this2.form.locked_domains = data.detail.locked_domains;

        if (data.quota === 0) {
          _this2.form.isUnlimitedQuota = true;
        }

        if (data.daily_quota === 0) {
          _this2.form.isUnlimitedDailyQuota = true;
        }

        if (data.detail.type === 'percentage') {
          _this2.nominalPrefix = '%';
        }

        if (data.detail.media) {
          _this2.form.media = data.detail.media.split(',');
        }

        if (data.detail.restriction) {
          _this2.form.restriction = data.detail.restriction.split(',');
        }

        if (data.detail.badges) {
          var badgesData = data.detail.badges.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          });
          _this2.form.badges = badgesData;
        }

        var productsData = [];
        if (data.detail.product_id) {
          var arrayProducts = data.detail.product_id.split(',');
          console.log(arrayProducts);
          arrayProducts.forEach(function (selected) {
            _this2.list.products.forEach(function (item) {
              if (item.value === parseInt(selected, 10)) {
                productsData.push(item);
              }
            });
          });
          console.log(productsData);
        }

        var categoriesData = [];
        if (data.detail.category_id) {
          var arrayCategory = data.detail.category_id.split(',');
          arrayCategory.forEach(function (selected) {
            _this2.list.categories.forEach(function (item) {
              if (item.value === parseInt(selected, 10)) {
                categoriesData.push(item);
              }
            });
          });
        }
        var arrayDestination = data.detail.destinations;
        if (arrayDestination) {
          var valueDestinations = arrayDestination.filter(function (l) {
            return !arrayDestination.find(function (val) {
              return l.id === val.parent_id;
            });
          }).map(function (l) {
            return l.id;
          });
          _this2.form.destination_id = valueDestinations;
        } else {
          _this2.form.destination_id = null;
        }
        var availableData = [];
        if (data.available_to === 'all') {
          availableData.push('all', 'member');
          _this2.availables[1].disabled = true;
        } else {
          availableData.push('member');
        }
        _this2.form.product_id = productsData;
        _this2.form.category_id = categoriesData;
        _this2.form.available_to = availableData;

        if (data.is_enable === 0) {
          _this2.form.is_enabled = {
            label: 'Inactive',
            value: 0
          };
        }
      }).catch(function (error) {
        console.log(error);
        if (error.response) {
          _this2.errors = error.response.data.errors;
        }

        if (error) {
          _this2.$swal({
            title: 'Failed',
            text: 'Failed to fetch promo code detail',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this2.fetch();
            }
          });
        }
      });
    },
    fetchItem: function fetchItem(type) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var endpoint = type;
        if (type === 'products') {
          endpoint = 'products-only';
        }
        _this3.axios.get('/' + endpoint, { params: _this3.params }).then(function (response) {
          var data = response.data.data;

          var results = data.map(function (item) {
            return {
              label: item.name,
              value: item.id
            };
          });
          _this3.list[type] = results;
          resolve(data);
        }).catch(function (error) {
          console.log('Fetch ' + type + ' error', error);

          if (error.response) {
            _this3.error = error.response.data.errors;
          }

          if (error) {
            _this3.$swal({
              title: 'Failed',
              text: 'Failed to fetch available ' + type,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this3.fetchItem(type);
              }
            });
          }
        });
      });
    },
    getAvailableDestination: function getAvailableDestination() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var destinations;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.fetchItem('destinations');

              case 2:
                destinations = _context2.sent;
                _context2.next = 5;
                return _this4.generate(destinations);

              case 5:
                _this4.list.destinations = _context2.sent;
                _context2.next = 8;
                return _this4.flattenDestination(destinations);

              case 8:
                _this4.list.flatDestinations = _context2.sent;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    flattenDestination: function flattenDestination(data) {
      var result = [];

      data.forEach(function (parent) {
        result.push({
          id: parent.id,
          label: parent.name
        });

        if (parent.child !== null) {
          parent.child.forEach(function (child) {
            result.push({
              id: child.id,
              label: child.name
            });

            if (child.child) {
              child.child.forEach(function (grandchild) {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name
                });
              });
            }
          });
        }
      });

      return __WEBPACK_IMPORTED_MODULE_5_lodash_flatten___default()(result);
    },
    generate: function generate(data) {
      if (!data) return [];

      return data.map(function (local) {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map(function (parent) {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  children: parent.child.map(function (child) {
                    if (child.child) {
                      return {
                        id: child.id,
                        label: child.name,
                        children: child.child.map(function (grandchild) {
                          return {
                            id: grandchild.id,
                            label: grandchild.name
                          };
                        })
                      };
                    }
                    return {
                      id: child.id,
                      label: child.name
                    };
                  })
                };
              }

              return {
                id: parent.id,
                label: parent.name
              };
            })
          };
        }

        return {
          id: local.id,
          label: local.name
        };
      });
    },
    init: function init() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.fetchItem('products');

              case 2:
                _context3.next = 4;
                return _this5.fetchItem('badges');

              case 4:
                _context3.next = 6;
                return _this5.fetchItem('categories');

              case 6:
                _context3.next = 8;
                return _this5.getAvailableDestination();

              case 8:
                _this5.fetch();

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Pagination__ = __webpack_require__(6);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoConfigIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_Common__["a" /* default */]],

  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Pagination__["a" /* default */]
  },

  data: function data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},

      params: {
        name: null,
        payment_method: null,
        page: null
      },

      payments: [],
      paymentsSelected: null,
      isInitial: true
    };
  },


  computed: {
    hasQuery: function hasQuery() {
      var _this = this;

      var query = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.params).filter(function (key) {
        return _this.params[key] !== null;
      });
      return query.length > 0;
    }
  },

  watch: {
    paymentsSelected: function paymentsSelected() {
      if (!this.isInitial) {
        this.setMethodAndFetch();
      }
    }
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.setQuery();

              case 2:
                _context.next = 4;
                return _this2.getPaymentMethod();

              case 4:
                _context.next = 6;
                return _this2.fetch();

              case 6:
                _this2.isInitial = false;

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetch: function fetch(page) {
      var _this3 = this;

      this.params.page = page || null;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.axios.get('/promoconfigs', { params: _this3.params }).then(function (response) {
          var _response$data = response.data,
              data = _response$data.data,
              meta = _response$data.meta;

          var isEmpty = !data && meta.pagination.current_page > meta.pagination.total_pages;

          _this3.items = !isEmpty ? data : [];
          _this3.pagination = !isEmpty ? meta.pagination : {};

          _this3.setPushState();
          resolve();
        }).catch(function () {
          _this3.$swal({
            title: 'Fetch Failed',
            text: 'Failed to fetch Promo Config data',
            type: 'warning',
            timer: 5000
          });

          reject();
        }).finally(function () {
          _this3.isLoading = false;
        });
      });
    },
    setQuery: function setQuery() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this4.params.name = _this4.$route.query.name || null;
        _this4.params.payment_method = _this4.$route.query.payment_method || null;
        _this4.params.page = _this4.$route.query.page ? _this4.$route.query.page : null;

        resolve();
      });
    },
    generateQuery: function generateQuery(params) {
      var _this5 = this;

      if (!params) return null;

      var query = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
        return params[key];
      }).map(function (key) {
        return key + '=' + _this5.params[key];
      });

      return query ? '?' + query.join('&') : null;
    },
    setPushState: function setPushState() {
      var title = 'Promo configs search page ' + this.params.page;
      var paramUrl = '/promo/config';
      var parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, '' + paramUrl + parameters);
    },


    onInput: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    getPaymentMethod: function getPaymentMethod() {
      var _this6 = this;

      var config = {
        baseURL: __WEBPACK_IMPORTED_MODULE_4__config__["i" /* default */],
        params: {
          page: 1,
          perpage: 100
        }
      };

      var mapToSelected = function mapToSelected(list, methods) {
        if (!methods || !list) return null;

        var selected = methods.split(',');
        if (!selected && selected.length < 1) return null;

        return list.filter(function (iL) {
          return selected.some(function (iM) {
            return parseInt(iM, 10) === iL.value;
          });
        });
      };

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.axios.get('/payments/v2/payment-method', config).then(function (response) {
          var data = response.data.data;

          _this6.payments = data.map(function (item) {
            return { label: item.name, value: item.id };
          });
          _this6.paymentsSelected = mapToSelected(_this6.payments, _this6.params.payment_method);
          resolve();
        }).catch(function (error) {
          _this6.$swal({
            title: 'Fetch Failed',
            text: 'Failed to fetch payment method data',
            type: 'warning',
            timer: 5000
          });
          reject(new Error(error));
        });
      });
    },
    setMethodParam: function setMethodParam() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var methodParam = [];

        if (_this7.paymentsSelected.length > 0) {
          _this7.paymentsSelected.forEach(function (item) {
            methodParam.push(item.value);
          });
        }

        _this7.params.payment_method = methodParam.toString();

        resolve();
      });
    },
    setMethodAndFetch: function setMethodAndFetch() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this8.setMethodParam();

              case 2:
                _context2.next = 4;
                return _this8.fetch();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    parseDay: function parseDay(day) {
      if (day === 1) return 'Mon';
      if (day === 2) return 'Tue';
      if (day === 3) return 'Wed';
      if (day === 4) return 'Thu';
      if (day === 5) return 'Fri';
      if (day === 6) return 'Sat';
      if (day === 7) return 'Sun';
      return '';
    },
    parseStatus: function parseStatus(status) {
      if (status === 1) return 'Active';
      return 'Inactive';
    },
    add: function add() {
      this.$router.push({ name: 'promo-config-create' });
    },
    view: function view(id) {
      this.$router.push({
        name: 'promo-config-view',
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'promo-config-edit',
        params: { id: id }
      });
    },
    toggleStatus: function toggleStatus(item) {
      var _this9 = this;

      var params = item.is_enabled === 1 ? 'deactivate/' + item.id : 'activate/' + item.id;
      this.axios.patch('/promoconfigs/' + params).then(function () {
        return _this9.fetch();
      });
    },
    delete: function _delete(id) {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this10.axios.delete('/promoconfigs/' + id).then(function (response) {
          console.log(response);
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject();
        });
      });
    },
    remove: function remove(item) {
      var _this11 = this;

      return this.$swal({
        title: 'Delete Config',
        text: 'Are you sure to delete ' + item.name,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(function (result) {
        if (result.value) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return _this11.delete(item.id);

                  case 3:
                    _context3.next = 5;
                    return _this11.fetch();

                  case 5:
                    _this11.$swal({
                      title: 'Deleted!',
                      text: item.name + ' has been deleted.',
                      type: 'success',
                      timer: 5000
                    });
                    _context3.next = 11;
                    break;

                  case 8:
                    _context3.prev = 8;
                    _context3.t0 = _context3['catch'](0);

                    console.log(_context3.t0);

                  case 11:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this11, [[0, 8]]);
          }))();
        }
      });
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { API_GATEWAY, X_API_KEY, X_SECRET_KEY } from '@/config';



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoConfigForm',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Create Promo Payments',

      error: null,

      form: {
        id: null,
        name: null,
        description: null,
        type: [],
        days: [],
        payment_method: [],
        installment_tenor: [],
        is_enabled: {
          label: 'Active',
          value: 1
        }
      },

      statuses: [{
        label: 'Active',
        value: 1
      }, {
        label: 'Inactive',
        value: 0
      }],

      installments: [{
        label: '3 Months',
        value: 3
      }, {
        label: '6 Months',
        value: 6
      }, {
        label: '12 Months',
        value: 12
      }],

      types: [{
        label: 'Promo Code',
        value: 'promocode'
      }],

      days: [{
        label: 'Mon',
        value: 1
      }, {
        label: 'Tue',
        value: 2
      }, {
        label: 'Wed',
        value: 3
      }, {
        label: 'Thu',
        value: 4
      }, {
        label: 'Fri',
        value: 5
      }, {
        label: 'Sat',
        value: 6
      }, {
        label: 'Sun',
        value: 7
      }],

      payments: []
    };
  },


  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    getPaymentMethods: function getPaymentMethods() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var config = {
          baseURL: __WEBPACK_IMPORTED_MODULE_4__config__["i" /* default */],
          params: {
            page: 1,
            perpage: 100
          }
        };

        _this.axios.get('/payments/v2/payment-method', config).then(function (response) {
          var data = response.data.data;

          data.forEach(function (item) {
            _this.payments.push({
              label: item.name,
              value: item.id
            });
          });
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject(error);
          _this.$swal({
            title: 'Failed',
            text: 'Failed to fetch available payment methods',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this.getPaymentMethods();
            }
          });
        });
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      this.axios.get('/promoconfigs/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;

        var typeData = [];
        if (data.type !== null && data.type.length > 0) {
          data.type.forEach(function (selected) {
            _this2.types.forEach(function (item) {
              if (item.value === selected) {
                typeData.push(item);
              }
            });
          });
        }

        var paymentMethodData = [];
        if (data.payment_method !== null && data.payment_method.length > 0) {
          data.payment_method.forEach(function (selected) {
            _this2.payments.forEach(function (item) {
              if (item.value === selected.id) {
                paymentMethodData.push(item);
              }
            });
          });
        }

        var installmentTenorData = [];
        if (data.installment_tenor !== null && data.installment_tenor.length > 0) {
          data.installment_tenor.forEach(function (selected) {
            _this2.installments.forEach(function (item) {
              if (item.value === selected) {
                installmentTenorData.push(item);
              }
            });
          });
        }

        var enabled = {};
        _this2.statuses.forEach(function (item) {
          if (item.value === data.is_enabled) {
            enabled = item;
          }
        });

        _this2.form.id = data.id;
        _this2.form.name = data.name;
        _this2.form.description = data.description;
        _this2.form.days = data.days;
        _this2.form.type = typeData;
        _this2.form.payment_method = paymentMethodData;
        _this2.form.installment_tenor = installmentTenorData;
        _this2.form.is_enabled = enabled;
      }).catch(function (error) {
        if (error.response) {
          _this2.errors = error.response.data.errors;
        }

        if (error) {
          _this2.$swal({
            title: 'Failed',
            text: 'Failed to fetch promo config detail',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this2.fetch();
            }
          });
        }
      });
    },
    toggleAllDays: function toggleAllDays() {
      if (this.form.days.length < 1) {
        this.form.days = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.form.days = [];
      }
    },
    prepareValues: function prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      var isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      var values = [];
      arr.forEach(function (item) {
        values.push(item.value);
      });

      return values;
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Promo name required', 'Please fill promo name to continue', 'warning');
        return false;
      }

      if (!this.form.description) {
        this.$swal('Promo description required', 'Please fill promo description to continue', 'warning');
        return false;
      }

      if (this.form.type.length > 1) {
        this.$swal('Promo Type exceeded', 'Please select only one promo type', 'warning');
        return false;
      }

      if (!this.form.type || this.form.type.length < 1) {
        this.$swal('Promo Type required', 'Please select promo type', 'warning');
        return false;
      }

      if (!this.form.days || this.form.days.length < 1) {
        this.$swal('Promo days required', 'Please select active promo days', 'warning');
        return false;
      }

      if (!this.form.payment_method || this.form.payment_method.length < 1) {
        this.$swal('Promo payment method required', 'Please select promo payment method', 'warning');
        return false;
      }

      if (!this.form.is_enabled || this.form.is_enabled.length < 1) {
        this.$swal('Promo payment status required', 'Please select promo payment status', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },
    create: function create() {
      var _this3 = this;

      var typeData = this.prepareValues(this.form.type);
      var paymentData = this.prepareValues(this.form.payment_method);
      var installmentData = this.prepareValues(this.form.installment_tenor);

      var data = {
        name: this.form.name,
        description: this.form.description,
        days: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.form.days),
        type: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(typeData),
        payment_method: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(paymentData),
        installment_tenor: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(installmentData),
        is_enabled: 1
      };

      return this.axios.post('/promoconfigs', this.stringify(data)).then(function () {
        _this3.$swal({
          title: 'created',
          text: _this3.form.name + ' has been created.',
          type: 'success',
          timer: 3000
        });

        _this3.$router.push({ name: 'promo-config-index' });
      }).catch(function (error) {
        if (error.response) {
          _this3.error = error.response.data.errors;

          _this3.$swal({
            title: 'Create Failed!',
            text: 'Failed to create new Promo Config',
            type: 'warning',
            timer: 5000
          });
        }
      });
    },
    update: function update() {
      var _this4 = this;

      var typeData = this.prepareValues(this.form.type);
      var paymentData = this.prepareValues(this.form.payment_method);
      var installmentData = this.prepareValues(this.form.installment_tenor);

      var data = {
        name: this.form.name,
        description: this.form.description,
        days: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.form.days),
        type: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(typeData),
        payment_method: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(paymentData),
        installment_tenor: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(installmentData),
        is_enabled: this.form.is_enabled.value.toString()
      };

      this.axios.put('/promoconfigs/' + this.form.id, this.stringify(data)).then(function () {
        _this4.$swal({
          title: 'Updated',
          text: _this4.form.name + ' has been updated.',
          type: 'success',
          timer: 3000
        });
        _this4.$router.push({ name: 'promo-config-index' });
      }).catch(function (error) {
        if (error.response) {
          _this4.$swal({
            title: 'Failed',
            text: 'Failed to update ' + _this4.form.name + '.',
            type: 'warning',
            timer: 5000
          });
          _this4.error = error.response.data.errors;
        }
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    },
    init: function init() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.getPaymentMethods();

              case 2:

                if (!_this5.isCreate) {
                  _this5.title = 'Edit Promo Config';
                  _this5.fetch();
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    }
  },

  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(14);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PromoConfigView',

  data: function data() {
    return {
      title: 'View Promo Payments',

      form: {
        id: null,
        name: null,
        description: null,
        type: [],
        days: [],
        payment_method: [],
        installment_tenor: [],
        is_enabled: {
          label: 'Active',
          value: 1
        }
      },

      statuses: [{
        label: 'Active',
        value: 1
      }, {
        label: 'Inactive',
        value: 0
      }],

      types: [{
        label: 'Promo Code',
        value: 'promocode'
      }],

      days: [{
        label: 'Mon',
        value: 1
      }, {
        label: 'Tue',
        value: 2
      }, {
        label: 'Wed',
        value: 3
      }, {
        label: 'Thu',
        value: 4
      }, {
        label: 'Fri',
        value: 5
      }, {
        label: 'Sat',
        value: 6
      }, {
        label: 'Sun',
        value: 7
      }],

      payments: []
    };
  },


  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var config = {
          baseURL: __WEBPACK_IMPORTED_MODULE_3__config__["i" /* default */],
          params: {
            page: 1,
            perpage: 100
          }
        };

        _this.axios.get('/payments/v2/payment-method', config).then(function (response) {
          var data = response.data.data;

          data.forEach(function (item) {
            _this.payments.push({
              label: item.name,
              value: item.id
            });
          });
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject(error);
          _this.$swal({
            title: 'Failed',
            text: 'Failed to fetch available payment methods',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this.getPaymentMethods();
            }
          });
        });
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      this.axios.get('/promoconfigs/' + this.$route.params.id).then(function (response) {
        var data = response.data.data;


        var typeData = [];
        if (data.type !== null && data.type.length > 0) {
          data.type.forEach(function (selected) {
            _this2.types.forEach(function (item) {
              if (item.value === selected) {
                typeData.push(item);
              }
            });
          });
        }

        var paymentMethodData = [];
        if (data.payment_method !== null && data.payment_method.length > 0) {
          data.payment_method.forEach(function (selected) {
            _this2.payments.forEach(function (item) {
              if (item.value === selected.id) {
                paymentMethodData.push(item);
              }
            });
          });
        }

        _this2.form.id = data.id;
        _this2.form.name = data.name;
        _this2.form.description = data.description;
        _this2.form.days = data.days;
        _this2.form.type = typeData;
        _this2.form.payment_method = paymentMethodData;

        if (data.is_enabled === 0) {
          _this2.form.is_enabled = {
            label: 'Inactive',
            value: 0
          };
        }
      }).catch(function (error) {
        if (error.response) {
          _this2.errors = error.response.data.errors;
        }

        if (error) {
          _this2.$swal({
            title: 'Failed',
            text: 'Failed to fetch promo config detail',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this2.fetch();
            }
          });
        }
      });
    },
    init: function init() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.getPaymentMethods();

              case 2:
                _this3.fetch();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    }
  },

  mounted: function mounted() {
    this.init();
  }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_spinner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_common_Modal__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderSummary',

  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      orders: [],
      pagination: {},
      isLoading: true,
      type: 'json',
      modalVisible: false,
      modalError: false,
      orderDetail: null,
      payment_methods: [],
      list: {
        merchants: []
      },

      params: {
        booking_no: null,
        merchant: null,
        member_name: null,
        member_email: null,
        status: '',
        date_from: null,
        date_to: null,
        departure_date: null,
        source: '',
        package_name: null,
        promo_code: null,
        payment_method: null,
        paid_from: null,
        paid_to: null,
        redeem_at_from: null,
        redeem_at_to: null,
        checkin_at_from: null,
        checkin_at_to: null,
        export_csv: 0,
        page: 1,
        perpage: 20
      }
    };
  },


  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_6_vuejs_datepicker___default.a,
    Circle2: __WEBPACK_IMPORTED_MODULE_7_vue_loading_spinner__["b" /* Circle2 */],
    Modal: __WEBPACK_IMPORTED_MODULE_11__components_modules_common_Modal__["a" /* default */]
  },
  computed: {
    disabledDates: function disabledDates() {
      var today = __WEBPACK_IMPORTED_MODULE_5_moment___default()().toDate();
      if (this.params.date_from) {
        return {
          from: __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.params.date_from).add(6, 'month').toDate()
        };
      }
      return {
        // to: moment().toDate(),
        from: today

      };
    }
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var queryParams;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _this.setListEmpty();

                _context.next = 4;
                return _this.populateQueryParams();

              case 4:
                queryParams = _context.sent;


                _this.axios.get('/orders', {
                  params: queryParams,
                  responseType: _this.type
                }).then(function (response) {
                  _this.params.export_csv = 0;

                  if (_this.type !== 'json') {
                    var blob = new Blob([response.data], {
                      type: 'text/csv'
                    });
                    var url = window.URL.createObjectURL(blob);

                    window.open(url);
                    _this.type = 'json';
                    return;
                  }

                  var _response$data = response.data,
                      data = _response$data.data,
                      meta = _response$data.meta;


                  if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
                    _this.setListEmpty();
                    _this.isLoading = false;
                    return;
                  }

                  _this.orders = data;
                  _this.pagination = meta.pagination;
                  _this.isLoading = false;
                }).catch(function () {
                  _this.params.export_csv = 0;
                  _this.isLoading = false;

                  _this.$swal({
                    title: 'Fetch Failed',
                    text: 'Failed to fetch BIN data',
                    type: 'warning',
                    timer: 3000
                  });
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchItem: function fetchItem(type) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.axios.get('/' + type, { params: { perpage: 5000 } }).then(function (response) {
          var data = response.data.data;

          var results = data.map(function (item) {
            return { label: item.name, value: item.id };
          });
          _this2.list[type] = results;
          resolve(data);
        }).catch(function (error) {
          console.log('Fetch ' + type + ' error', error);

          if (error.response) {
            _this2.error = error.response.data.errors;
          }

          if (error) {
            _this2.$swal({
              title: 'Failed',
              text: 'Failed to fetch available ' + type,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this2.fetchItem(type);
              }
            });
          }
        });
      });
    },
    setListEmpty: function setListEmpty() {
      this.orders = [];
      this.pagination = {};
    },
    getPaymentMethods: function getPaymentMethods() {
      var _this3 = this;

      var config = {
        baseURL: __WEBPACK_IMPORTED_MODULE_10__config__["i" /* default */],
        params: {
          page: 1,
          perpage: 100
        }
      };

      this.axios.get('/payments/v2/payment-method', config).then(function (response) {
        var data = response.data.data;

        data.forEach(function (item) {
          if (item.active) {
            _this3.payment_methods.push({
              label: item.name,
              value: item.slug
            });
          }
        });
      }).catch(function (error) {
        console.log(error);
        _this3.$swal({
          title: 'Failed',
          text: 'Failed to fetch available payment methods',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#666',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Try again'
        }).then(function (result) {
          if (result.value) {
            // this.getPaymentMethods();
          }
        });
      });
    },
    populateQueryParams: function populateQueryParams() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var params = {
          booking_no: _this4.params.booking_no,
          merchant: _this4.params.merchant ? _this4.params.merchant.value : null,
          member_name: _this4.params.member_name,
          member_email: _this4.params.member_email,
          status: _this4.params.status,
          date_from: _this4.params.date_from,
          date_to: _this4.params.date_to,
          visit_date: _this4.params.departure_date,
          source: _this4.params.source,
          package_name: _this4.params.package_name,
          promo_code: _this4.params.promo_code,
          payment_method: _this4.params.payment_method,
          export_csv: _this4.params.export_csv,
          paid_from: _this4.params.paid_from,
          redeem_at_from: _this4.params.redeem_at_from,
          redeem_at_to: _this4.params.redeem_at_to,
          checkin_at_from: _this4.params.checkin_at_from,
          checkin_at_to: _this4.params.checkin_at_to,
          paid_to: _this4.params.paid_to,
          page: _this4.params.page,
          perpage: _this4.params.perpage
        };

        if (_this4.params.payment_method) {
          params.payment_method = _this4.params.payment_method.value;
        }

        resolve(params);
      });
    },
    changePage: function changePage(page) {
      this.params.page = page;
      this.fetch();
    },
    onExportCsv: function onExportCsv(type) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, totalRow, queryParams, url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = '';

                _this5.params.export_csv = 1;

                totalRow = _this5.pagination.total;
                _context2.next = 5;
                return _this5.populateQueryParams();

              case 5:
                queryParams = _context2.sent;


                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queryParams).forEach(function (key) {
                  if (key === 'perpage') {
                    params += key + '=' + (totalRow || '') + '&';
                  } else {
                    params += key + '=' + (queryParams[key] || '') + '&';
                  }
                });

                params = params.slice(0, -1);
                // paid_from=2022-03-02&paid_to=2022-03-0
                if (_this5.params.date_from && _this5.params.date_to) {
                  url = '';

                  if (type === 'finance') {
                    url = __WEBPACK_IMPORTED_MODULE_10__config__["i" /* default */] + '/orders/finance?' + params;
                  } else {
                    url = __WEBPACK_IMPORTED_MODULE_10__config__["i" /* default */] + '/orders?' + params;
                  }
                  window.location = url;
                } else {
                  _this5.modalError = true;
                }

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },


    onInput: __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(function debouncedInput() {
      this.fetch();
    }, 500),

    onDateSelected: function onDateSelected(type, date) {
      date = this.parseTime(date, 'YYYY-MM-DD');

      if (type === 'departureDate') {
        this.params.departure_date = date;
      }

      if (type === 'bookingDateFrom') {
        this.params.date_from = date;
      }

      if (type === 'bookingDateTo') {
        this.params.date_to = date;
      }

      if (type === 'redeem_at_from') {
        this.params.redeem_at_from = date;
      }

      if (type === 'redeem_at_to') {
        this.params.redeem_at_to = date;
      }

      if (type === 'checkin_at_from') {
        this.params.checkin_at_from = date;
      }

      if (type === 'checkin_at_to') {
        this.params.checkin_at_to = date;
      }
    },
    onPaidSelected: function onPaidSelected(type, date) {
      date = this.parseTime(date, 'YYYY-MM-DD');

      if (type === 'paidFrom') {
        this.params.paid_from = date;
      }

      if (type === 'paidTo') {
        this.params.paid_to = date;
      }
    },
    onBookingNoClick: function onBookingNoClick(hash) {
      var _this6 = this;

      var config = {
        headers: {
          'X-Api-Key': '' + __WEBPACK_IMPORTED_MODULE_10__config__["f" /* X_API_KEY */]
        }
      };

      if (!hash) {
        this.modalVisible = false;
        return;
      }

      this.modalVisible = true;

      this.axios.get('orders/' + hash, config).then(function (response) {
        var data = response.data.data;

        _this6.orderDetail = data;
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  },

  created: function created() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this7.getPaymentMethods();
              _context3.next = 3;
              return _this7.fetchItem('merchants');

            case 3:
              _context3.next = 5;
              return _this7.fetch();

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this7);
    }))();
  }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_common_FileGallery__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_spinner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(14);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Payment2Merchant',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      orders: [],
      pagination: {},
      isLoading: false,
      modalDetailVisible: false,
      modalPaidVisible: false,
      list: {
        merchants: []
      },

      show: {
        gallery: false
      },

      selectedOrder: [],
      selectAllOrder: false,

      orderDetail: null,

      paidData: {
        items: [],
        merchant_name: null,
        transfer_date: null,
        bank_owner: null,
        bank_name: null,
        bank_number: null,
        swift_code: null,
        bank_branch: null,
        currency: null,
        total_nett: 0,
        image: {
          id: null,
          url: null
        }
      },

      params: {
        booking_no: null,
        member_name: null,
        departure_date: null,
        date_from: null,
        date_to: null,
        product_name: null,
        merchant: null,
        status: 'paid',
        status_payment: '',
        export_csv: 0,
        page: 1,
        perpage: 20
      },

      targetMerchant: null
    };
  },


  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_9__components_modules_common_Pagination__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a,
    Circle2: __WEBPACK_IMPORTED_MODULE_10_vue_loading_spinner__["b" /* Circle2 */],
    FileGallery: __WEBPACK_IMPORTED_MODULE_8__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Modal__["a" /* default */]
  },

  computed: {
    disabledTransferDate: function disabledTransferDate() {
      return {
        from: __WEBPACK_IMPORTED_MODULE_5_moment___default()().toDate()
      };
    }
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      this.isLoading = true;
      this.selectedOrder = [];
      this.selectAllOrder = false;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this.setListEmpty();

        var queryParams = _this.populateQueryParams();
        _this.axios.get('/merchant-payments', { params: queryParams }).then(function (response) {
          var _response$data = response.data,
              data = _response$data.data,
              meta = _response$data.meta;


          if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
            _this.setListEmpty();
            _this.isLoading = false;
            return;
          }

          _this.orders = data;
          _this.pagination = meta.pagination;
          resolve(data);
          _this.isLoading = false;
        }).catch(function (error) {
          console.log('Fetch error', error);

          if (error.response) {
            _this.error = error.response.data.errors;
          }

          if (error) {
            _this.$swal({
              title: 'Failed!',
              text: 'Failed to fetch Data',
              type: 'warning',
              timer: 3000
            });
          }
          _this.isLoading = false;
        });
      });
    },
    setListEmpty: function setListEmpty() {
      this.orders = [];
      this.pagination = {};
    },
    populateQueryParams: function populateQueryParams() {
      var params = {
        booking_no: this.params.booking_no,
        member_name: this.params.member_name,
        visit_date: this.params.departure_date,
        date_from: this.params.date_from,
        date_to: this.params.date_to,
        package_name: this.params.product_name,
        merchant: this.params.merchant ? this.params.merchant.value : null,
        status_payment: this.params.status_payment,
        status: this.params.status,
        export_csv: this.params.export_csv,
        page: this.params.page,
        perpage: this.params.perpage
      };

      return params;
    },
    fetchItem: function fetchItem(type) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.axios.get('/' + type, { params: { perpage: 5000 } }).then(function (response) {
          var data = response.data.data;

          var results = data.map(function (item) {
            return { label: item.name, value: item.id };
          });
          _this2.list[type] = results;
          resolve(data);
        }).catch(function (error) {
          console.log('Fetch ' + type + ' error', error);

          if (error.response) {
            _this2.error = error.response.data.errors;
          }

          if (error) {
            _this2.$swal({
              title: 'Failed',
              text: 'Failed to fetch available ' + type,
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again'
            }).then(function (result) {
              if (result.value) {
                _this2.fetchItem(type);
              }
            });
          }
        });
      });
    },
    onDateSelected: function onDateSelected(type, date) {
      date = this.parseTime(date, 'YYYY-MM-DD');

      if (type === 'departureDate') {
        this.params.departure_date = date;
      }

      if (type === 'bookingDateFrom') {
        this.params.date_from = date;
      }

      if (type === 'bookingDateTo') {
        this.params.date_to = date;
      }

      if (type === 'transfer_date') {
        this.paidData.transfer_date = date;
      }
    },
    changePage: function changePage(page) {
      this.params.page = page;
      this.fetch();
    },
    onBookingNoClick: function onBookingNoClick(hash) {
      var _this3 = this;

      var config = {
        headers: {
          'X-Api-Key': '' + __WEBPACK_IMPORTED_MODULE_11__config__["f" /* X_API_KEY */]
        }
      };
      console.log(hash + ', ' + config);
      if (!hash) {
        this.modalDetailVisible = false;
        return;
      }

      this.modalDetailVisible = true;

      this.axios.get('merchant-payments/' + hash, config).then(function (response) {
        var data = response.data.data;

        _this3.orderDetail = data;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    selectAll: function selectAll() {
      var _this4 = this;

      this.selectedOrder = [];

      if (!this.selectAllOrder) {
        this.orders.filter(function (data) {
          return data.status_payment !== 'paid';
        }).map(function (data) {
          return _this4.selectedOrder.push({
            merchant_id: data.items[0].product.merchant.id,
            booking_no: data.booking_no,
            total_nett: data.total_nett_rate
          });
        });
      }
    },
    onPaidClick: function onPaidClick() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var valid, bankExists;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                valid = _this5.validateSelectedOrder(_this5.selectedOrder);

                if (valid) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this5.setPaidDataEmpty();
                _context.next = 6;
                return _this5.getMerchantData();

              case 6:
                bankExists = _this5.checkMerchantBank(_this5.targetMerchant);

                if (bankExists) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt('return');

              case 9:

                _this5.generateFormPaid(_this5.targetMerchant);
                _this5.modalPaidVisible = true;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    validateSelectedOrder: function validateSelectedOrder(datas) {
      if (datas.length < 1) {
        this.$swal({
          title: 'No Order Selected',
          text: 'Please select Order to Pay',
          type: 'warning',
          timer: 5000
        });
        return false;
      }

      if (!datas.every(function (data) {
        return data.merchant_id === datas[0].merchant_id;
      })) {
        this.$swal({
          title: 'Different Merchants',
          text: 'Payment only valid for the same Merchant',
          type: 'warning',
          timer: 5000
        });
        return false;
      }

      if (datas.some(function (data) {
        return data.merchant_id === 0;
      })) {
        this.$swal({
          title: 'Merchant not available',
          text: 'Please check the merchant data on the selected order',
          type: 'warning',
          timer: 5000
        });
        return false;
      }

      return true;
    },
    checkMerchantBank: function checkMerchantBank(merchant) {
      if (merchant.banks.length < 1) {
        this.$swal({
          title: 'Incomplete Merchant Data',
          text: 'Please complete the merchant data to continue the payment process',
          type: 'warning',
          timer: 5000
        });
        return false;
      }

      return true;
    },
    setPaidDataEmpty: function setPaidDataEmpty() {
      var paidData = {
        items: [],
        merchant_id: null,
        merchant_name: null,
        transfer_date: null,
        bank_owner: null,
        bank_name: null,
        bank_id: null,
        bank_number: null,
        swift_code: null,
        bank_branch: null,
        currency: null,
        total_nett: 0,
        image: {
          id: null,
          url: null
        }
      };

      this.paidData = paidData;
    },
    generateFormPaid: function generateFormPaid(data) {
      this.paidData.items = this.getBookingsNo(this.selectedOrder);
      this.paidData.merchant_id = data.id;
      this.paidData.merchant_name = data.name;
      this.paidData.bank_owner = data.banks[0].account_owner;
      this.paidData.bank_name = data.banks[0].bank_name;
      this.paidData.bank_id = data.banks[0].id;
      this.paidData.bank_number = data.banks[0].account_number;
      this.paidData.swift_code = data.banks[0].swift_code;
      this.paidData.bank_branch = data.banks[0].bank_branch;
      this.paidData.currency = data.banks[0].currency;
      this.paidData.total_nett = this.selectedOrder.reduce(function (accum, item) {
        return accum + parseInt(item.total_nett, 10);
      }, 0);
    },
    getMerchantData: function getMerchantData() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this6.axios.get('merchants/' + _this6.selectedOrder[0].merchant_id).then(function (response) {
          var data = response.data.data;


          _this6.targetMerchant = data;
          resolve();
        }).catch(function (error) {
          console.log('error', error);
        });
      });
    },
    getBookingsNo: function getBookingsNo(datas) {
      var bookingsNo = [];
      datas.map(function (data) {
        return bookingsNo.push({
          booking_no: data.booking_no
        });
      });
      return bookingsNo;
    },
    submitPayment: function submitPayment() {
      var _this7 = this;

      var valid = this.validateSubmitOrder(this.paidData);
      if (!valid) return;

      var data = this.generatePaidData();

      this.axios.post('/merchant-payments', data).then(function () {
        _this7.modalPaidVisible = false;
        _this7.$swal({
          title: 'Payment Success',
          text: 'Payment for those order numbers successful',
          type: 'success',
          timer: 3000
        });
        _this7.fetch();
      }).catch(function (error) {
        console.log('error', error);

        if (error.response) {
          _this7.error = error.response.data.errors;
        }

        if (error) {
          _this7.$swal({
            title: 'Failed',
            text: 'Failed to submit Payment data',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#666',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Try again'
          }).then(function (result) {
            if (result.value) {
              _this7.fetchProduct();
            }
          });
        }
      });
    },
    generatePaidData: function generatePaidData() {
      var data = {};
      data.merchant_id = this.paidData.merchant_id;
      data.merchant_bank_id = this.paidData.bank_id;
      data.swift_code = this.paidData.swift_code;
      data.bank_name = this.paidData.bank_name;
      data.bank_branch = this.paidData.bank_branch;
      data.account_owner = this.paidData.bank_owner;
      data.account_number = this.paidData.bank_number;
      data.currency = this.paidData.currency;
      data.transfer_date = this.paidData.transfer_date;
      data.image_id = this.paidData.image.id;
      data.items = this.paidData.items;
      data.total = this.paidData.total_nett;

      return data;
    },
    validateSubmitOrder: function validateSubmitOrder(data) {
      if (!data.transfer_date) {
        this.$swal('Transfer date required', 'Please select transfer date to continue', 'warning');
        return false;
      }

      if (!data.image.id || !data.image.url) {
        this.$swal('Image required', 'Please select image to continue', 'warning');
        return false;
      }

      return true;
    },
    onExportCsv: function onExportCsv() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var params, queryParams, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = '';

                _this8.params.export_csv = 1;

                _context2.next = 4;
                return _this8.populateQueryParams();

              case 4:
                queryParams = _context2.sent;


                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queryParams).forEach(function (key) {
                  params += key + '=' + (queryParams[key] || '') + '&';
                });

                params = params.slice(0, -1);

                url = __WEBPACK_IMPORTED_MODULE_11__config__["i" /* default */] + '/merchant-payments?' + params;

                window.location = url;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage: function setImage(payload) {
      this.paidData.image = payload.images;
    }
  },

  created: function created() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this9.isLoading = true;
              _context3.next = 3;
              return _this9.fetchItem('merchants');

            case 3:
              _context3.next = 5;
              return _this9.fetch();

            case 5:
              _this9.isLoading = false;

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this9);
    }))();
  }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Pagination__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RequestsIndex',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},
      modalVisible: false,
      requestData: null
    };
  },


  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_4__components_modules_common_Pagination__["a" /* default */]
  },

  filters: {
    yesNo: function yesNo(value) {
      if (!value) return 'No';
      return 'Yes';
    },
    parseTime: function parseTime(date) {
      if (!date) return '';
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD MMM YYYY');
    }
  },

  methods: {
    fetch: function fetch(page) {
      var _this = this;

      var pageQuery = this.$route.query.page;

      var params = {
        page: page || pageQuery
      };

      this.axios.get('/customrequests', { params: params }).then(function (response) {
        var _response$data = response.data,
            data = _response$data.data,
            meta = _response$data.meta;


        if (!data && meta.pagination.current_page > meta.pagination.total_pages) {
          return;
        }

        _this.items = data;
        _this.pagination = meta.pagination;
        _this.isLoading = false;
      }).catch(function () {
        _this.$swal({
          title: 'Fetch Failed',
          text: 'Failed to fetch custom request data',
          type: 'warning',
          timer: 5000
        });
      });

      if (page) {
        window.history.pushState('Custom request page: ' + page, null, '/requests?page=' + page);
      }
    },
    changePage: function changePage(page) {
      this.fetch(page);
    },
    parseDate: function parseDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD MMMM YYYY');
    },
    showModal: function showModal() {
      this.$store.commit('SET_MODAL', 'plan');
      this.modalVisible = true;
      document.body.classList.add('locked');
    },
    closeModals: function closeModals() {
      this.modalVisible = false;
      document.body.classList.remove('locked');
    },
    view: function view(id) {
      var _this2 = this;

      this.axios.get('/customrequests/' + id).then(function (response) {
        _this2.requestData = response.data.data;
        _this2.showModal();
      }).catch(function (e) {
        console.log('Error', e);
      });
    }
  },

  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this3.closeModals();
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_common_FileGallery__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      title: 'Settings',

      form: {
        heroTitle: null,
        heroTitle_en: null,
        metaTitle: null,
        metaDescription: null,
        image: {
          id: null,
          url: null
        }
      },

      show: {
        gallery: false
      },

      error: null
    };
  },


  components: {
    FileGallery: __WEBPACK_IMPORTED_MODULE_4__components_modules_common_FileGallery__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__["a" /* default */]
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      this.axios.get('/settings').then(function (response) {
        var data = response.data.data;


        data.forEach(function (item) {
          if (item.slug === 'meta-title') {
            _this.form.metaTitle = item.value;
          }

          if (item.slug === 'meta-description') {
            _this.form.metaDescription = item.value;
          }

          if (item.slug === 'title') {
            _this.form.heroTitle = item.value;
          }

          if (item.slug === 'title_en') {
            _this.form.heroTitle_en = item.value;
          }

          if (item.slug === 'background') {
            _this.form.image.url = item.value;
          }
        });
      }).catch(function (error) {
        if (error.response) {
          _this.error = error.response.data.errors;
        }
      });
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    setImage: function setImage(payload) {
      this.form.image = payload.images;
    },
    validate: function validate() {
      if (!this.form.heroTitle) {
        this.$swal('Hero Title required', 'Please fill Hero Title to continue', 'warning');
        return false;
      }

      if (!this.form.heroTitle_en) {
        this.$swal('Hero Title En required', 'Please fill Hero Title En to continue', 'warning');
        return false;
      }

      if (!this.form.metaTitle) {
        this.$swal('Meta Title required', 'Please fill Meta Title to continue', 'warning');
        return false;
      }

      if (!this.form.metaDescription) {
        this.$swal('Meta Description required', 'Please fill Meta Description to continue', 'warning');
        return false;
      }

      if (!this.form.image) {
        this.$swal('Image required', 'Please select image to continue', 'warning');
        return false;
      }

      return true;
    },
    submit: function submit() {
      var _this2 = this;

      var result = this.validate();
      if (!result) return;

      var settings = [{
        slug: 'title',
        value: this.form.heroTitle
      }, {
        slug: 'title_en',
        value: this.form.heroTitle_en
      }, {
        slug: 'meta-title',
        value: this.form.metaTitle
      }, {
        slug: 'meta-description',
        value: this.form.metaDescription
      }, {
        slug: 'background',
        value: this.form.image.url
      }];

      var datas = {
        data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(settings)
      };

      this.axios.put('/settings', this.stringify(datas)).then(function () {
        _this2.fetch();
        _this2.$swal('Updated', 'Setting updated', 'success');
      }).catch(function (error) {
        if (error.response) {
          _this2.error = error.response.data.errors;
        }
      });
    },
    cancel: function cancel() {
      this.$router.push('/');
    }
  },

  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$on('close-modal', function () {
      _this3.show.gallery = false;
    });
  },
  destroyed: function destroyed() {
    __WEBPACK_IMPORTED_MODULE_1__utils_bus__["a" /* default */].$off('close-modal');
  }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_spinner__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Pagination__ = __webpack_require__(6);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable max-len */





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'KlookIndex',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      pagination: {},
      isLoading: false,
      activities: [],
      params: {
        page: 1,
        page_size: 25,
        country_id: 0,
        city_id: 0,
        activity_id: '',
        name: ''
      },
      form: {
        country: null,
        city: null
      },

      list: {
        countries: [],
        cities: []
      }
    };
  },


  components: {
    Circle2: __WEBPACK_IMPORTED_MODULE_4_vue_loading_spinner__["b" /* Circle2 */],
    Common: __WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_6__components_modules_common_Pagination__["a" /* default */]
  },

  methods: {
    fetchCountries: function fetchCountries() {
      var _this = this;

      return this.axios.get('/klook/countries').then(function (response) {
        var countries = response.data.countries;
        _this.list.countries = countries.map(function (item) {
          return { label: item.name, value: item.country_id };
        });
        _this.isLoading = false;
      }).catch(function (error) {
        console.log('Fetch countries error', error);
      });
    },
    fetchCities: function fetchCities() {
      var _this2 = this;

      return this.axios.get('/klook/country/' + this.params.country_id + '/cities').then(function (response) {
        var cities = response.data.cities;
        _this2.list.cities = cities.map(function (item) {
          return { label: item.city_name, value: item.city_id };
        });
        _this2.isLoading = false;
      }).catch(function (error) {
        console.log('Fetch cities error', error);
      });
    },
    setCountry: function setCountry() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var country = null;

        if (_this3.$route.query.country) {
          var countryId = parseInt(_this3.$route.query.country, 10);
          var sortedCountries = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(_this3.list.countries, [function (o) {
            return o.name;
          }]);
          country = sortedCountries.find(function (item) {
            return item.value === countryId;
          });
          _this3.params.country_id = countryId;
        }

        _this3.form.country = country;
        resolve(country);
      });
    },
    setCity: function setCity() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        var city = null;

        if (_this4.$route.query.city) {
          var cityId = parseInt(_this4.$route.query.city, 10);
          var sortedCities = Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["sortBy"])(_this4.list.cities, [function (o) {
            return o.name;
          }]);
          city = sortedCities.find(function (item) {
            return item.value === cityId;
          });
          _this4.params.city_id = cityId;
        }

        _this4.form.city = city;
        resolve(city);
      });
    },
    setName: function setName() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (_this5.$route.query.name) {
          _this5.params.name = _this5.$route.query.name;
        }
        resolve();
      });
    },
    payloadCountry: function payloadCountry(payload) {
      if (payload) {
        this.params.country_id = payload.value;
      } else {
        this.resetParams();
      }
      this.fetchCities();
      this.setCity();
      this.pushState();
      this.fetchActivity();
    },
    payloadCity: function payloadCity(payload) {
      if (payload) {
        this.params.city_id = payload.value;
      } else {
        this.params.city_id = 0;
        this.form.city = null;
      }
      this.pushState();
      this.fetchActivity();
    },
    pushState: function pushState() {
      var page = this.params.page;
      var country = this.params.country_id;
      var city = this.params.city_id;
      var activity = this.params.activity_id;
      var name = this.params.name;
      window.history.pushState('Klook page: ' + page, null, '/klook?country=' + country + '&city=' + city + '&activity=' + activity + '&name=' + name + '&page=' + page);
    },
    resetParams: function resetParams() {
      this.params.country_id = 0;
      this.params.city_id = 0;
      this.params.name = '';
      this.form.city = null;
      this.activities = [];
      this.list.cities = [];
      window.history.pushState('Klook index', null, '/klook');
    },
    fetchActivity: function fetchActivity() {
      var _this6 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        if (_this6.params.country_id) {
          _this6.activities = [];
          _this6.isLoading = true;

          _this6.axios.get('/klook/activities', { params: _this6.params }).then(function (response) {
            var activities = response.data.activities;

            _this6.activities = activities || [];
            _this6.isLoading = false;

            var totalPage = Math.ceil(response.data.total / response.data.page_size);

            _this6.pagination = {
              current_page: response.data.page,
              total_pages: totalPage
            };
            _this6.pushState();
            resolve();
          }).catch(function (error) {
            console.log('Fetch Activities error', error);
          });
        }
      });
    },
    changePage: function changePage(pages) {
      this.params.page = pages.toString();
      this.pushState();
      this.fetchActivity();
    },
    changeActivityID: function changeActivityID() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this7.fetchActivity();

              case 2:
                if (_this7.activities.length === 1 && _this7.params.activity_id) {
                  _this7.view(_this7.params.activity_id);
                }

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this7);
      }))();
    },
    view: function view(id) {
      this.$router.push({
        name: 'klook-view',
        params: { id: id }
      });
    },
    init: function init() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this8.setName();
                _context2.next = 3;
                return _this8.fetchCountries();

              case 3:
                _this8.setCountry();
                _context2.next = 6;
                return _this8.fetchCities();

              case 6:
                _this8.setCity();
                _context2.next = 9;
                return _this8.fetchActivity();

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this8);
      }))();
    }
  },

  created: function created() {
    this.init();
  }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Common__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'KlookView',

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Common__["a" /* default */]],

  data: function data() {
    return {
      isLoading: false,
      need_extra_info: true,
      guidelines: [],
      usages: [],
      schedule_diff: 0,
      start_date: null,
      modal: {
        title: null,
        product: null
      },
      form: {
        activity: null,
        schedules: null,
        date: null
      },
      show: {
        schedule: false,
        time_slot: false
      },
      configs: {
        datepicker: {
          disabled: {
            to: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, 'd').toDate()
          }
        }
      }
    };
  },


  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_3__components_modules_common_Modal__["a" /* default */],
    Datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker___default.a
  },

  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    showModal: function showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },
    closeModals: function closeModals() {
      var _this = this;

      document.body.classList.remove('locked');
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.show).forEach(function (modal) {
        _this.show[modal] = false;
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      this.isLoading = true;
      this.form.date = __WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'd').format(this.config.date.iso);
      this.axios.get('/klook/activities/' + this.$route.params.id).then(function (response) {
        var data = response.data;

        if (data.success === true) {
          var activity = data.activity;
          _this2.form.activity = activity;
          _this2.guidelines = JSON.parse(_this2.form.activity.giudelines);
          _this2.usages = JSON.parse(_this2.form.activity.usage);
        } else {
          console.log('Status', false);
        }
      }).catch(function (error) {
        console.log('Fetch country error', error);
      }).finally(function () {
        _this2.isLoading = false;
      });
    },
    checkExtraInfo: function checkExtraInfo(extrainfo) {
      if (!extrainfo) return false;

      var general = extrainfo.general,
          travelers = extrainfo.travelers;


      if (!general && !travelers) {
        return false;
      }
      return true;
    },
    getSchedules: function getSchedules(date, format) {
      var _this3 = this;

      var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, format).format(this.config.date.iso);
      var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, format).add(30, 'd').format(this.config.date.iso);
      var params = {
        lang: 'id_ID',
        start_date: startDate,
        end_date: endDate
      };

      this.start_date = startDate;
      this.schedule_diff = __WEBPACK_IMPORTED_MODULE_1_moment___default()(endDate).diff(startDate, 'd');
      this.axios.get('/klook/' + this.modal.product + '/schedules', { params: params }).then(function (response) {
        var data = response.data;

        _this3.form.schedules = data;

        _this3.checkTimeslot();
      }).catch(function (error) {
        console.log('Fetch schedule error', error);
      });
    },
    showSchedule: function showSchedule(product, title) {
      this.modal.title = title;
      this.modal.product = product;

      this.getSchedules(__WEBPACK_IMPORTED_MODULE_1_moment___default()().add(1, 'd'), this.config.date.iso);
      this.showModal('schedule');
    },
    getDate: function getDate(index) {
      var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date).format(this.config.date.simple);

      if (index !== 1) {
        date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.start_date).add(index - 1, 'd').format(this.config.date.simple);
      }

      return date;
    },
    checkSchedule: function checkSchedule(date) {
      var newDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, this.config.date.simple).format(this.config.date.iso);
      var result = Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["find"])(this.form.schedules.schedules, { date: newDate });

      if (result) {
        return result.sku_inventory;
      }

      return false;
    },
    checkTimeslot: function checkTimeslot() {
      var count = 0;
      this.show.time_slot = false;

      this.form.schedules.schedules.forEach(function (schedule) {
        if (schedule.times_slot.length > 0) {
          if (schedule.times_slot !== '00:00') {
            count += 1;
          }
        }
      });

      if (count > 0) this.show.time_slot = true;
    },
    nReplace: function nReplace(str) {
      var newStr = str.replace('\r\n', '<br>');

      newStr = newStr.replace(/_/g, ' ');

      return newStr;
    }
  },

  mounted: function mounted() {
    this.fetch();
  }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_Common__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Pagination__ = __webpack_require__(6);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserIndex',
  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_Common__["a" /* default */]],
  components: {
    Pagination: __WEBPACK_IMPORTED_MODULE_7__components_modules_common_Pagination__["a" /* default */]
  },
  data: function data() {
    return {
      users: [],
      pagination: {},
      isLoading: false,
      error: null,

      params: {
        page: null,
        name: null,
        email: null,
        role: null,
        status: null
      },

      list: {
        roles: [],
        status: [{
          label: 'Active',
          value: '1'
        }, {
          label: 'Inactive',
          value: '0'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setQuery();

              case 2:
                _context.next = 4;
                return _this.fetchRoles();

              case 4:
                _context.next = 6;
                return _this.fetchUsers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setQuery: function setQuery() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.params.name = _this2.$route.query.name || null;
        _this2.params.email = _this2.$route.query.email || null;
        _this2.params.role = _this2.$route.query.role || null;
        _this2.params.status = _this2.$route.query.status || null;
        _this2.params.page = _this2.$route.query.page || null;
        resolve();
      });
    },
    fetchRoles: function fetchRoles() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var response, data;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return _this3.axios.get('/roles?group=mister-aladin-staff');

                case 3:
                  response = _context2.sent;
                  data = response.data.data;

                  data.forEach(function (role) {
                    _this3.list.roles.push({
                      label: role.name,
                      value: role.slug
                    });
                  });
                  resolve(data);
                  _context2.next = 13;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](0);

                  reject(_context2.t0);
                  _this3.errorModal();

                case 13:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3, [[0, 9]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    fetchUsers: function fetchUsers() {
      var _this4 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
          var response, _response$data, data, meta, isEmpty;

          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;

                  _this4.isLoading = true;
                  if (page && (typeof page === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(page)) !== 'object') _this4.params.page = page;

                  _context3.next = 5;
                  return _this4.axios.get('/users', { params: _this4.params });

                case 5:
                  response = _context3.sent;
                  _response$data = response.data, data = _response$data.data, meta = _response$data.meta;
                  isEmpty = !data && meta.pagination.current_page > meta.pagination.total_pages;

                  _this4.users = !isEmpty ? data : [];
                  _this4.pagination = !isEmpty ? meta.pagination : {};
                  _this4.setPushState();
                  resolve();
                  _context3.next = 18;
                  break;

                case 14:
                  _context3.prev = 14;
                  _context3.t0 = _context3['catch'](0);

                  reject(_context3.t0);
                  _this4.errorModal();

                case 18:
                  _context3.prev = 18;

                  _this4.isLoading = false;
                  return _context3.finish(18);

                case 21:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this4, [[0, 14, 18, 21]]);
        }));

        return function (_x4, _x5) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    setPushState: function setPushState() {
      var title = 'User Setup page ' + this.params.page;
      var paramUrl = '/user-setup';
      var parameters = this.generateQuery(this.params);
      window.history.pushState(title, null, '' + paramUrl + parameters);
    },
    generateQuery: function generateQuery(params) {
      var _this5 = this;

      if (!params) return null;

      var query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).filter(function (key) {
        return params[key];
      }).map(function (key) {
        return key + '=' + _this5.params[key];
      });

      return query ? '?' + query.join('&') : null;
    },


    onInput: __WEBPACK_IMPORTED_MODULE_5_lodash_debounce___default()(function debouncedInput() {
      this.params.page = null;
      this.fetchUsers();
    }, 500),

    onSelect: function onSelect() {
      this.params.page = null;
      this.fetchUsers();
    },
    changePage: function changePage(page) {
      this.fetchUsers(page);
    },
    errorModal: function errorModal(title, text) {
      this.$swal({
        title: !title ? 'Failed' : title,
        text: !text ? 'Failed to fetch data' : text,
        type: 'error',
        timer: 3000
      });
    },
    add: function add() {
      this.$router.push({
        name: 'user-form-crete'
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'user-form-edit',
        params: {
          id: id
        }
      });
    },
    activation: function activation(type, user) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var confirmation;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this6.confirmModal(type, user);

              case 2:
                confirmation = _context4.sent;

                if (!confirmation.value) {
                  _context4.next = 16;
                  break;
                }

                _context4.prev = 4;
                _context4.next = 7;
                return _this6.axios.patch('/users/' + user.id + '/' + type);

              case 7:
                _this6.fetchUsers();
                _this6.successModal(type, user);
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](4);

                _this6.failedModal(type, user);

              case 14:
                _context4.next = 17;
                break;

              case 16:
                _this6.canceledModal();

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[4, 11]]);
      }))();
    },
    remove: function remove(user) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var confirmation;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.confirmModal('delete', user);

              case 2:
                confirmation = _context5.sent;

                if (!confirmation.value) {
                  _context5.next = 16;
                  break;
                }

                _context5.prev = 4;
                _context5.next = 7;
                return _this7.axios.delete('/users/' + user.id);

              case 7:
                _this7.fetchUsers();
                _this7.successModal('delete', user);
                _context5.next = 14;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](4);

                _this7.failedModal('delete', user);

              case 14:
                _context5.next = 17;
                break;

              case 16:
                _this7.canceledModal();

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[4, 11]]);
      }))();
    },
    confirmModal: function confirmModal(type, user) {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6(resolve) {
          var confirmation;
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return _this8.$swal({
                    title: '' + _this8.capitalizeFirstLetter(type),
                    text: 'Are you sure you want to ' + type + ' ' + user.name + '?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No'
                  });

                case 2:
                  confirmation = _context6.sent;

                  resolve(confirmation);

                case 4:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, _this8);
        }));

        return function (_x6) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    canceledModal: function canceledModal() {
      this.$swal({
        title: 'Cancelled',
        type: 'info',
        timer: 3000
      });
    },
    successModal: function successModal(type, user) {
      this.$swal({
        title: 'Success',
        text: user.name + ' has been ' + type + 'd',
        type: 'success',
        timer: 3000
      });
    },
    failedModal: function failedModal(type, user) {
      this.$swal({
        title: 'Failed',
        text: 'Failed to ' + type + ' ' + user.name,
        type: 'error',
        timer: 3000
      });
    }
  }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Common__ = __webpack_require__(2);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Common__["a" /* default */]],
  props: {
    isCreate: {
      type: Boolean,
      required: false
    }
  },
  data: function data() {
    return {
      title: 'Add New User',
      error: null,
      form: {
        name: null,
        email: null,
        role: null
      },
      list: {
        roles: []
      }
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      if (!this.isCreate) {
        this.title = 'Edit User';
        this.fetchUserDetails();
      }
      this.fetchRoles();
    },
    fetchUserDetails: function fetchUserDetails() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var id, response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _this.$route.params.id;
                _context.prev = 1;
                _context.next = 4;
                return _this.axios.get('/users/' + id);

              case 4:
                response = _context.sent;
                data = response.data.data;

                _this.setFieldValue(data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                _this.failedModal('fetch');

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 9]]);
      }))();
    },
    setFieldValue: function setFieldValue(data) {
      this.form.name = data.name ? data.name : '';
      this.form.email = data.email ? data.email : '';
      this.form.role = {
        value: data.role.code,
        label: data.role.name
      };
    },
    fetchRoles: function fetchRoles() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
          var response, data;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return _this2.axios.get('/roles?group=mister-aladin-staff');

                case 3:
                  response = _context2.sent;
                  data = response.data.data;

                  data.forEach(function (role) {
                    _this2.list.roles.push({
                      label: role.name,
                      value: role.slug
                    });
                  });
                  resolve(data);
                  _context2.next = 13;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](0);

                  reject(_context2.t0);
                  _this2.errorModal();

                case 13:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[0, 9]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    submit: function submit() {
      var result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.createUser();
      } else {
        this.updateUser();
      }
    },
    validate: function validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.email) {
        this.$swal('Email required', 'Please fill email to continue', 'warning');
        return false;
      }

      if (!this.form.role || this.form.role.length < 1) {
        this.$swal('Role required', 'Please select role to continue', 'warning');
        return false;
      }

      return true;
    },
    createUser: function createUser() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _this3.generateData();
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.axios.post('/users', data);

              case 4:
                _this3.successModal('created', data.get('name'));
                _this3.cancel();
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);

                _this3.failedModal('create');

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8]]);
      }))();
    },
    updateUser: function updateUser() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var data, id;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this4.generateData();
                id = _this4.$route.params.id;
                _context4.prev = 2;
                _context4.next = 5;
                return _this4.axios.put('/users/' + id, data);

              case 5:
                _this4.successModal('updated', data.get('name'));
                _this4.cancel();
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](2);

                _this4.failedModal('update');

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[2, 9]]);
      }))();
    },
    generateData: function generateData() {
      var formData = new FormData();

      formData.append('name', this.form.name);
      formData.append('email', this.form.email);
      formData.append('role', this.form.role.value);

      return formData;
    },
    successModal: function successModal(type, name) {
      this.$swal({
        title: this.capitalizeFirstLetter(type),
        text: name + ' has been ' + type + '.',
        type: 'success',
        timer: 3000
      });
    },
    failedModal: function failedModal(type) {
      this.$swal({
        title: this.capitalizeFirstLetter(type) + ' Failed!',
        text: 'Failed to ' + type + ' user',
        type: 'warning',
        timer: 3000
      });
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Common__ = __webpack_require__(2);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Common__["a" /* default */]],
  data: function data() {
    return {
      isLoading: false,
      error: null,
      form: {
        name: null,
        email: null,
        role: null,
        id: null,

        old_password: null,
        new_password: null,
        confirm_password: null
      }
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.setProfileData(this.$store.state.user);
    },
    setProfileData: function setProfileData(user) {
      this.form.name = user.name;
      this.form.email = user.email;
      this.form.role = user.role;
      this.form.id = user.id;
    },
    updateProfile: function updateProfile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.form.name) {
                  _context.next = 3;
                  break;
                }

                _this.$swal('Name required', 'Please fill name to continue', 'warning');
                return _context.abrupt('return');

              case 3:
                data = _this.generateData();
                _context.prev = 4;
                _context.next = 7;
                return _this.axios.put('/users/' + _this.form.id, data);

              case 7:
                _this.$store.commit('SET_USER_NAME', _this.form.name);
                _this.successModal('profile');
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](4);

                _this.failedModal('update data');

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 11]]);
      }))();
    },
    generateData: function generateData() {
      var formData = new FormData();

      formData.append('name', this.form.name);
      formData.append('email', this.form.email);
      formData.append('role', this.form.role);

      return formData;
    },
    updatePassword: function updatePassword() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var result, data, errMsg;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                result = _this2.validatePassword();

                if (result) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                data = _this2.generatePasswordData();
                _context2.prev = 4;
                _context2.next = 7;
                return _this2.axios.put('/users/password/' + _this2.form.id, data);

              case 7:
                _this2.successModal('password');
                _this2.setPasswordEmpty();
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](4);

                if (_context2.t0.response) {
                  errMsg = _context2.t0.response.data.errors;


                  if (errMsg === 'Invalid Old Password') {
                    errMsg = 'The old password you have entered is incorrect';
                  }

                  _this2.failedModal('update password', errMsg);
                } else {
                  _this2.failedModal('update password');
                }

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 11]]);
      }))();
    },
    validatePassword: function validatePassword() {
      if (!this.form.old_password) {
        this.$swal('Old Password required', 'Please fill old password to continue', 'warning');
        return false;
      }

      if (!this.form.new_password) {
        this.$swal('New Password required', 'Please fill new password to continue', 'warning');
        return false;
      }

      if (!this.form.confirm_password) {
        this.$swal('New Password Confirm required', 'Please fill new password confirm to continue', 'warning');
        return false;
      }

      var pattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z]).{8,}$');
      if (!pattern.test(this.form.new_password)) {
        this.$swal('Invalid New Password', 'Password must contains at least 1 uppercase, 1 lowercase and 8 character long', 'warning');
        return false;
      }

      if (this.form.confirm_password !== this.form.new_password) {
        this.$swal('Invalid New Password', 'The password confirmation does not match', 'warning');
        return false;
      }

      return true;
    },
    generatePasswordData: function generatePasswordData() {
      var formData = new FormData();

      formData.append('old_password', this.form.old_password);
      formData.append('new_password', this.form.new_password);
      formData.append('new_password_confirm', this.form.confirm_password);

      return formData;
    },
    successModal: function successModal(type) {
      this.$swal({
        title: 'Updated',
        text: this.capitalizeFirstLetter(type) + ' has been Updated.',
        type: 'success',
        timer: 3000
      });
    },
    failedModal: function failedModal(type, text) {
      this.$swal({
        title: this.capitalizeFirstLetter(type) + ' Failed!',
        text: !text ? 'Failed to ' + type : text,
        type: 'warning',
        timer: 4000
      });
    },
    setPasswordEmpty: function setPasswordEmpty() {
      this.form.old_password = null;
      this.form.new_password = null;
      this.form.confirm_password = null;
    }
  }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__ = __webpack_require__(30);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProgressLoader: __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__["a" /* Circle */]
  },
  data: function data() {
    return {
      isLoading: false,
      isReadonlyVoucher: false,
      voucherCode: '',
      wrisbandCode: '',
      message: {
        shown: false,
        item: [],
        text: '',
        type: '' // alert-danger alert-success
      },
      formValidation: {
        voucherCode: '',
        wrisbandCode: ''
      }
    };
  },
  mounted: function mounted() {
    this.focusInput();
  },

  methods: {
    handleKeyPress: function handleKeyPress(event, nextFieldId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(event.key === 'Enter')) {
                  _context.next = 22;
                  break;
                }

                if (nextFieldId === 'voucher_code') {
                  _this.onFocusVoucherInput();
                }

                if (!(nextFieldId === 'wristband_code')) {
                  _context.next = 21;
                  break;
                }

                _this.onResetMessage();
                formData = new FormData();

                formData.append('ticket_item_code', _this.voucherCode);
                _context.next = 9;
                return _this.axios.post('/ticketItems/check/ticket', formData);

              case 9:
                res = _context.sent;

                if (!(res.data.status_payment !== 'paid')) {
                  _context.next = 13;
                  break;
                }

                _this.message.item = res.data;
                throw new Error('Payment status is ' + res.data.status_payment);

              case 13:
                if (!(res.data.status_ticket === 'redeem' || res.data.status_ticket === 'checkin')) {
                  _context.next = 16;
                  break;
                }

                _this.message.item = res.data;
                throw new Error('Ticket status is ' + res.data.status_ticket);

              case 16:

                _this.message.shown = true;
                _this.message.item = res.data;
                _this.message.type = 'alert-success';
                _this.isReadonlyVoucher = res.data.status_payment === 'paid';
                _this.onFocusWrisbandInput();

              case 21:

                if (nextFieldId === 'submit') {
                  _this.onSubmit();
                }

              case 22:
                _context.next = 33;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](0);

                console.error('[ERR ONSUBMIT]', _context.t0.response);
                console.error('[ERR ONSUBMIT]', _context.t0.message);
                if (nextFieldId === 'wristband_code') {
                  _this.voucherCode = '';
                }
                _this.message.shown = true;
                _this.message.item = [];
                _this.message.text = _context.t0.message ? _context.t0.message : _context.t0.response.data.errors;
                _this.message.type = 'alert-danger';

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 24]]);
      }))();
    },
    validateForm: function validateForm() {
      if (!this.voucherCode) {
        this.formValidation.voucherCode = 'Please field with valid voucher code';
        return false;
      }

      // if (!this.wrisbandCode) {
      //   this.formValidation.wrisbandCode = 'Please field with valid wristband code';
      //   return false;
      // }
      return true;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var validation, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.onResetMessage();
                validation = _this2.validateForm();

                if (validation) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                if (!(_this2.voucherCode !== '' && _this2.wrisbandCode !== '')) {
                  _context2.next = 31;
                  break;
                }

                _context2.prev = 5;

                _this2.isLoading = true;
                formData = new FormData();

                formData.append('ticket_item_code', _this2.voucherCode);
                formData.append('wristband_code', _this2.wrisbandCode);

                _context2.next = 12;
                return _this2.axios.post('/ticketItems/redeem', formData);

              case 12:
                res = _context2.sent;


                _this2.message.shown = true;
                _this2.message.item = [];
                _this2.message.text = res.data.message;
                _this2.message.type = 'alert-success';
                _context2.next = 26;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](5);

                console.error('[ERR ONSUBMIT]', _context2.t0.response);
                _this2.message.shown = true;
                _this2.message.text = _context2.t0.response.data.errors;
                _this2.message.item = [];
                _this2.message.type = 'alert-danger';

              case 26:
                _context2.prev = 26;

                _this2.isLoading = false;
                _this2.onClearForm();
                _this2.onFocusVoucherInput();
                // setTimeout(() => this.onResetMessage(), 5000);
                return _context2.finish(26);

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 19, 26, 31]]);
      }))();
    },
    onResetMessage: function onResetMessage() {
      this.message.shown = false;
      this.message.text = '';
      this.message.type = '';
      this.message.item = [];
    },
    onClearForm: function onClearForm() {
      this.voucherCode = '';
      this.wrisbandCode = '';
      this.formValidation.voucherCode = '';
      this.formValidation.wrisbandCode = '';
      this.isReadonlyVoucher = false;
      this.isLoading = false;
    },
    onFocusWrisbandInput: function onFocusWrisbandInput() {
      this.$refs.wrisbandCodeRef.focus();
    },
    onFocusVoucherInput: function onFocusVoucherInput() {
      this.$refs.voucherCodeRef.focus();
    }
  }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__ = __webpack_require__(30);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProgressLoader: __WEBPACK_IMPORTED_MODULE_2_vue_loading_spinner__["a" /* Circle */]
  },
  data: function data() {
    return {
      isLoading: false,
      wrisbandCode: null,
      message: {
        shown: false,
        text: '',
        type: '' // alert-danger alert-success
      },
      formValidation: {
        wrisbandCode: ''
      }
    };
  },
  mounted: function mounted() {
    this.focusInput();
  },

  methods: {
    validateForm: function validateForm() {
      if (!this.wrisbandCode) {
        this.formValidation.wrisbandCode = 'Please field with valid voucher code';
        return false;
      }
      return true;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var validation, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.onResetMessage();
                validation = _this.validateForm();

                if (validation) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.prev = 4;

                _this.isLoading = true;
                formData = new FormData();

                formData.append('wristband_code', _this.wrisbandCode);

                _context.next = 10;
                return _this.axios.post('/ticketItems/checkin', formData);

              case 10:
                res = _context.sent;


                _this.message.shown = true;
                _this.message.text = res.data.message;
                _this.message.type = 'alert-success';
                _context.next = 22;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](4);

                console.error('[ERR ONSUBMIT]', _context.t0.response);
                _this.message.shown = true;
                _this.message.text = _context.t0.response.data.errors;
                _this.message.type = 'alert-danger';

              case 22:
                _context.prev = 22;

                _this.wrisbandCode = '';
                _this.formValidation.wrisbandCode = '';
                _this.isLoading = false;
                _this.focusInput();
                // setTimeout(() => this.onResetMessage(), 5000);
                return _context.finish(22);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 16, 22, 28]]);
      }))();
    },
    onResetMessage: function onResetMessage() {
      this.message.shown = false;
      this.message.text = '';
      this.message.type = '';
    },
    focusInput: function focusInput() {
      this.$refs.wrisbandCodeRef.focus();
    }
  }
});

/***/ }),
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bus__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrap__ = __webpack_require__(782);







/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  bus: __WEBPACK_IMPORTED_MODULE_4__utils_bus__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d888c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(374);
function injectStyle (ssrContext) {
  __webpack_require__(372)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49d888c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modules_badges_Index__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_modules_badges_Form__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modules_categories_Form__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modules_categories_Index__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_modules_dashboard_Index__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modules_destinations_Form__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modules_destinations_Index__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modules_inventory_Form__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_modules_inventory_Index__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_modules_inventory_View__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Login__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Forgot__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Reset__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_modules_moods_Form__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_modules_moods_Index__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modules_dashboard_404__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_modules_products_Form__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_modules_products_Index__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_modules_highlights_Form__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_modules_tags_Form__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_modules_tags_Index__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_modules_vendors_Form__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_modules_vendors_Index__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_modules_merchant_Form__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_modules_merchant_Index__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_modules_review_Index__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_modules_review_Form__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_modules_review_Approval__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_modules_operation_bin_Index__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_modules_operation_bin_Form__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_modules_operation_payment_methods_Index__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_modules_operation_payment_setups_Index__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_modules_promo_Index__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_modules_promo_bin_Index__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_modules_promo_bin_Form__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_modules_promo_code_Index__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_modules_promo_code_Form__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_modules_promo_code_View__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_modules_promo_config_Index__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_modules_promo_config_Form__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_modules_promo_config_View__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_modules_orders_summary_Index__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_modules_orders_payment2Merchant_Index__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_modules_requests_Index__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_modules_settings_Index__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_modules_klook_Index__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_modules_klook_View__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_modules_user_index__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_modules_user_form__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_modules_profile_form__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_modules_ticketing_redeem__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_modules_ticketing_checkin__ = __webpack_require__(779);




// import AdminForm from '@/components/modules/admins/Form';
// import AdminIndex from '@/components/modules/admins/Index';






















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// Routing logic
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Login__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      document.body.className = 'login-page';
      next();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      document.body.classList.remove('login-page');
      next();
    }
  }, {
    path: '/forgot',
    name: 'forgot',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Forgot__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      document.body.className = 'login-page';
      next();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      document.body.classList.remove('login-page');
      next();
    }
  }, {
    path: '/reset-password',
    name: 'reset',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Reset__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      document.body.className = 'login-page';
      next();
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
      document.body.classList.remove('login-page');
      next();
    }
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard__["a" /* default */],
    meta: { requiresAuth: true },
    beforeEnter: function beforeEnter(to, from, next) {
      document.body.classList.add('skin-blue', 'sidebar-mini');
      next();
    },
    activate: function activate() {
      this.$nextTick(function () {
        // => 'DOM loaded and ready'
      });
    },

    children: [{
      path: '',
      redirect: '/dashboard'
    }, {
      path: '/dashboard',
      name: 'dashboard',
      component: __WEBPACK_IMPORTED_MODULE_8__components_modules_dashboard_Index__["a" /* default */]
    },

    /*
     * Admins
     */

    // {
    //   path: '/admins',
    //   name: 'admin-index',
    //   component: AdminIndex,
    // },
    // {
    //   path: '/admins/create',
    //   name: 'admin-create',
    //   component: AdminForm,
    //   props: {
    //     isCreate: true,
    //   },
    // },
    // {
    //   path: '/admins/:id/edit',
    //   name: 'admin-edit',
    //   component: AdminForm,
    //   props: {
    //     isCreate: false,
    //   },
    // },
    /*
     * Badges
     */

    {
      path: '/badges',
      name: 'badges-index',
      component: __WEBPACK_IMPORTED_MODULE_3__components_modules_badges_Index__["a" /* default */]
    }, {
      path: '/badges/create',
      name: 'badges-create',
      component: __WEBPACK_IMPORTED_MODULE_4__components_modules_badges_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/badges/:id/edit',
      name: 'badges-edit',
      component: __WEBPACK_IMPORTED_MODULE_4__components_modules_badges_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },
    /*
     * Categories
     */

    {
      path: '/categories',
      name: 'category-index',
      component: __WEBPACK_IMPORTED_MODULE_6__components_modules_categories_Index__["a" /* default */]
    }, {
      path: '/categories/create',
      name: 'category-create',
      component: __WEBPACK_IMPORTED_MODULE_5__components_modules_categories_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/categories/:id/edit',
      name: 'category-edit',
      component: __WEBPACK_IMPORTED_MODULE_5__components_modules_categories_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Tags
     */

    {
      path: '/tags',
      name: 'tag-index',
      component: __WEBPACK_IMPORTED_MODULE_24__components_modules_tags_Index__["a" /* default */]
    }, {
      path: '/tags/create',
      name: 'tag-create',
      component: __WEBPACK_IMPORTED_MODULE_23__components_modules_tags_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/tags/:id/edit',
      name: 'tag-edit',
      component: __WEBPACK_IMPORTED_MODULE_23__components_modules_tags_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Destinations
     */

    {
      path: '/destinations',
      name: 'destination-index',
      component: __WEBPACK_IMPORTED_MODULE_10__components_modules_destinations_Index__["a" /* default */]
    }, {
      path: '/destinations/create',
      name: 'destination-create',
      component: __WEBPACK_IMPORTED_MODULE_9__components_modules_destinations_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/destinations/:id/edit',
      name: 'destination-edit',
      component: __WEBPACK_IMPORTED_MODULE_9__components_modules_destinations_Form__["a" /* default */],
      props: {
        isCreate: false,
        isEdit: true
      }
    }, {
      path: '/destinations/:id/view',
      name: 'destination-view',
      component: __WEBPACK_IMPORTED_MODULE_9__components_modules_destinations_Form__["a" /* default */],
      props: {
        isCreate: false,
        isEdit: false,
        isView: true
      }
    },

    /*
     * Moods
     */

    {
      path: '/moods',
      name: 'mood-index',
      component: __WEBPACK_IMPORTED_MODULE_18__components_modules_moods_Index__["a" /* default */]
    }, {
      path: '/moods/create',
      name: 'mood-create',
      component: __WEBPACK_IMPORTED_MODULE_17__components_modules_moods_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/moods/:id/edit',
      name: 'mood-edit',
      component: __WEBPACK_IMPORTED_MODULE_17__components_modules_moods_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Inventory
     */
    {
      path: '/inventory',
      name: 'inventory-index',
      component: __WEBPACK_IMPORTED_MODULE_12__components_modules_inventory_Index__["a" /* default */]
    }, {
      path: '/inventory/tickets/:page',
      name: 'inventory-index-page',
      component: __WEBPACK_IMPORTED_MODULE_12__components_modules_inventory_Index__["a" /* default */]
    }, {
      path: '/inventory/create',
      name: 'inventory-create',
      component: __WEBPACK_IMPORTED_MODULE_11__components_modules_inventory_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/inventory/:id/edit',
      name: 'inventory-edit',
      component: __WEBPACK_IMPORTED_MODULE_11__components_modules_inventory_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    }, {
      path: '/inventory/:id',
      name: 'inventory-view',
      component: __WEBPACK_IMPORTED_MODULE_13__components_modules_inventory_View__["a" /* default */]
    },

    /*
     * Vendors
     */

    {
      path: '/sources',
      name: 'source-index',
      component: __WEBPACK_IMPORTED_MODULE_26__components_modules_vendors_Index__["a" /* default */]
    }, {
      path: '/sources/create',
      name: 'source-create',
      component: __WEBPACK_IMPORTED_MODULE_25__components_modules_vendors_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/sources/:id/edit',
      name: 'source-edit',
      component: __WEBPACK_IMPORTED_MODULE_25__components_modules_vendors_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Review
     */
    {
      path: '/review',
      name: 'review-index',
      component: __WEBPACK_IMPORTED_MODULE_29__components_modules_review_Index__["a" /* default */]
    }, {
      path: '/review/create',
      name: 'review-create',
      component: __WEBPACK_IMPORTED_MODULE_30__components_modules_review_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/review/:id/approval',
      name: 'review-approval',
      component: __WEBPACK_IMPORTED_MODULE_31__components_modules_review_Approval__["a" /* default */]
    },

    /*
     * Merchant
     */

    {
      path: '/merchant',
      name: 'merchant-index',
      component: __WEBPACK_IMPORTED_MODULE_28__components_modules_merchant_Index__["a" /* default */]
    }, {
      path: '/merchant/create',
      name: 'merchant-create',
      component: __WEBPACK_IMPORTED_MODULE_27__components_modules_merchant_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/merchant/:id/edit',
      name: 'merchant-edit',
      component: __WEBPACK_IMPORTED_MODULE_27__components_modules_merchant_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Products
     */

    {
      path: '/products',
      name: 'product-index',
      component: __WEBPACK_IMPORTED_MODULE_21__components_modules_products_Index__["a" /* default */]
    }, {
      path: '/products/page/:page',
      name: 'product-index-page',
      component: __WEBPACK_IMPORTED_MODULE_21__components_modules_products_Index__["a" /* default */]
    }, {
      path: '/products/create',
      name: 'product-create',
      component: __WEBPACK_IMPORTED_MODULE_20__components_modules_products_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/products/:id/edit',
      name: 'product-edit',
      component: __WEBPACK_IMPORTED_MODULE_20__components_modules_products_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
    * Klook
    */
    {
      path: '/klook',
      name: 'klook-index',
      component: __WEBPACK_IMPORTED_MODULE_49__components_modules_klook_Index__["a" /* default */]
    }, {
      path: '/klook/activity/:id',
      name: 'klook-view',
      component: __WEBPACK_IMPORTED_MODULE_50__components_modules_klook_View__["a" /* default */]
    },

    /*
     * Highlights
     */

    {
      path: '/highlights/create',
      name: 'highlights-create',
      component: __WEBPACK_IMPORTED_MODULE_22__components_modules_highlights_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/highlights/edit',
      name: 'highlights-edit',
      component: __WEBPACK_IMPORTED_MODULE_22__components_modules_highlights_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Payments
     */

    {
      path: '/payment-methods',
      component: __WEBPACK_IMPORTED_MODULE_34__components_modules_operation_payment_methods_Index__["a" /* default */],
      children: [{
        name: 'payment-methods-index',
        path: ':page'
      }, {
        name: 'payment-methods-edit',
        path: ':id/:page'
      }]
    }, {
      path: '/payment-setups',
      component: __WEBPACK_IMPORTED_MODULE_35__components_modules_operation_payment_setups_Index__["a" /* default */],
      children: [{
        name: 'payment-setups-index',
        path: ':page'
      }, {
        name: 'payment-setups-edit',
        path: ':id/:page'
      }]
    },

    /*
     * BIN
     */

    {
      path: '/operation/bin',
      name: 'bin-index',
      component: __WEBPACK_IMPORTED_MODULE_32__components_modules_operation_bin_Index__["a" /* default */]
    }, {
      path: '/operation/bin/create',
      name: 'bin-create',
      component: __WEBPACK_IMPORTED_MODULE_33__components_modules_operation_bin_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/operation/bin/:id/edit',
      name: 'bin-edit',
      component: __WEBPACK_IMPORTED_MODULE_33__components_modules_operation_bin_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    },

    /*
     * Promo
     */

    {
      path: '/promo',
      name: 'promo-index',
      component: __WEBPACK_IMPORTED_MODULE_36__components_modules_promo_Index__["a" /* default */]
    }, {
      path: '/promo/bin',
      name: 'promo-bin-index',
      component: __WEBPACK_IMPORTED_MODULE_37__components_modules_promo_bin_Index__["a" /* default */]
    }, {
      path: '/promo/bin/create',
      name: 'promo-bin-create',
      component: __WEBPACK_IMPORTED_MODULE_38__components_modules_promo_bin_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/promo/bin/:id/edit',
      name: 'promo-bin-edit',
      component: __WEBPACK_IMPORTED_MODULE_38__components_modules_promo_bin_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    }, {
      path: '/promo/code',
      name: 'promo-code-index',
      component: __WEBPACK_IMPORTED_MODULE_39__components_modules_promo_code_Index__["a" /* default */]
    }, {
      path: '/promo/code/create',
      name: 'promo-code-create',
      component: __WEBPACK_IMPORTED_MODULE_40__components_modules_promo_code_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/promo/code/:id/edit',
      name: 'promo-code-edit',
      component: __WEBPACK_IMPORTED_MODULE_40__components_modules_promo_code_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    }, {
      path: '/promo/code/:id',
      name: 'promo-code-view',
      component: __WEBPACK_IMPORTED_MODULE_41__components_modules_promo_code_View__["a" /* default */]
    }, {
      path: '/promo/config',
      name: 'promo-config-index',
      component: __WEBPACK_IMPORTED_MODULE_42__components_modules_promo_config_Index__["a" /* default */]
    }, {
      path: '/promo/config/create',
      name: 'promo-config-create',
      component: __WEBPACK_IMPORTED_MODULE_43__components_modules_promo_config_Form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/promo/config/:id/edit',
      name: 'promo-config-edit',
      component: __WEBPACK_IMPORTED_MODULE_43__components_modules_promo_config_Form__["a" /* default */],
      props: {
        isCreate: false
      }
    }, {
      path: '/promo/config/:id',
      name: 'promo-config-view',
      component: __WEBPACK_IMPORTED_MODULE_44__components_modules_promo_config_View__["a" /* default */]
    },

    /*
     * Requests
     */

    {
      path: '/requests',
      name: 'requests-index',
      component: __WEBPACK_IMPORTED_MODULE_47__components_modules_requests_Index__["a" /* default */]
    },

    /*
     * Settings
     */

    {
      path: '/settings',
      name: 'settings-index',
      component: __WEBPACK_IMPORTED_MODULE_48__components_modules_settings_Index__["a" /* default */]
    },

    /*
     * Orders
     */

    {
      path: '/orders',
      name: 'orders-summary',
      component: __WEBPACK_IMPORTED_MODULE_45__components_modules_orders_summary_Index__["a" /* default */]
    }, {
      path: '/orders/summary/:page',
      name: 'orders-summary-page',
      component: __WEBPACK_IMPORTED_MODULE_45__components_modules_orders_summary_Index__["a" /* default */]
    }, {
      path: '/order-payment',
      name: 'order-payment',
      component: __WEBPACK_IMPORTED_MODULE_46__components_modules_orders_payment2Merchant_Index__["a" /* default */]
    }, {
      path: '/order-payment/summary/:page',
      name: 'order-payment-page',
      component: __WEBPACK_IMPORTED_MODULE_46__components_modules_orders_payment2Merchant_Index__["a" /* default */]
    }, {
      path: '/user-setup',
      name: 'user-setup-page',
      component: __WEBPACK_IMPORTED_MODULE_51__components_modules_user_index__["a" /* default */]
    }, {
      path: '/user-setup/crete',
      name: 'user-form-crete',
      component: __WEBPACK_IMPORTED_MODULE_52__components_modules_user_form__["a" /* default */],
      props: {
        isCreate: true
      }
    }, {
      path: '/user-setup/:id/edit',
      name: 'user-form-edit',
      component: __WEBPACK_IMPORTED_MODULE_52__components_modules_user_form__["a" /* default */],
      props: {
        isCreate: false
      }
    }, {
      path: '/profile',
      name: 'profile-page',
      component: __WEBPACK_IMPORTED_MODULE_53__components_modules_profile_form__["a" /* default */]
    },
    /*
     * Ticketing
     */
    {
      path: '/ticketing/redeem',
      name: 'ticketing-redeem',
      component: __WEBPACK_IMPORTED_MODULE_54__components_modules_ticketing_redeem__["a" /* default */]
    }, {
      path: '/ticketing/check-in',
      name: 'ticketing-check-in',
      component: __WEBPACK_IMPORTED_MODULE_55__components_modules_ticketing_checkin__["a" /* default */]

    },

    /*
     * Errors
     */
    {
      path: '*',
      name: '404',
      component: __WEBPACK_IMPORTED_MODULE_19__components_modules_dashboard_404__["a" /* default */]
    }]
  }, {
    path: '*',
    redirect: '/login'
  }]
});

// Some middleware to help us ensure the user is authenticated.
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  }) && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.token === null) {
    next('/login');
  } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.token !== null && to.path === '/login') {
    next('/dashboard');
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a836780_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(426);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a836780"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a836780_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 104,
	"./af.js": 104,
	"./ar": 105,
	"./ar-dz": 106,
	"./ar-dz.js": 106,
	"./ar-kw": 107,
	"./ar-kw.js": 107,
	"./ar-ly": 108,
	"./ar-ly.js": 108,
	"./ar-ma": 109,
	"./ar-ma.js": 109,
	"./ar-sa": 110,
	"./ar-sa.js": 110,
	"./ar-tn": 111,
	"./ar-tn.js": 111,
	"./ar.js": 105,
	"./az": 112,
	"./az.js": 112,
	"./be": 113,
	"./be.js": 113,
	"./bg": 114,
	"./bg.js": 114,
	"./bm": 115,
	"./bm.js": 115,
	"./bn": 116,
	"./bn-bd": 117,
	"./bn-bd.js": 117,
	"./bn.js": 116,
	"./bo": 118,
	"./bo.js": 118,
	"./br": 119,
	"./br.js": 119,
	"./bs": 120,
	"./bs.js": 120,
	"./ca": 121,
	"./ca.js": 121,
	"./cs": 122,
	"./cs.js": 122,
	"./cv": 123,
	"./cv.js": 123,
	"./cy": 124,
	"./cy.js": 124,
	"./da": 125,
	"./da.js": 125,
	"./de": 126,
	"./de-at": 127,
	"./de-at.js": 127,
	"./de-ch": 128,
	"./de-ch.js": 128,
	"./de.js": 126,
	"./dv": 129,
	"./dv.js": 129,
	"./el": 130,
	"./el.js": 130,
	"./en-au": 131,
	"./en-au.js": 131,
	"./en-ca": 132,
	"./en-ca.js": 132,
	"./en-gb": 133,
	"./en-gb.js": 133,
	"./en-ie": 134,
	"./en-ie.js": 134,
	"./en-il": 135,
	"./en-il.js": 135,
	"./en-in": 136,
	"./en-in.js": 136,
	"./en-nz": 137,
	"./en-nz.js": 137,
	"./en-sg": 138,
	"./en-sg.js": 138,
	"./eo": 139,
	"./eo.js": 139,
	"./es": 140,
	"./es-do": 141,
	"./es-do.js": 141,
	"./es-mx": 142,
	"./es-mx.js": 142,
	"./es-us": 143,
	"./es-us.js": 143,
	"./es.js": 140,
	"./et": 144,
	"./et.js": 144,
	"./eu": 145,
	"./eu.js": 145,
	"./fa": 146,
	"./fa.js": 146,
	"./fi": 147,
	"./fi.js": 147,
	"./fil": 148,
	"./fil.js": 148,
	"./fo": 149,
	"./fo.js": 149,
	"./fr": 150,
	"./fr-ca": 151,
	"./fr-ca.js": 151,
	"./fr-ch": 152,
	"./fr-ch.js": 152,
	"./fr.js": 150,
	"./fy": 153,
	"./fy.js": 153,
	"./ga": 154,
	"./ga.js": 154,
	"./gd": 155,
	"./gd.js": 155,
	"./gl": 156,
	"./gl.js": 156,
	"./gom-deva": 157,
	"./gom-deva.js": 157,
	"./gom-latn": 158,
	"./gom-latn.js": 158,
	"./gu": 159,
	"./gu.js": 159,
	"./he": 160,
	"./he.js": 160,
	"./hi": 161,
	"./hi.js": 161,
	"./hr": 162,
	"./hr.js": 162,
	"./hu": 163,
	"./hu.js": 163,
	"./hy-am": 164,
	"./hy-am.js": 164,
	"./id": 165,
	"./id.js": 165,
	"./is": 166,
	"./is.js": 166,
	"./it": 167,
	"./it-ch": 168,
	"./it-ch.js": 168,
	"./it.js": 167,
	"./ja": 169,
	"./ja.js": 169,
	"./jv": 170,
	"./jv.js": 170,
	"./ka": 171,
	"./ka.js": 171,
	"./kk": 172,
	"./kk.js": 172,
	"./km": 173,
	"./km.js": 173,
	"./kn": 174,
	"./kn.js": 174,
	"./ko": 175,
	"./ko.js": 175,
	"./ku": 176,
	"./ku.js": 176,
	"./ky": 177,
	"./ky.js": 177,
	"./lb": 178,
	"./lb.js": 178,
	"./lo": 179,
	"./lo.js": 179,
	"./lt": 180,
	"./lt.js": 180,
	"./lv": 181,
	"./lv.js": 181,
	"./me": 182,
	"./me.js": 182,
	"./mi": 183,
	"./mi.js": 183,
	"./mk": 184,
	"./mk.js": 184,
	"./ml": 185,
	"./ml.js": 185,
	"./mn": 186,
	"./mn.js": 186,
	"./mr": 187,
	"./mr.js": 187,
	"./ms": 188,
	"./ms-my": 189,
	"./ms-my.js": 189,
	"./ms.js": 188,
	"./mt": 190,
	"./mt.js": 190,
	"./my": 191,
	"./my.js": 191,
	"./nb": 192,
	"./nb.js": 192,
	"./ne": 193,
	"./ne.js": 193,
	"./nl": 194,
	"./nl-be": 195,
	"./nl-be.js": 195,
	"./nl.js": 194,
	"./nn": 196,
	"./nn.js": 196,
	"./oc-lnc": 197,
	"./oc-lnc.js": 197,
	"./pa-in": 198,
	"./pa-in.js": 198,
	"./pl": 199,
	"./pl.js": 199,
	"./pt": 200,
	"./pt-br": 201,
	"./pt-br.js": 201,
	"./pt.js": 200,
	"./ro": 202,
	"./ro.js": 202,
	"./ru": 203,
	"./ru.js": 203,
	"./sd": 204,
	"./sd.js": 204,
	"./se": 205,
	"./se.js": 205,
	"./si": 206,
	"./si.js": 206,
	"./sk": 207,
	"./sk.js": 207,
	"./sl": 208,
	"./sl.js": 208,
	"./sq": 209,
	"./sq.js": 209,
	"./sr": 210,
	"./sr-cyrl": 211,
	"./sr-cyrl.js": 211,
	"./sr.js": 210,
	"./ss": 212,
	"./ss.js": 212,
	"./sv": 213,
	"./sv.js": 213,
	"./sw": 214,
	"./sw.js": 214,
	"./ta": 215,
	"./ta.js": 215,
	"./te": 216,
	"./te.js": 216,
	"./tet": 217,
	"./tet.js": 217,
	"./tg": 218,
	"./tg.js": 218,
	"./th": 219,
	"./th.js": 219,
	"./tk": 220,
	"./tk.js": 220,
	"./tl-ph": 221,
	"./tl-ph.js": 221,
	"./tlh": 222,
	"./tlh.js": 222,
	"./tr": 223,
	"./tr.js": 223,
	"./tzl": 224,
	"./tzl.js": 224,
	"./tzm": 225,
	"./tzm-latn": 226,
	"./tzm-latn.js": 226,
	"./tzm.js": 225,
	"./ug-cn": 227,
	"./ug-cn.js": 227,
	"./uk": 228,
	"./uk.js": 228,
	"./ur": 229,
	"./ur.js": 229,
	"./uz": 230,
	"./uz-latn": 231,
	"./uz-latn.js": 231,
	"./uz.js": 230,
	"./vi": 232,
	"./vi.js": 232,
	"./x-pseudo": 233,
	"./x-pseudo.js": 233,
	"./yo": 234,
	"./yo.js": 234,
	"./zh-cn": 235,
	"./zh-cn.js": 235,
	"./zh-hk": 236,
	"./zh-hk.js": 236,
	"./zh-mo": 237,
	"./zh-mo.js": 237,
	"./zh-tw": 238,
	"./zh-tw.js": 238
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 424 */,
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('nav',{attrs:{"aria-label":_vm.label}},[_c('ul',{staticClass:"pagination"},[(_vm.pagination.current_page > 1)?_c('li',{class:{ 'disabled': _vm.pagination.current_page <= 1 }},[_c('a',{attrs:{"aria-label":"Previous","href":"#1"},on:{"click":function($event){$event.preventDefault();return _vm.goTo(1)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("«")])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.pages),function(page){return _c('li',{key:page,class:{ 'active' : _vm.pagination.current_page === page }},[_c('a',{attrs:{"href":("#" + page)},on:{"click":function($event){$event.preventDefault();return _vm.goTo(page)}}},[_vm._v("\n        "+_vm._s(page)+"\n      ")])])}),_vm._v(" "),(_vm.pagination.current_page < _vm.pagination.total_pages)?_c('li',[_c('a',{attrs:{"aria-label":"Next","href":("#" + (_vm.pagination.total_pages))},on:{"click":function($event){$event.preventDefault();return _vm.goTo(_vm.pagination.total_pages)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("»")])])]):_vm._e()],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"initial"}},[_c('div',{staticClass:"left-form"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("\n                Status\n              ")]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",attrs:{"id":"status","placeholder":"Select status","value":"null"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.statuses),function(status,index){return _c('option',{key:index,domProps:{"value":status.value}},[_vm._v(_vm._s(status.title))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"type"}},[_vm._v("\n                Badges Type\n              ")]),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.type),expression:"params.type"}],staticClass:"form-control",attrs:{"id":"type","placeholder":"Select type","value":"null"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.types),function(type,index){return _c('option',{key:index,domProps:{"value":type.value}},[_vm._v(_vm._s(type.title))])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"right-form"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"start_date"}},[_vm._v("\n                Start Date\n              ")]),_vm._v(" "),_c('div',[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},model:{value:(_vm.start_date),callback:function ($$v) {_vm.start_date=$$v},expression:"start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"end_date"}},[_vm._v("\n                End Date\n              ")]),_vm._v(" "),_c('div',[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},model:{value:(_vm.end_date),callback:function ($$v) {_vm.end_date=$$v},expression:"end_date"}})],1)])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-success pull-right position-bottom",on:{"click":function($event){return _vm.pushState()}}},[_vm._v("\n              Search\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Badges\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.error)?_c('tr',{key:"empty"},[_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && !_vm.badges)?_c('tr',[_vm._m(5)]):_vm._e(),_vm._v(" "),_vm._l((_vm.badges),function(badge){return _c('tr',{key:badge.id},[_c('td',[_vm._v(_vm._s(badge.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.badgeType(badge.type)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(badge.image && badge.image != '')?_c('img',{staticStyle:{"width":"64px"},attrs:{"src":_vm.parseImage(badge.image, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(badge.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(badge.start_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(badge.end_date))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(badge.id)}}},[_vm._v("\n                  Edit\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(badge)}}},[_vm._v("\n                  Delete\n                ")])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Badges\n      "),_c('small',[_vm._v("List of badges")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Badges")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Badges")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Badges Type")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Start Date")]),_vm._v(" "),_c('th',[_vm._v("End Date")]),_vm._v(" "),_c('th',[_vm._v("Action(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('strong',[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('strong',[_vm._v("Data failed to load")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('strong',[_vm._v("Result Not Found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449c4268_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(441);
function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-449c4268"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449c4268_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */,
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"infinite-scroll",rawName:"v-infinite-scroll",value:(_vm.showMore),expression:"showMore"}],staticClass:"gallery",attrs:{"infinite-scroll-disabled":"isAll","infinite-scroll-distance":"0"}},[_c('div',{staticClass:"row space-bottom"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v(_vm._s(_vm.parseTextintoTitle(_vm.type)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(!_vm.inline)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"tabindex":"0"},on:{"click":_vm.update}},[_vm._v("\n        "+_vm._s(_vm.allowVideo ? 'Set Media':'Set Image')+"\n      ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-default pull-right",staticStyle:{"margin-right":"1rem"},on:{"click":function($event){$event.preventDefault();return _vm.toggleDropzone.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-fw fa-upload"}),_vm._v(" "+_vm._s(_vm.allowVideo ? 'Upload Photo/Video':'Upload Image')+"\n      ")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(!_vm.isReview)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropzone),expression:"showDropzone"}],staticClass:"row space-bottom"},[_c('div',{staticClass:"col-md-12"},[_c('dropzone',{ref:"imageUpload",attrs:{"id":"imageUpload","options":_vm.gelleryDropzoneConfig.dropzone},on:{"vdropzone-success":_vm.fetch}})],1)]):_vm._e(),_vm._v(" "),(_vm.isReview)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropzone),expression:"showDropzone"}],staticClass:"row space-bottom"},[_c('div',{staticClass:"col-md-12"},[_c('dropzone',{ref:"imageUpload",attrs:{"id":"imageUpload","options":_vm.configs.dropzoneReview},on:{"vdropzone-error":_vm.errorUpload,"vdropzone-success":_vm.fetch}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{ref:"thumbnails",staticClass:"row space-bottom m-2",attrs:{"id":"thumbnails"}},_vm._l((_vm.limited),function(image){return _c('div',{key:image.id,staticClass:"col-md-3 img-wrapper",class:_vm.imageClass(image),on:{"click":function($event){$event.preventDefault();return _vm.selectImage(image)}}},[(_vm.isVideo(image.url))?_c('div',{staticClass:"video-thumbnail"},[_c('video',{attrs:{"controls":""}},[_c('source',{attrs:{"src":image.url,"type":"video/mp4"}})])]):_c('div',{staticClass:"thumbnail",attrs:{"data-src":_vm.parseImage(image.url, '_thumb')}}),_vm._v(" "),_vm._m(0,true)])}),0),_vm._v(" "),(!_vm.isAll)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-block btn-default",on:{"click":_vm.showMore}},[_vm._v("\n        Show more\n      ")])])]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"check",attrs:{"tabindex":"0"}},[_c('i',{staticClass:"fa fa-check"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"modal",attrs:{"tabindex":"-1","role":"dialog"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"},on:{"click":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("default")],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */,
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Badges\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'badges-index'}}},[_vm._v("Badges")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDate,"clear-button":true},on:{"cleared":_vm.handleClearDate},model:{value:(_vm.form.start_date),callback:function ($$v) {_vm.$set(_vm.form, "start_date", $$v)},expression:"form.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDate,"clear-button":true},model:{value:(_vm.form.end_date),callback:function ($$v) {_vm.$set(_vm.form, "end_date", $$v)},expression:"form.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"inactive"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('span',{staticClass:"btn btn-default btn-xs margin-all",on:{"click":_vm.toggleAllDays}},[_vm._v("\n                    All Days\n                  ")]),_vm._v(" "),_vm._l((_vm.days),function(item){return _c('label',{key:item.value,staticClass:"checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.days),expression:"form.days"}],attrs:{"type":"checkbox","id":item.value},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.days)?_vm._i(_vm.form.days,item.value)>-1:(_vm.form.days)},on:{"change":function($event){var $$a=_vm.form.days,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "days", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "days", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "days", $$c)}}}}),_vm._v("\n                    "+_vm._s(item.label)+"\n                  ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.type),expression:"form.type"}],staticClass:"form-control",attrs:{"placeholder":"Select Badge Type","id":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"default_badge"}},[_vm._v("Default Badge")]),_vm._v(" "),_c('option',{attrs:{"value":"top_badge"}},[_vm._v("Top Hover Badge")]),_vm._v(" "),_c('option',{attrs:{"value":"bottom_badge"}},[_vm._v("Bottom Hover Badge")])])])]),_vm._v(" "),(_vm.form.type === 'default_badge')?_c('div',{staticClass:"form-group type-badge"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                    Choose File\n                  ")]),_vm._v(" "),_vm._m(7),_vm._v(" "),(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})])]):_vm._e(),_vm._v(" "),(_vm.form.type === 'top_badge')?_c('div',{staticClass:"form-group type-badge"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                    Choose File\n                  ")]),_vm._v(" "),_vm._m(9),_vm._v(" "),(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-sm-10 margin-top-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.badge_title),expression:"form.badge_title"}],staticClass:"form-control",attrs:{"type":"text","id":"badge_title","placeholder":"Badge Title","maxlength":"11"},domProps:{"value":(_vm.form.badge_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "badge_title", $event.target.value)}}})])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-sm-10 margin-top-10"},_vm._l((_vm.badgeColor),function(item){return _c('label',{key:("preset-" + (item.id)),staticClass:"radio-inline",staticStyle:{"margin-left":"10px"},attrs:{"for":("preset-" + (item.id))}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.preset_color_id),expression:"form.preset_color_id"}],attrs:{"type":"radio","id":("preset-" + (item.id))},domProps:{"value":item.id,"checked":_vm._q(_vm.form.preset_color_id,item.id)},on:{"change":function($event){return _vm.$set(_vm.form, "preset_color_id", item.id)}}}),_vm._v(" "),_c('div',{staticClass:"preset-color",style:(("background-color: " + (item.background_color)))},[_c('p',{style:(("color: " + (item.text_color)))},[_vm._v(_vm._s(item.name))])])])}),0),_vm._v(" "),_c('div',[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-sm-10 margin-top-10"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.badge_description),expression:"form.badge_description"}],staticClass:"form-control",attrs:{"id":"badge_description","placeholder":"Badge Description","maxlength":"90"},domProps:{"value":(_vm.form.badge_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "badge_description", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),(_vm.form.type === 'bottom_badge')?_c('div',{staticClass:"form-group type-badge"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                    Choose File\n                  ")]),_vm._v(" "),_vm._m(14),_vm._v(" "),(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"col-sm-10 margin-top-10"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.badge_description),expression:"form.badge_description"}],staticClass:"form-control",attrs:{"id":"badge_description","placeholder":"Badge Description","maxlength":"90"},domProps:{"value":(_vm.form.badge_description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "badge_description", $event.target.value)}}})])])]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Badge Image"}},[_c('FileGallery',{attrs:{"type":"category","selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"destination"}},[_vm._v("\n                  Destination\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('treeselect',{ref:"destinationOption",attrs:{"placeholder":"Select Product Destination","value-consists-of":'ALL_WITH_INDETERMINATE',"sort-value-by":"LEVEL","id":"destination","multiple":true,"options":_vm.list.destinations,"default-expand-level":2,"auto-load-root-options":true},model:{value:(_vm.form.destinations),callback:function ($$v) {_vm.$set(_vm.form, "destinations", $$v)},expression:"form.destinations"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"category"}},[_vm._v("\n                  Category\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"multiple":"","id":"category","name":"category","placeholder":"Select Category","options":_vm.list.categories},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"source"}},[_vm._v("\n                  Source\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"multiple":"","id":"source","name":"source","placeholder":"Select Source","options":_vm.list.vendors},model:{value:(_vm.form.vendors),callback:function ($$v) {_vm.$set(_vm.form, "vendors", $$v)},expression:"form.vendors"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"merchant"}},[_vm._v("\n                  Merchant\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"multiple":"","id":"merchant","name":"merchant","placeholder":"Select Merchant","options":_vm.list.merchants},model:{value:(_vm.form.merchants),callback:function ($$v) {_vm.$set(_vm.form, "merchants", $$v)},expression:"form.merchants"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"products"}},[_vm._v("\n                  Products\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"multiple":"","id":"products","name":"products","placeholder":"Select Products","options":_vm.list.products},model:{value:(_vm.form.products),callback:function ($$v) {_vm.$set(_vm.form, "products", $$v)},expression:"form.products"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},_vm._l((_vm.medias),function(item){return _c('label',{key:item.value,staticClass:"checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.medias),expression:"form.medias"}],attrs:{"type":"checkbox","id":item.value},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.medias)?_vm._i(_vm.form.medias,item.value)>-1:(_vm.form.medias)},on:{"change":function($event){var $$a=_vm.form.medias,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "medias", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "medias", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "medias", $$c)}}}}),_vm._v("\n                    "+_vm._s(item.label)+"\n                  ")])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                  Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                  End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                  Status "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"days"}},[_vm._v("\n                  Days\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Badge Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"type"}},[_vm._v("\n                  Badge Type "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label-type",attrs:{"for":"image"}},[_vm._v("\n                  Image "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                      Allowed   extension only for PNG file with max size 1024KB and minimum-maximum   dimension width 32px and height 32px\n                      Info: Best uploaded image ratio is 1:1\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                  Icon Badges "),_c('span',{staticClass:"req"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                      Allowed   extension only for PNG file with max size 1024KB and minimum-maximum   dimension width 32px and height 32px\n                      Info: Best uploaded image ratio is 1:1                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label margin-top-10",attrs:{"for":"badge_title"}},[_vm._v("\n                    Title Badges "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label margin-top-10",attrs:{"for":"preset_color_id"}},[_vm._v("\n                  Preset Color\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label margin-top-10",attrs:{"for":"badge_description"}},[_vm._v("\n                    Description Badges "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                  Image "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                    Allowed extension only for PNG   file with max size 5000KB and maximum width: 200px and maximum height 100px.\n                      Info: Best uploaded image ratio is 2:1                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label margin-top-10",attrs:{"for":"badge_description"}},[_vm._v("\n                    Description Badges "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"media"}},[_vm._v("\n                  Media\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c041aeb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c041aeb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Category\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'category-index'}}},[_vm._v("Categories")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Nama"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name_en),expression:"form.name_en"}],staticClass:"form-control",attrs:{"type":"text","id":"name_en","placeholder":"Name"},domProps:{"value":(_vm.form.name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                  Slug\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.slug),expression:"form.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.form.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                        Select Image\n                      ")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Category Image"}},[_c('FileGallery',{attrs:{"type":"category","selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name_en"}},[_vm._v("\n                  Name En "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                  Image "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea856954_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(445);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea856954_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n            Name\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Category\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(!_vm.categories)?_c('tr',{key:"empty"},[_vm._m(3)]):_vm._l((_vm.categories),function(category){return _c('tr',[_c('td',[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(category.slug))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(category.image_url && category.image_url != '')?_c('img',{staticStyle:{"width":"64px"},attrs:{"src":_vm.parseImage(category.image_url, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(category.id)}}},[_vm._v("\n                  Edit\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(category)}}},[_vm._v("\n                  Delete\n                ")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                    ×\n                  ")]),_vm._v("\n                  "+_vm._s(_vm.error)+"\n                ")]):_vm._e()])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Categories\n      "),_c('small',[_vm._v("List of categories")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Categories")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Category")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Slug")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Action(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Result not found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3659b1a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(456);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3659b1a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a37a4a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(448);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a37a4a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"main-sidebar"},[_c('section',{staticClass:"sidebar"},[_c('ul',{staticClass:"sidebar-menu"},[_c('li',{staticClass:"header"},[_vm._v("MAIN NAVIGATION")]),_vm._v(" "),_vm._l((_vm.datarole),function(link){return [(link.to)?[_c('li',[_c('router-link',{attrs:{"to":link.to}},[_c('i',{class:[link.class]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(link.title))])])],1)]:_vm._e(),_vm._v(" "),(!link.to)?[_c('li',[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.toggle}},[_c('i',{class:[link.class]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(link.title))])]),_vm._v(" "),(link.children)?[_c('ul',{staticClass:"sidebar-menu",staticStyle:{"display":"none"}},[_vm._l((link.children),function(link){return [(link.title === 'Role Setup' || link.title === 'Merchant User Setup')?_c('li',[_c('a',{staticStyle:{"padding-left":"40px"},attrs:{"href":link.to,"target":"_blank"}},[_c('i',{class:[link.class]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(link.title))])])]):_c('li',[_c('router-link',{staticStyle:{"padding-left":"40px"},attrs:{"to":link.to}},[_c('i',{class:[link.class]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(link.title))])])],1)]})],2)]:_vm._e()],2)]:_vm._e()]})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8359ccd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(451);
function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8359ccd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8359ccd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/dashboard"}},[_c('span',{staticClass:"logo-mini"},[_c('b',[_vm._v("M")]),_vm._v("A")]),_vm._v(" "),_c('span',{staticClass:"logo-lg"},[_c('img',{staticClass:"logo-ma",attrs:{"src":"/static/img/Logo-MA-White.png","alt":"logo"}})])]),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-static-top"},[_c('a',{staticClass:"sidebar-toggle",attrs:{"data-toggle":"offcanvas","role":"button"},on:{"click":_vm.collapse}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})]),_vm._v(" "),_c('div',{staticClass:"navbar-custom-menu"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.klook.balance && _vm.klook.currency)?_c('li',[_c('h4',{staticClass:"navbar-text text-white"},[_c('span',{staticClass:"label label-info text-uppercase"},[_vm._v("\n                Balance\n              ")]),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(_vm.klook.currency)+" "+_vm._s(_vm.klook.balance)+"\n              ")]),_vm._v(" "),_c('button',{staticClass:"reload"},[_c('i',{staticClass:"fa fa-fw fa-refresh",class:{ 'fa-spin': _vm.isLoading },attrs:{"aria-hidden":"true"},on:{"click":_vm.getBalance}})])])]):_vm._e()]),_vm._v(" "),_c('li',{staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('img',{staticClass:"user-image",attrs:{"src":"/static/img/user2-160x160.svg","alt":"User Image"}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs"},[_vm._v(_vm._s(_vm.user.name))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"user-header"},[_c('img',{staticClass:"img-circle",attrs:{"src":"/static/img/user2-160x160.jpg","alt":"User Image"}}),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.user.name)+" as "+_vm._s(_vm.user.role)+"\n              ")])]),_vm._v(" "),_c('li',{staticClass:"user-footer"},[_c('div',{staticClass:"pull-left"},[_c('router-link',{attrs:{"to":"/profile"}},[_vm._v("Profile")])],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"btn btn-default btn-flat",on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v("Sign out")])])])])])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d1062a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(453);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d1062a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_vm._m(0),_vm._v(" "),_c('strong',[_vm._v("Mister Aladin © "+_vm._s(_vm.currentYear)+".")]),_vm._v(" All rights reserved.\n")])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("Version")]),_vm._v(" 2.4.3\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlSidebar_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3f77b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlSidebar_vue__ = __webpack_require__(455);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d3f77b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"control-sidebar control-sidebar-dark"},[_c('ul',{staticClass:"nav nav-tabs nav-justified control-sidebar-tabs"},[_c('li',[_c('a',{attrs:{"href":"#control-sidebar-home-tab","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-home"})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#control-sidebar-settings-tab","data-toggle":"tab"}},[_c('i',{staticClass:"fa fa-gears"})])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane",attrs:{"id":"control-sidebar-home-tab"}},[_c('h3',{staticClass:"control-sidebar-heading"},[_vm._v("Recent Activity")]),_vm._v(" "),_c('ul',{staticClass:"control-sidebar-menu"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"menu-icon fa fa-birthday-cake bg-red"}),_vm._v(" "),_c('div',{staticClass:"menu-info"},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("Langdon's Birthday")]),_vm._v(" "),_c('p',[_vm._v("Will be 23 on April 24th")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"menu-icon fa fa-user bg-yellow"}),_vm._v(" "),_c('div',{staticClass:"menu-info"},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("Frodo Updated His Profile")]),_vm._v(" "),_c('p',[_vm._v("New phone +1(800)555-1234")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"menu-icon fa fa-envelope-o bg-light-blue"}),_vm._v(" "),_c('div',{staticClass:"menu-info"},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("Nora Joined Mailing List")]),_vm._v(" "),_c('p',[_vm._v("nora@example.com")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"menu-icon fa fa-file-code-o bg-green"}),_vm._v(" "),_c('div',{staticClass:"menu-info"},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("Cron Job 254 Executed")]),_vm._v(" "),_c('p',[_vm._v("Execution time 5 seconds")])])])])]),_vm._v(" "),_c('h3',{staticClass:"control-sidebar-heading"},[_vm._v("Tasks Progress")]),_vm._v(" "),_c('ul',{staticClass:"control-sidebar-menu"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("\n                Custom Template Design\n                "),_c('span',{staticClass:"label label-danger pull-right"},[_vm._v("70%")])]),_vm._v(" "),_c('div',{staticClass:"progress progress-xxs"},[_c('div',{staticClass:"progress-bar progress-bar-danger",staticStyle:{"width":"70%"}})])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("\n                Update Resume\n                "),_c('span',{staticClass:"label label-success pull-right"},[_vm._v("95%")])]),_vm._v(" "),_c('div',{staticClass:"progress progress-xxs"},[_c('div',{staticClass:"progress-bar progress-bar-success",staticStyle:{"width":"95%"}})])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("\n                Laravel Integration\n                "),_c('span',{staticClass:"label label-warning pull-right"},[_vm._v("50%")])]),_vm._v(" "),_c('div',{staticClass:"progress progress-xxs"},[_c('div',{staticClass:"progress-bar progress-bar-warning",staticStyle:{"width":"50%"}})])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0)"}},[_c('h4',{staticClass:"control-sidebar-subheading"},[_vm._v("\n                Back End Framework\n                "),_c('span',{staticClass:"label label-primary pull-right"},[_vm._v("68%")])]),_vm._v(" "),_c('div',{staticClass:"progress progress-xxs"},[_c('div',{staticClass:"progress-bar progress-bar-primary",staticStyle:{"width":"68%"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"control-sidebar-stats-tab"}},[_vm._v("Stats Tab Content")]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"control-sidebar-settings-tab"}},[_c('form',{attrs:{"method":"post"}},[_c('h3',{staticClass:"control-sidebar-heading"},[_vm._v("General Settings")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-sidebar-subheading"},[_vm._v("\n              Report panel usage\n              "),_c('input',{staticClass:"pull-right",attrs:{"type":"checkbox","checked":""}})]),_vm._v(" "),_c('p',[_vm._v("\n              Some information about this general settings option\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-sidebar-subheading"},[_vm._v("\n              Allow mail redirect\n              "),_c('input',{staticClass:"pull-right",attrs:{"type":"checkbox","checked":""}})]),_vm._v(" "),_c('p',[_vm._v("\n              Other sets of options are available\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-sidebar-subheading"},[_vm._v("\n              Expose author name in posts\n              "),_c('input',{staticClass:"pull-right",attrs:{"type":"checkbox","checked":""}})]),_vm._v(" "),_c('p',[_vm._v("\n              Allow the user to show his name in blog posts\n            ")])]),_vm._v(" "),_c('h3',{staticClass:"control-sidebar-heading"},[_vm._v("Chat Settings")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-sidebar-subheading"},[_vm._v("\n              Show me as online\n              "),_c('input',{staticClass:"pull-right",attrs:{"type":"checkbox","checked":""}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-sidebar-subheading"},[_vm._v("\n              Turn off notifications\n              "),_c('input',{staticClass:"pull-right",attrs:{"type":"checkbox"}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-sidebar-subheading"},[_vm._v("\n              Delete chat history\n              "),_c('a',{staticClass:"text-red pull-right",attrs:{"href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-trash-o"})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"control-sidebar-bg"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header'),_vm._v(" "),_c('app-sidebar'),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath}),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f289e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(458);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54f289e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Dashboard\n      "),_c('small',[_vm._v("it all starts here")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_vm._v("\n        Let's start submitting your activity or tour packages\n      ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57395fa6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(462);
function injectStyle (ssrContext) {
  __webpack_require__(460)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57395fa6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57395fa6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Destination\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'destination-index'}}},[_vm._v("\n          Destinations\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('span',[_vm._v("Edit")]):_vm._e(),_vm._v(" "),(_vm.isView)?_c('span',[_vm._v("View")]):_vm._e()])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("×")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.type),expression:"form.type"}],staticClass:"form-control",attrs:{"disabled":_vm.isView,"id":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",style:(_vm.checkError.name ? 'border-color:#FF3333' : ''),attrs:{"type":"text","id":"name","disabled":_vm.isView,"placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}}),_vm._v(" "),(_vm.checkError.name)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                      "+_vm._s(_vm.checkError.name)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name_en),expression:"form.name_en"}],staticClass:"form-control",style:(_vm.checkError.name_en ? 'border-color:#FF3333' : ''),attrs:{"type":"text","id":"name_en","disabled":_vm.isView,"placeholder":"Name"},domProps:{"value":(_vm.form.name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name_en", $event.target.value)}}}),_vm._v(" "),(_vm.checkError.name_en)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                      "+_vm._s(_vm.checkError.name_en)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                  Slug\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.slug),expression:"form.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","disabled":_vm.isView,"placeholder":"Slug"},domProps:{"value":(_vm.form.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"disabled":_vm.isView},on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                        Select Image\n                      ")])])]),_vm._v(" "),(_vm.checkError.image)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                    "+_vm._s(_vm.checkError.image)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description"}},[_vm._v("\n                  Description\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"type":"text","id":"description","disabled":_vm.isView,"placeholder":"Description","maxlength":"300"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description_en"}},[_vm._v("\n                  Description En\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description_en),expression:"form.description_en"}],staticClass:"form-control",attrs:{"type":"text","id":"description_en","disabled":_vm.isView,"placeholder":"Description En","maxlength":"300"},domProps:{"value":(_vm.form.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.destinationType),expression:"form.destinationType"}],staticClass:"form-control",style:(_vm.checkError.destinationType ? 'border-color:#FF3333' : ''),attrs:{"disabled":_vm.isView,"id":"vendor","placeholder":"Select Destination Type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form, "destinationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.destinationType),function(data,index){return _c('option',{key:(index + "-" + (data.value)),domProps:{"value":data.value}},[_vm._v("\n                    "+_vm._s(data.label)+"\n                    ")])}),0),_vm._v(" "),(_vm.checkError.destinationType)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                      "+_vm._s(_vm.checkError.destinationType)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('treeselect',{style:(_vm.checkError.parent ? 'border-color:#FF3333' : ''),attrs:{"placeholder":"Select parent","value-format":"object","multiple":false,"disabled":_vm.isView || _vm.form.destinationType === null,"options":_vm.destinations,"load-options":_vm.loadOptions,"auto-load-root-options":false},model:{value:(_vm.form.parent),callback:function ($$v) {_vm.$set(_vm.form, "parent", $$v)},expression:"form.parent"}}),_vm._v(" "),(_vm.checkError.parent)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                      "+_vm._s(_vm.checkError.parent)+"\n                    ")]):_vm._e()],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Destination Image"}},[_c('FileGallery',{attrs:{"type":"destination","selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":_vm.checkForm}},[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.isEdit)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":_vm.checkForm}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modalVisible)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.setDefaultModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.setDefaultModal.apply(null, arguments)}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v(" "+_vm._s(_vm.isCreateModal ? 'Add New City' : 'Edit City'))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit('modal')}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("×")]),_vm._v("\n                      "+_vm._s(_vm.error)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"type"}},[_vm._v("\n                        Region "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.type),expression:"formModal.type"}],staticClass:"form-control",attrs:{"disabled":"","id":"type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formModal, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                        Name "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.name),expression:"formModal.name"}],staticClass:"form-control",style:(_vm.checkErrorModal.name ? 'border-color:#FF3333' : ''),attrs:{"type":"text","id":"name","disabled":_vm.isView,"placeholder":"Name"},domProps:{"value":(_vm.formModal.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formModal, "name", $event.target.value)}}}),_vm._v(" "),(_vm.checkErrorModal.name)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                            "+_vm._s(_vm.checkErrorModal.name)+"\n                          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name_en"}},[_vm._v("\n                        Name En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.name_en),expression:"formModal.name_en"}],staticClass:"form-control",style:(_vm.checkErrorModal.name_en ? 'border-color:#FF3333' : ''),attrs:{"type":"text","id":"name_en","disabled":_vm.isView,"placeholder":"Name"},domProps:{"value":(_vm.formModal.name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formModal, "name_en", $event.target.value)}}}),_vm._v(" "),(_vm.checkErrorModal.name_en)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                              "+_vm._s(_vm.checkErrorModal.name_en)+"\n                            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                        Slug\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.slug),expression:"formModal.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","disabled":_vm.isView,"placeholder":"Slug"},domProps:{"value":(_vm.formModal.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formModal, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                        Image "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.formModal.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.formModal.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"disabled":_vm.isView},on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                              Select Image\n                            ")])])]),_vm._v(" "),(_vm.checkErrorModal.image)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                          "+_vm._s(_vm.checkErrorModal.image)+"\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description"}},[_vm._v("\n                        Description\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.description),expression:"formModal.description"}],staticClass:"form-control",attrs:{"type":"text","id":"description","disabled":_vm.isView,"placeholder":"Description"},domProps:{"value":(_vm.formModal.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formModal, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description_en"}},[_vm._v("\n                        Description En\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.description_en),expression:"formModal.description_en"}],staticClass:"form-control",attrs:{"type":"text","id":"description_en","disabled":_vm.isView,"placeholder":"Description En"},domProps:{"value":(_vm.formModal.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formModal, "description_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description_en"}},[_vm._v("\n                        Destination Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formModal.destinationType),expression:"formModal.destinationType"}],staticClass:"form-control",style:(_vm.checkError.destinationType ? 'border-color:#FF3333' : ''),attrs:{"disabled":"","id":"vendor","placeholder":"Select Destination Type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formModal, "destinationType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.destinationType),function(data,index){return _c('option',{key:(index + "-" + (data.value)),domProps:{"value":data.value}},[_vm._v("\n                          "+_vm._s(data.label)+"\n                          ")])}),0),_vm._v(" "),(_vm.checkErrorModal.destinationType)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                          "+_vm._s(_vm.checkErrorModal.destinationType)+"\n                        ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                        Parent "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('treeselect',{style:(_vm.checkErrorModal.parent ? 'border-color:#FF3333' : ''),attrs:{"disabled":"","placeholder":"Select parent","value-format":"object","multiple":false,"options":_vm.destinations,"load-options":_vm.loadOptions,"auto-load-root-options":false},model:{value:(_vm.formModal.parent),callback:function ($$v) {_vm.$set(_vm.formModal, "parent", $$v)},expression:"formModal.parent"}}),_vm._v(" "),(_vm.checkErrorModal.parent)?_c('p',{staticStyle:{"color":"#FF3333","margin":"0"}},[_vm._v("\n                          "+_vm._s(_vm.checkErrorModal.parent)+"\n                        ")]):_vm._e()],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Destination Image"}},[_c('FileGallery',{attrs:{"type":"destination","selected":_vm.formModal.image},on:{"update-images":_vm.setImageModal}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreateModal)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":function($event){return _vm.checkForm('modal')}}},[_vm._v("Create")]):_vm._e(),_vm._v(" "),(_vm.isEditModal)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":function($event){return _vm.checkForm('modal')}}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                        ×\n                      ")]),_vm._v("\n                      "+_vm._s(_vm.error)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.setDefaultModal.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])]):_vm._e()]),_vm._v(" "),(((_vm.destinationData.region_type === 'province' && _vm.destinationData.type === 'domestic') || (_vm.destinationData.region_type === 'country' && _vm.destinationData.type === 'international')))?_c('section',{staticClass:"box"},[(!_vm.isView)?_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){return _vm.addModal(_vm.destinationData)}}},[_vm._v("\n          Add City\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("City")]),_vm._v(" "),_c('th',[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Slug")]),_vm._v(" "),(!_vm.isView)?_c('th',[_vm._v("Action(s)")]):_vm._e()])]),_vm._v(" "),(_vm.destinationData.child)?_c('tbody',[_vm._l((_vm.destinationData.child),function(item){return [_c('tr',{key:item.id},[_c('td',[_vm._v("\n                  "+_vm._s(item.name)+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(item.image_url && item.image_url != '')?_c('img',{staticStyle:{"width":"85px"},attrs:{"src":_vm.parseImage(item.image_url, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("\n                  "+_vm._s(item.slug)+"\n                ")]),_vm._v(" "),(!_vm.isView)?_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.editModal(item, _vm.destinationData.name)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(item)}}},[_vm._v("Delete")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                        ×\n                      ")]),_vm._v("\n                      "+_vm._s(_vm.error)+"\n                    ")]):_vm._e()]):_vm._e()])]})],2):_vm._e()])])]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"type"}},[_vm._v("\n                  Region "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name_en"}},[_vm._v("\n                  Name En "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                  Image "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description_en"}},[_vm._v("\n                  Destination Type "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                  Parent "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef7d21ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(466);
function injectStyle (ssrContext) {
  __webpack_require__(464)
  __webpack_require__(465)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ef7d21ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef7d21ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"button-flagging"},[(this.$route.query.type === 'domestic')?_c('a',{staticClass:"btn active-flag disabled",attrs:{"disabled":""}},[_vm._v("\n        Domestic Destinations\n      ")]):_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.changeFlag()}}},[_vm._v("\n        Domestic Destination\n      ")]),_vm._v(" "),(this.$route.query.type === 'international')?_c('a',{staticClass:"btn active-flag disabled",attrs:{"disabled":""}},[_vm._v("\n        International Destination\n      ")]):_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.changeFlag()}}},[_vm._v("\n        International Destination\n      ")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row"},[(_vm.params.type === 'domestic')?_c('div',{staticClass:"col-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"vendor"}},[_vm._v("\n                Province\n              ")]),_vm._v(" "),_c('v-select',{staticClass:"style-chooser",attrs:{"placeholder":"Select All","options":_vm.list.provinces,"id":"vendor"},on:{"input":_vm.onSelect},model:{value:(_vm.params.province),callback:function ($$v) {_vm.$set(_vm.params, "province", $$v)},expression:"params.province"}})],1)]):_c('div',{staticClass:"col-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"vendor"}},[_vm._v("\n                Country\n              ")]),_vm._v(" "),_c('v-select',{staticClass:"style-chooser",attrs:{"placeholder":"Select All","options":_vm.list.countries,"id":"vendor"},on:{"input":_vm.onSelectCountry},model:{value:(_vm.params.country),callback:function ($$v) {_vm.$set(_vm.params, "country", $$v)},expression:"params.country"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"vendor"}},[_vm._v("\n                City\n              ")]),_vm._v(" "),_c('v-select',{staticClass:"style-chooser",attrs:{"placeholder":"Select City","id":"vendor","options":_vm.list.cities},model:{value:(_vm.params.city),callback:function ($$v) {_vm.$set(_vm.params, "city", $$v)},expression:"params.city"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.search.apply(null, arguments)}}},[_vm._v("\n              Search\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Destination\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),(!_vm.destinations)?_c('tbody',{key:"empty"},[[_vm._m(3)]],2):_c('tbody',[_vm._l((_vm.destinations),function(parent){return [_vm._l((parent.child),function(child){return (parent.child)?[_c('tr',{key:child.id},[_c('td',[_vm._v(_vm._s(child.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(child.region_type))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(child.image_url && child.image_url != '')?_c('img',{staticStyle:{"width":"32px"},attrs:{"src":_vm.parseImage(child.image_url, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(child.slug))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(child.parent_name))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(child.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(child)}}},[_vm._v("Delete")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(child.id)}}},[_vm._v("View")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                        ×\n                      ")]),_vm._v("\n                      "+_vm._s(_vm.error)+"\n                    ")]):_vm._e()])]),_vm._v(" "),_vm._l((child.child),function(grandchild){return (child.child)?[_c('tr',{key:grandchild.id},[_c('td',[_vm._v(_vm._s(grandchild.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandchild.region_type))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(grandchild.image_url && grandchild.image_url != '')?_c('img',{staticStyle:{"width":"32px"},attrs:{"src":_vm.parseImage(grandchild.image_url, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandchild.slug))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandchild.parent_name))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(grandchild.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(grandchild)}}},[_vm._v("Delete")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(grandchild.id)}}},[_vm._v("View")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                          ×\n                        ")]),_vm._v("\n                        "+_vm._s(_vm.error)+"\n                      ")]):_vm._e()])]),_vm._v(" "),_vm._l((grandchild.child),function(grandgrandchild){return (grandchild.child)?[_c('tr',{key:grandgrandchild.id},[_c('td',[_vm._v(_vm._s(grandgrandchild.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandgrandchild.region_type))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(grandgrandchild.image_url && grandgrandchild.image_url != '')?_c('img',{staticStyle:{"width":"32px"},attrs:{"src":_vm.parseImage(grandgrandchild.image_url, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandgrandchild.slug))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grandgrandchild.parent_name))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(grandgrandchild.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(grandgrandchild)}}},[_vm._v("Delete")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(grandgrandchild.id)}}},[_vm._v("View")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                            ×\n                          ")]),_vm._v("\n                          "+_vm._s(_vm.error)+"\n                        ")]):_vm._e()])])]:_vm._e()})]:_vm._e()})]:_vm._e()})]})],2)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Destinations\n      "),_c('small',[_vm._v("List of destinations")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Destinations")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Destinations")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Slug")]),_vm._v(" "),_c('th',[_vm._v("Parent")]),_vm._v(" "),_c('th',[_vm._v("Action(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v("\n                  Result not found\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff06ca2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(469);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fff06ca2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff06ca2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Inventory Ticket\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Inventorys")])]),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border center-ver"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.downloadTemplate()}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v("  Download Template\n            ")])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                    ×\n                  ")]),_vm._v("\n                  "+_vm._s(_vm.error)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"placeholder":"Delimiter","options":_vm.list.delimiter},model:{value:(_vm.form.delimiter),callback:function ($$v) {_vm.$set(_vm.form, "delimiter", $$v)},expression:"form.delimiter"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{ref:"file",attrs:{"type":"file","name":"file","accept":"text/csv"},on:{"change":_vm.setFile}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Inventory Image"}},[_c('FileGallery',{attrs:{"type":"inventory","selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Delimiter "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"file"}},[_vm._v("\n                 Upload "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b40e3c28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(472);
function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b40e3c28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b40e3c28_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"button-flagging"},[(_vm.params.flaging === 'explore')?_c('a',{staticClass:"btn active-flag magin-right disabled",attrs:{"disabled":""}},[_vm._v("\n        Explore Inventory\n      ")]):_c('a',{staticClass:"btn btn-primary magin-right",on:{"click":function($event){$event.preventDefault();return _vm.changeFlag()}}},[_vm._v("\n        Explore Inventory\n      ")]),_vm._v(" "),(_vm.params.flaging === 'tour')?_c('a',{staticClass:"btn active-flag disabled",attrs:{"disabled":""}},[_vm._v("\n        Tour Inventory\n      ")]):_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.changeFlag()}}},[_vm._v("\n        Tour Inventory\n      ")])]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"inherit"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"promoPaymentName"}},[_vm._v("\n            Name\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"inventoryName","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])])]),_vm._v(" "),(_vm.params.flaging === 'explore')?_c('span',[_vm._v("Explore Inventory")]):_c('span',[_vm._v("Tour Inventory")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New inventory\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',[(_vm.params.flaging === 'explore')?_c('th',[_vm._v("Explore Name")]):_c('th',[_vm._v("Tour Name")]),_vm._v(" "),_c('th',[_vm._v("Stock All")]),_vm._v(" "),_c('th',[_vm._v("Stock Available")]),_vm._v(" "),_c('th',[_vm._v("Stock Booked")]),_vm._v(" "),_c('th',[_vm._v("Stock Sold")]),_vm._v(" "),_c('th',[_vm._v("Action")])])]),_vm._v(" "),(_vm.isLoading)?_c('tbody',{key:"loading"},[_vm._m(2)]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_vm._m(3)]):_c('tbody',{key:"data"},_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.stock_all))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.stock_available))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.stock_booked))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.stock_sold))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(item.id)}}},[_vm._v("\n                  Edit\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-success btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(item.id)}}},[_vm._v("\n                  Details\n                ")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Inventory Ticket\n      "),_c('small',[_vm._v("List of Inventory Ticket")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v("Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Inventory Ticket")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('strong',[_vm._v("Filter Inventory")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Loading")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Result not found")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05618417_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__(475);
function injectStyle (ssrContext) {
  __webpack_require__(474)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05618417"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05618417_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_vm._m(0),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'inventory-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Inventory\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'inventory-view' })}}},[_c('i',{staticClass:"fa"}),_vm._v(" Details\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.params.flaging === 'explore' ? 'Explore: '+_vm.title : 'Tour: '+_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.inventorys),function(inventory){return _c('tr',[_c('td',[_vm._v(_vm._s(inventory.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.unique_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.validity_date_from))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.validity_date_to))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.is_booked))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.booked_at == "0001-01-01" ? "" : inventory.booked_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.is_sold))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(inventory.sold_at == "0001-01-01" ? "" : inventory.sold_at))])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}}),_vm._v(" "),_c('a',{staticClass:"btn btn-default pull-right",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("\n          Back to Inventory List\n        ")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Inventory Tickets Details\n      "),_c('small',[_vm._v("List of Inventory Ticket")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Item ID")]),_vm._v(" "),_c('th',[_vm._v("Unique Code")]),_vm._v(" "),_c('th',[_vm._v("Validity Date From")]),_vm._v(" "),_c('th',[_vm._v("Validity Date To")]),_vm._v(" "),_c('th',[_vm._v("Is Booked")]),_vm._v(" "),_c('th',[_vm._v("Booked At")]),_vm._v(" "),_c('th',[_vm._v("Is Sold")]),_vm._v(" "),_c('th',[_vm._v("Sold At")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d24421_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30d24421_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('div',{staticClass:"login-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('b',[_vm._v("Mister")]),_vm._v(" Aladin")])],1),_vm._v(" "),_c('div',{staticClass:"login-box-body"},[_c('p',{staticClass:"login-box-msg"},[_vm._v("Sign in to start your session")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.errorMessage = false}}},[_vm._v("×")]),_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-user form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-lock form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-8"},[_c('router-link',{attrs:{"to":"/forgot"}},[_vm._v("Forgot password")])],1),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4"},[_c('button',{staticClass:"btn btn-primary btn-block btn-flat",attrs:{"type":"submit"}},[_vm._v("Sign In")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eba772b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__ = __webpack_require__(479);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Forgot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eba772b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Forgot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('div',{staticClass:"login-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('b',[_vm._v("Mister")]),_vm._v(" Aladin\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"login-box-body"},[_c('p',{staticClass:"login-box-msg"},[_vm._v("Forgot your password? No problem we will send your password.")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.errorMessage = false}}},[_vm._v("×")]),_vm._v("\n        "+_vm._s(_vm.errorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Email"},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-user form-control-feedback"})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-8"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Kembali ke halaman login")])],1),_vm._v(" "),_vm._m(0)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4"},[_c('button',{staticClass:"btn btn-primary btn-block btn-flat",attrs:{"type":"submit"}},[_vm._v("Submit")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1104826c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__ = __webpack_require__(482);
function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1104826c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1104826c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-box"},[_c('div',{staticClass:"login-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('b',[_vm._v("Mister")]),_vm._v(" Aladin\n    ")])],1),_vm._v(" "),_c('div',{staticClass:"login-box-body"},[(_vm.isInvalid)?[_c('p',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-fw fa-exclamation-triangle"}),_vm._v(" "+_vm._s(_vm.errorMessage)+"\n      ")])]:[_c('p',{staticClass:"login-box-msg"},[_vm._v("Please provide your new password")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.reset.apply(null, arguments)}}},[(_vm.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.errorMessage = false}}},[_vm._v("×")]),_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],ref:"password",staticClass:"form-control",attrs:{"type":"password","placeholder":"Password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"form-control-feedback",on:{"click":_vm.togglePassword}},[(_vm.showPassword)?_c('i',{staticClass:"glyphicon glyphicon-eye-open"}):_c('i',{staticClass:"glyphicon glyphicon-eye-close"})])]),_vm._v(" "),_vm._m(0)])]],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4"},[_c('button',{staticClass:"btn btn-primary btn-block btn-flat",attrs:{"type":"submit"}},[_vm._v("Submit")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eee4626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(484);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eee4626_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Mood\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'mood-index'}}},[_vm._v("\n          Moods\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body"},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                  Slug\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.slug),expression:"form.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.form.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                  Image\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                        Select Image\n                      ")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Mood Image"}},[_c('FileGallery',{attrs:{"type":"mood","selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e700fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(486);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e700fb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Mood\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.moods),function(mood){return _c('tr',[_c('td',[_vm._v(_vm._s(mood.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(mood.slug))]),_vm._v(" "),_c('td',[(mood.image_url && mood.image_url != '')?_c('img',{staticStyle:{"width":"64px"},attrs:{"src":_vm.parseImage(mood.image_url, '_thumb')}}):_vm._e()]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(mood.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(mood)}}},[_vm._v("Delete")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Moods\n      "),_c('small',[_vm._v("List of moods")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Moods")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Slug")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Image")]),_vm._v(" "),_c('th',[_vm._v("Action(s)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1e7ec2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(488);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1e7ec2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"error-page"},[_c('h2',{staticClass:"headline text-yellow"},[_vm._v(" 404")]),_vm._v(" "),_c('div',{staticClass:"error-content"},[_vm._m(1),_vm._v(" "),_c('p',[_vm._v("\n          We could not find the page you were looking for.\n          Meanwhile, you may\n          "),_c('router-link',{attrs:{"to":"/dashboard"}},[_vm._v("return to dashboard")]),_vm._v("\n          or try using the search form.\n        ")],1),_vm._v(" "),_vm._m(2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      404 Error Page\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Examples")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("404 error")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('i',{staticClass:"fa fa-warning text-yellow"}),_vm._v(" Oops! Page not found.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"search-form"},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","name":"search","placeholder":"Search"}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-warning btn-flat",attrs:{"type":"submit","name":"submit"}},[_c('i',{staticClass:"fa fa-search"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d598306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(636);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d598306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d598306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b11f679c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle_vue__ = __webpack_require__(493);
function injectStyle (ssrContext) {
  __webpack_require__(492)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b11f679c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b11f679c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner spinner--circle",style:(_vm.styles),attrs:{"viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle2_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6c679bfb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle2_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(495)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c679bfb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6c679bfb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-2",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle3_vue__ = __webpack_require__(269);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_284cf52c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle3_vue__ = __webpack_require__(499);
function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-284cf52c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_284cf52c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-3",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle4_vue__ = __webpack_require__(270);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6ce3a847_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle4_vue__ = __webpack_require__(502);
function injectStyle (ssrContext) {
  __webpack_require__(501)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ce3a847"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6ce3a847_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-4",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle5_vue__ = __webpack_require__(271);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_743fd83c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle5_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-743fd83c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_743fd83c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-5",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle6_vue__ = __webpack_require__(272);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a03e8c24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle6_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a03e8c24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle6_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a03e8c24_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle6_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner spinner--circle-6",style:(_vm.styles),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},[_c('g',{staticClass:"anim-0"},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill":_vm.background}})]),_vm._v(" "),_c('g',{staticClass:"anim-1"},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"5","fill":"white"}})]),_vm._v(" "),_c('g',{staticClass:"anim-2"},[_c('circle',{attrs:{"cx":"75","cy":"50","r":"5","fill":"white"}}),_vm._v(" "),_c('line',{attrs:{"x1":"25","y1":"50","x2":"75","y2":"50","stroke":"white","stroke-width":"3"}})]),_vm._v(" "),_c('g',{staticClass:"anim-3"},[_c('circle',{attrs:{"cx":"50","cy":"25","r":"5","fill":"white"}}),_vm._v(" "),_c('line',{attrs:{"x1":"50","y1":"25","x2":"25","y2":"75","stroke":"white","stroke-width":"3"}}),_vm._v(" "),_c('line',{attrs:{"x1":"50","y1":"25","x2":"75","y2":"75","stroke":"white","stroke-width":"3"}})]),_vm._v(" "),_c('g',{staticClass:"anim-4"},[_c('circle',{attrs:{"cx":"75","cy":"25","r":"5","fill":"white"}}),_vm._v(" "),_c('line',{attrs:{"x1":"75","y1":"25","x2":"25","y2":"25","stroke":"white","stroke-width":"3"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle7_vue__ = __webpack_require__(273);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9d2e53b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle7_vue__ = __webpack_require__(511);
function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9d2e53b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle7_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9d2e53b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle7_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-7",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle8_vue__ = __webpack_require__(274);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c1e82ad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle8_vue__ = __webpack_require__(514);
function injectStyle (ssrContext) {
  __webpack_require__(513)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c1e82ad8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle8_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c1e82ad8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle8_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-8",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball-container"},[_c('div',{staticClass:"contener_mixte"},[_c('div',{staticClass:"ballcolor ball_1"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"contener_mixte"},[_c('div',{staticClass:"ballcolor ball_2"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"contener_mixte"},[_c('div',{staticClass:"ballcolor ball_3"},[_vm._v(" ")])]),_vm._v(" "),_c('div',{staticClass:"contener_mixte"},[_c('div',{staticClass:"ballcolor ball_4"},[_vm._v(" ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle9_vue__ = __webpack_require__(275);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_060d9a88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle9_vue__ = __webpack_require__(517);
function injectStyle (ssrContext) {
  __webpack_require__(516)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-060d9a88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle9_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_060d9a88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle9_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-9",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading spin-1"},[_c('div',{staticClass:"loading spin-2"},[_c('div',{staticClass:"loading spin-3"},[_c('div',{staticClass:"loading spin-4"},[_c('div',{staticClass:"loading spin-5"},[_c('div',{staticClass:"loading spin-6"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle10_vue__ = __webpack_require__(276);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ffcc2a80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle10_vue__ = __webpack_require__(520);
function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffcc2a80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle10_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ffcc2a80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle10_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-10",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_c('div',{staticClass:"loader-xbox"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle11_vue__ = __webpack_require__(277);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_31d614bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle11_vue__ = __webpack_require__(523);
function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31d614bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Circle11_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_31d614bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Circle11_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--circle-11",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CubeShadow_vue__ = __webpack_require__(278);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26545e86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CubeShadow_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(525)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26545e86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CubeShadow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26545e86_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CubeShadow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 525 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--cube-shadow",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Diamond_vue__ = __webpack_require__(279);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_234ece92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Diamond_vue__ = __webpack_require__(529);
function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-234ece92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Diamond_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_234ece92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Diamond_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner spinner--rotate-diamond",style:(_vm.styles)},[_c('div',{staticClass:"diamond",style:(_vm.diamondStyle)}),_vm._v(" "),_c('div',{staticClass:"diamond",style:(_vm.diamondStyle)}),_vm._v(" "),_c('div',{staticClass:"diamond",style:(_vm.diamondStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_DoubleBounce_vue__ = __webpack_require__(280);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0e2c2720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_DoubleBounce_vue__ = __webpack_require__(532);
function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e2c2720"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_DoubleBounce_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0e2c2720_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_DoubleBounce_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--double-bounce",style:(_vm.styles)},[_c('div',{staticClass:"double-bounce1",style:(_vm.bounceStyle)}),_vm._v(" "),_c('div',{staticClass:"double-bounce2",style:(_vm.bounceStyle)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Gauge_vue__ = __webpack_require__(281);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b598f45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Gauge_vue__ = __webpack_require__(535);
function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b598f45"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Gauge_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b598f45_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Gauge_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--gauge",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Google_vue__ = __webpack_require__(282);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2db1e062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Google_vue__ = __webpack_require__(538);
function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2db1e062"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Google_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2db1e062_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Google_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--google",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Hexagon_vue__ = __webpack_require__(283);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_48cf437e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Hexagon_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48cf437e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Hexagon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_48cf437e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Hexagon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--hexagon",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"hexagon-container"},[_c('li',{staticClass:"hexagon hex_1"}),_vm._v(" "),_c('li',{staticClass:"hexagon hex_2"}),_vm._v(" "),_c('li',{staticClass:"hexagon hex_3"}),_vm._v(" "),_c('li',{staticClass:"hexagon hex_4"}),_vm._v(" "),_c('li',{staticClass:"hexagon hex_5"}),_vm._v(" "),_c('li',{staticClass:"hexagon hex_6"}),_vm._v(" "),_c('li',{staticClass:"hexagon hex_7"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HourGlass_vue__ = __webpack_require__(284);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_76b45bce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HourGlass_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76b45bce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HourGlass_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_76b45bce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_HourGlass_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--hour-glass",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_c('svg',{staticClass:"hourglass",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 206","preserveAspectRatio":"none"}},[_c('path',{staticClass:"middle",attrs:{"d":"M120 0H0v206h120V0zM77.1 133.2C87.5 140.9 92 145 92 152.6V178H28v-25.4c0-7.6 4.5-11.7 14.9-19.4 6-4.5 13-9.6 17.1-17 4.1 7.4 11.1 12.6 17.1 17zM60 89.7c-4.1-7.3-11.1-12.5-17.1-17C32.5 65.1 28 61 28 53.4V28h64v25.4c0 7.6-4.5 11.7-14.9 19.4-6 4.4-13 9.6-17.1 16.9z"}}),_vm._v(" "),_c('path',{staticClass:"outer",attrs:{"d":"M93.7 95.3c10.5-7.7 26.3-19.4 26.3-41.9V0H0v53.4c0 22.5 15.8 34.2 26.3 41.9 3 2.2 7.9 5.8 9 7.7-1.1 1.9-6 5.5-9 7.7C15.8 118.4 0 130.1 0 152.6V206h120v-53.4c0-22.5-15.8-34.2-26.3-41.9-3-2.2-7.9-5.8-9-7.7 1.1-2 6-5.5 9-7.7zM70.6 103c0 18 35.4 21.8 35.4 49.6V192H14v-39.4c0-27.9 35.4-31.6 35.4-49.6S14 81.2 14 53.4V14h92v39.4C106 81.2 70.6 85 70.6 103z"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Jawn_vue__ = __webpack_require__(285);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_47ba83ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Jawn_vue__ = __webpack_require__(547);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47ba83ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Jawn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_47ba83ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Jawn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--jawn"},[_c('div',{staticClass:"spinner-inner",style:(_vm.styles)},[_c('div',{staticClass:"jawn",style:(_vm.innerStyles)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Jumper_vue__ = __webpack_require__(286);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_54c05c29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Jumper_vue__ = __webpack_require__(550);
function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54c05c29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Jumper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_54c05c29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Jumper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--jumper",style:(_vm.styles)},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LetterCube_vue__ = __webpack_require__(287);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_638dd89f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LetterCube_vue__ = __webpack_require__(553);
function injectStyle (ssrContext) {
  __webpack_require__(552)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-638dd89f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LetterCube_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_638dd89f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LetterCube_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--socker",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cube panelLoad"},[_c('div',{staticClass:"cube-face cube-face-front"},[_vm._v("L")]),_vm._v(" "),_c('div',{staticClass:"cube-face cube-face-back"},[_vm._v("O")]),_vm._v(" "),_c('div',{staticClass:"cube-face cube-face-left"},[_vm._v("A")]),_vm._v(" "),_c('div',{staticClass:"cube-face cube-face-right"},[_vm._v("D")]),_vm._v(" "),_c('div',{staticClass:"cube-face cube-face-bottom"},[_vm._v("I")]),_vm._v(" "),_c('div',{staticClass:"cube-face cube-face-top"},[_vm._v("N'")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Mikepad_vue__ = __webpack_require__(288);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d374903_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Mikepad_vue__ = __webpack_require__(556);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d374903"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Mikepad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1d374903_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Mikepad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--mikepad",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_c('div',{staticClass:"binding"}),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pad"},[_c('div',{staticClass:"line line1"}),_vm._v(" "),_c('div',{staticClass:"line line2"}),_vm._v(" "),_c('div',{staticClass:"line line3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Origami_vue__ = __webpack_require__(289);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3b062c5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Origami_vue__ = __webpack_require__(559);
function injectStyle (ssrContext) {
  __webpack_require__(558)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b062c5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Origami_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3b062c5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Origami_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 558 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner-origami",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner loading",style:(_vm.innerStyles)},[_c('span',{staticClass:"slice"}),_vm._v(" "),_c('span',{staticClass:"slice"}),_vm._v(" "),_c('span',{staticClass:"slice"}),_vm._v(" "),_c('span',{staticClass:"slice"}),_vm._v(" "),_c('span',{staticClass:"slice"}),_vm._v(" "),_c('span',{staticClass:"slice"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pencil_vue__ = __webpack_require__(290);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6e372377_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pencil_vue__ = __webpack_require__(562);
function injectStyle (ssrContext) {
  __webpack_require__(561)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e372377"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Pencil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6e372377_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Pencil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 561 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner spinner--pencil",style:(_vm.styles),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 677.34762 182.15429"}},[_c('g',[_c('path',{staticClass:"body-pencil",attrs:{"d":"M128.273 0l-3.9 2.77L0 91.078l128.273 91.076 549.075-.006V.008L128.273 0zm20.852 30l498.223.006V152.15l-498.223.007V30zm-25 9.74v102.678l-49.033-34.813-.578-32.64 49.61-35.225z"}}),_vm._v(" "),_c('path',{staticClass:"line",attrs:{"d":"M134.482 157.147v25l518.57.008.002-25-518.572-.008z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PingPong_vue__ = __webpack_require__(291);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_066a86ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PingPong_vue__ = __webpack_require__(565);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-066a86ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PingPong_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_066a86ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PingPong_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--ping-pong",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board"},[_c('div',{staticClass:"left"}),_vm._v(" "),_c('div',{staticClass:"right"}),_vm._v(" "),_c('div',{staticClass:"ball"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Plane_vue__ = __webpack_require__(292);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_025893f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Plane_vue__ = __webpack_require__(568);
function injectStyle (ssrContext) {
  __webpack_require__(567)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-025893f1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Plane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_025893f1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Plane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--plane",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask",attrs:{"id":"top"}},[_c('div',{staticClass:"plane"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask",attrs:{"id":"middle"}},[_c('div',{staticClass:"plane"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mask",attrs:{"id":"bottom"}},[_c('div',{staticClass:"plane"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare_vue__ = __webpack_require__(293);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c74a824e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare_vue__ = __webpack_require__(571);
function injectStyle (ssrContext) {
  __webpack_require__(570)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c74a824e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c74a824e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--rotate-square",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare2_vue__ = __webpack_require__(294);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_10e8262c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare2_vue__ = __webpack_require__(574);
function injectStyle (ssrContext) {
  __webpack_require__(573)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10e8262c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_10e8262c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--rotate-square-2",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare3_vue__ = __webpack_require__(295);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6b2ba7d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare3_vue__ = __webpack_require__(577);
function injectStyle (ssrContext) {
  __webpack_require__(576)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b2ba7d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6b2ba7d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner spinner--cube",style:(_vm.styles),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500.00001 500.00001"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{staticClass:"b0",attrs:{"d":"M66.734 66.734v366.533h366.532V66.734H66.734zm15 15h336.532v336.533H81.734V81.734z"}}),_vm._v(" "),_c('path',{staticClass:"b2",attrs:{"d":"M354.16 2.5v143.34H497.5V2.5H354.16zm10 10H487.5v123.34H364.16V12.5z"}}),_vm._v(" "),_c('path',{staticClass:"b1",attrs:{"d":"M0 2.5v143.34h143.34V2.5H0zm10 10h123.34v123.34H10V12.5z"}}),_vm._v(" "),_c('path',{staticClass:"b3",attrs:{"d":"M354.16 356.66V500H497.5V356.66H354.16zm10 10H487.5V490H364.16V366.66z"}}),_vm._v(" "),_c('path',{staticClass:"b4",attrs:{"d":"M0 356.66V500h143.34V356.66H0zm10 10h123.34V490H10V366.66z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare4_vue__ = __webpack_require__(296);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23ee17bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare4_vue__ = __webpack_require__(580);
function injectStyle (ssrContext) {
  __webpack_require__(579)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23ee17bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_23ee17bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"spinner spinner--rotate-square4",style:(_vm.styles)},[_c('span',{staticClass:"loader-inner"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare5_vue__ = __webpack_require__(297);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f66ac8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare5_vue__ = __webpack_require__(583);
function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f66ac8a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateSquare5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_f66ac8a0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateSquare5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--rotate-square-5",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_c('span',{staticClass:"load3 one"}),_vm._v(" "),_c('span',{staticClass:"load3 two"}),_vm._v(" "),_c('span',{staticClass:"load3-center"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScaleOut_vue__ = __webpack_require__(298);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03dc618e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScaleOut_vue__ = __webpack_require__(586);
function injectStyle (ssrContext) {
  __webpack_require__(585)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03dc618e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ScaleOut_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_03dc618e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ScaleOut_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--scale-out",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Socket_vue__ = __webpack_require__(299);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_610093ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Socket_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-610093ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Socket_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_610093ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Socket_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--socker",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_vm._m(36)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel center-gel"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c1 r1"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c2 r1"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c3 r1"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c4 r1"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c5 r1"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c6 r1"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c7 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c8 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c9 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c10 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c11 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c12 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c13 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c14 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c15 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c16 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c17 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c18 r2"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c19 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c20 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c21 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c22 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c23 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c24 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c25 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c26 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c28 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c29 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c30 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c31 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c32 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c33 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c34 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c35 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c36 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gel c37 r3"},[_c('div',{staticClass:"hex-brick h1"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h2"}),_vm._v(" "),_c('div',{staticClass:"hex-brick h3"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpinLine_vue__ = __webpack_require__(300);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_162bb5c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpinLine_vue__ = __webpack_require__(592);
function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-162bb5c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SpinLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_162bb5c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SpinLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--spin-line",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.lineStyles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SquareGrid_vue__ = __webpack_require__(301);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6f313e63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SquareGrid_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f313e63"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SquareGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6f313e63_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_SquareGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--square-grid",style:(_vm.styles)},[_c('div',{staticClass:"sk-cube sk-cube1",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube2",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube3",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube4",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube5",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube6",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube7",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube8",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"sk-cube sk-cube9",style:(_vm.cubeStyles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Stretch_vue__ = __webpack_require__(302);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9048bf2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Stretch_vue__ = __webpack_require__(598);
function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9048bf2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Stretch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9048bf2e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Stretch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--stretch",style:(_vm.styles)},[_c('div',{staticClass:"rect rect-1",style:(_vm.rectStyles)}),_vm._v(" "),_c('div',{staticClass:"rect rect-2",style:(_vm.rectStyles)}),_vm._v(" "),_c('div',{staticClass:"rect rect-3",style:(_vm.rectStyles)}),_vm._v(" "),_c('div',{staticClass:"rect rect-4",style:(_vm.rectStyles)}),_vm._v(" "),_c('div',{staticClass:"rect rect-5",style:(_vm.rectStyles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Texture_vue__ = __webpack_require__(303);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e8e065d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Texture_vue__ = __webpack_require__(601);
function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e8e065d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Texture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e8e065d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Texture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--texture",style:(_vm.styles)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ThreeDots_vue__ = __webpack_require__(304);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11dc5b7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ThreeDots_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11dc5b7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ThreeDots_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11dc5b7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_ThreeDots_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner",style:(_vm.styles)},[_c('div',{staticClass:"blob top",style:(_vm.blobStyles)}),_vm._v(" "),_c('div',{staticClass:"blob bottom",style:(_vm.blobStyles)}),_vm._v(" "),_c('div',{staticClass:"blob left",style:(_vm.blobStyles)}),_vm._v(" "),_c('div',{staticClass:"blob move-blob",style:(_vm.moveBlobStyles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TwoCube_vue__ = __webpack_require__(305);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a083ee58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TwoCube_vue__ = __webpack_require__(607);
function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a083ee58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_TwoCube_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a083ee58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_TwoCube_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--two-cube",style:(_vm.styles)},[_c('div',{staticClass:"cube1",style:(_vm.cubeStyles)}),_vm._v(" "),_c('div',{staticClass:"cube2",style:(_vm.cubeStyles)})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Wave_vue__ = __webpack_require__(306);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_589e998e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Wave_vue__ = __webpack_require__(610);
function injectStyle (ssrContext) {
  __webpack_require__(609)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-589e998e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Wave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_589e998e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Wave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner--wave",style:(_vm.styles)},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__ = __webpack_require__(613);
function injectStyle (ssrContext) {
  __webpack_require__(612)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_vue_timepicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7f087038_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_vue_timepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"time-picker"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.displayTime),expression:"displayTime"}],staticClass:"display-time",attrs:{"id":_vm.id,"type":"text","readonly":""},domProps:{"value":(_vm.displayTime)},on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.displayTime=$event.target.value}}}),_vm._v(" "),(!_vm.hideClearButton)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showDropdown && _vm.showClearBtn),expression:"!showDropdown && showClearBtn"}],staticClass:"clear-btn",on:{"click":function($event){$event.stopPropagation();return _vm.clearTime.apply(null, arguments)}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),(_vm.showDropdown)?_c('div',{staticClass:"time-picker-overlay",on:{"click":function($event){$event.stopPropagation();return _vm.toggleDropdown.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropdown),expression:"showDropdown"}],staticClass:"dropdown"},[_c('div',{staticClass:"select-list"},[_c('ul',{staticClass:"hours"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.hourType)}}),_vm._v(" "),_vm._l((_vm.hours),function(hr){return _c('li',{class:{active: _vm.hour === hr},domProps:{"textContent":_vm._s(hr)},on:{"click":function($event){$event.stopPropagation();return _vm.select('hour', hr)}}})})],2),_vm._v(" "),_c('ul',{staticClass:"minutes"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.minuteType)}}),_vm._v(" "),_vm._l((_vm.minutes),function(m){return _c('li',{class:{active: _vm.minute === m},domProps:{"textContent":_vm._s(m)},on:{"click":function($event){$event.stopPropagation();return _vm.select('minute', m)}}})})],2),_vm._v(" "),(_vm.secondType)?_c('ul',{staticClass:"seconds"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.secondType)}}),_vm._v(" "),_vm._l((_vm.seconds),function(s){return _c('li',{class:{active: _vm.second === s},domProps:{"textContent":_vm._s(s)},on:{"click":function($event){$event.stopPropagation();return _vm.select('second', s)}}})})],2):_vm._e(),_vm._v(" "),(_vm.apmType)?_c('ul',{staticClass:"apms"},[_c('li',{staticClass:"hint",domProps:{"textContent":_vm._s(_vm.apmType)}}),_vm._v(" "),_vm._l((_vm.apms),function(a){return _c('li',{class:{active: _vm.apm === a},domProps:{"textContent":_vm._s(a)},on:{"click":function($event){$event.stopPropagation();return _vm.select('apm', a)}}})})],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ckeditor"},[_c('textarea',{attrs:{"name":_vm.name,"id":_vm.id,"types":_vm.types,"config":_vm.config},domProps:{"value":_vm.value}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentHeader_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a41bec2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentHeader_vue__ = __webpack_require__(617);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a41bec2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n      ")])],1),_vm._v(" "),_vm._l((_vm.breadcrumbs),function(item){return _c('li',[_c('router-link',{attrs:{"to":{ name: item.link }}},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])],1)}),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",class:_vm.borderType},[_c('div',{staticClass:"box-header",class:{ 'with-border': _vm.border },on:{"click":_vm.toggle}},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.action)?_c('span',{staticClass:"box-toggle"},[(!_vm.collapse)?_c('i',{staticClass:"fa fa-minus"}):_c('i',{staticClass:"fa fa-plus"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-body",class:{ 'collapse': _vm.collapse }},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quickjump_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500c1e58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quickjump_vue__ = __webpack_require__(622);
function injectStyle (ssrContext) {
  __webpack_require__(621)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-500c1e58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quickjump_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500c1e58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quickjump_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quickjump sticky"},[_c('span',{staticClass:"title"},[_vm._v("Jump")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#title', offset: -150 }),expression:"{ el: '#title', offset: -150 }"}],staticClass:"badge"},[_vm._v("Title")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#details', offset: -150 }),expression:"{ el: '#details', offset: -150 }"}],staticClass:"badge"},[_vm._v("Details")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#source', offset: -150 }),expression:"{ el: '#source', offset: -150 }"}],staticClass:"badge"},[_vm._v("Source")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#booking', offset: -150 }),expression:"{ el: '#booking', offset: -150 }"}],staticClass:"badge"},[_vm._v("Booking")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#packages', offset: -150 }),expression:"{ el: '#packages', offset: -150 }"}],staticClass:"badge"},[_vm._v("Packages")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#sequence', offset: -150 }),expression:"{ el: '#sequence', offset: -150 }"}],staticClass:"badge"},[_vm._v("Sequence")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#contents', offset: -150 }),expression:"{ el: '#contents', offset: -150 }"}],staticClass:"badge"},[_vm._v("Contents Tabs")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#voucher', offset: -150 }),expression:"{ el: '#voucher', offset: -150 }"}],staticClass:"badge"},[_vm._v("E-Voucher")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#cover', offset: -150 }),expression:"{ el: '#cover', offset: -150 }"}],staticClass:"badge"},[_vm._v("Cover")]),_vm._v(" "),_c('span',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({ el: '#gallery', offset: -150 }),expression:"{ el: '#gallery', offset: -150 }"}],staticClass:"badge"},[_vm._v("Gallery")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageTabs_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424d6087_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageTabs_vue__ = __webpack_require__(625);
function injectStyle (ssrContext) {
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-424d6087"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_424d6087_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-wrapper"},[_c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},_vm._l((_vm.tabs),function(tab,index){return _c('li',{key:index,class:[tab.tabClass, { 'active': tab.isActive }],attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":tab.href},on:{"click":function($event){$event.preventDefault();return _vm.selectTab(tab)}}},[(tab.name === 'English')?_c('img',{staticClass:"flag",attrs:{"src":"/static/img/flag-en.png"}}):_vm._e(),_vm._v(" "),(tab.name === 'Indonesia')?_c('img',{staticClass:"flag",attrs:{"src":"/static/img/flag-id.png"}}):_vm._e(),_vm._v("\n        "+_vm._s(tab.name)+"\n      ")])])}),0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageTab_vue__ = __webpack_require__(314);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5524e778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageTab_vue__ = __webpack_require__(627);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5524e778_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],attrs:{"data-name":_vm.name}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalTags_vue__ = __webpack_require__(315);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388b7166_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalTags_vue__ = __webpack_require__(629);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_388b7166_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideDown"}},[(_vm.show)?_c('modal',{attrs:{"title":"Add Tags"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n              Name\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.tags.name),expression:"optionForm.tags.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.optionForm.tags.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.tags, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n              Slug\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.tags.slug),expression:"optionForm.tags.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.optionForm.tags.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.tags, "slug", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.emit('add')}}},[_vm._v("\n            Add\n          ")])])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMoods_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa2ca20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMoods_vue__ = __webpack_require__(631);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMoods_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fa2ca20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMoods_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideDown"}},[_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show)?_c('modal',{attrs:{"title":"Add Moods"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.moods.name),expression:"optionForm.moods.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.optionForm.moods.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.moods, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                Slug\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.moods.slug),expression:"optionForm.moods.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.optionForm.moods.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.moods, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                Image\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('FileGallery',{attrs:{"type":"moods","inline":true,"selected":_vm.optionForm.moods.image},on:{"update-images":_vm.setImage}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.addOption('moods')}}},[_vm._v("\n              Add\n            ")])])])])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCategories_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec0731dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCategories_vue__ = __webpack_require__(633);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec0731dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideDown"}},[(_vm.show)?_c('modal',{attrs:{"title":"Add Category"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n              Name\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.categories.name),expression:"optionForm.categories.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.optionForm.categories.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.categories, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name_en"}},[_vm._v("\n              Name En\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.categories.name_en),expression:"optionForm.categories.name_en"}],staticClass:"form-control",attrs:{"type":"text","id":"name_en","placeholder":"Name English"},domProps:{"value":(_vm.optionForm.categories.name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.categories, "name_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n              Slug\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.categories.slug),expression:"optionForm.categories.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.optionForm.categories.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.categories, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n              Image\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('FileGallery',{attrs:{"type":"category","inline":true,"selected":_vm.optionForm.categories.image},on:{"update-images":_vm.setImage}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('add')}}},[_vm._v("\n            Add\n          ")])])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDestinations_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfd3063e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDestinations_vue__ = __webpack_require__(635);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalDestinations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfd3063e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalDestinations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideDown"}},[(_vm.show)?_c('modal',{attrs:{"title":"Add Destinations"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n              Name\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.destinations.name),expression:"optionForm.destinations.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.optionForm.destinations.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.destinations, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n              Slug\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.optionForm.destinations.slug),expression:"optionForm.destinations.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.optionForm.destinations.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.optionForm.destinations, "slug", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n              Parent\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10",staticStyle:{"z-index":"9999"}},[_c('treeselect',{ref:"destinationAddOption",attrs:{"placeholder":"Select parent","value-format":"object","id":"optionForm","multiple":false,"options":_vm.list.destinations,"load-options":_vm.loadOptions,"auto-load-root-options":false},model:{value:(_vm.optionForm.destinations.parent),callback:function ($$v) {_vm.$set(_vm.optionForm.destinations, "parent", $$v)},expression:"optionForm.destinations.parent"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"image"}},[_vm._v("\n              Image\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('FileGallery',{attrs:{"type":"destinations","inline":true,"selected":_vm.optionForm.destinations.image},on:{"update-images":_vm.setImage}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('add')}}},[_vm._v("\n            Add\n          ")])])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper",attrs:{"id":"top"}},[_c('ContentHeader',{attrs:{"title":_vm.title,"is-create":_vm.isCreate,"breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('section',{staticClass:"content"},[(_vm.isLoading)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"jumbotron"},[_c('ProgressLoader')],1)])]):_c('form',{staticClass:"form",attrs:{"id":"product_id"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-md-9 col-lg-9",attrs:{"id":"main-content"}},[_c('affix',{staticClass:"quickjump-menu",staticStyle:{"width":"800px"},attrs:{"relative-element-selector":"#main-content","offset":{ top: 0, bottom: 10 }}},[_c('Quickjump',{attrs:{"show-klook":_vm.isKlook}}),_vm._v(" "),_c('div',{staticClass:"flaging-title"},[_vm._v("\n              Product "+_vm._s(_vm.capitalizeFirstLetter(_vm.params.flaging))+"\n            ")])],1),_vm._v(" "),(_vm.status_product === 'Need Approval')?_c('div',{staticClass:"alert need-approval"},[_c('strong',{staticClass:"alert-title"},[_vm._v("Status "+_vm._s(_vm.status_product))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Please check data below and respond the product")])]):_vm._e(),_vm._v(" "),(_vm.status_product === 'Need Revision')?_c('div',{staticClass:"alert need-revision"},[_c('strong',{staticClass:"alert-title"},[_vm._v("Status "+_vm._s(_vm.status_product))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Waiting merchant partners to update the product")])]):_vm._e(),_vm._v(" "),(_vm.status_product === 'Approved')?_c('div',{staticClass:"alert approved"},[_c('strong',{staticClass:"alert-title"},[_vm._v("Status "+_vm._s(_vm.status_product))]),_vm._v(" "),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_c('box',{attrs:{"id":"title","title":"Title"}},[_c('tabs',[_c('tab',{attrs:{"name":"Indonesia","selected":true}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control input-lg strong",attrs:{"type":"text","id":"name","placeholder":"Product title Indonesia"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('tab',{attrs:{"name":"English"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name_en),expression:"form.name_en"}],staticClass:"form-control input-lg strong",attrs:{"type":"text","id":"name_en","placeholder":"Product title English"},domProps:{"value":(_vm.form.name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name_en", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('box',{attrs:{"id":"details","title":"Details"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"type"}},[_vm._v("\n                  Region "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"category","placeholder":"Select region category","clearable":false,"options":_vm.list.region},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"destination"}},[_vm._v("\n                  Destinations "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('treeselect',{ref:"destinationOption",class:{ disabled: _vm.vselect_disabled },attrs:{"placeholder":"Select destinations","id":"form","value-consists-of":'ALL_WITH_INDETERMINATE',"sort-value-by":'LEVEL',"multiple":true,"options":_vm.list.destinations,"default-expand-level":1,"disable-branch-nodes":true,"auto-load-root-options":true},model:{value:(_vm.form.destinations),callback:function ($$v) {_vm.$set(_vm.form, "destinations", $$v)},expression:"form.destinations"}}),_vm._v(" "),_c('p',{staticClass:"small help-block m-0"},[_vm._v("You can only choose one city as destinations. Province and Country. Province and Country will be automatically selected according to the selected city.")])],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.showModal('destinations')}}},[_vm._v("\n                    Add Option\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"category"}},[_vm._v("\n                  Categories "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"multiple":"","name":"category","placeholder":"Select product category","options":_vm.list.categories},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.showModal('categories')}}},[_vm._v("\n                    Add Option\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tag"}},[_vm._v("\n                  Tags "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"multiple":"","name":"tags","placeholder":"Select tags","options":_vm.list.tags},model:{value:(_vm.form.tags),callback:function ($$v) {_vm.$set(_vm.form, "tags", $$v)},expression:"form.tags"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"type"}},[_vm._v("\n                  Condition "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"condition","placeholder":"Select basic condition","clearable":false,"options":_vm.list.condition},model:{value:(_vm.form.condition),callback:function ($$v) {_vm.$set(_vm.form, "condition", $$v)},expression:"form.condition"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"printed"}},[_vm._v("\n                  Printed\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.print_voucher),expression:"form.print_voucher"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.print_voucher)?_vm._i(_vm.form.print_voucher,null)>-1:(_vm.form.print_voucher)},on:{"change":function($event){var $$a=_vm.form.print_voucher,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "print_voucher", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "print_voucher", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "print_voucher", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Print Voucher/Ticket")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Ticket/Voucher will not be printed if unchecked.")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"type"}},[_vm._v("\n                  Breadcrumbs\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.hide_breadcrumbs),expression:"form.hide_breadcrumbs"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.hide_breadcrumbs)?_vm._i(_vm.form.hide_breadcrumbs,null)>-1:(_vm.form.hide_breadcrumbs)},on:{"change":function($event){var $$a=_vm.form.hide_breadcrumbs,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "hide_breadcrumbs", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "hide_breadcrumbs", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "hide_breadcrumbs", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Hide Breadcrumbs")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Hide from product detail page")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"type"}},[_vm._v("\n                  Searchbar\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.hide_searchbar),expression:"form.hide_searchbar"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.hide_searchbar)?_vm._i(_vm.form.hide_searchbar,null)>-1:(_vm.form.hide_searchbar)},on:{"change":function($event){var $$a=_vm.form.hide_searchbar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "hide_searchbar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "hide_searchbar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "hide_searchbar", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Hide Searchbar")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Hide from product detail page")])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"type"}},[_vm._v("\n                  Recommendation\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.hide_recommendation),expression:"form.hide_recommendation"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.hide_recommendation)?_vm._i(_vm.form.hide_recommendation,null)>-1:(_vm.form.hide_recommendation)},on:{"change":function($event){var $$a=_vm.form.hide_recommendation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "hide_recommendation", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "hide_recommendation", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "hide_recommendation", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Hide Recommendation")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Hide from product detail page")])])])])])])]),_vm._v(" "),_c('box',{attrs:{"id":"source","title":"Source"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"merchant"}},[_vm._v("\n                  Merchant "),(!_vm.isKlook)?_c('span',{staticClass:"req"},[_vm._v("*")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"merchant","placeholder":"Select product merchant","options":_vm.list.merchants},model:{value:(_vm.form.merchant),callback:function ($$v) {_vm.$set(_vm.form, "merchant", $$v)},expression:"form.merchant"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"vendor"}},[_vm._v("\n                  Source "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"vendor","placeholder":"Select product source","clearable":false,"options":_vm.list.vendors},model:{value:(_vm.form.vendor),callback:function ($$v) {_vm.$set(_vm.form, "vendor", $$v)},expression:"form.vendor"}})],1)]),_vm._v(" "),(_vm.isKlook)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"vendor"}},[_vm._v("\n                  Klook Code\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.product_code),expression:"form.product_code"}],staticClass:"form-control",attrs:{"type":"text","id":"product_code","placeholder":"Klook product code"},domProps:{"value":(_vm.form.product_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "product_code", $event.target.value)}}})])]):_vm._e()])]),_vm._v(" "),(_vm.params.flaging === 'explore')?_c('box',{attrs:{"id":"booking","title":"Booking"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"criteria"}},[_vm._v("\n                  Booking Options\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.has_criteria),expression:"form.has_criteria"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.has_criteria)?_vm._i(_vm.form.has_criteria,null)>-1:(_vm.form.has_criteria)},on:{"click":function($event){return _vm.resetField('open date')},"change":function($event){var $$a=_vm.form.has_criteria,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "has_criteria", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "has_criteria", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "has_criteria", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Open date")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Limit ticket validity by date range. Booking Date will be overriden.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.has_booking_duration),expression:"form.has_booking_duration"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.has_booking_duration)?_vm._i(_vm.form.has_booking_duration,null)>-1:(_vm.form.has_booking_duration)},on:{"click":function($event){return _vm.resetField('booking duration')},"change":function($event){var $$a=_vm.form.has_booking_duration,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "has_booking_duration", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "has_booking_duration", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "has_booking_duration", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Booking duration")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Define minimum days tickets can be booked before travel date.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.has_travel_duration),expression:"form.has_travel_duration"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.has_travel_duration)?_vm._i(_vm.form.has_travel_duration,null)>-1:(_vm.form.has_travel_duration)},on:{"click":function($event){return _vm.resetField('travel duration')},"change":function($event){var $$a=_vm.form.has_travel_duration,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "has_travel_duration", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "has_travel_duration", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "has_travel_duration", $$c)}}}}),_vm._v(" "),_c('strong',[_vm._v("Travel duration")]),_vm._v(" "),_c('p',{staticClass:"small help-block"},[_vm._v("Define ticket validity duration based on issued booking date.")])])])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.form.has_criteria)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"criteria"}},[_vm._v("\n                  Booking Criteria "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.configs.datepicker.disabled,"format":"dd MMMM yyyy","placeholder":"Min. date","input-class":"form-control position-static","name":"min-booking-date"},model:{value:(_vm.form.valid_from),callback:function ($$v) {_vm.$set(_vm.form, "valid_from", $$v)},expression:"form.valid_from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('valid_to'),"format":"dd MMMM yyyy","placeholder":"Max. date","input-class":"form-control position-static","name":"max-booking-date"},model:{value:(_vm.form.valid_to),callback:function ($$v) {_vm.$set(_vm.form, "valid_to", $$v)},expression:"form.valid_to"}})],1)])])])])])]):_vm._e(),_vm._v(" "),(_vm.form.has_booking_duration)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"minimum_days"}},[_vm._v("\n                  Booking Duration\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking_duration),expression:"form.booking_duration"}],staticClass:"form-control position-static",attrs:{"type":"number","id":"booking_duration","placeholder":"Booking duration","min":"0","max":"31"},domProps:{"value":(_vm.form.booking_duration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "booking_duration", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm._f("pluralDays")(_vm.form.booking_duration)))])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.form.has_travel_duration)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"minimum_days"}},[_vm._v("\n                  Travel Duration\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("Amount")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.travel_duration),expression:"form.travel_duration"}],staticClass:"form-control",attrs:{"type":"number","id":"travel_duration","placeholder":"Travel duration","min":"0"},domProps:{"value":(_vm.form.travel_duration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "travel_duration", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"travel_duration_unit","placeholder":"Duration unit","options":_vm.list.travel_duration_unit},model:{value:(_vm.form.travel_duration_unit),callback:function ($$v) {_vm.$set(_vm.form, "travel_duration_unit", $$v)},expression:"form.travel_duration_unit"}})],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"booking-date"}},[_vm._v("\n                  Booking Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((_vm.form.booking.bookingDate),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('bookingDate', index, null, 'from'),"open-date":_vm.openDateFromMinDate('bookingDate', index, null, 'from'),"format":"dd MMMM yyyy","placeholder":"Min. booking date","input-class":"form-control position-static","name":"min-booking-date"},model:{value:(_vm.form.booking.bookingDate[index].from),callback:function ($$v) {_vm.$set(_vm.form.booking.bookingDate[index], "from", $$v)},expression:"form.booking.bookingDate[index].from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('bookingDate', index, null, 'to'),"open-date":_vm.openDateFromMinDate('bookingDate', index, null, 'to'),"format":"dd MMMM yyyy","placeholder":"Max. booking date","input-class":"form-control position-static","name":"max-booking-date"},model:{value:(_vm.form.booking.bookingDate[index].to),callback:function ($$v) {_vm.$set(_vm.form.booking.bookingDate[index], "to", $$v)},expression:"form.booking.bookingDate[index].to"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('booking')}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'booking', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])])}),0)],1)]),_vm._v(" "),(!_vm.isKlook)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"travel-date"}},[_vm._v("\n                  Travel Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((_vm.form.booking.travelDate),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('travelDate', index, null, 'from'),"open-date":_vm.openDateFromMinDate('travelDate', index, null, 'from'),"format":"dd MMMM yyyy","placeholder":"Min. travel date","input-class":"form-control position-static","name":"min-travel-date"},model:{value:(_vm.form.booking.travelDate[index].from),callback:function ($$v) {_vm.$set(_vm.form.booking.travelDate[index], "from", $$v)},expression:"form.booking.travelDate[index].from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('travelDate', index, null, 'to'),"open-date":_vm.openDateFromMinDate('travelDate', index, null, 'to'),"format":"dd MMMM yyyy","placeholder":"Max. travel date","input-class":"form-control position-static","name":"max-travel-date"},model:{value:(_vm.form.booking.travelDate[index].to),callback:function ($$v) {_vm.$set(_vm.form.booking.travelDate[index], "to", $$v)},expression:"form.booking.travelDate[index].to"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('travel')}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'travel', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])])}),0)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_time"}},[_vm._v("\n                  Start Time "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 time-width"},[_c('vue-timepicker',{staticClass:"v-timepicker",attrs:{"id":"start_time","hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.booking.start_time),callback:function ($$v) {_vm.$set(_vm.form.booking, "start_time", $$v)},expression:"form.booking.start_time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_time"}},[_vm._v("\n                  End Time "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 time-width"},[_c('vue-timepicker',{staticClass:"v-timepicker",attrs:{"id":"end_time","hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.booking.end_time),callback:function ($$v) {_vm.$set(_vm.form.booking, "end_time", $$v)},expression:"form.booking.end_time"}})],1)])])]):_vm._e(),_vm._v(" "),(_vm.params.flaging === 'tour')?_c('box',{attrs:{"id":"booking","title":"Booking"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"booking-options"}},[_vm._v("\n                  Booking Option\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking_tour.bookingOption),expression:"form.booking_tour.bookingOption"}],attrs:{"id":"booking-options","type":"radio","name":"booking-options","value":"0"},domProps:{"checked":_vm._q(_vm.form.booking_tour.bookingOption,"0")},on:{"change":function($event){return _vm.$set(_vm.form.booking_tour, "bookingOption", "0")}}}),_vm._v("\n                      Entrance\n                  ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking_tour.bookingOption),expression:"form.booking_tour.bookingOption"}],attrs:{"id":"booking-options","type":"radio","name":"booking-options","value":"1"},domProps:{"checked":_vm._q(_vm.form.booking_tour.bookingOption,"1")},on:{"change":function($event){return _vm.$set(_vm.form.booking_tour, "bookingOption", "1")}}}),_vm._v("\n                      Open Trip\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"minimum_days"}},[_vm._v("\n                  Booking Duration\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking_tour.bookingDuration),expression:"form.booking_tour.bookingDuration"}],staticClass:"form-control position-static",attrs:{"type":"number","id":"booking_duration","placeholder":"Booking duration","min":"0","max":"31"},domProps:{"value":(_vm.form.booking_tour.bookingDuration)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking_tour, "bookingDuration", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm._f("pluralDays")(_vm.form.booking_duration)))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"booking-date"}},[_vm._v("\n                  Booking Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((_vm.form.booking_tour.bookingDate),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('bookingDate', index, null, 'from'),"open-date":_vm.openDateFromMinDate('bookingDate', index, null, 'from'),"format":"dd MMMM yyyy","placeholder":"Min. booking date","input-class":"form-control position-static","name":"min-booking-date"},model:{value:(_vm.form.booking_tour.bookingDate[index].from),callback:function ($$v) {_vm.$set(_vm.form.booking_tour.bookingDate[index], "from", $$v)},expression:"form.booking_tour.bookingDate[index].from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('bookingDate', index, null, 'to'),"open-date":_vm.openDateFromMinDate('bookingDate', index, null, 'to'),"format":"dd MMMM yyyy","placeholder":"Max. booking date","input-class":"form-control position-static","name":"max-booking-date"},model:{value:(_vm.form.booking_tour.bookingDate[index].to),callback:function ($$v) {_vm.$set(_vm.form.booking_tour.bookingDate[index], "to", $$v)},expression:"form.booking_tour.bookingDate[index].to"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('booking')}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'booking', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])])}),0)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"travel-date"}},[_vm._v("\n                  Travel Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((_vm.form.booking_tour.travelDate),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('travelDate', index, null, 'from'),"open-date":_vm.openDateFromMinDate('travelDate', index, null, 'from'),"format":"dd MMMM yyyy","placeholder":"Min. travel date","input-class":"form-control position-static","name":"min-travel-date"},model:{value:(_vm.form.booking_tour.travelDate[index].from),callback:function ($$v) {_vm.$set(_vm.form.booking_tour.travelDate[index], "from", $$v)},expression:"form.booking_tour.travelDate[index].from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('travelDate', index, null, 'to'),"open-date":_vm.openDateFromMinDate('travelDate', index, null, 'to'),"format":"dd MMMM yyyy","placeholder":"Max. travel date","input-class":"form-control position-static","name":"max-travel-date"},model:{value:(_vm.form.booking_tour.travelDate[index].to),callback:function ($$v) {_vm.$set(_vm.form.booking_tour.travelDate[index], "to", $$v)},expression:"form.booking_tour.travelDate[index].to"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('travel')}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'travel', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])])}),0)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_time"}},[_vm._v("\n                  Start Time "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 time-width"},[_c('vue-timepicker',{staticClass:"v-timepicker",attrs:{"id":"start_time","hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.booking_tour.start_time),callback:function ($$v) {_vm.$set(_vm.form.booking_tour, "start_time", $$v)},expression:"form.booking_tour.start_time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_time"}},[_vm._v("\n                  End Time "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 time-width"},[_c('vue-timepicker',{staticClass:"v-timepicker",attrs:{"id":"end_time","hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.booking_tour.end_time),callback:function ($$v) {_vm.$set(_vm.form.booking_tour, "end_time", $$v)},expression:"form.booking_tour.end_time"}})],1)])])]):_vm._e(),_vm._v(" "),_c('box',{attrs:{"id":"packages","title":"Packages"}},[_c('div',{staticClass:"package-list"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((_vm.form.booking.packages),function(item,index){return _c('div',{key:index,staticClass:"panel panel-primary panel-package"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                      Package #"+_vm._s(index + 1)+" "+_vm._s(item.name)+"\n                      "),(index > 0)?_c('span',{staticClass:"label label-danger pull-right",class:{ disabled: _vm.vselect_disabled },on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'packages')}}},[_vm._v("\n                          Remove\n                      ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"item_type_name"}},[_vm._v("\n                          Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('tabs',[_c('tab',{attrs:{"name":"Indonesia","selected":true}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].name),expression:"form.booking.packages[index].name"}],staticClass:"form-control",attrs:{"type":"text","id":"item_type_name","placeholder":"Package title Indonesia"},domProps:{"value":(_vm.form.booking.packages[index].name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "name", $event.target.value)}}})]),_vm._v(" "),_c('tab',{attrs:{"name":"English"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].name_en),expression:"form.booking.packages[index].name_en"}],staticClass:"form-control",attrs:{"type":"text","id":"item_type_name_en","placeholder":"Package title english"},domProps:{"value":(_vm.form.booking.packages[index].name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "name_en", $event.target.value)}}})])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"item_type"}},[_vm._v("\n                          Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('tabs',[_c('tab',{attrs:{"name":"Indonesia","selected":true}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].description),expression:"form.booking.packages[index].description"}],staticClass:"form-control",attrs:{"type":"text","id":"description","placeholder":"Package description Indonesia"},domProps:{"value":(_vm.form.booking.packages[index].description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "description", $event.target.value)}}})]),_vm._v(" "),_c('tab',{attrs:{"name":"English"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].description_en),expression:"form.booking.packages[index].description_en"}],staticClass:"form-control",attrs:{"type":"text","id":"description_en","placeholder":"Package description English"},domProps:{"value":(_vm.form.booking.packages[index].description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "description_en", $event.target.value)}}})])],1)],1)]),_vm._v(" "),(_vm.isKlook)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"sku_id"}},[_vm._v("\n                          SKU ID "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].sku_id),expression:"form.booking.packages[index].sku_id"}],staticClass:"form-control",attrs:{"type":"text","id":"sku_id","placeholder":"Klook SKU ID"},domProps:{"value":(_vm.form.booking.packages[index].sku_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "sku_id", $event.target.value)}}}),_vm._v(" "),(_vm.form.booking.packages[index].sku_title)?_c('p',{staticClass:"help-block"},[_c('i',{staticClass:"fa fa-fw fa-check-circle-o text-success"}),_vm._v("\n                            "+_vm._s(_vm.form.booking.packages[index].sku_title)+"\n                          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.fetchKlookPrice(_vm.form.booking.packages[index].sku_id, index)}}},[(!_vm.klookLoading)?_c('span',[_vm._v("Fetch")]):_c('i',{staticClass:"fa fa-fw fa-spinner fa-spin"})])])]):_vm._e(),_vm._v(" "),(_vm.isKlook)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"travel-date"}},[_vm._v("\n                          Travel Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((_vm.form.booking.packages[index].travel_date),function(itemTravel,indexTravel){return _c('div',{key:("travel-date-" + indexTravel),staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("From")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('klook', indexTravel, index, 'from'),"format":"dd MMMM yyyy","placeholder":"Min. travel date","input-class":"form-control position-static","name":"min-travel-date"},model:{value:(_vm.form.booking.packages[index].travel_date[indexTravel].from),callback:function ($$v) {_vm.$set(_vm.form.booking.packages[index].travel_date[indexTravel], "from", $$v)},expression:"form.booking.packages[index].travel_date[indexTravel].from"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("To")]),_vm._v(" "),_c('datepicker',{attrs:{"disabled":_vm.generateDisabledDate('klook', indexTravel, index, 'to'),"format":"dd MMMM yyyy","placeholder":"Max. travel date","input-class":"form-control position-static","name":"max-travel-date"},model:{value:(_vm.form.booking.packages[index].travel_date[indexTravel].to),callback:function ($$v) {_vm.$set(_vm.form.booking.packages[index].travel_date[indexTravel], "to", $$v)},expression:"form.booking.packages[index].travel_date[indexTravel].to"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('klook-travel', index)}}},[_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),(indexTravel > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'klook-travel', indexTravel)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])])}),0)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"multiplier"}},[_vm._v("\n                          Multiplier "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].multiply),expression:"form.booking.packages[index].multiply"}],staticClass:"form-control",attrs:{"type":"text","id":"multiplier","placeholder":"Quantity multiplier"},domProps:{"value":(_vm.form.booking.packages[index].multiply)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "multiply", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":("ageMax-" + index)}},[_vm._v("\n                          Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"type","placeholder":"Select age type","options":_vm.list.type},model:{value:(_vm.form.booking.packages[index].type),callback:function ($$v) {_vm.$set(_vm.form.booking.packages[index], "type", $$v)},expression:"form.booking.packages[index].type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"minimum_person"}},[_vm._v("\n                          Person "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("Min")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].min_person),expression:"form.booking.packages[index].min_person"}],staticClass:"form-control form-shrink position-static",attrs:{"type":"number","id":"min_person","placeholder":"Minimum person(s)"},domProps:{"value":(_vm.form.booking.packages[index].min_person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "min_person", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"form-inline"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("Max")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].max_person),expression:"form.booking.packages[index].max_person"}],staticClass:"form-control position-static",attrs:{"type":"number","id":"max_person","placeholder":"Maximum person(s)"},domProps:{"value":(_vm.form.booking.packages[index].max_person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index], "max_person", $event.target.value)}}})])])])])])])]),_vm._v(" "),(!_vm.isKlook)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"ticket"}},[_vm._v("\n                          Inventory "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{class:{ disabled: _vm.vselect_disabled },attrs:{"name":"ticket","placeholder":"Select ticket inventory","options":_vm.list.tickets},model:{value:(_vm.form.booking.packages[index].ticket),callback:function ($$v) {_vm.$set(_vm.form.booking.packages[index], "ticket", $$v)},expression:"form.booking.packages[index].ticket"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"prices"}},[_vm._v("\n                          Prices "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('transition-group',{attrs:{"name":"slideDown"}},_vm._l((item.prices),function(price,priceIndex){return _c('div',{key:priceIndex,staticClass:"panel panel-info"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                                  Price #"+_vm._s(priceIndex + 1)+"\n\n                                  "),(_vm.publishRate(index, priceIndex))?_c('span',{staticClass:"label label-success ml-2"},[_vm._v("\n                                    "+_vm._s(_vm.publishRate(index, priceIndex))+"\n                                  ")]):_vm._e(),_vm._v(" "),(priceIndex > 0)?_c('span',{staticClass:"label label-danger ml-2",class:{ disabled: _vm.vselect_disabled },on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'price', priceIndex)}}},[_vm._v("\n                                      Remove\n                                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label label-info pull-right",on:{"click":function($event){$event.preventDefault();return _vm.fetchKlookPrice(_vm.form.booking.packages[index].sku_id, index)}}},[(!_vm.klookLoading)?_c('span',[_vm._v("Update Price")]):[_c('i',{staticClass:"fa fa-fw fa-spinner fa-spin"}),_vm._v(" loading..\n                                    ")]],2)])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",class:{ 'col-md-6': _vm.isKlook, }},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"item_min"}},[_vm._v("Min Qty")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].min_qty),expression:"form.booking.packages[index].prices[priceIndex].min_qty"}],staticClass:"form-control form-shrink",attrs:{"type":"number","placeholder":"E.g.: 5","id":"item_min","min":"0"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].min_qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "min_qty", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"base_cost"}},[_vm._v("\n                                        Nett "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].base_cost),expression:"form.booking.packages[index].prices[priceIndex].base_cost"}],staticClass:"form-control form-shrink",attrs:{"type":"number","id":"base_cost","placeholder":"0.00","min":"0","readonly":_vm.isKlook},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].base_cost)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "base_cost", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"block_cost"}},[_vm._v("\n                                        Commission "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"input-group select-group group-width"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].block_cost.type),expression:"form.booking.packages[index].prices[priceIndex].block_cost.type"}],staticClass:"form-control input-group-addon select-width",attrs:{"id":"block_cost_type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.booking.packages[index].prices[priceIndex].block_cost, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":0}},[_vm._v("Percentage")]),_vm._v(" "),_c('option',{domProps:{"value":1}},[_vm._v("Amount")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].block_cost.value),expression:"form.booking.packages[index].prices[priceIndex].block_cost.value"}],staticClass:"form-control input-width",attrs:{"type":"number","id":"block_cost","placeholder":"0.00","min":"0"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].block_cost.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex].block_cost, "value", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"item_type_name"}},[_vm._v("\n                                        Price per\n                                      ")]),_vm._v(" "),_c('tabs',[_c('tab',{attrs:{"name":"Indonesia","selected":true}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].price_per_type),expression:"form.booking.packages[index].prices[priceIndex].price_per_type"}],staticClass:"form-control",attrs:{"type":"text","id":"item_type_name","placeholder":"Unit teks. Contoh: IDR 344.000/kamar atau IDR 344.000/paket"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].price_per_type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "price_per_type", $event.target.value)}}})]),_vm._v(" "),_c('tab',{attrs:{"name":"English"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].price_per_type_en),expression:"form.booking.packages[index].prices[priceIndex].price_per_type_en"}],staticClass:"form-control",attrs:{"type":"text","id":"item_type_name_en","placeholder":"Unit text. Example: IDR 344.000/room atau IDR 344.000/package"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].price_per_type_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "price_per_type_en", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"gimmick_price"}},[_vm._v("Display Price")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].gimmick_price),expression:"form.booking.packages[index].prices[priceIndex].gimmick_price"}],staticClass:"form-control form-shrink",attrs:{"type":"number","placeholder":"E.g.: 2000000","id":"gimmick_price","min":"0"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].gimmick_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "gimmick_price", $event.target.value)}}})])]),_vm._v(" "),(_vm.isKlook)?_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"currency"}},[_vm._v("\n                                        Currency "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].currency),expression:"form.booking.packages[index].prices[priceIndex].currency"}],staticClass:"form-control",attrs:{"type":"text","id":"currency","placeholder":"IDR, SGD, USD, GBP","min":"0"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].currency)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "currency", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"source_price"}},[_vm._v("\n                                        Source Price "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].source_price),expression:"form.booking.packages[index].prices[priceIndex].source_price"}],staticClass:"form-control",attrs:{"type":"number","id":"source_price","placeholder":"0.00","min":"0","readonly":"readonly"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].source_price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "source_price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exchange_rate"}},[_vm._v("\n                                        Exchange Rate "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].exchange_rate),expression:"form.booking.packages[index].prices[priceIndex].exchange_rate"}],staticClass:"form-control",attrs:{"type":"number","id":"exchange_rate","placeholder":"0.00","min":"0","readonly":"readonly"},domProps:{"value":(_vm.form.booking.packages[index].prices[priceIndex].exchange_rate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "exchange_rate", $event.target.value)}}})])]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.booking.packages[index].prices[priceIndex].hasOwnProperty('start_from')),expression:"form.booking.packages[index].prices[priceIndex].hasOwnProperty('start_from')"}],staticClass:"panel-footer"},[_c('label',{attrs:{"for":"start_from"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.booking.packages[index].prices[priceIndex].start_from),expression:"form.booking.packages[index].prices[priceIndex].start_from"}],staticClass:"form-check",attrs:{"id":"start_from","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.booking.packages[index].prices[priceIndex].start_from)?_vm._i(_vm.form.booking.packages[index].prices[priceIndex].start_from,null)>-1:(_vm.form.booking.packages[index].prices[priceIndex].start_from)},on:{"change":[function($event){var $$a=_vm.form.booking.packages[index].prices[priceIndex].start_from,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "start_from", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "start_from", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form.booking.packages[index].prices[priceIndex], "start_from", $$c)}},function($event){return _vm.setPriceStartFrom(index, priceIndex)}]}}),_vm._v(" Start from\n                                ")])])])}),0),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-info btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.addItem('price', index)}}},[_vm._v("\n                            Add Price\n                          ")])],1)])])])])}),0)],1),_vm._v(" "),_c('button',{staticClass:"btn btn-block btn-info btn-sm",on:{"click":function($event){$event.preventDefault();return _vm.addItem('package')}}},[_vm._v("\n              Add more package\n            ")])]),_vm._v(" "),_c('box',{attrs:{"id":"sequence","title":"Sequence and Badge"}},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"sequence"}},[_vm._v("\n                  Sequence "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.sequence),expression:"form.sequence"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"E.g.: 2","id":"sequence"},domProps:{"value":(_vm.form.sequence)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "sequence", $event.target.value)}}})])]),_vm._v(" "),(!_vm.isCreate)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"badge"}},[_vm._v("\n                  Badges\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"badges","placeholder":"No Active Badges","clearable":false,"disabled":""},model:{value:(_vm.form.badges),callback:function ($$v) {_vm.$set(_vm.form, "badges", $$v)},expression:"form.badges"}}),_vm._v(" "),_c('span',[_vm._v("\n                    The active Badges depend on the badges setup. Only eligible Badges will appear in this section\n                  ")])],1)]):_vm._e()])]),_vm._v(" "),_c('box',{attrs:{"id":"contents","title":"Content Tabs"}},_vm._l((_vm.form.tabs),function(tab,index){return _c('div',{key:index,staticClass:"panel panel-info"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                  Tab #"+_vm._s(index + 1)+": "+_vm._s(tab.title)+" "),(tab.title_en)?_c('span',[_vm._v("/ "+_vm._s(tab.title_en))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('tabs',[_c('tab',{attrs:{"name":"Indonesia","selected":true}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tabs[index].title),expression:"form.tabs[index].title"}],staticClass:"form-control",attrs:{"type":"text","id":("tab-name-" + index),"name":("tab-name-" + index),"placeholder":"Tab Title Indonesia","disabled":""},domProps:{"value":(_vm.form.tabs[index].title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.tabs[index], "title", $event.target.value)}}}),_vm._v(" "),_c('ckeditor',{ref:"richTextEditor",refInFor:true,attrs:{"placeholder":"Tab content Indonesia","config":_vm.configs.ckeditor,"id":("tab-description-" + index),"name":("tab-description-" + index)},model:{value:(_vm.form.tabs[index].description),callback:function ($$v) {_vm.$set(_vm.form.tabs[index], "description", $$v)},expression:"form.tabs[index].description"}})],1),_vm._v(" "),_c('tab',{attrs:{"name":"English"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tabs[index].title_en),expression:"form.tabs[index].title_en"}],staticClass:"form-control",attrs:{"type":"text","id":("tab-name-en-" + index),"name":("tab-name-en-" + index),"placeholder":"Tab Title English","disabled":""},domProps:{"value":(_vm.form.tabs[index].title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.tabs[index], "title_en", $event.target.value)}}}),_vm._v(" "),_c('ckeditor',{ref:"richTextEditor",refInFor:true,attrs:{"placeholder":"Tab content English","config":_vm.configs.ckeditor,"id":("tab-description-en-" + index),"name":("tab-description-en-" + index)},model:{value:(_vm.form.tabs[index].description_en),callback:function ($$v) {_vm.$set(_vm.form.tabs[index], "description_en", $$v)},expression:"form.tabs[index].description_en"}})],1)],1)],1)])}),0),_vm._v(" "),_c('box',{attrs:{"id":"voucher","title":"Content on E-Voucher"}},_vm._l((_vm.form.vouchers),function(vouchers,index){return _c('div',{key:index,staticClass:"panel panel-info"},[_c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n                  Group #"+_vm._s(index + 1)+": "+_vm._s(vouchers.title)+" "),(vouchers.title_en)?_c('span',[_vm._v("/ "+_vm._s(vouchers.title_en))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('tabs',[_c('tab',{attrs:{"name":"Indonesia","selected":true}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.vouchers[index].title),expression:"form.vouchers[index].title"}],staticClass:"form-control",attrs:{"type":"text","id":("voucher-name-" + index),"name":("voucher-name-" + index),"placeholder":"Tab Title Indonesia","disabled":""},domProps:{"value":(_vm.form.vouchers[index].title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.vouchers[index], "title", $event.target.value)}}}),_vm._v(" "),_c('ckeditor',{ref:"richTextEditor",refInFor:true,attrs:{"placeholder":"Tab content Indonesia","config":_vm.configs.ckeditor,"id":("voucher-description-" + index),"name":("voucher-description-" + index)},model:{value:(_vm.form.vouchers[index].description),callback:function ($$v) {_vm.$set(_vm.form.vouchers[index], "description", $$v)},expression:"form.vouchers[index].description"}})],1),_vm._v(" "),_c('tab',{attrs:{"name":"English"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.vouchers[index].title_en),expression:"form.vouchers[index].title_en"}],staticClass:"form-control",attrs:{"type":"text","id":("voucher-name-en-" + index),"name":("voucher-name-en-" + index),"placeholder":"Tab Title English","disabled":""},domProps:{"value":(_vm.form.vouchers[index].title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.vouchers[index], "title_en", $event.target.value)}}}),_vm._v(" "),_c('ckeditor',{ref:"richTextEditor",refInFor:true,attrs:{"placeholder":"Tab content English","config":_vm.configs.ckeditor,"id":("voucher-description-en-" + index),"name":("voucher-description-en-" + index)},model:{value:(_vm.form.vouchers[index].description_en),callback:function ($$v) {_vm.$set(_vm.form.vouchers[index], "description_en", $$v)},expression:"form.vouchers[index].description_en"}})],1)],1)],1)])}),0)],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3 col-lg-3"},[_c('affix',{staticClass:"sidebar-menu",staticStyle:{"width":"240px"},attrs:{"relative-element-selector":"#main-content","offset":{ top: 20, bottom: 20 }}},[_c('box',{attrs:{"id":"publish","title":"Publish","border":true,"action":false}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"published"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.is_publish),expression:"form.is_publish"}],staticClass:"form-check",attrs:{"id":"published","name":"published","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.is_publish)?_vm._i(_vm.form.is_publish,null)>-1:(_vm.form.is_publish)},on:{"change":function($event){var $$a=_vm.form.is_publish,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "is_publish", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "is_publish", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "is_publish", $$c)}}}}),_vm._v(" Published\n                ")])]),_vm._v(" "),(_vm.isCreate)?_c('div',[_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.isSubmitting}},[(_vm.isSubmitting)?_c('span',[_c('i',{staticClass:"fa fa-cog fa-spin fa-fw"}),_vm._v(" Saving")]):_c('span',[_vm._v("Create")])])]):_c('div',[(_vm.status_product === 'Need Approval')?_c('div',[_c('button',{staticClass:"btn approved btn-block color-white",attrs:{"type":"button","disabled":_vm.isSubmitting},on:{"click":function($event){$event.preventDefault();return _vm.submit('approved')}}},[(_vm.isSubmitting)?_c('strong',[_c('i',{staticClass:"fa fa-cog fa-spin fa-fw color-red"}),_vm._v(" Saving")]):_c('strong',[_vm._v("Approved")])]),_vm._v(" "),_c('button',{staticClass:"btn need-revision btn-block color-white",attrs:{"type":"button","disabled":_vm.isSubmitting},on:{"click":function($event){$event.preventDefault();return _vm.submit('revision')}}},[(_vm.isSubmitting)?_c('strong',[_c('i',{staticClass:"fa fa-cog fa-spin fa-fw"}),_vm._v(" Saving")]):_c('strong',[_vm._v("Need Revision")])])]):(_vm.status_product === 'Need Revision')?_c('div',[_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":""}},[_c('strong',[_vm._v("Update")])])]):_c('div',[_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.isSubmitting}},[(_vm.isSubmitting)?_c('strong',[_c('i',{staticClass:"fa fa-cog fa-spin fa-fw"}),_vm._v(" Saving")]):_c('strong',[_vm._v("Update")])])])]),_vm._v(" "),_c('a',{staticClass:"btn btn-link",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.isCreate)?_c('a',{staticClass:"btn btn-link",staticStyle:{"float":"right"},attrs:{"href":_vm.generatePreview(_vm.form.slug, _vm.form.id),"target":"_blank"}},[_vm._v("Preview")]):_vm._e()]),_vm._v(" "),_c('box',{attrs:{"id":"cover","title":"Cover Thumbnail Web"}},[(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Product Image Web","src":_vm.getSize(_vm.form.image.url, 'thumb')}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.showModal('featured')}}},[_vm._v("\n                Select Image\n              ")])]),_vm._v(" "),_c('box',{attrs:{"id":"cover","title":"Cover Thumbnail Apps"}},[(_vm.form.image_apps.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Product Image Apps","src":_vm.getSize(_vm.form.image_apps.url, 'thumb')}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.showModal('featured_apps')}}},[_vm._v("\n                Select Image\n              ")])]),_vm._v(" "),_c('box',{attrs:{"id":"gallery","title":"Media"}},[(_vm.form.gallery)?_c('div',{staticClass:"gallery-grid-container"},_vm._l((_vm.form.gallery),function(image,index){return _c('div',{key:index},[(_vm.isVideo(image.url))?_c('div',{staticStyle:{"position":"relative"}},[_c('img',{staticStyle:{"position":"absolute","z-index":"2","top":"35%","left":"40%"},attrs:{"src":__webpack_require__(637),"alt":"icon play"}}),_vm._v(" "),_c('video',[_c('source',{attrs:{"src":image.url,"type":"video/mp4"}})])]):_c('img',{staticClass:"img",attrs:{"src":_vm.getSize(image.url, 'thumb')}})])}),0):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                Select Media\n              ")])]),_vm._v(" "),_c('box',{attrs:{"id":"cover","title":"TICKET IMAGE"}},[(_vm.form.ticket_image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Ticket Image","src":_vm.getSize(_vm.form.ticket_image.url, 'thumb')}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.showModal('ticket_image')}}},[_vm._v("\n                Select Image\n              ")])]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("×")]),_vm._v("\n              "+_vm._s(_vm.error)+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('i',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#top'),expression:"'#top'"}],staticClass:"fa fa-3x fa-arrow-circle-up goto-arrow"})],1)])]),_vm._v(" "),_c('ModalCategories',{attrs:{"show":_vm.show.categories,"option-form":_vm.optionForm},on:{"update:optionForm":function($event){_vm.optionForm=$event},"update:option-form":function($event){_vm.optionForm=$event},"add":function($event){return _vm.addOption('categories')},"setImage":_vm.setImage}}),_vm._v(" "),_c('ModalDestinations',{attrs:{"show":_vm.show.destinations,"option-form":_vm.optionForm,"list":_vm.list},on:{"update:optionForm":function($event){_vm.optionForm=$event},"update:option-form":function($event){_vm.optionForm=$event},"update:list":function($event){_vm.list=$event},"add":function($event){return _vm.addOption('destination')},"setImage":_vm.setImage}}),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Choose Media for Gallery"}},[_c('FileGallery',{attrs:{"type":"gallery","allow-video":true,"is-multiple":true,"selected":_vm.form.gallery},on:{"update-images":_vm.setImage}})],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.featured)?_c('modal',{attrs:{"title":"Select Featured Image"}},[_c('FileGallery',{attrs:{"type":"featured","is-multiple":false,"selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.featured_apps)?_c('modal',{attrs:{"title":"Select Featured Apps Image"}},[_c('FileGallery',{attrs:{"type":"featured_apps","is-multiple":false,"selected":_vm.form.image_apps},on:{"update-images":_vm.setImage}})],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.ticket_image)?_c('modal',{attrs:{"title":"Select Ticket Image"}},[_c('FileGallery',{attrs:{"type":"ticket_image","is-multiple":false,"selected":_vm.form.ticket_image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTEyIDEuNUM2LjIwMTU2IDEuNSAxLjUgNi4yMDE1NiAxLjUgMTJDMS41IDE3Ljc5ODQgNi4yMDE1NiAyMi41IDEyIDIyLjVDMTcuNzk4NCAyMi41IDIyLjUgMTcuNzk4NCAyMi41IDEyQzIyLjUgNi4yMDE1NiAxNy43OTg0IDEuNSAxMiAxLjVaTTE1LjM3NzMgMTIuMTYxN0wxMC4yNTg2IDE1Ljg4NTlDMTAuMjMwNSAxNS45MDYxIDEwLjE5NzUgMTUuOTE4MSAxMC4xNjMgMTUuOTIwN0MxMC4xMjg1IDE1LjkyMzMgMTAuMDk0IDE1LjkxNjQgMTAuMDYzMyAxNS45MDA2QzEwLjAzMjUgMTUuODg0OSAxMC4wMDY3IDE1Ljg2MSA5Ljk4ODYzIDE1LjgzMTVDOS45NzA1NyAxNS44MDIgOS45NjA5OSAxNS43NjgxIDkuOTYwOTQgMTUuNzMzNlY4LjI4OTg0QzkuOTYwODIgOC4yNTUyMiA5Ljk3MDMgOC4yMjEyNCA5Ljk4ODMyIDguMTkxNjdDMTAuMDA2MyA4LjE2MjEgMTAuMDMyMiA4LjEzODEgMTAuMDYzIDguMTIyMzJDMTAuMDkzOCA4LjEwNjU0IDEwLjEyODQgOC4wOTk2MSAxMC4xNjI5IDguMTAyMjlDMTAuMTk3NSA4LjEwNDk3IDEwLjIzMDYgOC4xMTcxNiAxMC4yNTg2IDguMTM3NUwxNS4zNzczIDExLjg1OTRDMTUuNDAxNSAxMS44NzY1IDE1LjQyMTMgMTEuODk5MSAxNS40MzQ5IDExLjkyNTRDMTUuNDQ4NSAxMS45NTE3IDE1LjQ1NTYgMTEuOTgwOSAxNS40NTU2IDEyLjAxMDVDMTUuNDU1NiAxMi4wNDAyIDE1LjQ0ODUgMTIuMDY5NCAxNS40MzQ5IDEyLjA5NTdDMTUuNDIxMyAxMi4xMjIgMTUuNDAxNSAxMi4xNDQ2IDE1LjM3NzMgMTIuMTYxN1oiIGZpbGw9IiNGRUZFRkUiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7d6f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(650);
function injectStyle (ssrContext) {
  __webpack_require__(639)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d7d6f52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7d6f52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_vm._m(0),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"button-flagging"},[(_vm.params.flaging === 'explore')?_c('a',{staticClass:"btn active-flag disabled",class:!_vm.need_approve_explore ? 'margin-right' : '',attrs:{"disabled":""}},[_vm._v("\n        Explore Products\n      ")]):_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.changeFlag()}}},[_vm._v("\n        Explore Products\n      ")]),_vm._v(" "),(_vm.need_approve_explore)?_c('span',{staticClass:"badge notif-badge"},[_vm._v("!")]):_vm._e(),_vm._v(" "),(_vm.params.flaging === 'tour')?_c('a',{staticClass:"btn active-flag disabled",class:!_vm.need_approve_explore ? 'margin-left' : '',attrs:{"disabled":""}},[_vm._v("\n        Tour Products\n      ")]):_c('a',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.changeFlag()}}},[_vm._v("\n        Tour Products\n      ")]),_vm._v(" "),(_vm.need_approve_tour)?_c('span',{staticClass:"badge notif-badge"},[_vm._v("!")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"vendor"}},[_vm._v("\n                Source Product\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.vendor),expression:"params.vendor"}],staticClass:"form-control",attrs:{"id":"vendor"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "vendor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onSelect]}},[_c('option',{domProps:{"value":null}},[_vm._v("Select All")]),_vm._v(" "),_vm._l((_vm.list.vendors),function(data,index){return _c('option',{key:(index + "-" + (data.value)),domProps:{"value":data.value}},[_vm._v("\n                "+_vm._s(data.label)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("\n                Status Live\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",attrs:{"id":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onSelect]}},[_c('option',{domProps:{"value":null}},[_vm._v("All Status Live")]),_vm._v(" "),_c('option',{attrs:{"value":"publish"}},[_vm._v("Published")]),_vm._v(" "),_c('option',{attrs:{"value":"unpublish"}},[_vm._v("Unpublished")]),_vm._v(" "),_c('option',{attrs:{"value":"draft"}},[_vm._v("Draft")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status_product"}},[_vm._v("\n                Status Product\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status_product),expression:"params.status_product"}],staticClass:"form-control",attrs:{"id":"status_product"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status_product", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onSelect]}},[_c('option',{domProps:{"value":null}},[_vm._v("All Status Product")]),_vm._v(" "),_c('option',{attrs:{"value":"Need Approval"}},[_vm._v("Need Approval")]),_vm._v(" "),_c('option',{attrs:{"value":"Need Revision"}},[_vm._v("Need Revision")]),_vm._v(" "),_c('option',{attrs:{"value":"Approved"}},[_vm._v("Approved")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                Merchant\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.merchant_id),expression:"params.merchant_id"}],staticClass:"form-control",attrs:{"id":"merchant"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "merchant_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onSelect]}},[_c('option',{domProps:{"value":null}},[_vm._v("Select All")]),_vm._v(" "),_vm._l((_vm.list.merchants),function(data,index){return _c('option',{key:(index + "-" + (data.value)),domProps:{"value":data.value}},[_vm._v("\n                "+_vm._s(data.label)+"\n                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"category"}},[_vm._v("\n                Category\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.category),expression:"params.category"}],staticClass:"form-control",attrs:{"type":"text","id":"category","placeholder":"Search by categories here"},domProps:{"value":(_vm.params.category)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "category", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"destination"}},[_vm._v("\n                Destination\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.destination),expression:"params.destination"}],staticClass:"form-control",attrs:{"type":"text","id":"destination","placeholder":"Search by destination here"},domProps:{"value":(_vm.params.destination)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "destination", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"destination"}},[_vm._v("\n                Sequence\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.sequence),expression:"params.sequence"}],staticClass:"form-control",attrs:{"type":"number","id":"destination","placeholder":"Search by sequence here"},domProps:{"value":(_vm.params.sequence)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "sequence", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportCsv('normal')}}},[_vm._v("\n              Export CSV\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Products\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"24rem"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticClass:"table-sort",staticStyle:{"min-width":"5rem"}},[_c('label',[_vm._v("Sequence")]),_vm._v(" "),_c('img',{attrs:{"src":("/static/icons/icon-sort-" + (_vm.sort.status ? 'asc' : 'desc') + ".png"),"alt":"icon sort"},on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.sortList('sequence')}}})]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Source")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Merchant")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Category")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Destination")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Tags")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Start Date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("End Date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"18rem"}},[_vm._v("Price Range")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"11rem"}},[_vm._v("Status Product")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Status Live")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"18rem"}},[_vm._v("Created By")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"18rem"}},[_vm._v("Approved By")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"18rem"}},[_vm._v("Last Edit By")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"18rem"}},[_vm._v("Last Edit At")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Actions")])])]),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(3)]):(!_vm.isLoading && _vm.products.length < 1)?_c('tr',[_c('td',{attrs:{"colspan":"13"}},[_vm._v("\n                Result not found\n              ")])]):_vm._l((_vm.products),function(product){return _c('tr',{key:product.id},[_c('td',[_c('router-link',{attrs:{"to":Object.assign({}, _vm.redirectEdit, {params: { id: product.id }})}},[_vm._v("\n                  "+_vm._s(product.name)+"\n                ")])],1),_vm._v(" "),_c('td',[_c('span',[_vm._v("\n                  "+_vm._s(product.sequence)+"\n                ")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label label-default"},[_vm._v("\n                  "+_vm._s(product.vendor_name)+"\n                ")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label label-default"},[_vm._v("\n                  "+_vm._s(product.merchant.name)+"\n                ")])]),_vm._v(" "),_c('td',_vm._l((product.categories),function(item,index){return _c('div',{key:(index + "-" + (item.id) + "-" + (item.slug))},[_c('span',{staticClass:"label label-default"},[_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")])])}),0),_vm._v(" "),_c('td',_vm._l((product.destinations),function(item,index){return _c('div',{key:(index + "-" + (item.id) + "-" + (item.slug))},[_c('span',{staticClass:"label label-default"},[_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")])])}),0),_vm._v(" "),_c('td',[(product.can_be_canceled)?_c('span',{staticClass:"label label-default"},[_vm._v("Tidak dapat dibatalkan")]):_vm._e(),_vm._v(" "),(product.duration_1_day)?_c('span',{staticClass:"label label-default"},[_vm._v("Durasi: 1 hari")]):_vm._e(),_vm._v(" "),(product.duration_2_day)?_c('span',{staticClass:"label label-default"},[_vm._v("Durasi: 2 hari")]):_vm._e(),_vm._v(" "),(product.is_open_date)?_c('span',{staticClass:"label label-default"},[_vm._v("Open date ticket")]):_vm._e(),_vm._v(" "),(product.is_fixed_date)?_c('span',{staticClass:"label label-default"},[_vm._v("Fixed date ticket")]):_vm._e(),_vm._v(" "),(product.changed_voucher)?_c('span',{staticClass:"label label-default"},[_vm._v("Tukar voucher dengan tiket fisik")]):_vm._e(),_vm._v(" "),(product.print_voucher)?_c('span',{staticClass:"label label-default"},[_vm._v("Cetak voucher")]):_vm._e()]),_vm._v(" "),_c('td',[(_vm.checkBookingDateType(product.booking_date))?[_vm._v("\n                  "+_vm._s(_vm.parseTime(product.booking_date[0].from, 'DD MMMM YYYY'))+"\n                ")]:[_vm._v("\n                  "+_vm._s(_vm.parseBookingDate(product.booking_date, 'from'))+"\n                ")]],2),_vm._v(" "),_c('td',[(_vm.checkBookingDateType(product.booking_date))?[_vm._v("\n                  "+_vm._s(_vm.parseTime(product.booking_date[0].to, 'DD MMMM YYYY'))+"\n                ")]:[_vm._v("\n                  "+_vm._s(_vm.parseBookingDate(product.booking_date, 'to'))+"\n                ")]],2),_vm._v(" "),_c('td',[_vm._v("\n                IDR "+_vm._s(_vm.digitGrouping(product.lowest_price))+" - "+_vm._s(_vm.digitGrouping(product.highest_price))+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(product.status_product)+"\n              ")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(product.status)+"\n              ")]),_vm._v(" "),_c('td',[(product.created_by_email)?_c('span',[_vm._v(_vm._s(product.created_by_email))]):_c('span',[_vm._v(" - ")])]),_vm._v(" "),_c('td',[(product.approved.email)?_c('span',[_vm._v(_vm._s(product.approved.email))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(" - ")])]),_vm._v(" "),_c('td',[(product.updated_by_email)?_c('span',[_vm._v(_vm._s(product.updated_by_email))]):_c('span',[_vm._v(" - ")])]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.parseTime(product.updated_at, 'DD MMM YYYY | HH:mm'))+"\n              ")]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(product.id)}}},[_vm._v("\n                  Edit\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(product)}}},[_vm._v("\n                  Delete\n                ")])])])})],2)])]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modalError)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.modalError = !_vm.modalError}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.modalError = !_vm.modalError}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title",staticStyle:{"text-align":"center"}},[_vm._v("Please input Status Live before export the data")])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("You can choose Published, Unpublished or Draft in parameter Status Live")])])])])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Products\n      "),_c('small',[_vm._v("List of products")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',[_vm._v("Products")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Products")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"13"}},[_c('strong',[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(322);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24009c1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(652)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-24009c1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24009c1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('vue-tabs',{attrs:{"start-index":1,"active-tab-color":"#fda229","active-text-color":"#fff","direction":"horizontal"}},[_c('v-tab',{attrs:{"title":"Eksplorasi Terfavorit"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Eksplorasi Terfavorit")]),_vm._v(" "),(_vm.error.favorite)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.favorite = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.favorite)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                        Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDatefavorite,"clear-button":true},model:{value:(_vm.form.favorite.start_date),callback:function ($$v) {_vm.$set(_vm.form.favorite, "start_date", $$v)},expression:"form.favorite.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                        End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDatefavorite,"clear-button":true},model:{value:(_vm.form.favorite.end_date),callback:function ($$v) {_vm.$set(_vm.form.favorite, "end_date", $$v)},expression:"form.favorite.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Status "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.status),expression:"form.favorite.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.favorite, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-sequence-aktivitas"}},[_vm._v("\n                        Section Style "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleSection"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.sectionStyle),expression:"form.favorite.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleFavorite","value":"1"},domProps:{"checked":_vm._q(_vm.form.favorite.sectionStyle,"1")},on:{"change":function($event){return _vm.$set(_vm.form.favorite, "sectionStyle", "1")}}}),_vm._v("\n                                Section Style 1\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle1.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.sectionStyle),expression:"form.favorite.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleFavorite","value":"2"},domProps:{"checked":_vm._q(_vm.form.favorite.sectionStyle,"2")},on:{"change":function($event){return _vm.$set(_vm.form.favorite, "sectionStyle", "2")}}}),_vm._v("\n                                Section Style 2\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle2.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 3"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.sectionStyle),expression:"form.favorite.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleFavortie","value":"3"},domProps:{"checked":_vm._q(_vm.form.favorite.sectionStyle,"3")},on:{"change":function($event){return _vm.$set(_vm.form.favorite, "sectionStyle", "3")}}}),_vm._v("\n                                Section Style 3\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle3.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 4"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.sectionStyle),expression:"form.favorite.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleFavorite","value":"4"},domProps:{"checked":_vm._q(_vm.form.favorite.sectionStyle,"4")},on:{"change":function($event){return _vm.$set(_vm.form.favorite, "sectionStyle", "4")}}}),_vm._v("\n                                Section Style 4\n                                "),(_vm.form.favorite.item_type === 'item')?_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4.png","alt":"No image"}}):_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4-chips.png","alt":"No image"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.title),expression:"form.favorite.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Eksplorasi Terfavorit","maxlength":"30"},domProps:{"value":(_vm.form.favorite.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.favorite, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.title_en),expression:"form.favorite.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Eksplorasi Terfavorit","maxlength":"30"},domProps:{"value":(_vm.form.favorite.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.favorite, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.description),expression:"form.favorite.description"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Eksplorasi Terfavorit","maxlength":"90"},domProps:{"value":(_vm.form.favorite.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.favorite, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description En"),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.description_en),expression:"form.favorite.description_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Eksplorasi Terfavorit","maxlength":"90"},domProps:{"value":(_vm.form.favorite.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.favorite, "description_en", $event.target.value)}}})])]),_vm._v(" "),(_vm.form.favorite.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                        Image Campaign "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                          Choose File\n                        ")]),_vm._v(" "),_c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                            Allowed   extension only for PNG / JPG\n                          ")])]),_vm._v(" "),(_vm.form.favorite.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.favorite.image.url)}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})])]):_vm._e(),_vm._v(" "),(_vm.form.favorite.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Item Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.favorite.item_type),expression:"form.favorite.item_type"}],staticClass:"form-control",attrs:{"placeholder":"Select Item Type","id":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.favorite, "item_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changelist('favorite')}]}},[_c('option',{attrs:{"value":"item"}},[_vm._v("Per-Item")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v("Category")]),_vm._v(" "),_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic Destination")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International Destination")])])])]):_vm._e(),_vm._v(" "),(_vm.form.favorite.sectionStyle == 4)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"control-label col-md-2 form-horizontal",attrs:{"for":"favorite"}},[_vm._v("\n                        items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),(_vm.form.favorite.item_type === 'item')?_c('div',{staticClass:"col-md-10 styleSingleItems"},[_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select favorite highlights","options":_vm.lists.products},model:{value:(_vm.form.favorite.items),callback:function ($$v) {_vm.$set(_vm.form.favorite, "items", $$v)},expression:"form.favorite.items"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.favorite.item_type === 'category')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.favorite.category_items),function(itemCategory,index){return _c('div',{key:(index + " + favorite"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                                Category "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"name":"categories","placeholder":"Select favorite category","clearable":false,"options":_vm.lists.categories},on:{"input":function($event){return _vm.onSelectCategories(index, 'favorite')}},model:{value:(itemCategory.category_id),callback:function ($$v) {_vm.$set(itemCategory, "category_id", $$v)},expression:"itemCategory.category_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.favorite.category_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('favorite', 'categories')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('categories', 'favorite', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select favorite highlights","options":_vm.lists.categoriesProducts},on:{"search:focus":function($event){return _vm.onSelectCategories(index, 'favorite', true)}},model:{value:(itemCategory.items),callback:function ($$v) {_vm.$set(itemCategory, "items", $$v)},expression:"itemCategory.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.favorite.item_type === 'domestic')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.favorite.destination_items),function(itemDomestic,index){return _c('div',{key:(index + " + favorite"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'favorite')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectDomestic(index, 'favorite')}},model:{value:(itemDomestic.destination_id),callback:function ($$v) {_vm.$set(itemDomestic, "destination_id", $$v)},expression:"itemDomestic.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.favorite.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('favorite', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'favorite', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select favorite highlights","options":_vm.lists.domesticProducts},on:{"search:focus":function($event){return _vm.onSelectDomestic(index, 'favorite', true)}},model:{value:(itemDomestic.items),callback:function ($$v) {_vm.$set(itemDomestic, "items", $$v)},expression:"itemDomestic.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.favorite.item_type === 'international')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.favorite.destination_items),function(itemInternational,index){return _c('div',{key:(index + " + favorite"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'favorite')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectInternational(index, 'favorite')}},model:{value:(itemInternational.destination_id),callback:function ($$v) {_vm.$set(itemInternational, "destination_id", $$v)},expression:"itemInternational.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.favorite.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('favorite', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'favorite', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select favorite highlights","options":_vm.lists.internationalProducts},on:{"search:focus":function($event){return _vm.onSelectInternational(index, 'favorite', true)}},model:{value:(itemInternational.items),callback:function ($$v) {_vm.$set(itemInternational, "items", $$v)},expression:"itemInternational.items"}})],1)])])}),0)]):_vm._e()]):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                        Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select favorite highlights","options":_vm.lists.products},on:{"input":function($event){return _vm.onSelectperItem('favorite')}},model:{value:(_vm.form.favorite.items),callback:function ($$v) {_vm.$set(_vm.form.favorite, "items", $$v)},expression:"form.favorite.items"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('favorite')}}},[_vm._v("\n                    Submit\n                  ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Badge Image"}},[_c('FileGallery',{attrs:{"type":"favorite","selected":_vm.form.favorite.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":"Rekomendasi Tour"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Rekomendasi Tour")]),_vm._v(" "),(_vm.error.tour)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.tour = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.tour)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                        Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDatetour,"clear-button":true},model:{value:(_vm.form.tour.start_date),callback:function ($$v) {_vm.$set(_vm.form.tour, "start_date", $$v)},expression:"form.tour.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                        End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDatetour,"clear-button":true},model:{value:(_vm.form.tour.end_date),callback:function ($$v) {_vm.$set(_vm.form.tour, "end_date", $$v)},expression:"form.tour.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Status "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.status),expression:"form.tour.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.tour, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-sequence-aktivitas"}},[_vm._v("\n                        Section Style "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleSection"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.sectionStyle),expression:"form.tour.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTour","value":"1"},domProps:{"checked":_vm._q(_vm.form.tour.sectionStyle,"1")},on:{"change":function($event){return _vm.$set(_vm.form.tour, "sectionStyle", "1")}}}),_vm._v("\n                                Section Style 1\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle1.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.sectionStyle),expression:"form.tour.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTour","value":"2"},domProps:{"checked":_vm._q(_vm.form.tour.sectionStyle,"2")},on:{"change":function($event){return _vm.$set(_vm.form.tour, "sectionStyle", "2")}}}),_vm._v("\n                                Section Style 2\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle2.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 3"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.sectionStyle),expression:"form.tour.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTour","value":"3"},domProps:{"checked":_vm._q(_vm.form.tour.sectionStyle,"3")},on:{"change":function($event){return _vm.$set(_vm.form.tour, "sectionStyle", "3")}}}),_vm._v("\n                                Section Style 3\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle3.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 4"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.sectionStyle),expression:"form.tour.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTour","value":"4"},domProps:{"checked":_vm._q(_vm.form.tour.sectionStyle,"4")},on:{"change":function($event){return _vm.$set(_vm.form.tour, "sectionStyle", "4")}}}),_vm._v("\n                                Section Style 4\n                                "),(_vm.form.tour.item_type === 'item')?_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4.png","alt":"No image"}}):_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4-chips.png","alt":"No image"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.title),expression:"form.tour.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Rekomendasi Tour","maxlength":"30"},domProps:{"value":(_vm.form.tour.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.tour, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.title_en),expression:"form.tour.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Rekomendasi Tour","maxlength":"30"},domProps:{"value":(_vm.form.tour.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.tour, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.description),expression:"form.tour.description"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Rekomendasi Tour","maxlength":"90"},domProps:{"value":(_vm.form.tour.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.tour, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description En"),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.description_en),expression:"form.tour.description_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Rekomendasi Tour","maxlength":"90"},domProps:{"value":(_vm.form.tour.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.tour, "description_en", $event.target.value)}}})])]),_vm._v(" "),(_vm.form.tour.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                        Image Campaign "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                          Choose File\n                        ")]),_vm._v(" "),_c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                            Allowed   extension only for PNG / JPG\n                          ")])]),_vm._v(" "),(_vm.form.tour.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.tour.image.url)}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})])]):_vm._e(),_vm._v(" "),(_vm.form.tour.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"type"}},[_vm._v("\n                        Item Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.tour.item_type),expression:"form.tour.item_type"}],staticClass:"form-control",attrs:{"placeholder":"Select type","id":"typetour"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.tour, "item_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changelist('tour')}]}},[_c('option',{attrs:{"value":"item"}},[_vm._v("Per-Item")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v("Category")]),_vm._v(" "),_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic Destination")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International Destination")])])])]):_vm._e(),_vm._v(" "),(_vm.form.tour.sectionStyle == 4)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"control-label col-md-2 form-horizontal",attrs:{"for":"tour"}},[_vm._v("\n                        items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),(_vm.form.tour.item_type === 'item')?_c('div',{staticClass:"col-md-10 styleSingleItems"},[_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","name":"tour","placeholder":"Select tour highlights","options":_vm.lists.productsTour},model:{value:(_vm.form.tour.items),callback:function ($$v) {_vm.$set(_vm.form.tour, "items", $$v)},expression:"form.tour.items"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.tour.item_type === 'category')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.tour.category_items),function(itemCategory,index){return _c('div',{key:(index + " + tour"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                                Category "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"name":"categories","placeholder":"Select tour category","clearable":false,"options":_vm.lists.categories},on:{"input":function($event){return _vm.onSelectCategories(index, 'tour')}},model:{value:(itemCategory.category_id),callback:function ($$v) {_vm.$set(itemCategory, "category_id", $$v)},expression:"itemCategory.category_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.tour.category_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('tour', 'categories')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('categories', 'tour', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"tour","placeholder":"Select tour highlights","options":_vm.lists.categoriesProducts},on:{"search:focus":function($event){return _vm.onSelectCategories(index, 'tour', true)}},model:{value:(itemCategory.items),callback:function ($$v) {_vm.$set(itemCategory, "items", $$v)},expression:"itemCategory.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.tour.item_type === 'domestic')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.tour.destination_items),function(itemDomestic,index){return _c('div',{key:(index + " + tour"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'tour')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectDomestic(index, 'tour')}},model:{value:(itemDomestic.destination_id),callback:function ($$v) {_vm.$set(itemDomestic, "destination_id", $$v)},expression:"itemDomestic.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.tour.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('tour', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'tour', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"tour","placeholder":"Select tour highlights","options":_vm.lists.domesticProducts},on:{"search:focus":function($event){return _vm.onSelectDomestic(index, 'tour', true)}},model:{value:(itemDomestic.items),callback:function ($$v) {_vm.$set(itemDomestic, "items", $$v)},expression:"itemDomestic.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.tour.item_type === 'international')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.tour.destination_items),function(itemInternational,index){return _c('div',{key:(index + " + tour"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'tour')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectInternational(index, 'tour')}},model:{value:(itemInternational.destination_id),callback:function ($$v) {_vm.$set(itemInternational, "destination_id", $$v)},expression:"itemInternational.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.tour.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('tour', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'tour', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"tour","placeholder":"Select tour highlights","options":_vm.lists.internationalProducts},on:{"search:focus":function($event){return _vm.onSelectInternational(index, 'tour', true)}},model:{value:(itemInternational.items),callback:function ($$v) {_vm.$set(itemInternational, "items", $$v)},expression:"itemInternational.items"}})],1)])])}),0)]):_vm._e()]):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"tour"}},[_vm._v("\n                        Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"tour","placeholder":"Select Rekomendasi Tour highlights","options":_vm.lists.productsTour},on:{"input":function($event){return _vm.onSelectperItem('tour')}},model:{value:(_vm.form.tour.items),callback:function ($$v) {_vm.$set(_vm.form.tour, "items", $$v)},expression:"form.tour.items"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('tour')}}},[_vm._v("\n                    Submit\n                  ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Badge Image"}},[_c('FileGallery',{attrs:{"type":"tour","selected":_vm.form.tour.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":"Category Populer"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Category Populer")]),_vm._v(" "),(_vm.error.category)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.category = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.category)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                        Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDatecategory,"clear-button":true},model:{value:(_vm.form.category.start_date),callback:function ($$v) {_vm.$set(_vm.form.category, "start_date", $$v)},expression:"form.category.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                        End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDatecategory,"clear-button":true},model:{value:(_vm.form.category.end_date),callback:function ($$v) {_vm.$set(_vm.form.category, "end_date", $$v)},expression:"form.category.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Status "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.category.status),expression:"form.category.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.category.title),expression:"form.category.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Category Populer","maxlength":"30"},domProps:{"value":(_vm.form.category.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.category, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.category.title_en),expression:"form.category.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Category Populer","maxlength":"30"},domProps:{"value":(_vm.form.category.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.category, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.category.description),expression:"form.category.description"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Category Populer","maxlength":"90"},domProps:{"value":(_vm.form.category.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.category, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description En"),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.category.description_en),expression:"form.category.description_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Category Populer","maxlength":"90"},domProps:{"value":(_vm.form.category.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.category, "description_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                        Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select category populer","options":_vm.lists.categories},on:{"input":_vm.limiterCategory},model:{value:(_vm.form.category.items),callback:function ($$v) {_vm.$set(_vm.form.category, "items", $$v)},expression:"form.category.items"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('category')}}},[_vm._v("\n                    Submit\n                  ")])])])])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Destinasi Populer"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Destinasi Populer")]),_vm._v(" "),(_vm.error.destination)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.destination = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.destination)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-destinasi"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.destination.title),expression:"form.destination.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-destinasi","name":"highlights-title-destinasi","placeholder":"Destinasi Populer","maxlength":"30"},domProps:{"value":(_vm.form.destination.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.destination, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-destinasi"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.destination.title_en),expression:"form.destination.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-destinasi","name":"highlights-title-destinasi","placeholder":"Destinasi Populer","maxlength":"30"},domProps:{"value":(_vm.form.destination.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.destination, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('vue-tabs',{attrs:{"start-index":1,"active-tab-color":"#fda229","active-text-color":"#fff","direction":"horizontal"},on:{"tab-change":_vm.onClick}},[_c('v-tab',{attrs:{"title":"Domestic Destination"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"country"}},[_vm._v("\n                                          Country "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"name":"country","disabled":"","placeholder":"Input Country (Indonesia)","options":_vm.lists.destinations},model:{value:(_vm.form.destination.country_domestic),callback:function ($$v) {_vm.$set(_vm.form.destination, "country_domestic", $$v)},expression:"form.destination.country_domestic"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"city"}},[_vm._v("\n                                          City/Province "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"city","placeholder":"Input multiple City and Province in Indonesia","options":_vm.lists.destinations},on:{"input":_vm.limiter},model:{value:(_vm.form.destination.city_domestic),callback:function ($$v) {_vm.$set(_vm.form.destination, "city_domestic", $$v)},expression:"form.destination.city_domestic"}})],1)])])])])])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"International Destination"}},[_c('div',{staticClass:"v-tabs-content"},_vm._l((_vm.form.destination.international),function(item,index){return _c('div',{key:index,staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"country"}},[_vm._v("\n                                          Country "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'destination')}}},[_c('v-select',{attrs:{"name":"country","placeholder":"Input Country","options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectCountry(index)}},model:{value:(_vm.form.destination.international[index].country_international),callback:function ($$v) {_vm.$set(_vm.form.destination.international[index], "country_international", $$v)},expression:"form.destination.international[index].country_international"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.destination.international.length < 4)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('international')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem(item, 'international', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"city"}},[_vm._v("\n                                          City "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"city","placeholder":"Input multiple City in This Country","options":_vm.lists.cities},on:{"input":_vm.limiter,"search:focus":function($event){return _vm.setSelected(index)}},model:{value:(_vm.form.destination.international[index].city_international),callback:function ($$v) {_vm.$set(_vm.form.destination.international[index], "city_international", $$v)},expression:"form.destination.international[index].city_international"}})],1)])])])])}),0)])],1)],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('destination')}}},[_vm._v("\n                    Submit\n                  ")])])])])]),_vm._v(" "),_c('v-tab',{attrs:{"title":"Pilihan Bulan Ini"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Pilihan Bulan Ini")]),_vm._v(" "),(_vm.error.favorite)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.favorite = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.favorite)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                        Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDatetrending,"clear-button":true},model:{value:(_vm.form.trending.start_date),callback:function ($$v) {_vm.$set(_vm.form.trending, "start_date", $$v)},expression:"form.trending.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                        End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDatetrending,"clear-button":true},model:{value:(_vm.form.trending.end_date),callback:function ($$v) {_vm.$set(_vm.form.trending, "end_date", $$v)},expression:"form.trending.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Status "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.status),expression:"form.trending.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.trending, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-sequence-aktivitas"}},[_vm._v("\n                        Section Style "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleSection"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.sectionStyle),expression:"form.trending.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTrending","value":"1"},domProps:{"checked":_vm._q(_vm.form.trending.sectionStyle,"1")},on:{"change":function($event){return _vm.$set(_vm.form.trending, "sectionStyle", "1")}}}),_vm._v("\n                                Section Style 1\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle1.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.sectionStyle),expression:"form.trending.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTrending","value":"2"},domProps:{"checked":_vm._q(_vm.form.trending.sectionStyle,"2")},on:{"change":function($event){return _vm.$set(_vm.form.trending, "sectionStyle", "2")}}}),_vm._v("\n                                Section Style 2\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle2.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 3"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.sectionStyle),expression:"form.trending.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTrending","value":"3"},domProps:{"checked":_vm._q(_vm.form.trending.sectionStyle,"3")},on:{"change":function($event){return _vm.$set(_vm.form.trending, "sectionStyle", "3")}}}),_vm._v("\n                                Section Style 3\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle3.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 4"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.sectionStyle),expression:"form.trending.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleTrending","value":"4"},domProps:{"checked":_vm._q(_vm.form.trending.sectionStyle,"4")},on:{"change":function($event){return _vm.$set(_vm.form.trending, "sectionStyle", "4")}}}),_vm._v("\n                                Section Style 4\n                                "),(_vm.form.trending.item_type === 'item')?_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4.png","alt":"No image"}}):_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4-chips.png","alt":"No image"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-pilihan"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.title),expression:"form.trending.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-pilihan","name":"highlights-title-pilihan","placeholder":"Pilihan Bulan Ini","maxlength":"30"},domProps:{"value":(_vm.form.trending.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.trending, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-pilihan"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.title_en),expression:"form.trending.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-pilihan","name":"highlights-title-pilihan","placeholder":"Pilihan Bulan Ini","maxlength":"30"},domProps:{"value":(_vm.form.trending.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.trending, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.description),expression:"form.trending.description"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Pilihan Bulan Ini","maxlength":"90"},domProps:{"value":(_vm.form.trending.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.trending, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description En"),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.description_en),expression:"form.trending.description_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Pilihan Bulan Ini","maxlength":"90"},domProps:{"value":(_vm.form.trending.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.trending, "description_en", $event.target.value)}}})])]),_vm._v(" "),(_vm.form.trending.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                        Image Campaign "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                          Choose File\n                        ")]),_vm._v(" "),_c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                            Allowed   extension only for PNG / JPG\n                          ")])]),_vm._v(" "),(_vm.form.trending.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.trending.image.url)}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})])]):_vm._e(),_vm._v(" "),(_vm.form.trending.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Item Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.trending.item_type),expression:"form.trending.item_type"}],staticClass:"form-control",attrs:{"placeholder":"Select Item Type","id":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.trending, "item_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changelist('trending')}]}},[_c('option',{attrs:{"value":"item"}},[_vm._v("Per-Item")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v("Category")]),_vm._v(" "),_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic Destination")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International Destination")])])])]):_vm._e(),_vm._v(" "),(_vm.form.trending.sectionStyle == 4)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"control-label col-md-2 form-horizontal",attrs:{"for":"trending"}},[_vm._v("\n                        items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),(_vm.form.trending.item_type === 'item')?_c('div',{staticClass:"col-md-10 styleSingleItems"},[_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","name":"trending","placeholder":"Select trending highlights","options":_vm.lists.products},model:{value:(_vm.form.trending.items),callback:function ($$v) {_vm.$set(_vm.form.trending, "items", $$v)},expression:"form.trending.items"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.trending.item_type === 'category')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.trending.category_items),function(itemCategory,index){return _c('div',{key:(index + " + trending"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"trending"}},[_vm._v("\n                                Category "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"name":"categories","placeholder":"Select trending category","clearable":false,"options":_vm.lists.categories},on:{"input":function($event){return _vm.onSelectCategories(index, 'trending')}},model:{value:(itemCategory.category_id),callback:function ($$v) {_vm.$set(itemCategory, "category_id", $$v)},expression:"itemCategory.category_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.trending.category_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('trending', 'categories')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('categories', 'trending', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"trending"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"trending","placeholder":"Select trending highlights","options":_vm.lists.categoriesProducts},on:{"search:focus":function($event){return _vm.setSelectedCategory(index, 'trending')}},model:{value:(itemCategory.items),callback:function ($$v) {_vm.$set(itemCategory, "items", $$v)},expression:"itemCategory.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.trending.item_type === 'domestic')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.trending.destination_items),function(itemDomestic,index){return _c('div',{key:(index + " + trending"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"trending"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'trending')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectDomestic(index, 'trending')}},model:{value:(itemDomestic.destination_id),callback:function ($$v) {_vm.$set(itemDomestic, "destination_id", $$v)},expression:"itemDomestic.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.trending.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('trending', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'trending', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"trending"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"trending","placeholder":"Select trending highlights","options":_vm.lists.domesticProducts},on:{"search:focus":function($event){return _vm.onSelectDomestic(index, 'trending', true)}},model:{value:(itemDomestic.items),callback:function ($$v) {_vm.$set(itemDomestic, "items", $$v)},expression:"itemDomestic.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.trending.item_type === 'international')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.trending.destination_items),function(itemInternational,index){return _c('div',{key:(index + " + trending"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"trending"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'trending')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectInternational(index, 'trending')}},model:{value:(itemInternational.destination_id),callback:function ($$v) {_vm.$set(itemInternational, "destination_id", $$v)},expression:"itemInternational.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.trending.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('trending', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'trending', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"trending"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"trending","placeholder":"Select trending highlights","options":_vm.lists.internationalProducts},on:{"search:focus":function($event){return _vm.onSelectInternational(index, 'trending', true)}},model:{value:(itemInternational.items),callback:function ($$v) {_vm.$set(itemInternational, "items", $$v)},expression:"itemInternational.items"}})],1)])])}),0)]):_vm._e()]):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"favorite"}},[_vm._v("\n                        Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"favorite","placeholder":"Select favorite highlights","options":_vm.lists.products},on:{"input":function($event){return _vm.onSelectperItem('trending')}},model:{value:(_vm.form.trending.items),callback:function ($$v) {_vm.$set(_vm.form.trending, "items", $$v)},expression:"form.trending.items"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('trending')}}},[_vm._v("\n                    Submit\n                  ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Badge Image"}},[_c('FileGallery',{attrs:{"type":"trending","selected":_vm.form.trending.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":"Campaign 1"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Campaign 1")]),_vm._v(" "),(_vm.error.campaign1)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.campaign1 = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.campaign1)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                        Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDateCampaign1,"clear-button":true},model:{value:(_vm.form.campaign1.start_date),callback:function ($$v) {_vm.$set(_vm.form.campaign1, "start_date", $$v)},expression:"form.campaign1.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                        End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDateCampaign1,"clear-button":true},model:{value:(_vm.form.campaign1.end_date),callback:function ($$v) {_vm.$set(_vm.form.campaign1, "end_date", $$v)},expression:"form.campaign1.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Status "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.status),expression:"form.campaign1.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.campaign1, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-sequence-aktivitas"}},[_vm._v("\n                        Section Style "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleSection"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.sectionStyle),expression:"form.campaign1.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign1","value":"1"},domProps:{"checked":_vm._q(_vm.form.campaign1.sectionStyle,"1")},on:{"change":function($event){return _vm.$set(_vm.form.campaign1, "sectionStyle", "1")}}}),_vm._v("\n                                Section Style 1\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle1.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.sectionStyle),expression:"form.campaign1.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign1","value":"2"},domProps:{"checked":_vm._q(_vm.form.campaign1.sectionStyle,"2")},on:{"change":function($event){return _vm.$set(_vm.form.campaign1, "sectionStyle", "2")}}}),_vm._v("\n                                Section Style 2\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle2.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 3"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.sectionStyle),expression:"form.campaign1.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign1","value":"3"},domProps:{"checked":_vm._q(_vm.form.campaign1.sectionStyle,"3")},on:{"change":function($event){return _vm.$set(_vm.form.campaign1, "sectionStyle", "3")}}}),_vm._v("\n                                Section Style 3\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle3.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 4"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.sectionStyle),expression:"form.campaign1.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign1","value":"4"},domProps:{"checked":_vm._q(_vm.form.campaign1.sectionStyle,"4")},on:{"change":function($event){return _vm.$set(_vm.form.campaign1, "sectionStyle", "4")}}}),_vm._v("\n                                Section Style 4\n                                "),(_vm.form.campaign1.item_type === 'item')?_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4.png","alt":"No image"}}):_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4-chips.png","alt":"No image"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.title),expression:"form.campaign1.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Eksplorasi Terfavorit","maxlength":"30"},domProps:{"value":(_vm.form.campaign1.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign1, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.title_en),expression:"form.campaign1.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Eksplorasi Terfavorit","maxlength":"30"},domProps:{"value":(_vm.form.campaign1.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign1, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.description),expression:"form.campaign1.description"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Eksplorasi Terfavorit","maxlength":"90"},domProps:{"value":(_vm.form.campaign1.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign1, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description En"),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.description_en),expression:"form.campaign1.description_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Eksplorasi Terfavorit","maxlength":"90"},domProps:{"value":(_vm.form.campaign1.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign1, "description_en", $event.target.value)}}})])]),_vm._v(" "),(_vm.form.campaign1.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                        Image Campaign "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                          Choose File\n                        ")]),_vm._v(" "),_c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                            Allowed   extension only for PNG / JPG\n                          ")])]),_vm._v(" "),(_vm.form.campaign1.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.campaign1.image.url)}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})])]):_vm._e(),_vm._v(" "),(_vm.form.campaign1.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Item Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign1.item_type),expression:"form.campaign1.item_type"}],staticClass:"form-control",attrs:{"placeholder":"Select Item Type","id":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.campaign1, "item_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changelist('campaign1')}]}},[_c('option',{attrs:{"value":"item"}},[_vm._v("Per-Item")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v("Category")]),_vm._v(" "),_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic Destination")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International Destination")])])])]):_vm._e(),_vm._v(" "),(_vm.form.campaign1.sectionStyle == 4)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"control-label col-md-2 form-horizontal",attrs:{"for":"campaign1"}},[_vm._v("\n                        items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),(_vm.form.campaign1.item_type === 'item')?_c('div',{staticClass:"col-md-10 styleSingleItems"},[_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","name":"campaign1","placeholder":"Select campaign1 highlights","options":_vm.lists.products},model:{value:(_vm.form.campaign1.items),callback:function ($$v) {_vm.$set(_vm.form.campaign1, "items", $$v)},expression:"form.campaign1.items"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.campaign1.item_type === 'category')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.campaign1.category_items),function(itemCategory,index){return _c('div',{key:(index + " + campaign1"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign1"}},[_vm._v("\n                                Category "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"name":"categories","placeholder":"Select campaign1 category","clearable":false,"options":_vm.lists.categories},on:{"input":function($event){return _vm.onSelectCategories(index, 'campaign1')}},model:{value:(itemCategory.category_id),callback:function ($$v) {_vm.$set(itemCategory, "category_id", $$v)},expression:"itemCategory.category_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.campaign1.category_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('campaign1', 'categories')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('categories', 'campaign1', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign1"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"campaign1","placeholder":"Select campaign1 highlights","options":_vm.lists.categoriesProducts},on:{"search:focus":function($event){return _vm.onSelectCategories(index, 'campaign1', true)}},model:{value:(itemCategory.items),callback:function ($$v) {_vm.$set(itemCategory, "items", $$v)},expression:"itemCategory.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.campaign1.item_type === 'domestic')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.campaign1.destination_items),function(itemDomestic,index){return _c('div',{key:(index + " + campaign1"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign1"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'campaign1')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectDomestic(index, 'campaign1')}},model:{value:(itemDomestic.destination_id),callback:function ($$v) {_vm.$set(itemDomestic, "destination_id", $$v)},expression:"itemDomestic.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.campaign1.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('campaign1', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'campaign1', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign1"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"campaign1","placeholder":"Select campaign1 highlights","options":_vm.lists.domesticProducts},on:{"search:focus":function($event){return _vm.onSelectDomestic(index, 'campaign1', true)}},model:{value:(itemDomestic.items),callback:function ($$v) {_vm.$set(itemDomestic, "items", $$v)},expression:"itemDomestic.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.campaign1.item_type === 'international')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.campaign1.destination_items),function(itemInternational,index){return _c('div',{key:(index + " + campaign1"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign1"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'campaign1')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectInternational(index, 'campaign1')}},model:{value:(itemInternational.destination_id),callback:function ($$v) {_vm.$set(itemInternational, "destination_id", $$v)},expression:"itemInternational.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.campaign1.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('campaign1', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'campaign1', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign1"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"campaign1","placeholder":"Select campaign1 highlights","options":_vm.lists.internationalProducts},on:{"search:focus":function($event){return _vm.onSelectInternational(index, 'campaign1', true)}},model:{value:(itemInternational.items),callback:function ($$v) {_vm.$set(itemInternational, "items", $$v)},expression:"itemInternational.items"}})],1)])])}),0)]):_vm._e()]):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign"}},[_vm._v("\n                        Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"campaign","placeholder":"Select Campaign 1 highlights","options":_vm.lists.products},on:{"input":function($event){return _vm.onSelectperItem('campaign1')}},model:{value:(_vm.form.campaign1.items),callback:function ($$v) {_vm.$set(_vm.form.campaign1, "items", $$v)},expression:"form.campaign1.items"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('campaign1')}}},[_vm._v("\n                    Submit\n                  ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Badge Image"}},[_c('FileGallery',{attrs:{"type":"campaign1","selected":_vm.form.campaign1.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":"Campaign 2"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("Campaign 2")]),_vm._v(" "),(_vm.error.campaign2)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error.campaign2 = false}}},[_vm._v("\n                      ×\n                    ")]),_vm._v("\n                    "+_vm._s(_vm.error.campaign2)+"\n                  ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"start_date"}},[_vm._v("\n                        Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"start_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledStartDateCampaign2,"clear-button":true},model:{value:(_vm.form.campaign2.start_date),callback:function ($$v) {_vm.$set(_vm.form.campaign2, "start_date", $$v)},expression:"form.campaign2.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"end_date"}},[_vm._v("\n                        End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('datepicker',{attrs:{"id":"end_date","wrapper-class":"custom-vdp","input-class":"form-control","disabled":_vm.disabledEndDateCampaign2,"clear-button":true},model:{value:(_vm.form.campaign2.end_date),callback:function ($$v) {_vm.$set(_vm.form.campaign2, "end_date", $$v)},expression:"form.campaign2.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Status "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.status),expression:"form.campaign2.status"}],staticClass:"form-control",attrs:{"placeholder":"Select Status","id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.campaign2, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-sequence-aktivitas"}},[_vm._v("\n                        Section Style "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleSection"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.sectionStyle),expression:"form.campaign2.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign2","value":"1"},domProps:{"checked":_vm._q(_vm.form.campaign2.sectionStyle,"1")},on:{"change":function($event){return _vm.$set(_vm.form.campaign2, "sectionStyle", "1")}}}),_vm._v("\n                                Section Style 1\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle1.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.sectionStyle),expression:"form.campaign2.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign2","value":"2"},domProps:{"checked":_vm._q(_vm.form.campaign2.sectionStyle,"2")},on:{"change":function($event){return _vm.$set(_vm.form.campaign2, "sectionStyle", "2")}}}),_vm._v("\n                                Section Style 2\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle2.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 3"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.sectionStyle),expression:"form.campaign2.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign2","value":"3"},domProps:{"checked":_vm._q(_vm.form.campaign2.sectionStyle,"3")},on:{"change":function($event){return _vm.$set(_vm.form.campaign2, "sectionStyle", "3")}}}),_vm._v("\n                                Section Style 3\n                                "),_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle3.png","alt":"No image"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"for":"Section Style 4"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.sectionStyle),expression:"form.campaign2.sectionStyle"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"sectionStyleCampaign2","value":"4"},domProps:{"checked":_vm._q(_vm.form.campaign2.sectionStyle,"4")},on:{"change":function($event){return _vm.$set(_vm.form.campaign2, "sectionStyle", "4")}}}),_vm._v("\n                                Section Style 4\n                                "),(_vm.form.campaign2.item_type === 'item')?_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4.png","alt":"No image"}}):_c('img',{staticClass:"imageSectionStyle",attrs:{"src":"/static/img/SectionStyle4-chips.png","alt":"No image"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.title),expression:"form.campaign2.title"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Eksplorasi Terfavorit","maxlength":"30"},domProps:{"value":(_vm.form.campaign2.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign2, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-title-aktivitas"}},[_vm._v("\n                        Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.title_en),expression:"form.campaign2.title_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-title-aktivitas","name":"highlights-title-aktivitas","placeholder":"Eksplorasi Terfavorit","maxlength":"30"},domProps:{"value":(_vm.form.campaign2.title_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign2, "title_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.description),expression:"form.campaign2.description"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Eksplorasi Terfavorit","maxlength":"90"},domProps:{"value":(_vm.form.campaign2.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign2, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"highlights-description"}},[_vm._v("\n                        Description En"),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.description_en),expression:"form.campaign2.description_en"}],staticClass:"form-control strong",attrs:{"type":"text","id":"highlights-description","name":"highlights-description","placeholder":"Deskripsi Eksplorasi Terfavorit","maxlength":"90"},domProps:{"value":(_vm.form.campaign2.description_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form.campaign2, "description_en", $event.target.value)}}})])]),_vm._v(" "),(_vm.form.campaign2.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                        Image Campaign "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                          Choose File\n                        ")]),_vm._v(" "),_c('div',{staticClass:"upload-attention"},[_c('h4',[_vm._v("Upload Attention")]),_vm._v(" "),_c('p',[_vm._v("\n                            Allowed   extension only for PNG / JPG\n                          ")])]),_vm._v(" "),(_vm.form.campaign2.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.campaign2.image.url)}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})])]):_vm._e(),_vm._v(" "),(_vm.form.campaign2.sectionStyle == 4)?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"status"}},[_vm._v("\n                        Item Type "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.campaign2.item_type),expression:"form.campaign2.item_type"}],staticClass:"form-control",attrs:{"placeholder":"Select Item Type","id":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.form.campaign2, "item_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.changelist('campaign2')}]}},[_c('option',{attrs:{"value":"item"}},[_vm._v("Per-Item")]),_vm._v(" "),_c('option',{attrs:{"value":"category"}},[_vm._v("Category")]),_vm._v(" "),_c('option',{attrs:{"value":"domestic"}},[_vm._v("Domestic Destination")]),_vm._v(" "),_c('option',{attrs:{"value":"international"}},[_vm._v("International Destination")])])])]):_vm._e(),_vm._v(" "),(_vm.form.campaign2.sectionStyle == 4)?_c('div',{staticClass:"row"},[_c('label',{staticClass:"control-label col-md-2 form-horizontal",attrs:{"for":"campaign2"}},[_vm._v("\n                        items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),(_vm.form.campaign2.item_type === 'item')?_c('div',{staticClass:"col-md-10 styleSingleItems"},[_c('div',{staticClass:"col-md-12"},[_c('v-select',{attrs:{"multiple":"","name":"campaign2","placeholder":"Select campaign2 highlights","options":_vm.lists.products},model:{value:(_vm.form.campaign2.items),callback:function ($$v) {_vm.$set(_vm.form.campaign2, "items", $$v)},expression:"form.campaign2.items"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.campaign2.item_type === 'category')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.campaign2.category_items),function(itemCategory,index){return _c('div',{key:(index + " + campaign2"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign2"}},[_vm._v("\n                                Category "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"name":"categories","placeholder":"Select campaign2 category","clearable":false,"options":_vm.lists.categories},on:{"input":function($event){return _vm.onSelectCategories(index, 'campaign2')}},model:{value:(itemCategory.category_id),callback:function ($$v) {_vm.$set(itemCategory, "category_id", $$v)},expression:"itemCategory.category_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.campaign2.category_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('campaign2', 'categories')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('categories', 'campaign2', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign2"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"campaign2","placeholder":"Select campaign2 highlights","options":_vm.lists.categoriesProducts},on:{"search:focus":function($event){return _vm.onSelectCategories(index, 'campaign2', true)}},model:{value:(itemCategory.items),callback:function ($$v) {_vm.$set(itemCategory, "items", $$v)},expression:"itemCategory.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.campaign2.item_type === 'domestic')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.campaign2.destination_items),function(itemDomestic,index){return _c('div',{key:(index + " + campaign2"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign2"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'campaign2')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectDomestic(index, 'campaign2')}},model:{value:(itemDomestic.destination_id),callback:function ($$v) {_vm.$set(itemDomestic, "destination_id", $$v)},expression:"itemDomestic.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.campaign2.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('campaign2', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'campaign2', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign2"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"campaign2","placeholder":"Select campaign2 highlights","options":_vm.lists.domesticProducts},on:{"search:focus":function($event){return _vm.onSelectDomestic(index, 'campaign2', true)}},model:{value:(itemDomestic.items),callback:function ($$v) {_vm.$set(itemDomestic, "items", $$v)},expression:"itemDomestic.items"}})],1)])])}),0)]):_vm._e(),_vm._v(" "),(_vm.form.campaign2.item_type === 'international')?_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"styleItems"},_vm._l((_vm.form.campaign2.destination_items),function(itemInternational,index){return _c('div',{key:(index + " + campaign2"),staticClass:"row"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign2"}},[_vm._v("\n                                Destination "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8",on:{"click":function($event){return _vm.onSelectDestination(index, 'campaign2')}}},[_c('v-select',{attrs:{"name":"destination","placeholder":"Input Destination","clearable":false,"options":_vm.lists.destinations},on:{"input":function($event){return _vm.onSelectInternational(index, 'campaign2')}},model:{value:(itemInternational.destination_id),callback:function ($$v) {_vm.$set(itemInternational, "destination_id", $$v)},expression:"itemInternational.destination_id"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[(_vm.form.campaign2.destination_items.length < 8)?_c('button',{staticClass:"btn btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.addItem('campaign2', 'destination')}}},[_c('i',{staticClass:"fa fa-plus"})]):_vm._e(),_vm._v(" "),(index > 0)?_c('button',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeItem('destination', 'campaign2', index)}}},[_c('i',{staticClass:"fa fa-minus"})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign2"}},[_vm._v("\n                                Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('v-select',{attrs:{"multiple":"","name":"campaign2","placeholder":"Select campaign2 highlights","options":_vm.lists.internationalProducts},on:{"search:focus":function($event){return _vm.onSelectInternational(index, 'campaign2', true)}},model:{value:(itemInternational.items),callback:function ($$v) {_vm.$set(itemInternational, "items", $$v)},expression:"itemInternational.items"}})],1)])])}),0)]):_vm._e()]):_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label col-md-2",attrs:{"for":"campaign"}},[_vm._v("\n                        Items "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('v-select',{attrs:{"multiple":"","name":"campaign","placeholder":"Select Campaign 2 highlights","options":_vm.lists.products},on:{"input":function($event){return _vm.onSelectperItem('campaign2')}},model:{value:(_vm.form.campaign2.items),callback:function ($$v) {_vm.$set(_vm.form.campaign2, "items", $$v)},expression:"form.campaign2.items"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('campaign2')}}},[_vm._v("\n                    Submit\n                  ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Badge Image"}},[_c('FileGallery',{attrs:{"type":"campaign2","selected":_vm.form.campaign2.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"title":"Sequence"}},[_c('div',{staticClass:"v-tabs-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Sequence for Section")]),_vm._v(" "),_c('draggable',{staticClass:"list-group",attrs:{"list":_vm.lists.sequenceList,"disabled":false,"animation":"200","ghost-class":"ghost"},on:{"start":function($event){_vm.dragging = true},"end":function($event){_vm.dragging = false}}},[_c('transition-group',{attrs:{"type":"transition","name":!_vm.dragging ? 'flip-list' : null}},_vm._l((_vm.lists.sequenceList),function(element){return _c('div',{key:element.id,staticClass:"list-group-item listSequence"},[_vm._v("\n                        "+_vm._s(element.title)+"\n                      ")])}),0)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-2",staticStyle:{"float":"right","margin-top":"55px"}},[_c('button',{staticClass:"btn btn-info btn-block",on:{"click":function($event){return _vm.submit('sequence')}}},[_vm._v("\n                    Submit\n                  ")])])])])])],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Highlights\n      "),_c('small',[_vm._v("Products sorted by favorite, popular and trending")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647697fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(680);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_647697fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Tag\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'tag-index'}}},[_vm._v("\n          Tags\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name_en),expression:"form.name_en"}],staticClass:"form-control",attrs:{"type":"text","id":"name_en","placeholder":"Name EN"},domProps:{"value":(_vm.form.name_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                  Slug\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.slug),expression:"form.slug"}],staticClass:"form-control",attrs:{"type":"text","id":"slug","placeholder":"Slug"},domProps:{"value":(_vm.form.slug)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "slug", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name_en"}},[_vm._v("\n                  Name EN"),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f596fe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(682);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f596fe2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"inherit"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"promoPaymentName"}},[_vm._v("\n            Name\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"tagName","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Tag\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),(_vm.isLoading)?_c('tbody',{key:"loading"},[_vm._m(3)]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_vm._m(4)]):_c('tbody',{key:"data"},_vm._l((_vm.items),function(item){return _c('tr',[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.slug))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(item.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(item)}}},[_vm._v("Delete")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Tags\n      "),_c('small',[_vm._v("List of tags")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Tags")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('strong',[_vm._v("Filter Tags")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Slug")]),_vm._v(" "),_c('th',[_vm._v("Action(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('h3',[_vm._v("Loading")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"3"}},[_c('strong',[_vm._v("Result not found")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(326);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce5c0bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(684);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce5c0bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Source\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'source-index'}}},[_vm._v("\n          Sources\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendor.name),expression:"vendor.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.vendor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vendor, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendor.code),expression:"vendor.code"}],staticClass:"form-control",attrs:{"type":"text","id":"code","placeholder":"Code (2-digits character)","maxlength":"2"},domProps:{"value":(_vm.vendor.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vendor, "code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendor.contact_person),expression:"vendor.contact_person"}],staticClass:"form-control",attrs:{"type":"text","id":"contact_person","placeholder":"Contact Person"},domProps:{"value":(_vm.vendor.contact_person)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vendor, "contact_person", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendor.phone),expression:"vendor.phone"}],staticClass:"form-control",attrs:{"type":"number","id":"phone","placeholder":"Phone","min":"8"},domProps:{"value":(_vm.vendor.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vendor, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendor.email),expression:"vendor.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","placeholder":"Email"},domProps:{"value":(_vm.vendor.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.vendor, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"description"}},[_vm._v("\n                  Description\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('ckeditor',{attrs:{"id":"description","config":_vm.configs.ckeditor},model:{value:(_vm.vendor.description),callback:function ($$v) {_vm.$set(_vm.vendor, "description", $$v)},expression:"vendor.description"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Code "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"contact_person"}},[_vm._v("\n                  Contact Person "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"phone"}},[_vm._v("\n                  Phone "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"email"}},[_vm._v("\n                  Email "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c3a4b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(686);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c3a4b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"contact"}},[_vm._v("\n                Contact\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.contact),expression:"params.contact"}],staticClass:"form-control",attrs:{"type":"text","id":"contact","placeholder":"Search by contact here"},domProps:{"value":(_vm.params.contact)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "contact", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Source\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(!_vm.vendors)?_c('tr',{key:"empty"},[_vm._m(3)]):_vm._l((_vm.vendors),function(vendor){return _c('tr',[_c('td',[_vm._v(_vm._s(vendor.name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(vendor.code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(vendor.contact_person))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(vendor.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(vendor.email))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"10rem"}},[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(vendor.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(vendor)}}},[_vm._v("Delete")])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Sources\n      "),_c('small',[_vm._v("List of Sources")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Sources")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Sources")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Source Name")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Source Code")]),_vm._v(" "),_c('th',[_vm._v("Contact Person")]),_vm._v(" "),_c('th',[_vm._v("Phone")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Action(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Result not found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d36cb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(689);
function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77d36cb1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77d36cb1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'merchant-index'}}},[_vm._v("\n          Merchant\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_vm._m(0),_vm._v(" "),_c('form',{staticClass:"form-horizontal",attrs:{"id":"merchant-form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.name),expression:"merchant.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.merchant.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.address),expression:"merchant.address"}],staticClass:"form-control",attrs:{"type":"text","id":"address","placeholder":"Address"},domProps:{"value":(_vm.merchant.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.city),expression:"merchant.city"}],staticClass:"form-control",attrs:{"type":"text","id":"city","placeholder":"City"},domProps:{"value":(_vm.merchant.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "city", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.province),expression:"merchant.province"}],staticClass:"form-control",attrs:{"type":"text","id":"province","placeholder":"Province"},domProps:{"value":(_vm.merchant.province)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "province", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.country),expression:"merchant.country"}],staticClass:"form-control",attrs:{"type":"text","id":"country","placeholder":"Country"},domProps:{"value":(_vm.merchant.country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "country", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.zip_code),expression:"merchant.zip_code"}],staticClass:"form-control",attrs:{"type":"text","id":"zip_code","placeholder":"Zip Code"},domProps:{"value":(_vm.merchant.zip_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "zip_code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.phone),expression:"merchant.phone"}],staticClass:"form-control",attrs:{"type":"number","id":"phone","placeholder":"Phone"},domProps:{"value":(_vm.merchant.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.email),expression:"merchant.email"}],staticClass:"form-control",attrs:{"type":"text","id":"email","placeholder":"E-mail"},domProps:{"value":(_vm.merchant.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "email", $event.target.value)}}})])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.pic_name),expression:"merchant.pic_name"}],staticClass:"form-control",attrs:{"type":"text","id":"pic_name","placeholder":"PIC Name"},domProps:{"value":(_vm.merchant.pic_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "pic_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.pic_phone),expression:"merchant.pic_phone"}],staticClass:"form-control",attrs:{"type":"number","id":"pic_phone","placeholder":"Phone"},domProps:{"value":(_vm.merchant.pic_phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "pic_phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.merchant.pic_email),expression:"merchant.pic_email"}],staticClass:"form-control",attrs:{"type":"text","id":"pic_email","placeholder":"E-mail"},domProps:{"value":(_vm.merchant.pic_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.merchant, "pic_email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"box-header with-border line-height"},[_c('h3',{staticClass:"box-title"},[_vm._v("Bank Account")]),_vm._v(" "),_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.showAddBank()}}},[_vm._v("\n                  Add New\n                ")])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.bank)?_c('modal',{attrs:{"title":_vm.isEditBank ? 'Edit Bank Account' : 'Add Bank Account'}},[_c('form',{staticClass:"form-horizontal",attrs:{"id":"bank-form"}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"Currency"}},[_vm._v("\n                          Currency "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"placeholder":"Select Currency","id":"currency","options":_vm.list.currency},model:{value:(_vm.bank.currency),callback:function ($$v) {_vm.$set(_vm.bank, "currency", $$v)},expression:"bank.currency"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"swift_code"}},[_vm._v("\n                          Swift Code\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank.swift_code),expression:"bank.swift_code"}],staticClass:"form-control",attrs:{"type":"text","id":"swift_code","placeholder":"Swift Code"},domProps:{"value":(_vm.bank.swift_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bank, "swift_code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"bank_name"}},[_vm._v("\n                          Bank Name "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank.name),expression:"bank.name"}],staticClass:"form-control",attrs:{"type":"text","id":"bank_name","placeholder":"Bank Name"},domProps:{"value":(_vm.bank.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bank, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"bank_branch"}},[_vm._v("\n                          Bank Branch\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank.branch),expression:"bank.branch"}],staticClass:"form-control",attrs:{"type":"text","id":"bank_branch","placeholder":"Bank Branch"},domProps:{"value":(_vm.bank.branch)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bank, "branch", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"account_number"}},[_vm._v("\n                          Account Number "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank.account_number),expression:"bank.account_number"}],staticClass:"form-control",attrs:{"type":"number","id":"account_number","placeholder":"Account Number"},domProps:{"value":(_vm.bank.account_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bank, "account_number", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"account_owner"}},[_vm._v("\n                          Account Owner "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bank.account_owner),expression:"bank.account_owner"}],staticClass:"form-control",attrs:{"type":"text","id":"account_owner","placeholder":"Account Owner"},domProps:{"value":(_vm.bank.account_owner)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.bank, "account_owner", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isEditBank)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":function($event){return _vm.editBank(_vm.editIdx)}}},[_vm._v("Edit Bank")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.addBank()}}},[_vm._v("Add Bank")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return (function (){_vm.show.bank = false;}).apply(null, arguments)}}},[_vm._v("Cancel")])])])]):_vm._e()],1),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(13),_vm._v(" "),(_vm.merchant.banks.length < 1)?_c('tbody',[_vm._m(14)]):_c('tbody',_vm._l((_vm.merchant.banks),function(bank_acc,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(bank_acc.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(bank_acc.branch))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(bank_acc.account_owner))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(bank_acc.account_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(bank_acc.currency))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.showEditBank(index)}}},[_vm._v("\n                        Edit\n                      ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.removeBank(index)}}},[_vm._v("\n                        Delete\n                      ")])])])}),0)])],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Contact Detail Company")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Agent Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"Address"}},[_vm._v("\n                  Address "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"City"}},[_vm._v("\n                  City "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"Province"}},[_vm._v("\n                  Province "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"Country"}},[_vm._v("\n                  Country "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"zip_code"}},[_vm._v("\n                  ZIP Code "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"phone"}},[_vm._v("\n                  Phone Number "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"email"}},[_vm._v("\n                  Email "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border margin-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("Contact Detail PIC")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"pic_name"}},[_vm._v("\n                  PIC Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"pic_phone"}},[_vm._v("\n                  Phone Number "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"pic_email"}},[_vm._v("\n                  Email "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"3rem"}},[_vm._v("No")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"8rem"}},[_vm._v("Bank Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"8rem"}},[_vm._v("Bank Branch")]),_vm._v(" "),_c('th',[_vm._v("Account Owner")]),_vm._v(" "),_c('th',[_vm._v("Account Number")]),_vm._v(" "),_c('th',[_vm._v("Currency")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"7"}},[_vm._v("\n                      No bank added\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_692a2ed2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(691);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_692a2ed2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"city"}},[_vm._v("\n                City\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.city),expression:"params.city"}],staticClass:"form-control",attrs:{"type":"text","id":"city","placeholder":"Search by city here"},domProps:{"value":(_vm.params.city)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "city", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"province"}},[_vm._v("\n                Province\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.province),expression:"params.province"}],staticClass:"form-control",attrs:{"type":"text","id":"province","placeholder":"Search by province here"},domProps:{"value":(_vm.params.province)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "province", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"country"}},[_vm._v("\n                Country\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.country),expression:"params.country"}],staticClass:"form-control",attrs:{"type":"text","id":"country","placeholder":"Search by country here"},domProps:{"value":(_vm.params.country)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "country", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"pic"}},[_vm._v("\n                PIC\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.pic),expression:"params.pic"}],staticClass:"form-control",attrs:{"type":"text","id":"pic","placeholder":"Search by pic here"},domProps:{"value":(_vm.params.pic)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "pic", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Merchant\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),(!_vm.merchants)?_c('tbody',{key:"empty"},[_vm._m(3)]):_c('tbody',{key:"data"},[(_vm.isLoading)?_c('tr',[_vm._m(4)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.error)?_c('tr',{key:"empty"},[_vm._m(5)]):_vm._l((_vm.merchants),function(merchant){return _c('tr',{key:merchant.id},[_c('td',[_vm._v(_vm._s(merchant.name))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(merchant.code)?_c('span',{staticClass:"badge badge-primary pointer"},[_vm._v("\n                  "+_vm._s(merchant.code)+"\n                ")]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.address))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.province))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.country))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.zip_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(merchant.pic))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"10rem"}},[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(merchant.id)}}},[_vm._v("Edit")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(merchant)}}},[_vm._v("Delete")])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Merchant\n      "),_c('small',[_vm._v("List of Merchant")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Merchant")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Merchants")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"min-width":"15rem"}},[_vm._v("Merchant Name")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Merchant ID")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"15rem"}},[_vm._v("Address")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("City")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Province")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Country")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Zip Code")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"13rem"}},[_vm._v("Phone Number")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("PIC")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Action(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"13"}},[_c('h4',[_vm._v("Result not found")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"13"}},[_c('strong',[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Data failed to load")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76914c02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(694);
function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76914c02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76914c02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"initial"}},[_c('div',{staticClass:"left-form"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"product_name"}},[_vm._v("\n                Product Name\n              ")]),_vm._v(" "),_c('v-select',{attrs:{"name":"favorite","placeholder":"Select favorite highlights","options":_vm.listProducts},model:{value:(_vm.product_name),callback:function ($$v) {_vm.product_name=$$v},expression:"product_name"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"account_name"}},[_vm._v("\n                Account Name\n              ")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Account Name"},domProps:{"value":(_vm.params.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"type"}},[_vm._v("\n                Email\n              ")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.email),expression:"params.email"}],staticClass:"form-control",attrs:{"type":"text","id":"email","placeholder":"Email"},domProps:{"value":(_vm.params.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportCsv('normal')}}},[_vm._v("\n                Export CSV\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"right-form"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-md-12",attrs:{"for":"start_submit_date"}},[_vm._v("\n                Submitted Date\n                ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('div',[_c('datepicker',{attrs:{"id":"start_submit_date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},model:{value:(_vm.start_submit_date),callback:function ($$v) {_vm.start_submit_date=$$v},expression:"start_submit_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('div',[_c('datepicker',{attrs:{"id":"end_submit_date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},model:{value:(_vm.end_submit_date),callback:function ($$v) {_vm.end_submit_date=$$v},expression:"end_submit_date"}})],1)]),_vm._v(" "),_c('label',{staticClass:"col-md-12",attrs:{"for":"start_approval_date"}},[_vm._v("\n                Reviewed Date\n                ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('div',[_c('datepicker',{attrs:{"id":"start_approval_date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},model:{value:(_vm.start_approval_date),callback:function ($$v) {_vm.start_approval_date=$$v},expression:"start_approval_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group col-12 col-md-6"},[_c('div',[_c('datepicker',{attrs:{"id":"end_approval_date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},model:{value:(_vm.end_approval_date),callback:function ($$v) {_vm.end_approval_date=$$v},expression:"end_approval_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                            Status\n                        ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.approval_status),expression:"params.approval_status"}],staticClass:"form-control",attrs:{"id":"status","placeholder":"Select status","value":"null"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "approval_status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.statuses),function(status,index){return _c('option',{key:index,domProps:{"value":status.value}},[_vm._v(_vm._s(status.title))])}),0)])])])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-success pull-right position-bottom",on:{"click":function($event){return _vm.pushState()}}},[_vm._v("\n                Search\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary position-bot",on:{"click":function($event){return _vm.resetState()}}},[_vm._v("\n              Reset\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New Review\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.error)?_c('tr',{key:"empty"},[_vm._m(4)]):_vm._e(),_vm._v(" "),((!_vm.isLoading && _vm.reviews.length < 1))?_c('tr',[_vm._m(5)]):_vm._e(),_vm._v(" "),_vm._l((_vm.reviews),function(review){return _c('tr',{key:review.id},[_c('td',[_vm._v(_vm._s(_vm.parseTime(review.reviewed_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(review.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(review.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(review.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(review.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.reviewType(review.approval_status)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.parseTime(review.approval_date)))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(review.id)}}},[_vm._v("\n                  Preview\n                ")])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Review List\n      "),_c('small',[_vm._v("List of Review")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Review")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Review")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Submitted Date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"30rem"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Account Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Reviewed Date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('strong',[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('strong',[_vm._v("Data failed to load")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('strong',[_vm._v("Result Not Found")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_811ebdbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(701);
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-811ebdbc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_811ebdbc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoUpload_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c0c6656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoUpload_vue__ = __webpack_require__(700);
function injectStyle (ssrContext) {
  __webpack_require__(698)
  __webpack_require__(699)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c0c6656"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoUpload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c0c6656_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"galleriesVideo"},[_c('div',{staticClass:"row space-bottom"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v(_vm._s(_vm.parseTextintoTitle(_vm.type)))])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(!_vm.inline)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"disabled":_vm.isLoading || _vm.isDisabled,"tabindex":"0"},on:{"click":_vm.update}},[_vm._v("\n        Set Video\n      ")]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropzones),expression:"showDropzones"}],staticClass:"row space-bottom"},[_c('div',{staticClass:"col-md-12"},[(_vm.isLoading)?_c('div',{staticClass:"loading-process"},[_c('p',{staticClass:"text-center"},[_c('circle2')],1),_vm._v(" "),_c('div',[_vm._v("\n            Please Wait Video Upload Process...\n          ")])]):_vm._e(),_vm._v(" "),(_vm.isComplete)?_c('div',{staticClass:"loading-process success"},[_vm._v("\n            Upload Success\n        ")]):_vm._e(),_vm._v(" "),_c('dropzone',{ref:"videoUpload",attrs:{"id":"videoUpload","options":_vm.configs.dropzones},on:{"vdropzone-file-added":_vm.fileAddedEvent,"vdropzone-sending":_vm.completeEvent}})],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n                ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'review-index'}}},[_vm._v("\n                    Explore Review\n                ")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"}),_vm._v(" "),_c('form',{staticClass:"form-horizontal",attrs:{"id":"review-form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-select',{attrs:{"name":"product","id":"product-name","options":_vm.list.type,"placeholder":"Select Product Type"},on:{"input":_vm.fetchlistProducts},model:{value:(_vm.flaging),callback:function ($$v) {_vm.flaging=$$v},expression:"flaging"}})],1)]),_vm._v(" "),(_vm.flaging)?_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('v-select',{attrs:{"name":"product","id":"product-name","options":_vm.list.product,"placeholder":"Select Product Name"},model:{value:(_vm.review.product_name),callback:function ($$v) {_vm.$set(_vm.review, "product_name", $$v)},expression:"review.product_name"}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.review.name),expression:"review.name"}],staticClass:"form-control",attrs:{"type":"text","id":"account-name","placeholder":"Input Account Name"},domProps:{"value":(_vm.review.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.review, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.review.description),expression:"review.description"}],staticClass:"form-control",attrs:{"id":"review-description","placeholder":"Input Review Description","maxlength":"1000"},domProps:{"value":(_vm.review.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.review, "description", $event.target.value)}}})])]),_vm._v(" "),_c('box',{attrs:{"id":"gallery","title":"Insert Photo*"}},[_c('button',{staticClass:"btn btn-sm btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                                Choose File\n                                ")]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("\n                                        Upload Attention\n                                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                                        Allowed extension only for PNG, Jpg/Jpeg. file with max size 10000KB\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},[(_vm.review.gallery)?_vm._l((_vm.review.gallery),function(image,index){return _c('div',{key:index,staticClass:"image-item img-thumbnail img-responsive",style:({ backgroundImage: ("url('" + (_vm.getSize(image.url, 'thumb')) + "')") })})}):_vm._e()],2)]),_vm._v(" "),_c('box',{attrs:{"id":"video","title":"Insert Video"}},[_c('button',{staticClass:"btn btn-sm btn-block btn-info",on:{"click":function($event){$event.preventDefault();return _vm.showModal('video')}}},[_vm._v("\n                                Choose File\n                                ")]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("\n                                        Upload Attention\n                                    ")]),_vm._v(" "),_c('p',[_vm._v("\n                                        Allowed extension only for Mp4, Mov. file with max size 100000KB\n                                    ")])]),_vm._v(" "),_c('div',{staticClass:"image-gallery"},[(_vm.review.video.length)?[_c('video',{attrs:{"width":"320","height":"240","controls":""}},[_c('source',{attrs:{"src":_vm.review.video,"type":"video/mp4"}})])]:_vm._e()],2)])],1)])])]),_vm._v(" "),(_vm.review.product_name)?_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"col-sm-12 mt-5",attrs:{"for":"name"}},[_vm._v("Detail Product ")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"image-review",attrs:{"src":_vm.review.product_name.image,"alt":"image-product"}})]),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v("\n                        Product Name \n                    ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n                        : "+_vm._s(_vm.review.product_name.label)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v("\n                        Merchant \n                    ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n                        : "+_vm._s(_vm.review.product_name.merchant)+"\n                    ")])]),_vm._v(" "),(_vm.review.product_name)?_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v("\n                        Destination \n                    ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n                        : "+_vm._s(_vm.review.product_name.destination[_vm.review.product_name.destination.length-1].name+', '+ _vm.review.product_name.destination[_vm.review.product_name.destination.length-2].name)+"\n                    ")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Gallery Images"}},[_c('FileGallery',{attrs:{"type":"gallery","is-multiple":true,"selected":_vm.review.gallery,"is-review":true},on:{"update-images":_vm.setImage}})],1):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.video)?_c('modal',{attrs:{"title":"Select Video"}},[_c('VideoUpload',{attrs:{"type":"Video Upload","is-multiple":false,"selected":_vm.review.video,"is-review":true},on:{"update-video":_vm.setVideo}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":_vm.create}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"},on:{"click":_vm.submit}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"active"},[_c('span',[_vm._v("Create")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-12",attrs:{"for":"name"}},[_vm._v("Product Type\n                                    "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-12",attrs:{"for":"name"}},[_vm._v("Product Name \n                                    "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-12",attrs:{"for":"name"}},[_vm._v("Account Name \n                                    "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-12",attrs:{"for":"name"}},[_vm._v("Review Description\n                                    "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approval_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4389a040_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approval_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(703)
  __webpack_require__(704)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4389a040"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4389a040_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Approval_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */,
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{ name: 'review-index' }}},[_vm._v("\n          Explore Review\n        ")])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"}),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('tr',[_vm._m(1),_vm._v(" "),_c('td',[_vm._v(": "+_vm._s(_vm.parseTime(_vm.detailReview.reviewed_at)))])]),_vm._v(" "),_c('tr',[_vm._m(2),_vm._v(" "),_c('td',[_vm._v(": "+_vm._s(_vm.detailReview.type))])]),_vm._v(" "),_c('tr',[_vm._m(3),_vm._v(" "),_c('td',[_vm._v(": "+_vm._s(_vm.detailReview.name))])]),_vm._v(" "),_c('tr',[_vm._m(4),_vm._v(" "),_c('td',[_vm._v(": "+_vm._s(_vm.detailReview.email))])]),_vm._v(" "),_c('tr',[_vm._m(5),_vm._v(" "),(_vm.detailReview.approval_status === 0)?_c('td',[_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.detailReview.approval_status === 1)?_c('td',[_vm._m(7)]):_vm._e(),_vm._v(" "),(_vm.detailReview.approval_status === 2)?_c('td',[_vm._m(8)]):_vm._e()]),_vm._v(" "),_c('tr',[_vm._m(9),_vm._v(" "),_c('td',[_vm._v(": "+_vm._s(_vm.parseTime(_vm.detailReview.approval_date) || "-"))])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('tr',[_c('td',{staticClass:"description-detail",attrs:{"colspan":"2"}},[_vm._v("\n                "+_vm._s(_vm.detailReview.detail.description)+"\n              ")])]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"image-gallery"},[(_vm.detailReview.detail && _vm.checkImage)?_vm._l((_vm.detailReview.detail.photos),function(image,index){return _c('div',{key:index,staticClass:"image-item img-thumbnail img-responsive",style:({ backgroundImage: ("url('" + (_vm.getSize(image)) + "')") }),on:{"click":_vm.openModal}})}):[_vm._m(12)]],2)])]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('div',{staticClass:"image-gallery"},[((_vm.detailReview.detail && _vm.checkVideo))?[_c('video',{attrs:{"width":"320","height":"240","controls":""}},[_c('source',{attrs:{"src":_vm.detailReview.detail.videos[0],"type":"video/mp4"}})])]:[_c('img',{staticClass:"no-video",attrs:{"src":"/static/img/no-video.png"}})]],2)])])])])]),_vm._v(" "),(_vm.detailReview.detail)?_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"col-sm-12 mt-5",attrs:{"for":"name"}},[_vm._v("Detail Product ")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"image-review",attrs:{"src":_vm.detailReview.detail.product_image,"alt":"image-product"}})]),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v(" Product Name ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.detailReview.detail.product_name)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v(" Merchant ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.detailReview.detail.merchant || "-")+"\n          ")])]),_vm._v(" "),(_vm.destinationDetail.length)?_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v(" Destination ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.destinationDetail[0] + ", ")+"\n            "+_vm._s(_vm.destinationDetail[1] || "-")+"\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v(" Booking Id ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.detailReview.booking_id || "-")+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v(" Booking Date ")]),_vm._v(" "),_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.parseTime(_vm.detailReview.detail.booking_at) || "-")+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"review-list row"},[_c('span',{staticClass:"review-detail-product col-md-3"},[_vm._v(" Activity Date ")]),_vm._v(" "),(_vm.detailReview.detail.travel_date.from === _vm.detailReview.detail.travel_date.to)?_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.parseTime(_vm.detailReview.detail.travel_date.from, 'YYYY-MM-DD') || "-")+"\n          ")]):_c('span',{staticClass:"col-md-7"},[_vm._v("\n            : "+_vm._s(_vm.parseTime(_vm.detailReview.detail.travel_date.from, 'YYYY-MM-DD') || "-")+_vm._s(_vm.parseTime(_vm.detailReview.detail.travel_date.to, 'YYYY-MM-DD')
                ? " s.d. " + _vm.parseTime(_vm.detailReview.detail.travel_date.to, 'YYYY-MM-DD')
                : "")+"\n          ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.detailReview.approval_status === 0)?_c('button',{staticClass:"btn btn-info pull-right approve-button",attrs:{"type":"submit"},on:{"click":_vm.approve}},[_vm._v("\n        Approve\n      ")]):_vm._e(),_vm._v(" "),(_vm.detailReview.approval_status === 0)?_c('button',{staticClass:"btn btn-danger pull-right",attrs:{"type":"submit"},on:{"click":_vm.reject}},[_vm._v("\n        Reject\n      ")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.images)?_c('modal',{staticClass:"modal-review",attrs:{"title":_vm.detailReview.detail.product_name}},[(_vm.detailReview.detail && _vm.checkImage)?_c('div',{staticClass:"carousel-popup"},[_c('VueSlickCarousel',_vm._b({ref:"c1",staticClass:"main-image",attrs:{"asNavFor":_vm.c2}},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.detailReview.detail.photos),function(image,index){return _c('div',{key:index},[_c('img',{staticClass:"image-carousel",attrs:{"src":image}})])}),0),_vm._v(" "),_c('VueSlickCarousel',_vm._b({ref:"c2",staticClass:"thumb-carousel",attrs:{"asNavFor":_vm.c1}},'VueSlickCarousel',_vm.settings2,false),_vm._l((_vm.detailReview.detail.photos),function(image,index){return (_vm.detailReview.detail && _vm.checkImage)?_c('div',{key:index,staticClass:"image-carousel-thumb"},[_c('img',{staticClass:"image-carousel-bottom",attrs:{"src":image}})]):_vm._e()}),0)],1):_vm._e()]):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"active"},[_c('span',[_vm._v("Detail")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('strong',[_vm._v(" Submitted Date ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('strong',[_vm._v(" Type ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('strong',[_vm._v(" Account Name ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('strong',[_vm._v(" Email ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('strong',[_vm._v(" Status ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-field"},[_vm._v("\n                  :\n                  "),_c('span',{staticClass:"status waiting-status"},[_vm._v("\n                    Waiting for Approval\n                  ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-field"},[_vm._v("\n                  :\n                  "),_c('span',{staticClass:"status approved-status"},[_vm._v(" Approved ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-field"},[_vm._v("\n                  :\n                  "),_c('span',{staticClass:"status rejected-status"},[_vm._v(" Rejected ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[_c('strong',[_vm._v(" Reviewed Date ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_c('strong',[_vm._v(" Review Description ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_c('strong',[_vm._v(" Photo ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"no-video",attrs:{"src":"/static/img/no-image.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_c('strong',[_vm._v(" Video ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a653a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(711);
function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03a653a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      BIN\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'bin-index' })}}},[_c('i',{staticClass:"fa fa-bank"}),_vm._v(" BIN\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"box-header"},[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n            Create New\n          ")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('tbody',{key:"loading"},[_c('tr',[_c('td',[_c('h3',[_vm._v("Loading")])])])]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_c('tr',[_c('td',[_c('h3',[_vm._v("Empty")])])])]):_c('tbody',{key:"data"},[_c('tr',[_c('th',[_vm._v("BIN")]),_vm._v(" "),_c('th',[_vm._v("Bank Name")]),_vm._v(" "),_c('th',[_vm._v("Card Series")]),_vm._v(" "),_c('th',[_vm._v("Category")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10rem"}},[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.bin))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.bank_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.card_series))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCreditCardName(item.category)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type))]),_vm._v(" "),_c('td',[_c('strong',{class:{
                      'text-success': item.is_enabled === 1,
                      'text-muted': item.is_enabled === 0
                    }},[(item.is_enabled === 1)?_c('i',{staticClass:"fa fa-check-square-o"}):_c('i',{staticClass:"fa fa-square-o"}),_vm._v("\n                      "+_vm._s(_vm.parseStatus(item.is_enabled))+"\n                    ")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(item.id)}}},[_vm._v("\n                      Edit\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(item)}}},[_vm._v("\n                      Delete\n                    ")])])])})],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("BIN")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94941c32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(713);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94941c32_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      BIN\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'bin-index' })}}},[_c('i',{staticClass:"fa fa-bank"}),_vm._v(" BIN\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.bin),expression:"form.bin"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control",attrs:{"data-vv-as":"BIN","type":"text","id":"bin","name":"bin","placeholder":"BIN Number"},domProps:{"value":(_vm.form.bin)},on:{"keydown":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "bin", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.bankName),expression:"form.bankName"}],staticClass:"form-control",attrs:{"type":"text","id":"bank-name","name":"bank-name","placeholder":"Bank Name"},domProps:{"value":(_vm.form.bankName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "bankName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"category","options":_vm.lists.type},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"category","options":_vm.lists.category},model:{value:(_vm.form.category),callback:function ($$v) {_vm.$set(_vm.form, "category", $$v)},expression:"form.category"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.cardSeries),expression:"form.cardSeries"}],staticClass:"form-control",attrs:{"type":"text","id":"card-series","name":"card-series","placeholder":"Card Series Name"},domProps:{"value":(_vm.form.cardSeries)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "cardSeries", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"status"}},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"status","name":"status","options":_vm.lists.statuses},model:{value:(_vm.form.isEnabled),callback:function ($$v) {_vm.$set(_vm.form, "isEnabled", $$v)},expression:"form.isEnabled"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",on:{"click":_vm.submit}},[(_vm.isCreate)?[_vm._v("Create")]:[_vm._v("Update")]],2),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("\n          Cancel\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"bin"}},[_vm._v("\n                  BIN "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"bank-name"}},[_vm._v("\n                  Bank Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"category"}},[_vm._v("\n                  Type "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"category"}},[_vm._v("\n                  Category "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"card-series"}},[_vm._v("\n                  Card Series "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b18a16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(719);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56b18a16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d073f73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(716);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d073f73_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n            Add New Payment Method\n          ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[(_vm.paymentMethods)?[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.paymentMethods),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.key))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-xs",class:{
                        'btn-success': item.status == 1,
                        'btn-default': item.status == 0,
                      },on:{"click":function($event){return _vm.toggleStatus(item)}}},[(item.status == 0)?[_vm._v("Disabled")]:[_vm._v("Enabled")]],2)]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){return _vm.edit(item.id)}}},[_vm._v("\n                      Edit\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){return _vm.remove(item)}}},[_vm._v("\n                      Delete\n                    ")])])])}),0)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n        Payment Methods\n        "),_c('small',[_vm._v("List of payment methods")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_vm._v("Operation Tools")]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Payment Methods")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Payment Method")]),_vm._v(" "),_c('th',[_vm._v("Key")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"12rem"}},[_vm._v("Action(s)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c64690_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(718);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68c64690_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n        Payment Methods\n        "),_c('small',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path: '/payment/methods'}}},[_vm._v("\n          Payment Methods\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body"},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){$event.preventDefault();_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","name":"name","placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.key),expression:"form.key"}],staticClass:"form-control",attrs:{"type":"text","id":"key","name":"key","placeholder":"Key"},domProps:{"value":(_vm.form.key)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "key", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('label',{staticClass:"form-check-label"},[_c('label',{attrs:{"for":"disable"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"status","id":"disable","value":"0"},domProps:{"checked":_vm._q(_vm.form.status,"0")},on:{"change":function($event){return _vm.$set(_vm.form, "status", "0")}}}),_vm._v(" Disabled\n                    ")]),_vm._v(" "),_c('label',{attrs:{"for":"enable"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"status","id":"enable","value":"1"},domProps:{"checked":_vm._q(_vm.form.status,"1")},on:{"change":function($event){return _vm.$set(_vm.form, "status", "1")}}}),_vm._v(" Enabled\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"key"}},[_vm._v("\n                  Key "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7059f2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(726);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7059f2a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae16d5e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(723);
function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae16d5e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae16d5e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n            Add New Disable Payment\n          ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(1),_vm._v(" "),(!_vm.setups)?_c('tbody',{key:"empty"},[_vm._m(2)]):_c('tbody',{key:"finish"},_vm._l((_vm.setups),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.getMethodName(item.payment_method)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.parseDate(item.start_date)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.parseDate(item.end_date)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.start_end_time[0].start)+" - "+_vm._s(item.start_end_time[0].end))]),_vm._v(" "),_c('td',_vm._l((item.days),function(day,dayIndex){return _c('span',{key:dayIndex},[_vm._v("\n                      "+_vm._s(_vm.parseDay(day))+",\n                    ")])}),0),_vm._v(" "),_c('td',{staticClass:"text-center"},_vm._l((item.media),function(media,mediaIndex){return _c('span',{key:mediaIndex,staticClass:"label",class:media},[_c('i',{staticClass:"fa fa-fw",class:_vm.parseMedia(media)})])}),0),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-xs",class:{
                        'btn-success': item.is_enabled == 1,
                        'btn-default': item.is_enabled == 0,
                      }},[(item.is_enabled == 0)?[_vm._v("Disabled")]:[_vm._v("Enabled")]],2)]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){return _vm.edit(item.id)}}},[_vm._v("\n                      Edit\n                    ")])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n        Disable Payment\n        "),_c('small',[_vm._v("Disable a payment on specific time")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_vm._v("Operation Tools")]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Disable Payment")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Payment Method")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Start Date")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("End Date")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Time Range")]),_vm._v(" "),_c('th',[_vm._v("Days")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Media")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Actions(s)")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"8"}},[_vm._v("\n                    No record\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd3ac972_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(725);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd3ac972_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_vm._m(0),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path: '/payment-setups'}}},[_vm._v("Payment Setups")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                ×\n              ")]),_vm._v("\n              "+_vm._s(_vm.error)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","name":"methods","id":"methods","options":_vm.lists.payments},model:{value:(_vm.form.payment_method),callback:function ($$v) {_vm.$set(_vm.form, "payment_method", $$v)},expression:"form.payment_method"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"id":"setup-description","name":"setup-description","row":"6","placeholder":"Payment setup description"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","id":"media","name":"media","options":_vm.lists.medias},model:{value:(_vm.form.media),callback:function ($$v) {_vm.$set(_vm.form, "media", $$v)},expression:"form.media"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","id":"days","name":"days","options":_vm.lists.days},model:{value:(_vm.form.days),callback:function ($$v) {_vm.$set(_vm.form, "days", $$v)},expression:"form.days"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"start_date","name":"start_date","wrapper-class":"custom-vdp","format":"yyyy-MM-dd","disabled":_vm.disabledStartDate,"input-class":"form-control"},model:{value:(_vm.form.date.start),callback:function ($$v) {_vm.$set(_vm.form.date, "start", $$v)},expression:"form.date.start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"end_date","name":"end_date","wrapper-class":"custom-vdp","format":"yyyy-MM-dd","disabled":_vm.disabledEndDate,"input-class":"form-control"},model:{value:(_vm.form.date.end),callback:function ($$v) {_vm.$set(_vm.form.date, "end", $$v)},expression:"form.date.end"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('vue-timepicker',{attrs:{"hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.time.start),callback:function ($$v) {_vm.$set(_vm.form.time, "start", $$v)},expression:"form.time.start"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('vue-timepicker',{attrs:{"hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.time.end),callback:function ($$v) {_vm.$set(_vm.form.time, "end", $$v)},expression:"form.time.end"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"status"}},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"status","name":"status","options":_vm.lists.statuses},model:{value:(_vm.form.is_enabled),callback:function ($$v) {_vm.$set(_vm.form, "is_enabled", $$v)},expression:"form.is_enabled"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",on:{"click":_vm.submit}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",on:{"click":_vm.submit}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n      Payment Setups\n      "),_c('small',[_vm._v("Create new payment setup")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"methods"}},[_vm._v("\n                  Payment Methods "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"setup"}},[_vm._v("\n                  Payment Description "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"media"}},[_vm._v("\n                  Media "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"days"}},[_vm._v("\n                  Active Days "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"date"}},[_vm._v("\n                  Date "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"time"}},[_vm._v("\n                  Time "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.component,{tag:"component"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a4a604_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(728);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11a4a604_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promo\n      "),_c('small',[_vm._v("Promo tools")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Promo")])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('h2',[_c('i',{staticClass:"fa fa-fw fa-bank"}),_vm._v(" BIN")])]),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_vm._v("Panel footer")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('h2',[_c('i',{staticClass:"fa fa-fw fa-ticket"}),_vm._v(" Code")])]),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_vm._v("Panel footer")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6 col-lg-4"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('h2',[_c('i',{staticClass:"fa fa-fw fa-cog"}),_vm._v(" Config")])]),_vm._v(" "),_c('div',{staticClass:"panel-footer"},[_vm._v("Panel footer")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(343);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0f9f59a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(731);
function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0f9f59a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promotions\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-bin-index' })}}},[_c('i',{staticClass:"fa fa-bank"}),_vm._v(" BIN\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"promo_payment"}},[_vm._v("\n            Promo Payment\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.promo_payment),expression:"params.promo_payment"}],staticClass:"form-control",attrs:{"type":"text","id":"promo_payment","placeholder":"Search by promo payment here"},domProps:{"value":(_vm.params.promo_payment)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "promo_payment", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"box-header"},[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n            Create New\n          ")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('tbody',{key:"loading"},[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('strong',[_vm._v("Loading")])])])]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_c('strong',[_vm._v("Result not found")])])])]):_c('tbody',{key:"data"},[_c('tr',[_c('th',[_vm._v("Promo Payment")]),_vm._v(" "),_c('th',[_vm._v("Promo Codes")]),_vm._v(" "),_c('th',[_vm._v("BIN")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"width":"10rem"}},[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.promo_config))]),_vm._v(" "),_c('td',_vm._l((item.code),function(code){return _c('span',{staticClass:"label label-info"},[_vm._v("\n                      "+_vm._s(code)+"\n                    ")])}),0),_vm._v(" "),_c('td',_vm._l((item.bin),function(bin){return _c('span',{staticClass:"label label-default"},[_vm._v("\n                      "+_vm._s(bin)+"\n                    ")])}),0),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(item.promo_config_id)}}},[_vm._v("\n                      Edit\n                    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(item)}}},[_vm._v("\n                      Delete\n                    ")])])])})],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',[_vm._v("Filter Promo Bin")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("Promo BIN")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e74411c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(736);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e74411c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 733 */,
/* 734 */,
/* 735 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promotions\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-bin-index' })}}},[_c('i',{staticClass:"fa fa-bank"}),_vm._v(" BIN\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"visible"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"promo-config","options":_vm.promoConfigs},model:{value:(_vm.form.config),callback:function ($$v) {_vm.$set(_vm.form, "config", $$v)},expression:"form.config"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","id":"promo-code","options":_vm.promoCodes},model:{value:(_vm.form.code),callback:function ($$v) {_vm.$set(_vm.form, "code", $$v)},expression:"form.code"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","id":"promo-config-bin","options":_vm.promoBins},model:{value:(_vm.form.bin),callback:function ($$v) {_vm.$set(_vm.form, "bin", $$v)},expression:"form.bin"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",on:{"click":_vm.submit}},[(_vm.isCreate)?[_vm._v("Create")]:[_vm._v("Update")]],2),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("\n          Cancel\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-config"}},[_vm._v("\n                  Promo Payment "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-code"}},[_vm._v("\n                  Promo Codes "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-config-bin"}},[_vm._v("\n                  Promo BINs "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee6021f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(739);
function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ee6021f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee6021f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("Promotions")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-code-index' })}}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v(" Code\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n            Promo Code\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.code),expression:"params.code"}],staticClass:"form-control",attrs:{"type":"text","id":"code","placeholder":"Search by promo code here"},domProps:{"value":(_vm.params.code)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "code", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("Create New")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"box-body table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('tbody',{key:"loading"},[_c('tr',[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v("Loading")])])])]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_c('tr',[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v("Result not found")])])])]):_c('tbody',{key:"data"},[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Promo Code")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"21rem"}},[_vm._v("Promo Payment")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Start Date")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("End Date")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"14rem"}},[_vm._v("Time Range")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Applicable To")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"8rem"}},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Nominal")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Min. Amount")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Max. Amount")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Minimum Pay")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Quota")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Daily Quota")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Recurring Type")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Recurring Value")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Locked Domains")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"14rem"}},[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_c('a',{staticClass:"label label-block text-uppercase",class:{
                        'label-info': item.detail.type === 'percentage',
                        'label-success': item.detail.type === 'amount',
                      },on:{"click":function($event){$event.preventDefault();return _vm.edit(item.id)}}},[_vm._v(_vm._s(item.code))])]),_vm._v(" "),_c('td',[(item.promo_config_name)?[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item.promo_config_name)))]:[_vm._v("-")]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('strong',{class:{
                      'text-success': item.is_enable === 1,
                      'text-muted': item.is_enable === 0
                    }},[(item.is_enable === 1)?_c('i',{staticClass:"fa fa-check-square-o"}):_c('i',{staticClass:"fa fa-square-o"}),_vm._v("\n                      "+_vm._s(_vm.parseStatus(item.is_enable))+"\n                    ")])]),_vm._v(" "),_c('td',{staticClass:"text-center",class:{
                      'text-primary strong': item.is_date_active,
                      'text-muted': !item.is_date_active,
                    }},[_vm._v(_vm._s(_vm._f("simpleDate")(item.start_date)))]),_vm._v(" "),_c('td',{staticClass:"text-center",class:{
                      'text-primary strong': item.is_date_active,
                      'text-muted': !item.is_date_active,
                    }},[_vm._v(_vm._s(_vm._f("simpleDate")(item.end_date)))]),_vm._v(" "),_c('td',{staticClass:"text-center",class:{
                      'text-primary strong': item.is_date_active,
                      'text-muted': !item.is_date_active,
                    }},[_vm._v(_vm._s(item.start_time)+" - "+_vm._s(item.end_time))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._l((item.detail.medias),function(media){return [_c('span',{staticClass:"label",class:media},[_c('i',{staticClass:"fa fa-fw",class:_vm.parseMedia(media)})])]})],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(item.detail.type)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.parseNominal(item.detail.nominal, item.detail.type)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("digitGrouping")(item.detail.minimum_pay_amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("digitGrouping")(item.detail.maximum_amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("digitGrouping")(item.detail.minimum_payment)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.quota))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.daily_quota))]),_vm._v(" "),_c('td',{staticClass:"text-center",staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(item.detail.recurring_type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.renderRecurringValue(item.detail.recurring_type, item.detail.recurring_value)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.checkLockedDomain(item.detail.is_locked_domain, item.detail.locked_domains)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-info btn-xs",staticStyle:{"min-width":"6rem"},on:{"click":function($event){$event.preventDefault();return _vm.view(item.id)}}},[_vm._v("View")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default btn-xs",staticStyle:{"min-width":"6rem"},on:{"click":function($event){$event.preventDefault();return _vm.edit(item.id)}}},[_vm._v("Edit")])])])})],2)])],1)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',[_vm._v("Filter Promo Code")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("Promo Codes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70831fb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(741);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70831fb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("Promotions")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-code-index' })}}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v(" Code\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('datepicker',{attrs:{"disabled":_vm.disabledStartDate,"input-class":"form-control","name":"promo-start-date"},model:{value:(_vm.form.start_date),callback:function ($$v) {_vm.$set(_vm.form, "start_date", $$v)},expression:"form.start_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('datepicker',{attrs:{"disabled":_vm.disabledEndDate,"input-class":"form-control","name":"promo-end-date"},model:{value:(_vm.form.end_date),callback:function ($$v) {_vm.$set(_vm.form, "end_date", $$v)},expression:"form.end_date"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('vue-timepicker',{attrs:{"hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.start_time),callback:function ($$v) {_vm.$set(_vm.form, "start_time", $$v)},expression:"form.start_time"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('vue-timepicker',{attrs:{"hide-clear-button":"","format":"HH:mm:ss"},model:{value:(_vm.form.end_time),callback:function ($$v) {_vm.$set(_vm.form, "end_time", $$v)},expression:"form.end_time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.code),expression:"form.code"}],staticClass:"form-control",staticStyle:{"text-transform":"uppercase"},attrs:{"required":"","type":"text","maxlength":"15","id":"promo-code","name":"promo-code","pattern":".{0}|.{7,15}","placeholder":"Promo Code (7 to 15 chars)"},domProps:{"value":(_vm.form.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name"}},[_vm._v("Product Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","name":"product","placeholder":"Select Product","options":_vm.list.products},model:{value:(_vm.form.product_id),callback:function ($$v) {_vm.$set(_vm.form, "product_id", $$v)},expression:"form.product_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name"}},[_vm._v("Badges")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","name":"badges","placeholder":"Select Product Badges","options":_vm.list.badges},model:{value:(_vm.form.badges_id),callback:function ($$v) {_vm.$set(_vm.form, "badges_id", $$v)},expression:"form.badges_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name"}},[_vm._v("Destination")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('treeselect',{ref:"destinationOption",attrs:{"placeholder":"Select Product Destination","sort-value-by":"LEVEL","value-consists-of":'ALL_WITH_INDETERMINATE',"id":"form","multiple":true,"options":_vm.list.destinations,"default-expand-level":2,"auto-load-root-options":true},model:{value:(_vm.form.destination_id),callback:function ($$v) {_vm.$set(_vm.form, "destination_id", $$v)},expression:"form.destination_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"promo-name","options":_vm.promoconfigs},model:{value:(_vm.form.config),callback:function ($$v) {_vm.$set(_vm.form, "config", $$v)},expression:"form.config"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"id":"promo-type","on-change":_vm.switchType,"options":_vm.nominalTypes},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group",class:{ 'has-error': _vm.errors.has('promo-nominal') }},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon",attrs:{"id":"nominal"}},[_vm._v(_vm._s(_vm.nominalPrefix))]),_vm._v(" "),_c('cleave',{directives:[{name:"validate",rawName:"v-validate",value:(_vm.nominalValidation),expression:"nominalValidation"}],staticClass:"form-control",attrs:{"options":{ numeral: true },"maxlength":_vm.nominalMaxLength,"type":"text","min":"0","id":"promo-nominal","name":"promo-nominal","aria-describedby":"nominal","placeholder":"Amount/Percentage"},on:{"keydown":_vm.isNumber},model:{value:(_vm.form.nominal),callback:function ($$v) {_vm.$set(_vm.form, "nominal", $$v)},expression:"form.nominal"}})],1)])]),_vm._v(" "),(_vm.showMinPayment)?_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.minimum_pay_amount),expression:"form.minimum_pay_amount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":"promo-min-pay-amount","name":"promo-min-pay-amount","placeholder":"Minimum payment amount"},domProps:{"value":(_vm.form.minimum_pay_amount)},on:{"keydown":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "minimum_pay_amount", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.maximum_amount),expression:"form.maximum_amount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":"promo-max-pay-amount","name":"promo-max-pay-amount","placeholder":"Maximum payment amount"},domProps:{"value":(_vm.form.maximum_amount)},on:{"keydown":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "maximum_amount", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.quota),expression:"form.quota"}],staticClass:"form-control",attrs:{"type":"number","min":"1","id":"promo-quota","name":"promo-quota","placeholder":"Quota (0 = Unlimited)","disabled":_vm.form.isUnlimitedQuota},domProps:{"value":(_vm.form.quota)},on:{"keydown":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "quota", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.isUnlimitedQuota),expression:"form.isUnlimitedQuota"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.isUnlimitedQuota)?_vm._i(_vm.form.isUnlimitedQuota,null)>-1:(_vm.form.isUnlimitedQuota)},on:{"change":[function($event){var $$a=_vm.form.isUnlimitedQuota,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "isUnlimitedQuota", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "isUnlimitedQuota", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "isUnlimitedQuota", $$c)}},function($event){return _vm.onUnlimitedChecked('quota')}]}}),_vm._v(" Unlimited Quota\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.daily_quota),expression:"form.daily_quota"}],staticClass:"form-control",attrs:{"type":"number","min":"1","id":"promo-quota","name":"promo-quota","placeholder":"Daily Quota (0 = Unlimited)","disabled":_vm.form.isUnlimitedDailyQuota},domProps:{"value":(_vm.form.daily_quota)},on:{"keydown":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "daily_quota", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.isUnlimitedDailyQuota),expression:"form.isUnlimitedDailyQuota"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.form.isUnlimitedDailyQuota)?_vm._i(_vm.form.isUnlimitedDailyQuota,null)>-1:(_vm.form.isUnlimitedDailyQuota)},on:{"change":[function($event){var $$a=_vm.form.isUnlimitedDailyQuota,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "isUnlimitedDailyQuota", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "isUnlimitedDailyQuota", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "isUnlimitedDailyQuota", $$c)}},function($event){return _vm.onUnlimitedChecked('daily_quota')}]}}),_vm._v(" Unlimited Daily Quota\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.minimum_payment),expression:"form.minimum_payment"}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":"promo-min-payment","name":"promo-min-payment","placeholder":"Minimum payment"},domProps:{"value":(_vm.form.minimum_payment)},on:{"keydown":_vm.isNumber,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "minimum_payment", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},_vm._l((_vm.medias),function(item){return _c('label',{staticClass:"checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.media),expression:"form.media"}],attrs:{"type":"checkbox","id":item.value},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.media)?_vm._i(_vm.form.media,item.value)>-1:(_vm.form.media)},on:{"change":function($event){var $$a=_vm.form.media,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "media", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "media", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "media", $$c)}}}}),_vm._v("\n                    "+_vm._s(item.label)+"\n                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},_vm._l((_vm.availables),function(item){return _c('label',{staticClass:"checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.available_to),expression:"form.available_to"}],attrs:{"type":"checkbox","id":'available_to_' + item.value,"disabled":item.disabled},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.available_to)?_vm._i(_vm.form.available_to,item.value)>-1:(_vm.form.available_to)},on:{"click":function($event){return _vm.availableToChecked(item.value)},"change":function($event){var $$a=_vm.form.available_to,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "available_to", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "available_to", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "available_to", $$c)}}}}),_vm._v("\n                    "+_vm._s(item.label)+"\n                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"restriction"}},[_vm._v("Restriction")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":true,"options":_vm.restrictions},model:{value:(_vm.form.restriction),callback:function ($$v) {_vm.$set(_vm.form, "restriction", $$v)},expression:"form.restriction"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"recurring-type"}},[_vm._v("Recurring Type")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{staticStyle:{"text-transform":"capitalize"},attrs:{"options":['none', 'day', 'date']},model:{value:(_vm.form.recurring_type),callback:function ($$v) {_vm.$set(_vm.form, "recurring_type", $$v)},expression:"form.recurring_type"}})],1)]),_vm._v(" "),(_vm.form.recurring_type !== 'none' && _vm.form.recurring_type === 'date')?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"recurring-value"}},[_vm._v("Recurring Value (Date)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":true,"options":_vm.dates},model:{value:(_vm.form.recurring_date),callback:function ($$v) {_vm.$set(_vm.form, "recurring_date", $$v)},expression:"form.recurring_date"}})],1)]):_vm._e(),_vm._v(" "),(_vm.form.recurring_type !== 'none' && _vm.form.recurring_type === 'day')?_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-media"}},[_vm._v("Recurring Value (Day)")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('span',{staticClass:"btn btn-default btn-xs",on:{"click":_vm.toggleAllDays}},[_vm._v("All Days")]),_vm._v(" "),_vm._l((_vm.days),function(day){return _c('label',{staticClass:"checkbox-inline",attrs:{"for":day.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.recurring_day),expression:"form.recurring_day"}],attrs:{"type":"checkbox","id":day.value},domProps:{"value":day.value,"checked":Array.isArray(_vm.form.recurring_day)?_vm._i(_vm.form.recurring_day,day.value)>-1:(_vm.form.recurring_day)},on:{"change":function($event){var $$a=_vm.form.recurring_day,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=day.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "recurring_day", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "recurring_day", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "recurring_day", $$c)}}}}),_vm._v("\n                    "+_vm._s(day.label)+"\n                  ")])})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"is-locked-domain"}},[_vm._v("Is Locked Domain")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.is_locked_domain),expression:"form.is_locked_domain"}],attrs:{"type":"radio","name":_vm.form.is_locked_domain},domProps:{"value":1,"checked":_vm._q(_vm.form.is_locked_domain,1)},on:{"change":function($event){return _vm.$set(_vm.form, "is_locked_domain", 1)}}}),_vm._v("\n                    Yes\n                  ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.is_locked_domain),expression:"form.is_locked_domain"}],attrs:{"type":"radio","name":_vm.form.is_locked_domain},domProps:{"value":0,"checked":_vm._q(_vm.form.is_locked_domain,0)},on:{"change":function($event){return _vm.$set(_vm.form, "is_locked_domain", 0)}}}),_vm._v("\n                    No\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"locked-domains"}},[_vm._v("Locked Domains")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.locked_domains),expression:"form.locked_domains"}],staticClass:"form-control",attrs:{"multiple":true,"placeholder":"Separated by comma (,)"},domProps:{"value":(_vm.form.locked_domains)},on:{"keydown":_vm.isStringCommaOnly,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "locked_domains", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"type":"text","id":"promo-description","name":"promo-description","placeholder":"Promo description"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(15),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"options":_vm.statuses},model:{value:(_vm.form.is_enabled),callback:function ($$v) {_vm.$set(_vm.form, "is_enabled", $$v)},expression:"form.is_enabled"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",on:{"click":_vm.submit}},[(_vm.isCreate)?[_vm._v("Create")]:[_vm._v("Update")]],2),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  Start Date\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-end-date"}},[_vm._v("\n                  End Date\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-time"}},[_vm._v("\n                  Start-End Time\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-code"}},[_vm._v("\n                  Promo Name\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name"}},[_vm._v("\n                  Promo Payments\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-type"}},[_vm._v("\n                  Type\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-nominal"}},[_vm._v("\n                  Nominal\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-min-pay-amount"}},[_vm._v("\n                  Min. Pay Amount\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-max-pay-amount"}},[_vm._v("\n                  Max. Promo Disc.\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-quota"}},[_vm._v("\n                  Quota\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-quota"}},[_vm._v("\n                  Daily Quota\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-min-payment"}},[_vm._v("\n                  Min. Payment\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-media"}},[_vm._v("\n                  Applicable To\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-available"}},[_vm._v("\n                  Available To\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-description"}},[_vm._v("\n                  Description\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Status\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db11408_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__(743);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9db11408_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promotions\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-code-index' })}}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v(" Code\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.start_date),expression:"form.start_date"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.start_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "start_date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.end_date),expression:"form.end_date"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.end_date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "end_date", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.start_time),expression:"form.start_time"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.start_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "start_time", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.end_time),expression:"form.end_time"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.end_time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "end_time", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.code),expression:"form.code"}],staticClass:"form-control",staticStyle:{"text-transform":"uppercase"},attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name"}},[_vm._v("Product Name")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","name":"product","placeholder":"Select Product","options":_vm.list.products,"disabled":""},model:{value:(_vm.form.product_id),callback:function ($$v) {_vm.$set(_vm.form, "product_id", $$v)},expression:"form.product_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name-badges"}},[_vm._v("Badges")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","name":"badges","placeholder":"Select Product Badges","options":_vm.list.badges,"disabled":""},model:{value:(_vm.form.badges),callback:function ($$v) {_vm.$set(_vm.form, "badges", $$v)},expression:"form.badges"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-name"}},[_vm._v("Destination")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('treeselect',{ref:"destinationOption",attrs:{"placeholder":"Select Product Destination","sort-value-by":"LEVEL","value-consists-of":'ALL_WITH_INDETERMINATE',"id":"form","multiple":true,"options":_vm.list.destinations,"default-expand-level":2,"auto-load-root-options":true,"disabled":""},model:{value:(_vm.form.destination_id),callback:function ($$v) {_vm.$set(_vm.form, "destination_id", $$v)},expression:"form.destination_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  Promo Payments\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.promo_config_name),expression:"form.promo_config_name"}],staticClass:"form-control",staticStyle:{"text-transform":"uppercase"},attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.promo_config_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "promo_config_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.type),expression:"form.type"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.type)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "type", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon",attrs:{"id":"nominal"}},[_vm._v("\n                      "+_vm._s(_vm.nominalPrefix)+"\n                    ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.nominal),expression:"form.nominal"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.nominal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "nominal", $event.target.value)}}})])])]),_vm._v(" "),(_vm.form.type === 'nominal')?_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.minimum_pay_amount),expression:"form.minimum_pay_amount"}],staticClass:"form-control",attrs:{"disabled":"","type":"number"},domProps:{"value":(_vm.form.minimum_pay_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "minimum_pay_amount", $event.target.value)}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.maximum_amount),expression:"form.maximum_amount"}],staticClass:"form-control",attrs:{"disabled":"","type":"number"},domProps:{"value":(_vm.form.maximum_amount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "maximum_amount", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.quota),expression:"form.quota"}],staticClass:"form-control",attrs:{"type":"number","min":"1","id":"promo-quota","name":"promo-quota","placeholder":"Quota (0 = Unlimited)","disabled":""},domProps:{"value":(_vm.form.quota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "quota", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.isUnlimitedQuota),expression:"form.isUnlimitedQuota"}],attrs:{"type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.form.isUnlimitedQuota)?_vm._i(_vm.form.isUnlimitedQuota,null)>-1:(_vm.form.isUnlimitedQuota)},on:{"change":function($event){var $$a=_vm.form.isUnlimitedQuota,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "isUnlimitedQuota", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "isUnlimitedQuota", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "isUnlimitedQuota", $$c)}}}}),_vm._v(" Unlimited Quota\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.daily_quota),expression:"form.daily_quota"}],staticClass:"form-control",attrs:{"type":"number","min":"1","id":"promo-quota","name":"promo-quota","placeholder":"Daily Quota (0 = Unlimited)","disabled":""},domProps:{"value":(_vm.form.daily_quota)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "daily_quota", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.isUnlimitedDailyQuota),expression:"form.isUnlimitedDailyQuota"}],attrs:{"type":"checkbox","disabled":""},domProps:{"checked":Array.isArray(_vm.form.isUnlimitedDailyQuota)?_vm._i(_vm.form.isUnlimitedDailyQuota,null)>-1:(_vm.form.isUnlimitedDailyQuota)},on:{"change":function($event){var $$a=_vm.form.isUnlimitedDailyQuota,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "isUnlimitedDailyQuota", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "isUnlimitedDailyQuota", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "isUnlimitedDailyQuota", $$c)}}}}),_vm._v(" Unlimited Daily Quota\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.minimum_payment),expression:"form.minimum_payment"}],staticClass:"form-control",attrs:{"disabled":"","type":"number"},domProps:{"value":(_vm.form.minimum_payment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "minimum_payment", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},_vm._l((_vm.form.media),function(item){return _c('label',{staticClass:"checkbox-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.media),expression:"form.media"}],attrs:{"disabled":"","type":"checkbox","id":item},domProps:{"value":item,"checked":Array.isArray(_vm.form.media)?_vm._i(_vm.form.media,item)>-1:(_vm.form.media)},on:{"change":function($event){var $$a=_vm.form.media,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "media", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "media", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "media", $$c)}}}}),_vm._v("\n                    "+_vm._s(item)+"\n                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},_vm._l((_vm.availables),function(item){return _c('label',{staticClass:"checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.available_to),expression:"form.available_to"}],attrs:{"type":"checkbox","id":'available_to_' + item.value,"disabled":""},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.available_to)?_vm._i(_vm.form.available_to,item.value)>-1:(_vm.form.available_to)},on:{"change":function($event){var $$a=_vm.form.available_to,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "available_to", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "available_to", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "available_to", $$c)}}}}),_vm._v("\n                    "+_vm._s(item.label)+"\n                  ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"restriction"}},[_vm._v("\n                  Restriction\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"disabled":"","multiple":true},model:{value:(_vm.form.restriction),callback:function ($$v) {_vm.$set(_vm.form, "restriction", $$v)},expression:"form.restriction"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"is-locked-domain"}},[_vm._v("\n                  Is Locked Domain\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.is_locked_domain),expression:"form.is_locked_domain"}],attrs:{"disabled":"","type":"radio"},domProps:{"value":1,"checked":_vm._q(_vm.form.is_locked_domain,1)},on:{"change":function($event){return _vm.$set(_vm.form, "is_locked_domain", 1)}}}),_vm._v("\n                    Yes\n                  ")]),_vm._v(" "),_c('label',{staticClass:"radio-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.is_locked_domain),expression:"form.is_locked_domain"}],attrs:{"disabled":"","type":"radio"},domProps:{"value":0,"checked":_vm._q(_vm.form.is_locked_domain,0)},on:{"change":function($event){return _vm.$set(_vm.form, "is_locked_domain", 0)}}}),_vm._v("\n                    No\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"locked-domains"}},[_vm._v("Locked Domains")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.locked_domains),expression:"form.locked_domains"}],staticClass:"form-control",attrs:{"disabled":"","multiple":true,"placeholder":"Separated by comma (,)"},domProps:{"value":(_vm.form.locked_domains)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "locked_domains", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"disabled":"","options":_vm.statuses},model:{value:(_vm.form.is_enabled),callback:function ($$v) {_vm.$set(_vm.form, "is_enabled", $$v)},expression:"form.is_enabled"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('a',{staticClass:"btn btn-default pull-right",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("\n          Back\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  Start Date "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  End Date "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-time"}},[_vm._v("\n                  Start-End Time "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  Promo Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  Type "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-start-date"}},[_vm._v("\n                  Nominal "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-min-pay-amount"}},[_vm._v("\n                  Min. Pay Amount "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-max-pay-amount"}},[_vm._v("\n                  Max. Promo Disc. "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-quota"}},[_vm._v("\n                  Quota\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-quota"}},[_vm._v("\n                  Daily Quota\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-min-payment"}},[_vm._v("\n                  Min. Payment "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-media"}},[_vm._v("\n                  Applicable To "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-available"}},[_vm._v("\n                  Available To\n                  "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-description"}},[_vm._v("\n                  Description "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Status "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8a7836_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(745);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d8a7836_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promotions\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-config-index' })}}},[_c('i',{staticClass:"fa fa-credit-card"}),_vm._v(" Payments\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"inherit"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"promoPaymentName"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"promoPaymentName","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"paymentMethod"}},[_vm._v("\n                Payment Method\n              ")]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","id":"paymentMethod","name":"paymentMethod","options":_vm.payments},model:{value:(_vm.paymentsSelected),callback:function ($$v) {_vm.paymentsSelected=$$v},expression:"paymentsSelected"}})],1)])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_vm._m(1),_vm._v(" "),_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Create New\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('tbody',{key:"loading"},[_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Loading")])])])]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_c('tr',[_c('td',{attrs:{"colspan":"6"}},[_c('strong',[_vm._v("Result not found")])])])]):_c('tbody',{key:"data"},[_c('tr',[_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Days")]),_vm._v(" "),_c('th',[_vm._v("Payment Methods")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',_vm._l((item.type),function(promoType){return _c('span',{key:promoType.id},[_vm._v("\n                    "+_vm._s(promoType)+"\n                  ")])}),0),_vm._v(" "),_c('td',_vm._l((item.days),function(day){return _c('span',{key:day},[_vm._v("\n                    "+_vm._s(_vm.parseDay(day))+"\n                  ")])}),0),_vm._v(" "),_c('td',[_c('ul',_vm._l((item.payment_method),function(method){return _c('li',{key:method.id},[_vm._v("\n                      "+_vm._s(method.name)+"\n                    ")])}),0)]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('strong',{class:{
                    'text-success': item.is_enabled === 1,
                    'text-muted': item.is_enabled === 0
                  }},[(item.is_enabled === 1)?_c('i',{staticClass:"fa fa-check-square-o"}):_c('i',{staticClass:"fa fa-square-o"}),_vm._v("\n                    "+_vm._s(_vm.parseStatus(item.is_enabled))+"\n                  ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-default btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.toggleStatus(item)}}},[(item.is_enabled === 1)?[_vm._v("Deactivate")]:[_vm._v("Activate")]],2)]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-block btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(item.id)}}},[_vm._v("\n                    View\n                  ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(item.id)}}},[_vm._v("\n                    Edit\n                  ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-block btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(item)}}},[_vm._v("\n                    Delete\n                  ")])])])})],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('strong',[_vm._v("Filter Promo Payments")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("Promo Payments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69bdc13b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(747);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69bdc13b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promotions\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-config-index' })}}},[_c('i',{staticClass:"fa fa-credit-card"}),_vm._v(" Payments\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"promo-name","name":"promo-name","placeholder":"Promo name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"id":"promo-description","name":"promo-description","row":"6","placeholder":"Promo description"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","id":"type","name":"type","options":_vm.types},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('span',{staticClass:"btn btn-default btn-xs",on:{"click":_vm.toggleAllDays}},[_vm._v("\n                    All Days\n                  ")]),_vm._v(" "),_vm._l((_vm.days),function(item){return [_c('label',{key:item.value,staticClass:"checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.days),expression:"form.days"}],attrs:{"type":"checkbox","id":item.value},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.days)?_vm._i(_vm.form.days,item.value)>-1:(_vm.form.days)},on:{"change":function($event){var $$a=_vm.form.days,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "days", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "days", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "days", $$c)}}}}),_vm._v("\n                        "+_vm._s(item.label)+"\n                    ")])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","id":"methods","name":"methods","options":_vm.payments},model:{value:(_vm.form.payment_method),callback:function ($$v) {_vm.$set(_vm.form, "payment_method", $$v)},expression:"form.payment_method"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"options":_vm.statuses},model:{value:(_vm.form.is_enabled),callback:function ($$v) {_vm.$set(_vm.form, "is_enabled", $$v)},expression:"form.is_enabled"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",on:{"click":_vm.submit}},[(_vm.isCreate)?[_vm._v("Create")]:[_vm._v("Update")]],2),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("\n          Cancel\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Promo Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-description"}},[_vm._v("\n                  Payment Description "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Promo Type "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"days"}},[_vm._v("\n                  Days "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"methods"}},[_vm._v("\n                  Payment Methods "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Status "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f97d6db6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__(749);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f97d6db6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Promotions\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-index' })}}},[_c('i',{staticClass:"fa fa-gift"}),_vm._v(" Promotions\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'promo-config-index' })}}},[_c('i',{staticClass:"fa fa-credit-card"}),_vm._v(" Payments\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-10"},[_c('div',{staticClass:"form-horizontal"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Promo Name\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"disabled":"","type":"text"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"promo-description"}},[_vm._v("\n                  Payment Description\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"disabled":"","row":"6"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Promo Type\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","disabled":""},model:{value:(_vm.form.type),callback:function ($$v) {_vm.$set(_vm.form, "type", $$v)},expression:"form.type"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"days"}},[_vm._v("\n                  Days\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_vm._l((_vm.days),function(item){return [_c('label',{key:item.value,staticClass:"col-checkbox-inline",attrs:{"for":item.value}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.days),expression:"form.days"}],attrs:{"type":"checkbox","disabled":"","id":item.value},domProps:{"value":item.value,"checked":Array.isArray(_vm.form.days)?_vm._i(_vm.form.days,item.value)>-1:(_vm.form.days)},on:{"change":function($event){var $$a=_vm.form.days,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=item.value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "days", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "days", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "days", $$c)}}}}),_vm._v("\n                        "+_vm._s(item.label)+"\n                    ")])]})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"methods"}},[_vm._v("\n                  Payment Methods\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"multiple":"","disabled":"","id":"methods","name":"methods"},model:{value:(_vm.form.payment_method),callback:function ($$v) {_vm.$set(_vm.form, "payment_method", $$v)},expression:"form.payment_method"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-3 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Status\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('v-select',{attrs:{"disabled":"","options":_vm.statuses},model:{value:(_vm.form.is_enabled),callback:function ($$v) {_vm.$set(_vm.form, "is_enabled", $$v)},expression:"form.is_enabled"}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('a',{staticClass:"btn btn-default pull-right",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("\n          Back\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4bbe208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(752);
function injectStyle (ssrContext) {
  __webpack_require__(751)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c4bbe208"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4bbe208_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Booking No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.booking_no),expression:"params.booking_no"}],staticClass:"form-control",attrs:{"type":"text","id":"bookingNo","placeholder":"Booking No"},domProps:{"value":(_vm.params.booking_no)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "booking_no", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Merchant Name")]),_vm._v(" "),_c('v-select',{attrs:{"id":"merchant","name":"merchant","label":"label","options":_vm.list.merchants,"placeholder":"Select Merchant"},model:{value:(_vm.params.merchant),callback:function ($$v) {_vm.$set(_vm.params, "merchant", $$v)},expression:"params.merchant"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status Booking")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",attrs:{"id":"status"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Status")]),_vm._v(" "),_c('option',{attrs:{"value":"active"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"checkout"}},[_vm._v("Checkout")]),_vm._v(" "),_c('option',{attrs:{"value":"expired"}},[_vm._v("Expired")]),_vm._v(" "),_c('option',{attrs:{"value":"paid"}},[_vm._v("Paid")])])])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customerName"}},[_vm._v("Customer Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.member_name),expression:"params.member_name"}],staticClass:"form-control",attrs:{"type":"text","id":"customerName","placeholder":"Name"},domProps:{"value":(_vm.params.member_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "member_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customerEmail"}},[_vm._v("Customer Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.member_email),expression:"params.member_email"}],staticClass:"form-control",attrs:{"type":"text","id":"customerEmail","placeholder":"Email"},domProps:{"value":(_vm.params.member_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "member_email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"departureDate"}},[_vm._v("Departure Date")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"departureDate","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('departureDate', date) }}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Booking Date")]),_vm._v(" "),_c('div',{staticClass:"row date-row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"bookingDateFrom","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","placeholder":"From","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('bookingDateFrom', date) }}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"bookingDateTo","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","placeholder":"To","clear-button":true,"disabled":_vm.disabledDates},on:{"selected":function (date) { _vm.onDateSelected('bookingDateTo', date) }}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"productName"}},[_vm._v("Product Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.package_name),expression:"params.package_name"}],staticClass:"form-control",attrs:{"type":"text","id":"productName"},domProps:{"value":(_vm.params.package_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "package_name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"source"}},[_vm._v("Source")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.source),expression:"params.source"}],staticClass:"form-control",attrs:{"id":"source","title":"Pilih"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "source", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Source")]),_vm._v(" "),_c('option',{attrs:{"value":"misteraladin"}},[_vm._v("Mister Aladin")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"promoCode"}},[_vm._v("Promo Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.promo_code),expression:"params.promo_code"}],staticClass:"form-control",attrs:{"type":"text","id":"promoCode"},domProps:{"value":(_vm.params.promo_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "promo_code", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"paymentMethod"}},[_vm._v("Payment Method")]),_vm._v(" "),_c('v-select',{attrs:{"id":"methods","name":"methods","label":"label","options":_vm.payment_methods,"placeholder":"Select Payment Method"},model:{value:(_vm.params.payment_method),callback:function ($$v) {_vm.$set(_vm.params, "payment_method", $$v)},expression:"params.payment_method"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customerName"}},[_vm._v("Redeem At From")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"redemAtFrom","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","placeholder":"From","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('redeem_at_from', date) }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customerName"}},[_vm._v("Redeem At To")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"redeemAtTo","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","placeholder":"To","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('redeem_at_to', date) }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customerName"}},[_vm._v("Check In At From")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"checkinAtFrom","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","placeholder":"From","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('checkin_at_from', date) }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customerName"}},[_vm._v("Check In At To")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"checkinAtTo","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","placeholder":"To","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('checkin_at_to', date) }}})],1)])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Issued Date")]),_vm._v(" "),_c('div',{staticClass:"row date-row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"paidFrom","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","placeholder":"From"},on:{"selected":function (date) { _vm.onPaidSelected('paidFrom', date) }}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"paidTo","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","placeholder":"To"},on:{"selected":function (date) { _vm.onPaidSelected('paidTo', date) }}})],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportCsv('normal')}}},[_vm._v("\n          Export CSV\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportCsv('finance')}}},[_vm._v("\n          Export CSV for Finance\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"type":"button"},on:{"click":_vm.fetch}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"box box-success"},[_c('div',{staticClass:"box-body no-padding"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',{key:"loading"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"18"}},[_c('circle2')],1)]):(_vm.orders.length < 1)?_c('tr',{key:"empty"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"18"}},[_vm._v("Data Not Found")])]):_vm._l((_vm.orders),function(order,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.parseTime(order.created_at)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge badge-primary pointer",on:{"click":function($event){return _vm.onBookingNoClick(order.hash)}}},[_vm._v(_vm._s(order.booking_no))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(order.media)))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(order.package_name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.visit_date))]),_vm._v(" "),_c('td',[(order.items[0].product.merchant.name)?_c('span',{staticClass:"truncate"},[_vm._v("\n                    "+_vm._s(order.items[0].product.merchant.name)+"\n                  ")]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',[(order.member_name)?_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(order.member_name))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',[(order.member_email)?_c('span',[_vm._v(_vm._s(order.member_email))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',[(order.member_phone)?_c('span',[_vm._v(_vm._s(order.member_phone))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.payment_method)?_c('span',[_vm._v(_vm._s(order.payment.payment_method))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.card_type)?_c('span',[_vm._v(_vm._s(_vm.capitalizeFirstLetter(order.payment.card_type)))]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.bank)?_c('span',[_vm._v(_vm._s(order.payment.bank))]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.installment_term)?_c('span',[_vm._v(_vm._s(order.payment.installment_term))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.installment_mdr)?_c('span',[_vm._v(_vm._s(order.payment.installment_mdr)+"%")]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.promo_code.code)?_c('kbd',[_vm._v(_vm._s(order.promo_code.code))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.total_discount_promo_code != 0)?[_vm._v("IDR "+_vm._s(_vm.numberFormat(order.total_discount_promo_code)))]:_c('span',{staticClass:"text-center"},[_vm._v("-")])],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.charging_fee_price && order.payment.charging_fee_price > 0 && order.payment.installment_fee == 0)?_c('span',[_vm._v("\n                    IDR "+_vm._s(_vm.numberFormat(order.payment.charging_fee_price))+"\n                  ")]):_vm._e(),_vm._v(" "),(order.payment.installment_fee && order.payment.installment_fee > 0)?_c('span',[_vm._v("\n                    IDR "+_vm._s(_vm.numberFormat(order.payment.installment_fee))+"\n                  ")]):_vm._e(),_vm._v(" "),(order.payment.charging_fee_price == 0 && order.payment.installment_fee == 0)?_c('span',[_c('span',{staticClass:"text-center"},[_vm._v("-")])]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.numberFormat(order.total_publish_rate)))]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.numberFormat(order.payment.amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.paid_at))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.latitude))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.longitude))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"label label-status",class:order.status === 'paid' ? 'label-success':'label-default'},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(order.status)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){return _vm.onBookingNoClick(order.hash)}}},[_vm._v("View Detail")])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modalError)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.modalError = !_vm.modalError}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.modalError = !_vm.modalError}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title",staticStyle:{"text-align":"center"}},[_vm._v("Please input Booking Date before export the data")])]),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Input Booking Date From and To within a maximum range of 6 months")])])])])])])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modalVisible)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.modalVisible = !_vm.modalVisible}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.modalVisible = !_vm.modalVisible}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Participant Detail - "+_vm._s(_vm.orderDetail.booking_no))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Product Name : "+_vm._s(_vm.orderDetail.package_name))])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',{staticClass:"nowrap"},[_c('th',[_vm._v("Price Name")]),_vm._v(" "),_c('th',[_vm._v("Unique Code")]),_vm._v(" "),_c('th',[_vm._v("Wristband Code")]),_vm._v(" "),_c('th',[_vm._v("Redeem At")]),_vm._v(" "),_c('th',[_vm._v("Check In At")]),_vm._v(" "),_c('th',[_vm._v("Nett Rate")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.orderDetail.items),function(item){return [_vm._l((item.tickets),function(ticket){return [_c('tr',{key:ticket.id},[_c('td',[_vm._v(_vm._s(item.price_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ticket.unique_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ticket.wristband_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.parseTime(ticket.redeem_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.parseTime(ticket.checkin_at)))]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(item.nett_rate))])])]})]})],2)])])])])])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("Orders Summary")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Summary")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"nowrap"},[_c('th',{staticClass:"text-center",staticStyle:{"min-width":"15rem"}},[_vm._v("Booking Date")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Booking No")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Media")]),_vm._v(" "),_c('th',[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Departure Date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Merchant Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Customer Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Customer Email")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Customer Phone")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Payment Method")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Card Type")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Bank Name")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Tenor")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("MDR")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Promo Code")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Promo Amount")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Installment/Charging Fee")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Total Publish Rate")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Payment Amount")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Issued date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Latitude")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Longitude")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7237940a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(754)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7237940a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7237940a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 754 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"booking-no"}},[_vm._v("Booking No.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.booking_no),expression:"params.booking_no"}],staticClass:"form-control",attrs:{"type":"text","id":"bookingNo","placeholder":"Booking No"},domProps:{"value":(_vm.params.booking_no)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "booking_no", $event.target.value)}}})])])]),_vm._v(" "),_c('hr',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"customer-name"}},[_vm._v("Customer Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.member_name),expression:"params.member_name"}],staticClass:"form-control",attrs:{"type":"text","id":"customerName","placeholder":"Customer Name"},domProps:{"value":(_vm.params.member_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "member_name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"departureDate"}},[_vm._v("Departure Date")]),_vm._v(" "),_c('datepicker',{attrs:{"id":"departureDate","format":"yyyy-MM-dd","placeholder":"Departure Date","wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('departureDate', date) }}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"productName"}},[_vm._v("Product Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.product_name),expression:"params.product_name"}],staticClass:"form-control",attrs:{"type":"text","id":"productName","placeholder":"Product Name"},domProps:{"value":(_vm.params.product_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "product_name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"merchantName"}},[_vm._v("Merchant Name")]),_vm._v(" "),_c('v-select',{attrs:{"id":"merchant","name":"merchant","label":"label","options":_vm.list.merchants,"placeholder":"Select Merchant"},model:{value:(_vm.params.merchant),callback:function ($$v) {_vm.$set(_vm.params, "merchant", $$v)},expression:"params.merchant"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Booking Date")]),_vm._v(" "),_c('div',{staticClass:"row date-row"},[_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"bookingDateFrom","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","placeholder":"From","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('bookingDateFrom', date) }}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-6"},[_c('datepicker',{attrs:{"id":"bookingDateTo","format":"yyyy-MM-dd","wrapper-class":"custom-vdp","input-class":"form-control","placeholder":"To","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('bookingDateTo', date) }}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status-payment"}},[_vm._v("Status Payment")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status_payment),expression:"params.status_payment"}],staticClass:"form-control",attrs:{"id":"status-payment"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status_payment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select Status")]),_vm._v(" "),_c('option',{attrs:{"value":"paid"}},[_vm._v("Paid")]),_vm._v(" "),_c('option',{attrs:{"value":"unpaid"}},[_vm._v("Unpaid")])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.onExportCsv()}}},[_vm._v("\n          Export CSV\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"type":"button"},on:{"click":_vm.fetch}},[_vm._v("\n          Search\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"box box-success"},[_c('div',{staticClass:"box-body no-padding"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',{staticClass:"nowrap"},[_c('th',{staticClass:"text-center",staticStyle:{"min-width":"15rem"}},[_vm._v("Booking Date")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Booking No")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"15rem"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Departure Date")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Merchant")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"15rem"}},[_vm._v("Customer Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Payment Method")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Card Type")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Bank Name")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Tenor")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("MDR")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Promo Code")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Payment Amount")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Total Nett Rate")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Status Booking")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Status Payment")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("\n                  Select Paid "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAllOrder),expression:"selectAllOrder"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAllOrder)?_vm._i(_vm.selectAllOrder,null)>-1:(_vm.selectAllOrder)},on:{"click":_vm.selectAll,"change":function($event){var $$a=_vm.selectAllOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAllOrder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAllOrder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAllOrder=$$c}}}})]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Action")])])]),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',{key:"loading"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"18"}},[_c('circle2')],1)]):(!_vm.isLoading && _vm.orders.length < 1)?_c('tr',{key:"empty"},[_c('td',{attrs:{"colspan":"18"}},[_vm._v("Data Not Found")])]):_vm._l((_vm.orders),function(order,index){return _c('tr',{key:index},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.parseTime(order.created_at)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge badge-primary pointer",on:{"click":function($event){return _vm.onBookingNoClick(order.hash)}}},[_vm._v(_vm._s(order.booking_no))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(order.package_name))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(order.visit_date))]),_vm._v(" "),_c('td',[(order.items[0].product.merchant.name)?_c('span',{staticClass:"truncate"},[_vm._v("\n                    "+_vm._s(order.items[0].product.merchant.name)+"\n                  ")]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',[(order.member_name)?_c('span',{staticClass:"truncate"},[_vm._v(_vm._s(order.member_name))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.payment_method)?_c('span',[_vm._v(_vm._s(order.payment.payment_method))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.card_type)?_c('span',[_vm._v(_vm._s(_vm.capitalizeFirstLetter(order.payment.card_type)))]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.bank)?_c('span',[_vm._v(_vm._s(order.payment.bank))]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.installment_term)?_c('span',[_vm._v(_vm._s(order.payment.installment_term))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.payment.installment_mdr)?_c('span',[_vm._v(_vm._s(order.payment.installment_mdr)+"%")]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(order.promo_code.code)?_c('kbd',[_vm._v(_vm._s(order.promo_code.code))]):_c('span',{staticClass:"text-center"},[_vm._v("-")])]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.numberFormat(order.payment_amount)))]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.numberFormat(order.total_nett_rate)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"label label-status",class:order.status === 'paid' ? 'label-success':'label-default'},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(order.status)))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"label label-status",class:order.status_payment === 'paid' ? 'label-success':'label-default'},[_vm._v(_vm._s(_vm.capitalizeFirstLetter(order.status_payment)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(order.status_payment !== "paid")?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedOrder),expression:"selectedOrder"}],attrs:{"type":"checkbox"},domProps:{"value":{
                        merchant_id: order.items[0].product.merchant.id,
                        booking_no: order.booking_no,
                        total_nett: order.total_nett_rate,
                      },"checked":Array.isArray(_vm.selectedOrder)?_vm._i(_vm.selectedOrder,{
                        merchant_id: order.items[0].product.merchant.id,
                        booking_no: order.booking_no,
                        total_nett: order.total_nett_rate,
                      })>-1:(_vm.selectedOrder)},on:{"change":function($event){var $$a=_vm.selectedOrder,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v={
                        merchant_id: order.items[0].product.merchant.id,
                        booking_no: order.booking_no,
                        total_nett: order.total_nett_rate,
                      },$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedOrder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedOrder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedOrder=$$c}}}})]):_c('div')]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){return _vm.onBookingNoClick(order.hash)}}},[_vm._v("View Detail")])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"type":"button"},on:{"click":_vm.onPaidClick}},[_vm._v("Pay to Merchant")])],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modalDetailVisible)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.modalDetailVisible = !_vm.modalDetailVisible}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.modalDetailVisible = !_vm.modalDetailVisible}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Participant Detail - "+_vm._s(_vm.orderDetail.booking_no))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Product Name : "+_vm._s(_vm.orderDetail.package_name))])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',{staticClass:"nowrap"},[_c('th',[_vm._v("Price Name")]),_vm._v(" "),_c('th',[_vm._v("Uniqe Code")]),_vm._v(" "),_c('th',[_vm._v("Nett Rate")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.orderDetail.items),function(item){return [_vm._l((item.tickets),function(ticket){return [_c('tr',{key:ticket.id},[_c('td',[_vm._v(_vm._s(item.price_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ticket.unique_code))]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.numberFormat(item.nett_rate)))])])]})]})],2)])]),_vm._v(" "),(_vm.orderDetail.merchant_payment_items.merchant_payment.image !== '')?_c('div',{staticClass:"img-section"},[_c('label',[_vm._v("Bukti Pembayaran: ")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"paid-img",attrs:{"src":_vm.orderDetail.merchant_payment_items.merchant_payment.image,"alt":"payment"}})])]):_vm._e()])])])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[(_vm.modalPaidVisible)?_c('div',{staticClass:"modal-mask",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.modalPaidVisible = !_vm.modalPaidVisible}}},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.modalPaidVisible = !_vm.modalPaidVisible}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Payment to Merchant")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Are you sure you want to paid this booking number?")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive scroll"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('thead',[_c('tr',{staticClass:"nowrap"},[_c('th',[_vm._v("Booking No")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.paidData.items),function(item){return [_c('tr',{key:item.booking_no},[_c('td',[_vm._v(_vm._s(item.booking_no))])])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"paid-form"},[_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-md-2",attrs:{"for":"merchants_name"}},[_vm._v("\n                      Merchants Name\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10",attrs:{"id":"merchants_name"}},[_vm._v("\n                      "+_vm._s(_vm.paidData.merchant_name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-sm-2 label-paid",attrs:{"for":"transfer_date"}},[_vm._v("\n                      Transfer Date "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('datepicker',{attrs:{"id":"transfer_date","placeholder":"Transfer Date","disabled":_vm.disabledTransferDate,"wrapper-class":"custom-vdp","input-class":"form-control","clear-button":true},on:{"selected":function (date) { _vm.onDateSelected('transfer_date', date) }}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Transfer to:")])])])]),_vm._v(" "),_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-md-2",attrs:{"for":"bank_owner"}},[_vm._v("\n                      Bank Owner\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10",attrs:{"id":"bank_owner"}},[_vm._v("\n                      "+_vm._s(_vm.paidData.bank_owner)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-md-2",attrs:{"for":"bank_name"}},[_vm._v("\n                      Bank Name\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10",attrs:{"id":"bank_name"}},[_vm._v("\n                      "+_vm._s(_vm.paidData.bank_name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-md-2",attrs:{"for":"bank_number"}},[_vm._v("\n                      Bank Number\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10",attrs:{"id":"bank_number"}},[_vm._v("\n                      "+_vm._s(_vm.paidData.bank_number)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-md-2",attrs:{"for":"total_nett"}},[_vm._v("\n                      Total Nett Rate\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-10",attrs:{"id":"total_nett"}},[_vm._v("\n                      IDR "+_vm._s(_vm.numberFormat(_vm.paidData.total_nett))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"row margin-row"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"image"}},[_vm._v("\n                      Upload File "),_c('span',{staticClass:"req"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.paidData.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.paidData.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                            Choose File\n                          ")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Upload File"}},[_c('FileGallery',{attrs:{"type":"category","selected":_vm.paidData.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.modalPaidVisible = !_vm.modalPaidVisible}}},[_vm._v("\n                      Cancel\n                    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.submitPayment.apply(null, arguments)}}},[_vm._v("\n                      Submit\n                    ")])])],1)])])])])]):_vm._e()])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("Payment to Merchant")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter Payment")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_149fda32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(758);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-149fda32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_149fda32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Custom Requests\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n        ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'requests-index' })}}},[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Custom Requests\n        ")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body table-responsive"},[_c('table',{staticClass:"table table-hover"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('tbody',{key:"loading"},[_c('tr',[_c('td',[_c('h3',[_vm._v("Loading")])])])]):(!_vm.isLoading && _vm.items.length < 1)?_c('tbody',{key:"empty"},[_c('tr',[_c('td',[_c('h3',[_vm._v("Empty")])])])]):_c('tbody',{key:"data"},[_c('tr',[_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Created")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"16rem"}},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"16rem"}},[_vm._v("Email")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Phone")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Type")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Destination")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Starting City")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Departure")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Return")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"6rem"}},[_vm._v("Adult")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"6rem"}},[_vm._v("Children")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"12rem"}},[_vm._v("Budget")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("Action")])]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.parseDate(item.created_at)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.full_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.type_of_travel))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.destination))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.starting_city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("parseTime")(item.departure_date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("parseTime")(item.return_date)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.adult))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(item.children))]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.digitGrouping(item.budget_per_person)))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-block btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(item.id)}}},[_vm._v("\n                    View\n                  ")])])])})],2)])],1)]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.modalVisible)?_c('modal',{attrs:{"title":"Plan My Trip Detail"}},[(_vm.requestData)?_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('tbody',[_c('tr',[_c('td',[_vm._v("Tanggal")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.parseDate(_vm.requestData.created_at)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Destinasi")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.destination))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Kota")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.starting_city))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tanggal Berangkat")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.parseDate(_vm.requestData.departure_date)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tanggal Kembali")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.parseDate(_vm.requestData.return_date)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Dewasa")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.adult))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Anak-anak")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.children))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tipe Travel")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.type_of_travel))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Makanan")]),_vm._v(" "),_c('td',[_vm._v("\n                Sarapan: "+_vm._s(_vm._f("yesNo")(_vm.requestData.breakfast))+" |\n                Makan Siang: "+_vm._s(_vm._f("yesNo")(_vm.requestData.lunch))+" |\n                Makan Malam: "+_vm._s(_vm._f("yesNo")(_vm.requestData.dinner))+"\n              ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Pesawat")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("yesNo")(_vm.requestData.flight)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Bintang Hotel")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.hotel_star))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Anggaran")]),_vm._v(" "),_c('td',[_vm._v("IDR "+_vm._s(_vm.digitGrouping(_vm.requestData.budget_per_person)))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Aktifitas")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.activity))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Permintaan Khusus")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.request))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Nama")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.full_name))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Email")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.email))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Telepon")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.requestData.phone))])])])])]):_vm._e()]):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("Custom Requests")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(354);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d3a74e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(760);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20d3a74e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      Settings\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("\n        Settings\n      ")])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.metaTitle),expression:"form.metaTitle"}],staticClass:"form-control",attrs:{"type":"text","id":"meta-title","placeholder":"Meta Title"},domProps:{"value":(_vm.form.metaTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "metaTitle", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.metaDescription),expression:"form.metaDescription"}],staticClass:"form-control",attrs:{"type":"text","id":"meta-description","placeholder":"Meta description"},domProps:{"value":(_vm.form.metaDescription)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "metaDescription", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.heroTitle),expression:"form.heroTitle"}],staticClass:"form-control",attrs:{"type":"text","id":"hero-title","placeholder":"Hero Title"},domProps:{"value":(_vm.form.heroTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "heroTitle", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.heroTitle_en),expression:"form.heroTitle_en"}],staticClass:"form-control",attrs:{"type":"text","id":"hero-title_en","placeholder":"Hero Title"},domProps:{"value":(_vm.form.heroTitle_en)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "heroTitle_en", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[(_vm.form.image.url)?_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"alt":"Destination Image","src":_vm.parseImage(_vm.form.image.url, '_thumb')}}):_c('img',{staticClass:"img-thumbnail img-responsive",attrs:{"src":"/static/img/img_placeholder.png","alt":"No image"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('button',{staticClass:"btn btn-sm btn-secondary",on:{"click":function($event){$event.preventDefault();return _vm.showModal('gallery')}}},[_vm._v("\n                        Select Image\n                      ")])])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.gallery)?_c('modal',{attrs:{"title":"Select Background Image"}},[_c('FileGallery',{attrs:{"type":"category","selected":_vm.form.image},on:{"update-images":_vm.setImage}})],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                  Meta Title "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"slug"}},[_vm._v("\n                  Meta Description "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Hero Title "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Hero Title En "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"parent"}},[_vm._v("\n                  Hero Background "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff39a072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(763);
function injectStyle (ssrContext) {
  __webpack_require__(762)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff39a072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff39a072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 762 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_vm._m(0),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home\n                ")])],1),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                    Country\n                  ")]),_vm._v(" "),_c('v-select',{attrs:{"name":"country","placeholder":"Select country","options":_vm.list.countries},on:{"input":_vm.payloadCountry,"change":function($event){_vm.form.city = null}},model:{value:(_vm.form.country),callback:function ($$v) {_vm.$set(_vm.form, "country", $$v)},expression:"form.country"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.params.country_id),expression:"params.country_id"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                        Explore ID\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.activity_id),expression:"params.activity_id"}],staticClass:"form-control",attrs:{"type":"number","id":"name","placeholder":"Search by Explore ID"},domProps:{"value":(_vm.params.activity_id)},on:{"change":function($event){return _vm.changeActivityID()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "activity_id", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("\n                        Title\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"title","placeholder":"Search by title"},domProps:{"value":(_vm.params.name)},on:{"keyup":function($event){return _vm.fetchActivity()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"destination"}},[_vm._v("\n                        City\n                      ")]),_vm._v(" "),_c('v-select',{attrs:{"name":"city","placeholder":"Select city","options":_vm.list.cities},on:{"input":_vm.payloadCity},model:{value:(_vm.form.city),callback:function ($$v) {_vm.$set(_vm.form, "city", $$v)},expression:"form.city"}})],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"box box-success"},[_c('div',{staticClass:"box-body no-padding"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading && (_vm.activities.length < 1))?_c('tr',{key:"loading"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('circle2')],1)]):(!_vm.isLoading && (_vm.activities.length < 1))?_c('tr',{key:"empty"},[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("Data Not Found")])]):_vm._l((_vm.activities),function(activity,index){return _c('tr',{key:index},[_c('td',[_c('span',{staticClass:"truncate"},[_vm._v("\n                      "+_vm._s(activity.id)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"truncate"},[_vm._v("\n                      "+_vm._s(activity.title)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"truncate"},[_vm._v("\n                      "+_vm._s(activity.city_name)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"truncate"},[_vm._v("\n                      "+_vm._s(activity.country_name)+"\n                    ")])]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-block btn-info btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.view(activity.id)}}},[_vm._v("\n                      View\n                    ")])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n            Klook\n            "),_c('small',[_vm._v("List of Klook explore")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('span',[_vm._v("Klook")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"nowrap"},[_c('th',{staticClass:"text-center",staticStyle:{"min-width":"5rem"}},[_vm._v("Explore ID")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"15rem"}},[_vm._v("Title")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"12rem"}},[_vm._v("City")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"10rem"}},[_vm._v("Country")]),_vm._v(" "),_c('th',{staticClass:"text-center",staticStyle:{"min-width":"8rem"}},[_vm._v("Action")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b8ce592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__(766);
function injectStyle (ssrContext) {
  __webpack_require__(765)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b8ce592"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b8ce592_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n        Klook\n      ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'dashboard' })}}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Dashboard\n          ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push({ name: 'klook-index' })}}},[_c('i',{staticClass:"fa fa-ticket"}),_vm._v(" Klook\n          ")])]),_vm._v(" "),_c('li',[_vm._v("\n          Activity\n        ")])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header with-border"},[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"btn btn-default pull-right",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("\n          Back\n        ")])]),_vm._v(" "),(_vm.isLoading)?_c('div',{staticStyle:{"padding":"20px"}},[_vm._v("\n        Loading...\n      ")]):(_vm.form.activity !== null)?_c('div',{staticClass:"box-body table-responsive",staticStyle:{"overflow":"unset"}},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Activity ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.activity_id))])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Activity Name")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.title))])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("City")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.city)+" ("+_vm._s(_vm.form.activity.city_id)+")")])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Country")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.country)+" ("+_vm._s(_vm.form.activity.country_id)+")")])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Duration")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.duration))])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Confirmation")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.confirmation))])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Refund")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.form.activity.refund))])]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Usage")]),_vm._v(" "),_c('td',{staticStyle:{"word-break":"break-word"}},_vm._l((_vm.usages),function(usage,index){return _c('div',{key:("usage-" + index),staticStyle:{"padding":"10px 0"}},[_c('strong',[_vm._v(_vm._s(_vm.nReplace(_vm.capitalizeFirstLetter(index))))]),_vm._v(": "+_vm._s(usage)+" "),_c('br')])}),0)]),_vm._v(" "),_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("Guide Lines")]),_vm._v(" "),_c('td',{staticStyle:{"word-break":"break-word"}},_vm._l((_vm.guidelines),function(guide,index){return _c('div',{key:("guide-" + index),staticStyle:{"padding":"10px 0"}},[_c('strong',[_vm._v(_vm._s(_vm.nReplace(_vm.capitalizeFirstLetter(index))))]),_vm._v(": "+_vm._s(guide)+" "),_c('br')])}),0)])])])]):_c('div',{staticStyle:{"text-align":"center","margin":"2rem"}},[_c('h4',[_vm._v("Activity data failed")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-responsive table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),(_vm.isLoading)?_c('tbody',[_vm._m(3)]):(_vm.form.activity !== null)?_c('tbody',_vm._l((_vm.form.activity.products),function(product,index){return _c('tr',{key:index},[_c('td',{staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v(_vm._s(product.product_id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(product.title))]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"word-break":"break-word"}},[_c('pre',[_vm._v(_vm._s(product.detail))])])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(product.product_min_pax)+"\n                ")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v("\n                  "+_vm._s(product.product_max_pax)+"\n                ")]),_vm._v(" "),_c('td',[_c('table',{attrs:{"width":"100%"}},[_c('tbody',_vm._l((product.skus),function(sku,index){return _c('tr',{key:("sku-" + index)},[_c('td',[_c('strong',[_vm._v(_vm._s(sku.sku_id))]),_vm._v(" - "+_vm._s(sku.title)+" ("),_c('strong',[_vm._v("Min")]),_vm._v(": "+_vm._s(sku.sku_min_pax)+" "),_c('strong',[_vm._v("Max")]),_vm._v(": "+_vm._s(sku.sku_max_pax)+")\n                          "),(sku.required)?_c('span',{staticStyle:{"color":"red"}},[_vm._v("Required")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(_vm.checkExtraInfo(product.extra_info))?_c('span',{staticClass:"label label-danger"},[_vm._v("Required")]):_c('span',{staticClass:"label label-info"},[_vm._v("Not Required")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"btn btn-success btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.showSchedule(product.product_id, product.title)}}},[_vm._v("\n                    Get Schedules\n                  ")])])])}),0):_c('tbody',[_vm._m(4)])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_vm._v("\n            Back\n          ")])])])]),_vm._v(" "),_c('transition',{attrs:{"name":"slideDown"}},[(_vm.show.schedule)?_c('modal',{attrs:{"title":((_vm.form.activity.title) + " - " + (_vm.modal.title))}},[_c('div',{staticClass:"row"},[(_vm.show.time_slot)?_c('div',{staticClass:"col-md-12"},[_c('span',{staticClass:"label label-danger"},[_vm._v("Warning!")]),_vm._v(" This product need time slot!"),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"10px"}},[_c('h4',[_vm._v("Schedules")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('label',{staticClass:"control-label col-md-2"},[_vm._v("\n                  Date From\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('datepicker',{attrs:{"disabled":_vm.configs.datepicker.disabled,"format":"dd MMMM yyyy","input-class":"form-control","placeholder":"Schedule will appear max for next 30 days","name":"date"},model:{value:(_vm.form.date),callback:function ($$v) {_vm.$set(_vm.form, "date", $$v)},expression:"form.date"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){$event.preventDefault();return _vm.getSchedules(_vm.form.date)}}},[_vm._v("Check")])])])]),_vm._v(" "),(_vm.form.schedules)?_c('div',{staticClass:"col-md-12"},[(!_vm.form.schedules.error.code)?_c('div',{staticClass:"schedule-wrapper"},[_vm._l((_vm.schedule_diff),function(index){return _c('span',{key:("schedule-item-" + index),staticClass:"schedule-item"},[_c('div',{staticClass:"title"},[_vm._v("\n                      "+_vm._s(_vm.getDate(index))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"body"},_vm._l((_vm.checkSchedule(_vm.getDate(index))),function(schedule,idx){return _c('div',{key:("sku-inventory-" + idx),staticClass:"item"},[_vm._v("\n                        "+_vm._s(schedule.sku_id)+"\n                      ")])}),0)])}),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('h4',[_vm._v("Prices")]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"overflow":"unset"}},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table","width":"100%"}},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"15em"}},[_vm._v("SKU ID")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Price")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.form.schedules.skus),function(sku,idx){return _c('tr',{key:("price-" + idx)},[_c('td',[_c('strong',[_vm._v(_vm._s(sku.sku_id))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(sku.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(sku.price))])])}),0)])])])])],2):_c('div',{staticClass:"col-md-12"},[_vm._v("Error "+_vm._s(_vm.form.schedules.error.message))])]):_c('div',{staticClass:"col-md-12"},[_vm._v("\n              No data found\n            ")])])]):_vm._e()],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("Activity")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('div',{staticClass:"box-title"},[_c('h3',[_vm._v("Product")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticStyle:{"min-width":"10rem"}},[_vm._v("Product ID")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"20rem"}},[_vm._v("Title")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"20rem"}},[_vm._v("Detail")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"7rem"}},[_vm._v("Min Pax")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"7rem"}},[_vm._v("Max Pax")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"40rem"}},[_vm._v("SKUS")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem","text-align":"center"}},[_vm._v("Extra Info")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"10rem","text-align":"center"}},[_vm._v("Action")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('div',[_vm._v("Loading...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('div',[_vm._v("Product data failed to load")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(357);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c50832_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(769);
function injectStyle (ssrContext) {
  __webpack_require__(768)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14c50832"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c50832_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"overflow":"hidden"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("\n                Name\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.name),expression:"params.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Search by name here"},domProps:{"value":(_vm.params.name)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"Email"}},[_vm._v("\n                Email\n              ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.email),expression:"params.email"}],staticClass:"form-control",attrs:{"type":"text","id":"category","placeholder":"Search by Email here"},domProps:{"value":(_vm.params.email)},on:{"keyup":_vm.onInput,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.params, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"role"}},[_vm._v("\n                Role\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.role),expression:"params.role"}],staticClass:"form-control",attrs:{"id":"role"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onSelect]}},[_c('option',{domProps:{"value":null}},[_vm._v("Select All")]),_vm._v(" "),_vm._l((_vm.list.roles),function(data,index){return _c('option',{key:(index + "-" + (data.value)),domProps:{"value":data.value}},[_vm._v("\n                "+_vm._s(data.label)+"\n                ")])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"status"}},[_vm._v("\n                Status\n              ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.params.status),expression:"params.status"}],staticClass:"form-control",attrs:{"id":"status"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.params, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},_vm.onSelect]}},[_c('option',{domProps:{"value":null}},[_vm._v("Select All")]),_vm._v(" "),_vm._l((_vm.list.status),function(data,index){return _c('option',{key:(index + "-" + (data.value)),domProps:{"value":data.value}},[_vm._v("\n                "+_vm._s(data.label)+"\n                ")])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header"},[_c('a',{staticClass:"btn btn-success pull-right",on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n          Add New User\n        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('table',{staticClass:"table table-bordered table-striped",attrs:{"id":"table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(3)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.error)?_c('tr',{key:"empty"},[_vm._m(4)]):_vm._e(),_vm._v(" "),_vm._l((_vm.users),function(user){return _c('tr',{key:user.id},[_c('td',[_vm._v(_vm._s(user.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.capitalizeFirstLetter(user.role.code)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.is_active ? 'Active' : 'Inactive'))]),_vm._v(" "),_c('td',[_c('a',{staticClass:"btn btn-primary btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.edit(user.id)}}},[_vm._v("\n                  Edit\n                ")]),_vm._v(" "),(user.is_active)?_c('a',{staticClass:"btn btn-warning btn-xs btn-active",on:{"click":function($event){$event.preventDefault();return _vm.activation('deactivate', user)}}},[_vm._v("\n                  Deactivate\n                ")]):_c('a',{staticClass:"btn btn-success btn-xs btn-active",on:{"click":function($event){$event.preventDefault();return _vm.activation('activate', user)}}},[_vm._v("\n                  Activate\n                ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-danger btn-xs",on:{"click":function($event){$event.preventDefault();return _vm.remove(user)}}},[_vm._v("\n                  Delete\n                ")])])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('Pagination',{attrs:{"pagination":_vm.pagination},on:{"goto-page":_vm.changePage}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      User Setup\n      "),_c('small',[_vm._v("List of user")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("User Setup")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Filter User")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button","data-widget":"collapse"}},[_c('i',{staticClass:"fa fa-minus"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Full Name")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Role")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Actions")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"5"}},[_c('strong',[_vm._v("Data failed to load")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(358);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b3fe48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(772);
function injectStyle (ssrContext) {
  __webpack_require__(771)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a5b3fe48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5b3fe48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      User Setup\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('router-link',{attrs:{"to":{ name: 'dashboard' }}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name: 'user-setup-page'}}},[_vm._v("User Setup")])],1),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.isCreate)?_c('span',[_vm._v("Create")]):_c('span',[_vm._v("Edit")])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_c('a',{staticClass:"close",on:{"click":function($event){_vm.error = false}}},[_vm._v("\n                  ×\n                ")]),_vm._v("\n                "+_vm._s(_vm.error)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"Name"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-control",attrs:{"type":"text","id":"email","placeholder":"Email","disabled":!_vm.isCreate},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('v-select',{attrs:{"id":"role","name":"role","placeholder":"Select Role","options":_vm.list.roles},model:{value:(_vm.form.role),callback:function ($$v) {_vm.$set(_vm.form, "role", $$v)},expression:"form.role"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[(_vm.isCreate)?_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Create")]):_c('button',{staticClass:"btn btn-info pull-right",attrs:{"type":"submit"}},[_vm._v("Update")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v("Cancel")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n                  Full Name "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"email"}},[_vm._v("\n                  Email "),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"role"}},[_vm._v("\n                  Role "),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(359);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ecc77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(775);
function injectStyle (ssrContext) {
  __webpack_require__(774)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-792ecc77"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_792ecc77_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"box"},[_vm._m(1),_vm._v(" "),_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"form-group"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","placeholder":"FullName"},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"email"}},[_vm._v("\n              Email\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 margin-top"},[_vm._v("\n              "+_vm._s(_vm.form.email)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"role"}},[_vm._v("\n              Role\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-10 margin-top"},[_vm._v("\n              "+_vm._s(_vm.form.role)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",on:{"click":function($event){$event.preventDefault();return _vm.updateProfile.apply(null, arguments)}}},[_vm._v("Update")])])])]),_vm._v(" "),_c('div',{staticClass:"box"},[_vm._m(3),_vm._v(" "),_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"box-body",staticStyle:{"overflow":"unset"}},[_c('div',{staticClass:"form-group"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.old_password),expression:"form.old_password"}],staticClass:"form-control",attrs:{"type":"password","id":"old_password","placeholder":"Old Password"},domProps:{"value":(_vm.form.old_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "old_password", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.new_password),expression:"form.new_password"}],staticClass:"form-control",attrs:{"type":"password","id":"new_password","placeholder":"New Password"},domProps:{"value":(_vm.form.new_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "new_password", $event.target.value)}}}),_vm._v(" "),_c('span',[_vm._v("\n                Password must contains at least 1 uppercase, 1 lowercase and 8 character long\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.confirm_password),expression:"form.confirm_password"}],staticClass:"form-control",attrs:{"type":"password","id":"confirm_password","placeholder":"New Password"},domProps:{"value":(_vm.form.confirm_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "confirm_password", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-info pull-right",on:{"click":function($event){$event.preventDefault();return _vm.updatePassword.apply(null, arguments)}}},[_vm._v("Update")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      My Profile\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Profile")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Manage Profile")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"name"}},[_vm._v("\n              Full Name"),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_vm._v("Change Password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"old_password"}},[_vm._v("\n              Old Password"),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"new_password"}},[_vm._v("\n              New Password"),_c('span',{staticClass:"req"},[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-sm-2 control-label",attrs:{"for":"confirm_password"}},[_vm._v("\n              Confirm New Password"),_c('span',{staticClass:"req"},[_vm._v("*")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_redeem_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1ee1d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_redeem_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(777)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c1ee1d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_redeem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1ee1d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_redeem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 777 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-sm-12 col-lg-8 col-md-8 col-md-offset-2"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('h1',[_vm._v("Redeem Ticket")]),_vm._v(" "),_c('p',[_vm._v("\"Festival Musik & Seni Outdoor Berkelas Dunia Pertama di Indonesia\"")]),_vm._v(" "),_c('form',{staticStyle:{"margin-top":"35px"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{class:_vm.formValidation.voucherCode === '' ? 'form-group input-group-lg':  'form-group input-group-lg has-error'},[_c('label',{staticStyle:{"color":"#333333 !important"}},[_vm._v("Voucher Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.voucherCode),expression:"voucherCode"}],ref:"voucherCodeRef",staticClass:"form-control",attrs:{"type":"text","readonly":_vm.isReadonlyVoucher,"placeholder":"Voucher code"},domProps:{"value":(_vm.voucherCode)},on:{"keypress":function (event){ return _vm.handleKeyPress(event, 'wristband_code'); },"input":function($event){if($event.target.composing){ return; }_vm.voucherCode=$event.target.value}}}),_vm._v(" "),(_vm.formValidation.voucherCode !== '')?_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.formValidation.voucherCode)+" ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{class:_vm.formValidation.wrisbandCode === '' ? 'form-group input-group-lg' : 'form-group input-group-lg has-error'},[_c('label',{staticStyle:{"color":"#333333 !important"}},[_vm._v("Wrisband Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wrisbandCode),expression:"wrisbandCode"}],ref:"wrisbandCodeRef",staticClass:"form-control",attrs:{"type":"text","placeholder":"Wrisband code"},domProps:{"value":(_vm.wrisbandCode)},on:{"keypress":function (event){ return _vm.handleKeyPress(event, 'submit'); },"input":function($event){if($event.target.composing){ return; }_vm.wrisbandCode=$event.target.value}}}),_vm._v(" "),(_vm.formValidation.wrisbandCode !== '')?_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.formValidation.wrisbandCode)+" ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[(_vm.isLoading)?_c('button',{staticClass:"btn btn-primary btn-flat",attrs:{"type":"button","disabled":""}},[_c('ProgressLoader',{attrs:{"size":"15"}}),_vm._v(" Loading...")],1):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('button',{staticClass:"btn btn-primary btn-flat",attrs:{"type":"submit"}},[_vm._v("Linked")]):_vm._e()])]),_vm._v(" "),_c('Transition',{attrs:{"name":"fade"}},[(_vm.message.shown)?_c('div',{staticStyle:{"margin-top":"15px"}},[_c('div',{class:("alert alert-dismissible " + (_vm.message.type)),attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"},on:{"click":function($event){return _vm.onResetMessage()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v("\n                  "+_vm._s(_vm.message.text)+"\n                  "),(_vm.message.item)?_c('ol',{staticStyle:{"text-align":"start"}},_vm._l((_vm.message.item),function(list,index){return _c('li',{key:index},[_c('b',[_vm._v(_vm._s(index.toUpperCase()))]),_vm._v(" : "+_vm._s(list)+"\n                    ")])}),0):_vm._e()])]):_vm._e()])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkin_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dacd326_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkin_vue__ = __webpack_require__(781);
function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dacd326"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dacd326_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checkin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-sm-12 col-lg-8 col-md-8 col-md-offset-2"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('h1',[_vm._v("Check In")]),_vm._v(" "),_c('p',[_vm._v("\"Festival Musik & Seni Outdoor Berkelas Dunia Pertama di Indonesia\"")]),_vm._v(" "),_c('form',{staticStyle:{"margin-top":"35px"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-3"},[_c('div',{class:_vm.formValidation.wrisbandCode === '' ? 'form-group input-group-lg' : 'form-group input-group-lg has-error'},[_c('label',{staticStyle:{"color":"#333333 !important"}},[_vm._v("Wrisband Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.wrisbandCode),expression:"wrisbandCode"}],ref:"wrisbandCodeRef",staticClass:"form-control",attrs:{"type":"text","placeholder":"Wrisband code"},domProps:{"value":(_vm.wrisbandCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.wrisbandCode=$event.target.value}}}),_vm._v(" "),(_vm.formValidation.wrisbandCode !== '')?_c('span',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.formValidation.wrisbandCode)+" ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[(_vm.isLoading)?_c('button',{staticClass:"btn btn-primary btn-flat",attrs:{"type":"button","disabled":""}},[_c('ProgressLoader',{attrs:{"size":"15"}}),_vm._v(" Loading...")],1):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_c('button',{staticClass:"btn btn-primary btn-flat",attrs:{"type":"submit"}},[_vm._v("Check In")]):_vm._e()])]),_vm._v(" "),_c('Transition',{attrs:{"name":"fade"}},[_vm._v("\n              "+_vm._s(_vm.message)+"\n              "),(_vm.message.shown)?_c('div',{staticStyle:{"margin-top":"15px"}},[_c('div',{class:("alert alert-dismissible " + (_vm.message.type)),attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-label":"Close"},on:{"click":function($event){return _vm.onResetMessage()}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v("\n                  "+_vm._s(_vm.message.text)+"\n                ")])]):_vm._e()])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_admin_lte___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_admin_lte__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cleave_component__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cleave_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cleave_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vee_validate__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raven_js__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raven_js_plugins_vue__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_scrollto__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_affix__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_affix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_affix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(50);




















__WEBPACK_IMPORTED_MODULE_11_raven_js___default.a.config('https://f3945a0c6081405c9d0c89af63b6f08a@sentry.io/1190660').addPlugin(__WEBPACK_IMPORTED_MODULE_12_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]).install();

window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(8);
window._ = __webpack_require__(49);

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_15__config__["i" /* default */];
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common.Authorization = 'Bearer ' + window.localStorage.getItem('token');
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers['X-MA-Client'] = 'backend';

window.qs = __WEBPACK_IMPORTED_MODULE_10_qs___default.a;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_3_axios___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert2__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_cleave_component___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_scrollto___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_affix___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

// Check local storage to handle refreshes
if (window.localStorage) {
  if (__WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].state.token !== window.localStorage.getItem('token')) {
    __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

var parseJwt = function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].mixin({
  methods: {
    parseJwt: parseJwt,

    setDate: function setDate(value) {
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
      var text = '';

      if (value.date) {
        var nuDate = new Date(value.date);
        var day = nuDate.getDay();
        var date = nuDate.getDate();
        var month = nuDate.getMonth();
        month += 1;
        if (month < 10) {
          month = '0' + month;
        }
        var year = nuDate.getFullYear();

        // return days[day]+', '+date+'-'+month+'-'+year;
        text = days[day] + ', ' + date + '-' + month + '-' + year;
      }
      return text;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(8)))

/***/ }),
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[368]);


// WEBPACK FOOTER //
// static/js/app.1d0e130b96d274b32b8e.js